let moduleZh = {
  common: {
    next_step: "下一步",

    submit_info: "提交信息",

    submit: "提交",

    confirm_next_step: "确认无误，下一步",

    back_pre_step: "返回上一步",

    understand_everything: "我已清楚明白全部内容",

    login_password: '请输入登录密码',

    confirm: "确定", //U//U
    complete: "完成", //U
    opera_success: "操作成功", // U
    male: "男", // U
    female: "女", //U

    tips: "提示", //U
    ok: "知道了",
    select_placeholder_default: "请选择",
    uploading_text: "上传中...",
    loading_text: "加载中...",
    checking_text: "验证中...",
    withdraw_text: "正在转出",
    message_send_pending_text: "短信发送中...",
    message_send_success_text: "验证码已发送",
    //效验错误toast提示文字
    email_verify_fail_text: "请填写正确格式的邮箱",
    trade_password_verify_fail_text: "密码应为数字和字母结合，长度不低于6位", //U
    trade_password_repeat_fail_text: "两次输入不一致", //U
    phone_verify_fail_text: "请输入正确的手机号",
    captcha_verify_fail_text: "请填写图片验证码",
    card_verify_fail_text: "请填写正确的证件号码",
    agreement_verify_fail_text: "请阅读并同意上述协议",
    amount_verify_fail_text: "您输入的金额超出范围",
    no_network_tip: "请检查网络连接",

    usd: "美元", //U  2020.12.8
    hkd: "港币", //U  2020.12.8
    rmb: "人民币", //U  2020.12.8

    countryname: "国籍",
    edit_info:'修改资料',
    confirm_info:'确认资料'
  },

  // 开户提示语
  error_text:'仅数字和字母',
  error_tips:'样本：C6666664',
  error_zh_text:'仅数字+X',

  // 选择国籍title
  choose_nationality:'选择国籍',

  // 证件号错误提示
  error_hk_tips:'证件号码不能小于6位数',
  error_cn_tips:'身份证号码格式有误',


  //登录

  login: {
    title: "登录",

    forget_password_text: "忘记登录密码",

    register_text_prev: " 没有账号，",

    register_text_next: " 立即注册",

    password_login_title: "密码登录",

    account_placeholder: "账号/邮箱/证件号",

    password_placeholder: "登录密码",

    message_password_title: "短信验证码登录",

    phone_placeholder: "手机号",

    captcha_placeholder: "图片验证码",

    message_code_placeholder: "短信验证码",

    send_message_btn_text: "点击获取",

    title_h5: "登录",

    account_placeholder_h5:"账号ID/用户名/邮箱名/身份证号",
    faceIDOrFingerprint: "指纹或FaceID验证",
    account_password_login: "账号密码",
    message_login_text: "短信验证码",
    isCheckAgreementTips: "请阅读并同意免责申明"
  },

  //h5页面模块
  h5Page:{
    login:{
      title:'登录'
    },
    transaction:{
      title:'交易设置'
    },
    futuresSetup:{
      title:'期货开仓设置'
    },
    operation:{
      title:'操作记录'
    },
    account:{
      title:'账户/组'
    },
    order:{
      title:'订单执行'
    },
    accountDetails:{
      title:'账户明细'
    },
  },

  //注册

  register: {
    nav_title: "高盈证券",
    nav_titile2: "登录密码", //U
    title: "注册", //U
    password_setting_page_title: "设置登录密码", //U
    phone_placeholder: "手机号",

    captcha_placeholder: "图片验证码",

    message_code_placeholder: "短信验证码",

    send_message_btn_text: "点击获取",

    argeement_text: ["我已阅读并同意", "产品使用许可协议", "和", "隐私协议"],

    password_placeholder: "密码至少8位数字和字母组合",

    confirm_placeholder: "确认密码",
    password_verify_fail_text: "两次输入不一致",

    register_success_text: "注册成功"
  },

  //忘记密码

  forget_password: {
    nav_title: "找回登录密码",
    first_step_desc: " 请输入注册时的手机号",
    phone_placeholder: "手机号",

    captcha_placeholder: "图片验证码",

    message_code_placeholder: "短信验证码",

    send_message_btn_text: "点击获取",

    set_login_password_text: "请设置登录密码",

    password_placeholder: "至少八位数字和字母组合",

    confirm_placeholder: "再次输入密码",

    email_address: "邮箱地址",

    tips1: "前后密码不一致，请重新输入",
    tips2: "密码设置成功",
    tips3:"密码是至少8位数字和字母组合"
  },

  //开户流程

  open_account: {
    mode_select: {
      nav_title: "选择开户方式",

      page_title: "请选择您所属国家/地区",

      mode_list: [
        {
          icon: require("@/assets/images/icon_modeSelect_hk.png"),

          title: "中国香港用户",

          prepare_text: "开户准备",

          prepare_list: ["香港公民身份证"],

		  index: 1
        },
		{
		  icon: require("@/assets/images/icon_modechoose_china.png"),

		  title: "中国内地用户",

		  prepare_text: "开户准备",

		  prepare_list: ["中国内地公民身份证"],

		  index: 0
		}
      ],

      tip_title: "温馨提示",

      tip_content:
        "本服务不支持代开账户，需客户本人填写；\n本服务不支持多重国籍客户开户",

      footer_text_prev: "本服务由",

      footer_text_middle: "高盈期货(香港)公司",

      footer_text_next: "提供" //U
    },

    idcard_upload: {
      page_title: "根据身份证核实身份信息(1/2)",

      step_title: "步骤一：上传身份证照片",

      step_tip: "请务必上传清晰完整的证件照",

      face_idcard_upload_label: "上传身份证正面",

      back_idcard_upload_label: "上传身份证反面",

      submit_btn_text1: "识别身份证信息",

      submit_btn_text2: "填写身份信息"
    },

    idcard_verify: {
      nav_title1: "身份认证", //U
      nav_title2: "身份认证", //U
      page_title: "根据身份证核实身份信息(2/2)",
      page_extra_text: "*号必填",
      step_title: "步骤二：核实身份信息",
      step_tip: "查阅下列信息是否与身份证一致，\n  如有不同，请按真实信息填写",

      chinese_name_field: {
        label: "中文名"
      },

      english_name_field: {
        label1: "英文名",
        label2: "英文名(拼音)" //U
      },

      sex_field: {
        label: "性别"
      },

      birth_field: {
        label: "出生年月"
      },

      idcard_field: {
        label: "证件号码"
      },

      address_field: {
        label: "地址归属"
        // placeholder: "请选择"
      },

      address_detail_field: {
        label: "详细住址" // U
        // placeholder: "请填写您的住址"
      }
    },

    address_proof: {
      nav_title: "住址证明",
      page_title: "请上传住址证明",

      tip:
        "请使用最近三个月内的银行结单或公共服务单据副本作为 住址证明。住址证明应包含完整的姓名、住址或联系地址、 日期，如果你的住址和身份证件一致，请上传证件证明",

      address_proof_field: {
        label: "住址证明"
      },

      address_field: {
        label: "地址归属",

        placeholder: "请选择"
      },

      address_detail_field: {
        label: "详细地址",
        placeholder: "请填写您的住址"
      }
    },
    //用户资料
    account_info:{
      nav_title: "账户资料",
      page_title: "客户账户资料",

      email_field: {
        label: "邮箱",
        placeholder: "请绑定"
      },
    },

    personal_info_supply: {
      nav_title: "个人信息补充",

      page_title: "请补充个人其他信息",

      page_extra_text_1: "*", //U
      page_extra_text_2: "号必填",

      contact_info: "联系方式",

      contact_info_desc: "(重要)",

      phone_field: {
        label: "手机号"
      },

      email_field: {
        label: "电子邮箱",
        tip: "电子邮箱用于接受期货账户结算单，请绑定常用邮箱" //U
      },

      education_module_title: "教育/就业情况", //U

      education_field: {
        label: "教育情况",
        columns: [
          //U
          {
            text: "小学",
            value: 1
          },
          {
            text: "中学",
            value: 2
          },
          {
            text: "大学",
            value: 3
          },
          {
            text: "硕士及以上",
            value: 4
          }
        ]
      },

      employment_field: {
        label: "就业情况",
        columns: [
          //U
          {
            text: "受雇",
            value: 1
          },
          {
            text: "自雇",
            value: 2
          },
          {
            text: "退休",
            value: 3
          },
          {
            text: "学生",
            value: 4
          },
          {
            text: "其他",
            value: 5
          }
        ],
        placeholder_other: "请填写，例如：家庭主妇"
      },

      employer_name_field: {
        label: "雇主名称",
        placeholder:"选填"
      },

      profession_attr_field: {
        label: "职业属性",
        placeholder:"选填"
      },

      position_field: {
        label: "职位",
        placeholder:"选填"
      },

      employment_duration_field: {
        label: "受雇年期",
        columns: [
          //U
          {
            text: "不满一年",
            value: 1
          },
          {
            text: "1～3年",
            value: 2
          },
          {
            text: "3年以上",
            value: 3
          }
        ]
      },

      company_phone_field: {
        label: "公司/机构电话",
        placeholder:"选填"
      },

      company_address_field: {
        label: "公司/机构地址", //U
        placeholder:"选填"
      }
    },

    email_bind: {
      nav_title: "邮箱",
      page_title: "绑定邮箱",

      bind_title: "两步绑定邮箱",

      first_step_name: "第一步",

      first_step_desc: "填写邮箱号，提交",

      second_step_name: "第二步",

      second_step_desc: "打开邮件，点击激活按钮",

      email_field: {
        label: "邮箱",
        placeholder: "邮箱名"
      },

      captcha_field: {
        label: "图片验证",
        placeholder: "验证码"
      },
      email_send_success_title: "操作成功，邮件已发送，请注意查收", //U
      email_send_success_tip: "请进入邮箱，在邮件中点击激活按钮" //U
    },

    customer_state: {
      nav_title: "客户声明",

      page_title: "客户声明", 

      fail_toast_text: "您必须符合上述条件才能开户", //U
      statement_list: [
        {
          title: "1、本人是该账户之最终受益人",
          tip: "我司不接受申请人为非账户最终受益人"
        },
        {
          title:
            " 2、您是否与高盈证券有限公司(高盈证券)或联系人士的职员或代理人有亲戚关係？",
          tip: "请提供以下资料",
          input_label_1: "职员/代理人名称：",
          input_label_2: "关系："
        },
        {
          title:
            "3、您是否是证券/期货交易所参与者的僱员或代理人，或于证监会注册的持牌法团/注册机构？",
          tip: "请提供以下资料",
          input_label_1: "相关参与者或注册人的姓名是：",
          input_label_2: "阁下的牌照编号："
        },
        {
          title:
            "4、本人是否是美国公民或美国居民或出生于美国或美国领土，或持有“美国永久居民身份证（绿卡）？",
          tip: "我司不接受申请人是美国公民"
        },
        {
          title:
            "5、您的配偶是否在高盈证券有限公司开设过任何账户?如是，户口号码是：",
          tip: "请提供以下资料",
          input_label_1: "配偶账号ID："
        }
      ],
      yes: "是",
      no: "否",
      input_placeholder: "请输入"
    },

    tax_resident_info: {
      page_one: {
        nav_title: "税务居民资料",

        page_title: "税务目的地",

        page_extra_text: "请按照实际情况选择",

        common_country_list: [
          {
            text: "中国内地"
          },
          {
            text: "中国香港"
          },
          {
            text: "中国澳门"
          },
          {
            text: "台湾"
          },
          {
            text: "日本"
          },
          {
            text: "加拿大"
          },
          {
            text: "泰国"
          },
          {
            text: "印尼"
          }
        ],

        extra: "其他",

        search_placeholder: "请输入中文或者英文搜索国家",
        toast_fail_text: "税务目的地请不要超过2个"
      },

      page_two: {
        nav_title: "税务居民资料",

        page_title: "客户税务居民资料",

        tax_area: "纳税地区",

        tax_number_field: {
          label: "税务编号",

          placeholder: "请录入"
        },

        residence_jurisdiction_field: {
          label: "居留司法管辖区",

          placeholder: "请录入"
        }
      }
    },

    country_list: {
      nav_title: "选择税务目的地",
      search_bar_placeholder: "请输入关键字搜索",
      no_result_tip: "抱歉，未能匹配到您搜索的内容"
    },

    w_8ben: {
      nav_title: "W-8BEN资料",
      page_title: "客户W-8BEN资料",

      taxpayer_name: "纳税人姓名",

      region: "所属地区",

      address_field: {
        label: "地址归属(英文)",

        placeholder: "请选择"
      },

      address_detail_field: {
        label: "详细住址(英文)",

        placeholder:
          "请填写街道/请填写英文详细地址, 格式按照楼栋及单元,小区/村组,街道/乡镇"
      }
    },

    survey: {
      nav_title: "适当性调查",
      cognition_of_derivatives: "衍生品的认知",
      page_one: {
        invest_target_title: "投资目标",
        invest_target_desc: "*号必填",
        invest_tagert_list: [
          {
            title: "投资目标（可多选）",
            type: "checkbox",
            value: [],
            options: [
              {
                value: 1,
                label: "赚取收入"
              },
              {
                value: 2,
                label: "资本增长"
              },
              {
                value: 3,
                label: "对冲"
              },
              {
                value: 4,
                label: "投机"
              },
              {
                value: 5,
                label: "其他",
                placeholder: "请填写其他投资目标",
                isChecked: false,
                inputValue: ""
              }
            ]
          }
        ], //U
        derivative_title: "对衍生品的认知", //U
        derivative_tip: "您通过哪种方式了解衍生品",
        derivative_tip_two: "可选择以下任意一项",
        whitelist_users_tips: "不了解衍生品，无法开户",
        derivative_no_title:
          "如您的回答为“未有衍生产品之认识”。如果您仍然有意认购衍生产品，您仅限于以下情况可作认购:",
        derivative_no: [
          "如该衍生产品是在交易所买卖 - 我们没有就拟进行的交易向您作出招揽或建议，而且我们已向您解释该产品所附带的相关风险；或",
          "如该衍生产品并非在交易所买卖 - 我们没有就拟进行的交易向您作出招揽或建议，而且我们已就有关交易向您提出警告，并考虑到我们通过尽职调查已知悉或应当知悉的关于您的资讯，尤其是您是一名对衍生品并不瞭解的客户的事实，就有关交易对您是否在任何情况下都合适。如评估结果显示有关交易并不适合您，我们只可在执行有关交易是维护您最佳利益的行事方式的前提下，著手执行有关交易。"
        ],
        derivative_no_agree:
          "本人(等) (客户)没有上述经验，但已细阅、同意及明白所有关于衍生产品的风险声明，本人(等) (客户)明白于买卖有关衍生产品前必须先具备足够的认识，并愿意接受一切有关的风险。",
        derivative_list: [
          {
            title: "本人是否了解衍生产品的性质和风险",
            options: ["了解", "不了解"]
          },
          {
            title: "1、已接受有关的培训或课程（可多选）",
            options: ["监管机构", "交易所", "大专院校", "进修学院", "金融机构"]
          },
          {
            title:
              "2、于经济公司或银行、基金或资产管理公司、监管机构 或交易所等金融机构有关的工作经验（可多选）",
            options: ["受监管持牌人士", "管理层", "与衍生工具相关活动"]
          },
          {
            title:
              "3、于过去三年内进行了五次或以上有关任何衍生产品之交易(不论是否在交易所买卖)",
            options: ["是", "否"]
          }
        ] // U
      },

      page_two: {
        investment_exp_title: "投资经验",
        investment_exp_list: [
          {
            label: "上市证券",
            value: "",
            options: [
              {
                text: "没有经验",
                value: 1
              },
              {
                text: "少于一年",
                value: 2
              },
              {
                text: "一至三年",
                value: 3
              },
              {
                text: "三至五年",
                value: 4
              },
              {
                text: "五年以上",
                value: 5
              }
            ]
          },
          {
            label: "牛熊证/窝轮",
            value: "",
            options: [
              {
                text: "没有经验",
                value: 1
              },
              {
                text: "少于一年",
                value: 2
              },
              {
                text: "一至三年",
                value: 3
              },
              {
                text: "三至五年",
                value: 4
              },
              {
                text: "五年以上",
                value: 5
              }
            ]
          },
          {
            label: "期货/期权",
            value: "",
            options: [
              {
                text: "没有经验",
                value: 1
              },
              {
                text: "少于一年",
                value: 2
              },
              {
                text: "一至三年",
                value: 3
              },
              {
                text: "三至五年",
                value: 4
              },
              {
                text: "五年以上",
                value: 5
              }
            ]
          },
          {
            label: "杠杆式外汇",
            value: "",
            options: [
              {
                text: "没有经验",
                value: 1
              },
              {
                text: "少于一年",
                value: 2
              },
              {
                text: "一至三年",
                value: 3
              },
              {
                text: "三至五年",
                value: 4
              },
              {
                text: "五年以上",
                value: 5
              }
            ]
          },
          {
            label: "单位信托基金或债券",
            value: "",
            options: [
              {
                text: "没有经验",
                value: 1
              },
              {
                text: "少于一年",
                value: 2
              },
              {
                text: "一至三年",
                value: 3
              },
              {
                text: "三至五年",
                value: 4
              },
              {
                text: "五年以上",
                value: 5
              }
            ]
          },
          {
            label: "结构性产品",
            value: "",
            options: [
              {
                text: "没有经验",
                value: 1
              },
              {
                text: "少于一年",
                value: 2
              },
              {
                text: "一至三年",
                value: 3
              },
              {
                text: "三至五年",
                value: 4
              },
              {
                text: "五年以上",
                value: 5
              }
            ]
          },
          {
            label: "其他",
            value: 2,
            options: [
              {
                text: "没有经验",
                value: 1
              },
              {
                text: "少于一年",
                value: 2
              },
              {
                text: "一至三年",
                value: 3
              },
              {
                text: "三至五年",
                value: 4
              },
              {
                text: "五年以上",
                value: 5
              }
            ]
          }
        ], //U
        not_allow_open_account_dialog: {
          content: "您对期货的认知有限，无法开户！\n建议您先了解期货知识。",
          cancelButtonText: "返回首页"
        },
        fail_toast_text: "无法开户" //U
      },

      page_three: {
        page_title: "财务状况",
        page_extra_text: "*号必填", //U
        financial_list: [
          {
            type: "select",
            label: "流动资产（港币）",
            value: "",
            options: [
              {
                text: "＜HKD100,000",
                value: 1
              },
              {
                text: "HKD100,001-HKD500,000",
                value: 2
              },
              {
                text: "HKD500,001-HKD1,000,000",
                value: 3
              },
              {
                text: "HKD1,000,001-HKD5,000,000",
                value: 4
              },
              {
                text: "HKD5,000,001-HKD10,000,000",
                value: 5
              },
              {
                text: ">HKD10,000,000",
                value: 6
              }
            ]
          },
          {
            type: "select",
            label: "资产净值（港币）",
            value: "",
            options: [
              {
                text: "＜HKD100,000",
                value: 1
              },
              {
                text: "HKD100,001-HKD500,000",
                value: 2
              },
              {
                text: "HKD500,001-HKD1,000,000",
                value: 3
              },
              {
                text: "HKD1,000,001-HKD5,000,000",
                value: 4
              },
              {
                text: "HKD5,000,001-HKD10,000,000",
                value: 5
              },
              {
                text: ">HKD10,000,000",
                value: 6
              }
            ]
          },
          {
            type: "select",
            label: "每年收入（港币）",
            value: "",
            options: [
              {
                text: "＜HKD100,000",
                value: 1
              },
              {
                text: "HKD100,000-HKD200,000",
                value: 2
              },
              {
                text: "HKD200,001-HKD500,000",
                value: 3
              },
              {
                text: "HKD500,001-HKD1,000,000",
                value: 4
              },
              {
                text: ">HKD1,000,000",
                value: 5
              }
            ]
          },
          {
            type: "inputCheckbox",
            label: "资金来源（可多选）",
            value: [],
            options: [
              {
                text: "薪金储蓄",
                value: 1
              },
              {
                text: "家庭",
                value: 2
              },
              {
                text: "营业盈利",
                value: 3
              },
              {
                text: "租金收入",
                value: 4
              },
              {
                text: "金融机构贷款",
                value: 5
              },
              {
                isChecked: false,
                inputValue: "",
                text: "其他",
                placeholder: "请填写其他资金来源",
                value: 6
              }
            ]
          },
          {
            type: "multiSelect",
            label: "住宅业权（按实际情况选择）",
            value: "",
            options: [
              {
                text: "拥有",
                value: 1,
                children: {
                  value: "",
                  options: [
                    {
                      value: 1,
                      label: "已抵押"
                    },
                    {
                      value: 2,
                      label: "未抵押"
                    }
                  ]
                }
              },
              {
                text: "没有",
                value: 2,
                children: {
                  value: "",
                  options: [
                    {
                      value: 1,
                      label: "租住"
                    },
                    {
                      value: 2,
                      label: "与家人同住"
                    }
                  ]
                }
              }
            ]
          }
        ] // U
      }
    },

    risk_disclosure: {
      nav_title: "风险披露",
      page_title: "请了解风险内容并确认",
      toast_fail_text: "请仔细阅读完风险披露",
      p1: "持牌代表",
      p2: "中央编号",
      p3: "X",
      p4: "普通话",
      p5: "粤语",
      p6: "英语",
      p7: "约",
      p8: "分",
      p9: "秒",
      p10: "请先播放完语音",
    },

    customer_payment: {
      nav_title: "客户常设授权",
      page_title: "常设授权通用条款（适用于所有账户）",
      company_info:[
        "香港尖沙咀港威大厦 6 座 31 樓 3102 室",
        "电话: (852) 2187 2100",
        "传真: (852) 2187 2107",
        "网址: www.goingf.hk"
      ],
      letter_title:"客户常设授权",
      customer_letter:[
        "致：高盈证券有限公司",
        "      香港尖沙咀港威大厦 6 座 31 樓 3102 室"
      ],
      // page_name:
      //   "本授权根据（证券及期货（客户款项）规则）涵盖贵公司为我/我们在香港持有或收取并存放于一个或多个独立账户内的款项（包括因持有并非属于贵公司的款项而产生之任何利息）（下称「款项」）。",
      // h: "我/我们授权贵公司：",
      p: [
        "除文义另有所指外，于本常设授权书内的任何名词，与《证券及期货条例》 、《证券及期货（客户款项）规则》及《证券及期货（客户证券）规则》不时修订之定义具有相同意思。",
        "按照由客户续期或根据客户款项规则或客户证券规则（视乎情况而定）当作已被续期所制约下，本常设授权书的有效期为十二（12）个月，自本常设授权书之签发日起计有效。",
        "本人／吾等明白本人／吾等可以以书面形式向高盈证券于上述所列明之地址发出通知，撤回本授权书。撤回本授权书之生效日期为高盈证券收到该通知后起计三十（30）天",
        "本人／吾等明白常设授权续期通知书将于常设授权届满前最少十四天寄予本人／吾等。如高盈证券于常设授权有效期届满前未有接获本人／吾等书面反对，则本人／吾等之常设授权会在届满时按照常设授权的条款及细则视作为同意续期十二个月。",
        "除非本常设授权书到期或于到期前被撤回（以较早者为准），否则本常设授权书保持有效。",
        "本人／吾等明白及同意，若本人／吾等的账户有任何不寻常或可疑活动，高盈证券有权冻结本人／吾等的账户并要求本人／吾等的账户提供更多资料。",
        "本人／吾等确认高盈证券已向其解释本常设授权书，本人／吾等完全明白本常设授权书的内容，并已经或有机会就其内容及效力寻求法律顾问的意见。",
        "本人／吾等明白，倘若中文版本与英文版本在解释或意义方面有任何歧义，应以英文版本为准。"
      ],
      timebtn: "我已清楚明白全部内容"
    },
    customer_payment_two: {
      nav_title: "客户常设授权",
      page_title: "证券及期货（客户款项）规则规定的常设授权",
      // page_name:
      //   "本授权根据（证券及期货（客户款项）规则）涵盖贵公司为我/我们在香港持有或收取并存放于一个或多个独立账户内的款项（包括因持有并非属于贵公司的款项而产生之任何利息）（下称「款项」）。",
      // h: "我/我们授权贵公司：",
      p: [
        "本常设授权是涵盖高盈证券为本人／吾等在香港以及海外收取或持有并存放于一个或多个独立账户内之款项（包括因持有并非属于高盈证券之款项而产生之任何利息）（下称“款项”）。本人兹授权高盈证券处理此等款项。",
        "就高盈证券为吾等在香港收取或持有的款项，本人／吾等进一步授权高盈证券：",
        "1.组合或合併高盈证券所维持的任何性质的任何或全部独立账户，此等组合或合併活动可以个别地或与其他账户联合进行，高盈证券可将该等独立账户内任何数额之款项作出转移，以解除吾等对高盈证券的义务或法律责任，不论此等义务和法律责任是确实或或然的、原有或附带的、有抵押或无抵押的、共同或分别的；及",
        "2.高盈证券可将款项的任何款额任何时间维持的独立账户之间转入转出以结清吾等对高盈证券负有的债务；及",
        "3.可将账户内的款项以高盈证券最终确定的汇率兑换成任何其他货币。",
        "就高盈证券为吾等在海外收取或持有的款项，本人／吾等进一步授权高盈证券：",
        "本常设授权书授权高盈证券不需事先通知或取得的确认及／或指示可酌情动用款项的全部或部份作买卖海外证券之用、符合交收或按金要求及或其他用途。高盈证券有权：",
        "将任何数额之款项支付／转往本人／吾等于高盈证券的账户及／或任何海外金融机构及／或结算公司的期货账户及其继承人及受让人以作本人／吾等买卖海外证券之用或符合交收或按金的要求（如适用）；及／或",
        "从高盈证券在香港或其他地方设立之一或多个独立账户及在任何海外金融机构及／或结算公司设立之独立账户或于该等账户之间来回调动；及／或",
        "订立外币兑换合约，适用于当日或之前为了购买海外期货合约之用或符合交收或按金的要求（如适用）而需要将资金转换为其他货币，此等兑换合约按高盈证券惯例并以市场汇率订立。外币兑换合约的内容（包括但不限于订约时间）由高盈证券全权决定。",
        "高盈证券可以不向本人／吾等发出通知而采取上述行动。",
        "本人／吾等明白本常设授权乃鑑于高盈证券同意开立及继续维持吾等的证券现金／融资交易账户及期货交易账户。",
        "本人／吾等明白本人／吾等的证券可能受制于第三者之权利，高盈证券可于全数抵偿该等权利后，方可将本人／吾等的证券退回给本人／吾等。",
        "本人／吾等确认，高盈证券在香港以外地方收取或持有的本人／吾等的资产，是受到有关海外司法管辖区的适用法律及规例所监管的。这些法律及规例与《证券及期货条例》（第 571 条）及根据该条例制订的规则可能有所不同。因此，有关资产有可能不会享有赋予本人／吾等在香港收取或持有的资产的相同保障。",
        "(本段只适用于证券融资账户) 当客户在本公司的个人及／或联名户口没有现金结馀时，若透过客户的个人及／或联名户口进行股票孖展贷款，提取资金以满足其他户口的按金或交收要求，客户将面对额外的风险与成本，包括市场风险、保证金交易风险等和需要承担额外的利息成本。"
      ],
      timebtn: "我已清楚明白全部内容"
    },

    customer_payment_three: {
      nav_title: "客户常设授权",
      page_title: "证券及期货（客户证券）规则规定的常设授权",
      p: [
        "本人／吾等确认本人／吾等完全明白本常设授权的内容，并且本人／吾等进一步确认本人／吾等授权高盈证券处理在高盈证券处即将开立" +
          "的证券融资账户中所有证券。本人／吾等确认本人／吾等授权高盈证券：",
        "1. 根据证券借贷协议，运用本人／吾等的任何证券或证券抵押品；",
        "2. 把本人／吾等的任何证券抵押品存放于任何认可财务机构，作为该机构向高盈证券提供财务通融的抵押品；",
        "3. 将本人／吾等的任何证券抵押品存放给香港中央结算有限公司（下称“香港结算”），用作履行及清偿本人／吾等的清算责任和债务。"+
        "本人／吾等明白香港结算因应高盈证券承担的义务对本人／吾等的证券设定第一固定押记；",
        "4. 将本人／吾等的任何证券抵押品存放给任何其他认可结算所或者其他有获发牌或获注册进行证券交易的中介人，作为解除高盈证券在交收上的法律责任的抵押品；以及",
        "5. 若高盈证券在证券交易过程中以及任何其它已经获发牌或已获注册的受规管活动过程中，向本人／吾等提供财务通融，可根据上述第（1）、（2）、（3）和／或（4）段所述调动或存放本人／吾等的任何证券抵押品。",
        "高盈证券可以不向本人／吾等发出通知而采取上述行动。",
        "本人／吾等明白本授权书不影响高盈证券为解除由本人／吾等对高盈证券或第三者所负的法律责任，而处置或促使高盈证券处置本人／吾等证券抵押品的权利。",
        "此赋予高盈证券之授权乃鉴于高盈证券同意继续维持本人／吾等之证券融资账户户口。"
      ],
      timebtn: "我已清楚明白全部内容"
    },

    risk_content: {
      h: "客户务须细阅此等风险披露声明",
      p: "",
      // h1: "A.期货及期权交易的风险",
      p1: [
        "客户务须细阅此等风险披露声明。此等声明为本协议及开户表格的组成部份。客户执行开户表格，即表示确认其已阅读并细阅其选择语言版本（英文或中文）的此等风险披露声明，并获邀阅读该声明、提出问题及在有此意愿的情况下征求独立的意见，以及确认其明白与账户有关的投资及交易可能产生的风险。",
        "此等风险披露声明没有亦不旨在披露与账户有关的所有投资及交易的一切风险及相关考虑因素。客户于全面了解所涉及的风险，并从客户本身的顾问取得客户认为适当的独立意见前，应避免作出任何投资或交易。本公司并非客户的财务顾问，亦不应被视作客户的财务顾问。"
      ],
      // h2: "B.关于期货及期权买卖的额外风险披露",
      p2: [
        // "客户确认本声明并不涵盖买卖期货及期权的所有风险及其他重要事宜。",
        // "就风险而言，客户在进行任何上述交易前，应先了解将订立的合约的性质（及有关的合约关系）和客户就此须承担的风险程度。",
        // "期货及期权买卖对很多公众投资者都并不适合，客户应就本身的投资经验、投资目标、财政资源及其他相关条件，小心衡量自己是否适合参与该等买卖。",
        // "期货",
        // "1.“杠杆”效应",
        // "期货交易的风险非常高。由于期货的开仓保证金的金额较期货合约本身的价值相对为低，因而能在期货交易中发挥“杠杆”作用。",
        // "市场轻微的波动也会对客户投入或将需要投入的资金造成大比例的影响。",
        // "所以，对客户来说，这种杠杆作用可说是利弊参半，因此客户可能会损失全部开仓保证金及为维持本身的仓盘而向有关商号存入的额外金额。",
        // "若果市况不利客户所持仓盘或保证金水平提高，客户会遭追收保证金，须在短时间内存入额外资金以维持本身仓盘。",
        // "假如客户未有在指定时间内缴付额外的资金，客户可能会被迫在亏蚀情况下平仓，而所有因此出现的短欠数额一概由客户承担。",
        // "2.减低风险交易指示或投资策略",
        // "使客户采用某些旨在预设亏损限额的交易指示（如“止蚀”或“止蚀限价”指示），也可能作用不大，因为市况可以令这些交易指示无法执行。",
        // "至于运用不同持仓组合的策略，如“跨期”和“马鞍式”等组合，所承担的风险也可能与持有最基本的“长”仓或“短”仓同的高。",
        // "期权",
        // "3.不同风险程度",
        // "期权交易的风险非常高。投资者不论是购入或出售期权，均应先了解其打算买卖的期权类别（即认沽期权或认购期权）以及相关的风险。",
        // "客户应计入期权金及所有交易成本，然后计算出期权价值必须增加多少才能获利。",
        // "购入期权的投资者可选择抵销或行使期权或任由期权到期。如果期权持有人选择行使期权，便必须进行现金交收或购入或交付相关的资产。",
        // "若购入的是期货产品的期权，期权持有人将获得期货仓盘，并附带相关的保证金责任（参阅上文“期货”一节）。",
        // "如所购入的期权在到期时已无任何价值，客户将损失所有投资金额，当中包括所有的期权金及交易费用。假如客户拟购入极价外期权，应注意客户可以从这类期权获利的机会极微。",
        // "出售",
        // " (“沽出”或“卖出”）期权承受的风险一般较买入期权高得多。卖方虽然能获得定额期权金，但亦可能会承受远高于该笔期权金的损失。倘若市况逆转，期权卖方便须投入额外保证金来补仓。",
        // "期权卖方还需承担买方可能会行使期权的风险，即期权卖方在期权买方行使时有责任以现金进行交收或买入或交付相关资产。",
        // "若卖出的是期货产品的期权，则期权卖方将获得期货仓盘及附带的保证金责任（参阅上文“期货”一节）。",
        // "若期权卖方持有相应数量的相关资产或期货或其他期权作“备兑”，则所承受的风险或会减少。假如有关期权并无任何“备兑”安排，亏损风险可以是无限大。",
        // "某些国家的交易所允许期权买方延迟支付期权金，令买方支付保证金费用的责任不超过期权金。",
        // "尽管如此，买方最终仍须承受损失期权金及交易费用的风险。在期权被行使又或到期时，买方有需要支付当时尚未缴付的期权金。",
        // "期货及期权其他常见风险",
        // "4.合约的条款及细则",
        // "客户应向替客户进行交易的商号查询所买卖的有关期货或期权合约的条款及细则，以及有关责任（例如在什么情况下客户或会有责任就期货合约的相关资产进行交收，或就期权而言，期权的到期日及行使时间限制）。",
        // "交易所或结算公司在某情况下，或会修改尚未行使的合约的细则（包括期权行使价），以反映合约的相关资产的变化。",
        // "5.暂停或限制交易及价格关系：",
        // "市场情况（例如市场流通量不足）及／或某些市场规则的施行（例如因价格限制或“停板”措施而暂停任何合约或合约月份的交易），都可以增加亏损风险，这是因为投资者届时将难以或无法执行交易或平掉／抵销仓盘。如果客户卖出期权后遇到这种情况，客户须承受的亏损风险可能会增加。",
        // "此外，相关资产与期货之间以及相关资产与期权之间的正常价格关系可能并不存在。例如，期货期权所涉及的期货合约须受价格限制所规限，但期权本身则不受其规限。",
        // "缺乏相关资产参考价格会导致投资者难以判断何谓“公平价格”。",
        // "6.存放的现金及财产",
        // "如果客户为在本地或海外进行的交易存放款项或其他财产，客户应了解清楚该等款项或财产会获得哪些保障，特别是在有关商号破产或无力偿债时的保障。",
        // "至于能追讨多少款项或财产一事，可能须受限于具体法例规定或当地的规则。在某些司法管辖区，收回的款项或财产如有不足之数，则可认定属于客户的财产将会如现金般按比例分配予客户。",
        // "7.佣金及其他收费",
        // "在开始交易之前，客户先要清楚了解必须缴付的所有佣金、费用或其他收费。这些费用将直接影响客户可获得的净利润（如有）或增加客户的亏损。",
        // "8.在其他司法管辖区进行交易",
        // "在其他司法管辖区的市场（包括与本地市场有正式连系的市场）进行交易，或会涉及额外的风险。",
        // "根据这些市场的规例，投资者享有的保障程度可能有所不同，甚或有所下降。在进行交易前，客户应先行查明有关客户将进行的该项交易的所有规则。",
        // "客户本身所在地的监管机构，将不能迫使客户已执行的交易所在地的所属司法管辖区的监管机构或市场执行有关的规则。",
        // "有鉴于此，在进行交易之前，客户应先向有关商号查询客户本身地区所属的司法管辖区及其他司法管辖区可提供哪种补救措施及有关详情。",
        // "9.货币风险",
        // "以外币计算的合约买卖所带来的利润或招致的亏损（不论交易是否在客户本身所在的司法管辖区或其他地区进行），均会在需要将合约的单位货币兑换成另一种货币时受到汇率波动的影响。",
        // "10.交易设施",
        // "电子交易的设施是以电脑组成系统来进行交易指示传递、执行、配对、登记或交易结算。",
        // "然而，所有设施及系统均有可能会暂时中断或失灵，而客户就此所能获得的赔偿或会受制于系统供应商、市场、结算公司及／或参与者商号就其所承担的责任所施加的限制。由于这些责任限制可以各有不同，客户应向为客户进行交易的商号查询这方面的详情。",
        // "11.电子交易",
        // "透过某个电子交易系统进行买卖，可能会与透过其他电子交易系统进行买卖有所不同。如果客户透过某个电子交易系统进行买卖，便须承受该系统带来的风险，包括有关系统硬件或软件可能会失灵的风险。",
        // "系统失灵可能会导致客户的交易指示不能根据指示执行，甚或完全不获执行。",
        // "12.场外交易",
        // "某些司法管辖区，及只有在特定情况之下，有关商号获准进行场外交易。为客户进行交易的商号可能是客户所进行的买卖的交易对手方。",
        // "在这种情况下，有可能难以或根本无法平掉既有仓盘、评估价值、厘定公平价格又或评估风险。因此，这些交易或会涉及更大的风险。",
        // "此外，场外交易的监管或会比较宽松，又或需遵照不同的监管制度；因此，客户在进行该等交易前，应先了解适用的规则和有关的风险。",
        // "C.在香港以外地方收取或持有的客户资产的风险",
        // "持牌人或注册人在香港以外地方收取或持有的客户资产，是受到有关海外司法管辖区的适用法律及规例所监管的。这些法律及规例与《证券及期货条例》（第571章）及根据该条例制订的规则可能有所不同。",
        // "因此，有关客户资产将可能不会享有赋予在香港收取或持有的客户资产的相同保障。",
        // "D.提供代存邮件或将邮件转交第三方的授权书的风险",
        // "假如客户向持牌人或注册人提供授权书，允许他人代存邮件或将邮件转交予第三方，那么客户便须尽速亲身收取所有关于客户账户的成交单据及结单，并加以详细阅读，以确保可及时侦察到任何差异或错误。",
        // "E.免责声明",
        // "1.期交所免责声明",
        // "作为在期交所买卖合约基准之股份指数及其他专利产品可由期交所不时发展。期交所台湾指数期货为期交所发展之首个该等股份指数。可由期交所不时发展之期交所台湾指数及该等其他指数或专利产品（「期交所指数」）为期交所之财产。",
        // "编制及计算各期交所指数之程序属期交所之独家财产及专利品。",
        // "编制及计算期交所指数之程序及基准可在毋须通知之情况下由期交所随时作出变动或更改，而期交所亦可随时要求以期交所可能指定之任何期交所指数为基准之该等期货或期权合约在买卖及结算时参考一项将会计算之替代指数。",
        // "期交所概无就任何期交所指数或其编制及计算或任何有关资料之准确性或完整性而向任何会员或任何第三者作出保证或声明或担保，亦无就与任何期交所指数相关之任何事宜作出或暗示任何该等保证或声明或任何类型之担保。",
        // "此外，期交所亦不会就任何期交所指数之使用或其委任以编制及计算任何期交所指数之任何一名或多名人士在编制及计算任何期交所指数时出现之不确、遗漏、错误、出错、延误、中断、暂停、变动或不足（包括但不限于因疏忽引致之事宜）或任何会员或任何第三者因买卖以任何期交所指数为基准之期货及期权合约而直接或间接导致之任何经济或其他损失承担任何责任或债务。",
        // "任何会员或任何第三者概不得就与本免责声明所述有关或因而产生之事宜向期交所提出索偿、法律行动或法律诉讼。任何参与买卖以任何期交所指数为基准之期货及期权合约之会员或任何第三者均完全明了本免责声明，并不会就该等交易对期交所作出任何依赖。",
        // "2.股份指数期货及期权",
        // "恒指服务有限公司（「恒指服务」）现时刊印、编制及计算多项股市指数，及可在恒生数据服务有限公司（「恒生数据」）不时要求下，刊印、编制及计算该等额外股市指数（合称「恒生指数」）。",
        // "恒生指数各自之标记、名称及编制及计算方法为恒生数据之独家财产及专利品。",
        // "恒指服务经以许可证之形式，允许期交所使用恒生指数及恒生指数四类分类指数、恒生中资企业指数及恒生中国企业指数，纯粹分别用作设立、推广及买卖以该等指数为基准之期权合约及期货合约以及可不时允许期交所相应使用任何其他恒生指数用作以该等其恒生指数期权合约及期货合约（合称「合约」）之基准。",
        // "编制及计算任何恒生指数之程序及基准及任何有关公式或各项公式、成份股及系数可在无须通知之情况下由恒指服务不时作出变动或更改，而期交所可不时要求期交所可能指定之该等合约之买卖及结算参考一项或多项将会计算之替代指数进行。",
        // "期交所或恒生数据或恒指服务概无就恒生指数或任何恒生指数及其编制及计算或其任何有关资料之正确性或完整性而给予任何会员或任何第三者保证或声明或担保，亦无就有关恒生指数或任何恒生指数给予或暗示任何该等保证或声明或任何类型之担保。",
        // "此外，期交所、恒生数据或恒指服务亦不会就有关合约或任何合约及／或买卖合约而使用恒生指数或任何恒生指数，或恒指服务编制及计算恒生指数或任何恒生指数之不正确、遗漏、错误、出错、延误、中断、暂停、变动或不足（包括但不限于因疏忽引致之事宜）或任何会员或任何第三者因买卖合约或任何合约而直接或间接导致之任何经济或其他损失承担任何责任或债务。",
        // "任何会员或任何第三者概不得就本免责声明所述所产生之事宜向期交所及／或恒生数据及／或恒指服务提出索偿、法律行动或法律诉讼。任何买卖合约之会员或任何第三者均完全明了本免责声明，并不会对期交所、恒生数据、及／或恒指服务作出任何依赖。"

        "1 证券交易的风险",
        "投资附带风险，过往业绩并非未来表现的指标。证券价格有时可能会非常波动。证券价格可升可跌，甚至变成毫无价值。买卖证券未必一定能够赚取利润，反而可能会招致损失。",
        "2 期货及期权交易的风险",
        "2.1 买卖期货合约或期权的亏蚀风险可以极大。在若干情况下，客户所蒙受的亏蚀可能会超过最初存入的保证金数额。",
        "2.2 即使客户设定了备用指示，例如“止蚀”或“限价”等指示，亦未必能够避免损失。市场情况可能使该等指示无法执行。",
        "2.3 客户可能会在短时间内被要求存入额外的保证金。假如未能在指定的时间内提供所需数额，客户的未平仓合约可能会被平仓。然而，客户仍然要客户的账户内任何因此而出现的短欠数额负责。",
        "2.4 因此，客户在买卖前应研究及理解期货合约及期权，以及根据本身的财政状况及投资目标，仔细考虑这种买卖是否适合自己。",
        "2.5 如果客户买卖期权，便应熟悉行使期权及期权到期时的程序，以及客户在行使期权及期权到期时的权利与责任。",
        "2.6 期权涉及高风险，未必适合所有投资者。投资者应确保在参与期权市场之前了解这些风险。",
        "2.7 有些期权在到期日方可行使（欧式期权的行使），其他期权可于到期前的任何时间行使（美式期权的行使）。有些期权在行使时须以正股交收，而其他期权在行使时则须支付现金。",
        "2.8 客户知悉期权乃损耗性资产，期权持有人可能会损失该期权的全部期权金。作为期权持有人，如欲赚取利润，必须行使期权或在市场将期权长仓平仓。在某些情况下，因市场流通量不足，买卖期权会出现困难。",
        "2.9 作为期权沽出人，客户随时可能要缴付额外的按金。期权沽出人与期权持有人不同，正股价的起跌可令沽出人蒙受无限损失，而期权金乃沽出人的唯一回报。",
        "2.10 此外，美式认购（认沽）期权的沽出人可能需要在到期前的任何时候交收正股或支付现金代价，该价格为行使价乘以正股数目的积，上述责任可能与沽出期权所收到的期权金的价值完全不成比例，而有关的通知期亦可能甚短。",
        "3 买卖创业板股份的风险",
        "3.1 创业板股份涉及很高的投资风险。尤其是该等公司可在无需具备盈利往绩及无需预测未来盈利的情况下在创业板上市。创业板股份可能非常波动及流通性很低。",
        "3.2 客户只应在审慎及仔细考虑后，才作出有关的投资决定。创业板市场的较高风险性质及其他特点，意味著这个市场较适合专业及其他熟悉投资技巧的投资者。",
        "3.3 现时有关创业板股份的资料只可以在香港联合交易所有限公司所操作的互联网网站上找到。创业板上市公司一般毋须在宪报指定的报章刊登付费公告。",
        "3.4 假如客户对本风险披露声明的内容或创业板市场的性质及在创业板买卖的股份所涉风险有不明白之处，应寻求独立的专业意见。",
        "4 在香港以外地方收取或持有的客户资产的风险",
        "4.1 本公司在香港以外地方收取或持有的客户资产，是受到有关海外司法管辖区的适用法律及规例所监管的。这些法律及规例与《证券及期货条例》（第 571 章）及根据该条例制订的规则可能有所不同。",
        "4.2 因此，有关客户资产将可能不会享有赋予在香港收取或持有的客户资产的相同保障。",
        "5 在香港联合交易所有限公司买卖纳斯达克–美国证券交易所证券的风险",
        "5.1 按照纳斯达克–美国证券交易所试验计划（“试验计划”）挂牌买卖的证券是为熟悉投资技巧的投资者而设的。客户在买卖该项试验计划的证券之前，应先谘询本公司的意见和熟悉该项试验计划。客户应知悉，按照该项试验计划挂牌买卖的证券并非以香港联合交易所有限公司的主板或创业板作第一或第二上市的证券类别加以监管。",
        "6 使用网上交易协议下之电子服务的风险",
        "6.1 如果客户透过电子服务进行买卖，客户便须承受该电子服务系统带来的风险，包括有关系统硬体和软件可能会失灵的风险。系统失灵可能会导致客户的买卖盘不能根据指示执行，甚或完全不获执行。",
        "6.2 由于未可预计的流量挤塞和其他原因，电子服务可能并不可靠的，及存在通过电子服务进行的交易在传输和接收客户的指示或其他资讯过程中可能会被耽误、延迟执行客户的指示或有关指示以有别于客户发出指示时的市价执行、指示在传输时被中断或停顿等风险。",
        "6.3 在通讯过程中也存在误解或错误的风险，以及在发出了指示后，通常也不一定可以取消。由于此类中断、耽误或被第三方入侵而使客户遭受的任何损失，本公司概不承担责任。如果客户不准备接受此类中断或耽误引致的风险，客户不应透过电子服务来"+
        "作出任何指示。",
        "6.4 通过电子服务向客户提供的市场数据和其他资讯可能是本公司从第三者获得的。虽然本公司相信这些数据和资讯是可靠的，但本公司或该等第三者都不会保证这些数据和资讯的准确性、完整性和即时性。",
        "7 保证金买卖的风险",
        "7.1 藉存放抵押品而为交易取得融资的亏损风险可能极大。客户所蒙受的亏蚀可能会超过客户存放于本公司作为抵押品的现金及任何其他资产。",
        "7.2 市场情况可能使备用交易指示，例如“止蚀”或“限价”指示无法执行。",
        "7.3 客户可能会在短时间内被要求存入额外的保证金款额或缴付利息。假如客户未能在指定的时间内支付所需的保证金款额或利息，客户的抵押品可能会在未经客户的同意下被出售。",
        "7.4 客户应密切留意账户状况，在市场波动下，本公司未必能联络客户或提供足够时间予客户存钱，而客户的持仓将有可能被强制平仓。此外，客户将要为客户的账户内因此而出现的任何短欠数额及需缴付的利息负责。",
        "7.5 因此，客户应根据本身的财政状况及投资目标，仔细考虑这种融资安排是否适合客户。",
        "8 提供将客户的证券抵押品等再质押的授权书的风险",
        "8.1 本公司提供授权书，容许其按照某份证券借贷协议书使用客户的证券或证券抵押品、将客户的证券抵押品再质押以取得财务通融，或将客户的证券抵押品存放为用以履行及清偿其交收责任及债务的抵押品，存在一定风险。",
        "8.2 假如客户的证券或抵押品是由本公司收取或持有的，则上述安排仅限于客户已就此给予书面同意的情况下方行有效。此外，除非客户是专业投资者，客户的授权书必须指明有效期，该段有效期不得超逾 12 个月。若客户是专业投资者，则有关限制并不适用。",
        "8.3 此外，假如本公司在有关授权的期限届满前最少 14 日向客户发出有关授权将被视为已续期的提示，而客户对于在有关授权的期限届满前以此方式将该授权延续不表示反对，则客户的授权将会在没有客户的书面同意下被视为已续期。",
        "8.4 现时并无任何法例规定客户必须签署这些授权书。然而，本公司可能需要授权书，以便例如向客户提供保证金贷款或获准将客户的证券或证券抵押品借出予第三方或作为抵押品存放于第三方。本公司应向客户解释将为何种目的而使用授权书。",
        "8.5 倘若客户签署授权书，而客户的证券或证券抵押品已借出予或存放予第三方，该等第三方将对客户的证券或证券抵押品具有留置权或作出押记。虽然本公司根据客户的授权书而借出或存放属于客户的证券或证券抵押品须对客户负责，但若本公司的违责" +
          "行为可能会导致客户损失客户的证券或证券抵押品。",
        "8.6 本公司提供不涉及证券借贷的证券现金账户。假如客户毋需使用保证金贷款，或不希望本身证券或证券抵押品被借出或遭抵押，则切勿签署上述的授权书，并应要求开立该等证券现金账户。",
        "9 提供代存邮件或将邮件转交第三方的授权书的风险",
        "假如你向本公司提供授权书，允许本公司代存邮件或将邮件转交予第三方，那麽你便须尽速亲身收取所有关于你账户的成交单据及结单，并加以详细阅读，以确保可及时侦察到任何差异或错误。",
        "10 关于境外证券买卖，包括在中国内地上市股票的风险",
        "10.1 客户在进行任何境外证券交易前，应先了解将境外证券交易的性质和客户就此须承担的风险程度。",
        "10.2 尤其是，尽管本公司是联交所的交易所参与者，但境外证券买卖不受联交所监管，也不受投资者赔偿基金保护。",
        "10.3 客户应就本身的投资经验、投资目标、财政资源及其他相关条件，小心衡量自己是否适合参与该等买卖。假如客户存有疑问，应寻求独立的专业意见。",
        "11 外币交易的风险",
        "11.1 以外币计算产品的买卖所带来的利润或招致的亏损（不论交易是否在客户本身所在的司法管辖区或其他司法管辖区进行），均会在需要将产品的单位货币兑换成另一种货币时受到汇率波动的影响。",
        "11.2 客户明白若所买卖结构性产品的相关资产并非以港币为单位，其尚要面对外汇风险。货币兑换率的波动可对相关资产的价值造成负面影响，连带影响结构性产品的价格。",
        '12 交易所交易票据（"ETNs"）的风险',
        "12.1 ETN 是一种由承销银行发行的无担保、非次级债务证券，旨在为投资者提供各个市场基准的回报。ETN 的回报通常与一个市场基准或策略的表现挂鈎，并扣除适用的费用。与其他债务证券类似，ETN 有到期日，且仅以发行人信用作为支持。",
        "12.2 客户可以透过交易所买卖 ETN 或于预定到期日收取现金付款，或视乎基准指数的表现有机会直接向发行人提早赎回 ETN（须扣除适用的费用）。然而，客户于赎回时可能受 ETN 的提早赎回条件限制，例如最少赎回数量。",
        "12.3 本公司并不保证客户于到期日或发行人提早回购时可收回投资本金或任何投资回报。对于 ETN，正面表现的月份或无法抵销其中某些极不利之月度表现。",
        "12.4 ETN 发行人有权随时按回购价值赎回 ETN。",
        "12.5 若于任何时候 ETN 的回购价值为零，客户的投资则变得毫无价值。ETN 可能流通性不足，不能保证客户可随时按其意愿，以目标价格买卖。",
        "12.6 尽管 ETF 与 ETN 均有追踪基准指数的特性，但 ETN 属于债务证券，并不实际拥有其追踪的任何资产，拥有的仅是发行人向投资者分配理论上存在的基准指数所反映的回报之承诺。ETN 对投资组合的多元化程度有限，投资者须受集中于特定指数及指数成份的集中性风险。鉴于 ETN 属无抵押品的债务工具，若 ETN 发行商发生违约或破产，最大潜在损失可能是投资额的百分之一百及无法获得任何利润。",
        "12.7 即使受追踪的相关指数没有变化，发行人信用评级降级亦会导致 ETN 的价值下跌。因此，买卖 ETN 的客户直接面临发行人的信用风险，且在发行人宣布破产的情况下仅拥有无担保的破产索偿权。",
        "12.8 本金金额须扣除定期收纳的投资者费用或任何适用的费用，该等费用会对回报产生不利影响。",
        "12.9 个别 ETN 可能会采用杠杆，而 ETN 的价值会因应其对于相关资产的杠杆比率而迅速变化。客户应注意 ETN 的价值可能会跌至零，客户可能损失所有的投资本金。",
        "13 违约风险及交易对手风险",
        "13.1 所有产品都具有违约风险及/或交易对手风险。违约风险是指发行商未能根据协定缴付。遇上经济不景，发行商未必能成功借贷继续经营或偿还旧债。信贷评级是评估结构性产品违约风险最常用的工具。信贷评级代表信贷评级机构于某一持定时间内的意见，而信贷评级往往会因应发行商的财政状况或市场情况的改变而作出调整。",
        "13.2 交易对手风险指交易方无力履行其财务合约责任，虽然信贷评级的评级有一定的可靠性，客户除了要参考发行商的信贷评级外，更要仔细留意产品的结构本身是否涉及衍生工具，以免招致损失。",
        "14 集体投资计划的风险",
        "14.1 集体投资计划可广泛地（最多 100%）投资于金融衍生工具，定息证券及/或结构性产品（包括但不限于信用违约掉期、次等投资级别债务、按揭抵押证券及其他资产抵押证券）、并涉及不同的风险（包括但不限于交易对手风险、流通性风险、信用风险及市场风险）。",
        "14.2 集体投资计划可能使用衍生工具的交易策略可能招致损失的部份原因包括但不限于：市场状况动盪、衍生工具与取决其价格的证券走势关连性不完美、市场缺乏流动性，以及交易对手方的违责风险。",
        "15 衍生产品和结构性产品交易的一般风险",
        "15.1 发行商失责风险：倘若结构性产品发行商破产而未能履行其对所发行证券的责任，客户只被视为无抵押债权人，对发行商任何资产均无优先索偿权。因此，客户须特别留意结构性产品发行商的财力及信用。",
        "15.2 非抵押产品风险：非抵押结构性产品并没有资产担保。倘若发行商破产，客户可以损失其全数投资。客户须细阅上市文件以确定产品是否属非抵押性质，及该产品是否适合自己。",
        "15.3 杠杆风险：衍生权证及牛熊证均是杠杆产品，其价值可按相对相关资产的杠杆比率而快速改变。客户须留意，衍生权证及牛熊证的价值可以跌至零，届时当初投资的资金将会尽失。",
        "15.4 有效期的考虑：结构性产品设有到期日，到期后的产品即一文不值。客户须留意产品的到期时间，确保所选产品尚馀的有效期能配合其交易策略。",
        "15.5 特殊价格移动：结构性产品的价格或会因为外来因素（如市场供求）而有别于其理论价，因此实际成交价可以高过亦可以低过理论价。",
        "15.6 流通量风险：联交所规定所有结构性产品发行商要为每一隻个别产品委任一名流通量提供者。流通量提供者的职责在为产品提供两边开盘方便买卖。若有流通量提供者失责或停止履行职责，有关产品的客户或就不能进行买卖，直至有新的流通量提供者委任出来止。",
        "16 买卖衍生权证的特定风险",
        "16.1 时间损耗风险：假若其他情况不变，衍生权证愈接近到期日，价值会愈低，因此不能视为长线投资。",
        "16.2 波幅风险：衍生权证的价格可随相关资产价格的引申波幅而升跌，客户须注意相关资产的波幅。",
        "16.3 非长期有效：与股票不同，衍生权证有到期日，并非长期有效。衍生权证到期时如非价内权证，则不会有价值。",
        "16.4 成交额：衍生权证成交额高不应被认作为其价值会上升。除了市场力量外，衍生权证的价值还受其它因素影响，包括相关资产价格及波幅、剩馀到期时间、利率及预期股息。",
        "17 买卖牛熊证的特定风险",
        "17.1 强制收回风险：客户买卖牛熊证，须留意牛熊证可以即日“取消”或强制收回的特色。若牛熊证的相关资产值等同上市文件所述的强制收回价/水平，牛熊证即停止买卖。届时，客户只能收回已停止买卖的牛熊证由产品发行商按上市文件所述计算出来的剩馀价值（注意：剩馀价值可以是零）。",
        "17.2 融资成本：牛熊证的发行价已包括融资成本。融资成本会随牛熊证接近到期日而逐渐减少。牛熊证的年期愈长，总融资成本愈高。若一天牛熊证被收回，客户即损失牛熊证整个有效期的融资成本。融资成本的计算程式载于牛熊证的上市文件。",
        "17.3 限定的有效期：牛熊证有一固定有效期，并于指定日期到期。有效期可以是 3 个月至 5 年不等。若在到期前遭提早收回牛熊证的有效期将变得更短。期间牛熊证的价值会随著相关资产价格的变动而波动，于到期后或遭提早收回后更可能会变得没有价值。",
        "17.4 相关资产的走势：牛熊证的价格变动虽然趋向紧贴相关资产的价格变动，但在某些情况下未必与相关资产价格的变动同步（即对冲值不一定等于 1）。牛熊证的价格受多个因素所影响，包括其本身的供求、财务费用及距离到期的时限。此外，个别牛熊证的对冲值亦不会经常接近 1，特别是当相关资产的价格接近收回价时。",
        "17.5 接近收回价时的交易：相关资产价格接近收回价时，牛熊证的价格可能会变得更加波动，买卖差价可能会较阔，流通量亦可能较低。牛熊证随时会被收回而交易终止。由于任何在强制收回事件后始执行的交易将不被承认并会被取消，而强制收回事件发生的时间与牛熊证停止买卖之间可能有时差，一些在强制收回事件发生后才达成的交易即使已被证券商确认最后亦会被取消，因此客户买卖接近收回价的牛熊证时需额外小心。",
        "17.6 海外资产发行的牛熊证：若属海外资产发行的牛熊证，强制收回事件可能会于香港交易所交易时段以外的时间发生。",
        "18 交易所买卖基金的特定风险",
        "18.1 市场风险：交易所买卖基金主要为追踪某些指数、行业/领域又或资产组别（如股票、债券或商品）的表现。交易所买卖基金经理可用不同策略达至目标，但通常也不能在跌市中酌情採取防守策略。客户必须要有因为相关指数/资产的波动而蒙受损失的准备。",
        "18.2 追踪误差：这是指交易所买卖基金的表现与相关指数/资产的表现脱节，原因可以来自交易所买卖基金的交易费及其他费用、相关指数/资产改变组合、交易所买卖基金经理的复制策略等等因素。（常见的复制策略包括完全复制/选具代表性样本以及综合复制。）",
        "18.3 以折让或溢价交易：交易所买卖基金的价格可能会高于或低于其资产净值，当中主要是供求因素的问题，在市场大幅波动兼变化不定期间尤其多见，专门追踪一些对直接投资设限的市场/行业的交易所买卖基金亦可能会有此情况。",
        "18.4 流通量风险：证券庄家是负责提供流通量、方便买卖交易所买卖基金的交易所参与者。尽管交易所买卖基金多有一个或以上的证券庄家，但若有证券庄家失责或停止履行职责，客户或就不能进行买卖。",
        "18.5 由衍生工具构成的 ETF 风险：",
        '(a) 交易所买卖基金（"ETF"）可投资于衍生工具。由衍生工具构成的 ETF 可投资于 CAAP、指数期货合约及其他金融衍生工具。',
        "(b) 投资于金融衍生工具不等同直接投资于组成基础指数之相关资产。",
        "(c) 金融衍生工具乃一种合约。由衍生工具构成的 ETF 及其交易对手（即与由衍生工具构成的 ETF 达成协议之人士）根据衍" +
          "生工具合约之条款同意在合约中列明之特定情况下或发生特定事件时向对方支付若干款项。金融衍生工具之价值视乎或来自或参考相关资产之价值（例如证券或指数）而定。",
        "(d) 若干金融衍生工具可能产生杠杆效应，令由衍生工具构成的 ETF 承受更大风险及增加其成本。金融衍生工具或会较容易" +
          "受到影响有关投资价值之因素所影响。因此，金融衍生工具价格变化幅度甚大，并偶尔会出现急速之大幅价格变动。故此，金融衍生工具出现相对较为轻微之价格变动，有可能即时导致由衍生工具构成的 ETF 蒙受重大损失（或收益）。与只" +
          "投资传统证券相比，由衍生工具构成的 ETF 可能会因投资金融衍生工具而蒙受大于或可能相等于金融衍生工具全部价值的损失。",
        "(e) 此外，不少金融衍生工具均不在证券交易所买卖，这意味著由衍生工具构成的 ETF 较难出售其金融衍生工具投资以筹措现金及╱或已变现收益或损失或对该等金融衍生工具进行准确估值。出售或购买不在证券交易所买卖之金融衍生工具均须私下协商，且一般并非由中央结算机构担保、每日盯市、结算及隔离账户审查机制、中介机构最低资本规定或政府机关" +
          "监管，亦可能较难找到自愿之买方╱卖方，原因是并无监管规定要求市场作价者确保该等金融衍生工具有持续市场。",
        "18.6 衍生工具之交易对手风险：如有关衍生工具风险一节所述，金融衍生工具乃一种合约。根据多份金融衍生工具合约将予支付之款项并非通过中央结算机构支付，亦非获中央结算机构作担保。因此，由衍生工具构成的 ETF 因投资金融衍生工具而须承受其交易对手不愿或未能根据合约履行付款（及其他）责任之风险。倘金融衍生工具之交易对手涉及任何无力偿还债务事件，金融衍生工具之价值或会大幅下跌，甚至不具任何价值，由衍生工具构成的 ETF 或迟迟无法收回款项，原因是投资于金融衍生工具不等同直接投资于组成基础指数之相关资产。",
        "18.7 期货买卖风险：期货乃高度杠杆化，意指期货合约价格的较小变动或会导致高于实缴保证金比例的利润或损失，及或会导致超过预缴任何保证金数额的不可估量的进一步损失。不少期货合约买卖须遵守每日价格波动限制，即禁止于特定日期按基于上一日收市价的规定价格范围以外之价格进行期货交易。这或会产生流动性风险，原因是管理人于不断变动的市场变现期货持仓或会成本高昂或行不通。",
        "18.8 “CAAP”指以美元为单位之中国 A 股连接产品，即为（a）基础指数所挂鈎或不挂鈎之 A 股；或（b）基础指数，挂鈎之金融衍生工具（例如认股权证、票据或参与证明）。",
        "19 杠杆及反向产品的主要风险",
        "19.1 投资风险：买卖杠杆及反向产品涉及投资风险及并非为所有投资者而设。不保证可取回投资本金。",
        "19.2 波动风险：杠杆及反向产品涉及使用杠杆和重新平衡活动，因而其价格可能会比传统的交易所买卖基金（ETF）更波动。",
        "19.3 不同于传统的 ETF：杠杆及反向产品与传统的 ETF 不同，具有不同的特性及风险。",
        "19.4 长线持有的风险：杠杆及反向产品并非为持有超过重新平衡活动的间距，一般为一天而设。在每日重新平衡及复合效应下，有关产品超过一天的表现会从幅度或方向上偏离相关指数同期的杠杆或相反表现。在市况波动时有关偏离会更明显。随著一段时" +
          "间受到每日重新平衡活动、相关指数波动，以及复合效应对每日回报的影响，可能会出现相关指数上升或表现平稳，但杠杆产" +
          "品却录得亏损。同样地亦有可能会出现相关指数下跌或表现平稳，但反向产品却录得亏损。",
        "19.5 重新平衡活动的风险：杠杆及反向产品不保证每天都可以重新平衡其投资组合，以实现其投资目标。市场中断、规管限制或市场异常波动可能会对产品的重新平衡活动造成不利影响。",
        "19.6 即日投资风险：杠杆及反向产品的杠杆倍数会随交易日市场走势而改变，但直至交易日完结都不会重新平衡。因此杠杆及反向产品于交易日内的回报有可能会多于或少于相关指数的杠杆或相反回报。",
        "19.7 重整组合的风险：相对传统的 ETF，每日重新平衡活动会令杠杆及反向产品的投资交易次数较频密，因而增加经纪佣金和其他买卖开支。",
        "19.8 关联风险：费用、开支、交易成本及使用衍生工具的成本，可令有关产品的单日表现，与相关指数的单日杠杆/反向表现的关联度下降。",
        "19.9 终止运作风险：如所有证券庄家均辞任，杠杆及反向产品必须终止运作。杠杆及反向产品必须在最后一名证券庄家辞任生效时同时终止运作。",
        "19.10 杠杆风险（仅适用于杠杆产品）：在杠杆效应下，当相关指数变动，或者当相关指数的计价货币不同于有关杠杆产品的基准货币，而有关货币的汇价出现波动时，会令杠杆产品的盈利和亏损倍增。",
        "19.11 有别于传统的回报模式（仅适用于反向产品）：反向产品旨在提供与相关指数相反的单日回报。如果有关指数长时间上升，或者当相关指数的计价货币不同于有关反向产品的基准货币，而该计价货币的汇价长时间上升时，反向产品可能会损失大部分或所有价值。",
        "19.12 反向产品与沽空（仅适用于反向产品）：投资反向产品并不等同于建立短仓。因为涉及重新平衡活动，反向产品的表现可能会偏离短仓表现，特别是当市况波动和走势经常摇摆不定的时候。",
        "20 供股权证的风险",
        "20.1 供股权证是公司向现有股东一次性发行股份，让他们有机会通过在未来的某个日期以折扣价购买额外的新股，来维持所有权的原有比例不被稀释。",
        "20.2 直至购买新股的日期为止，客户可以按照与普通股交易的方式进行供股权证交易。如果客户不打算行使认购权，可以在公开市场上出售。",
        "20.3 认购权一旦行使，便不能再次使用。如果客户在这段时间内不行使认购权，认购权将会失效。",
        "20.4 面对有折扣提供的股票很容易受到诱惑，但客户不应假设这是买平货，而是应先了解资金筹集的背后原因，才作出明智的决定。",
        "20.5 一家公司可能会使用供股来弥补债务，特别是当他们无法从其他来源借钱时。客户应留意管理层有否透露任何潜在的问题。",
        "20.6 如果客户决定不行使新股认购权，则由于所发行股份数量的增加，客户所持有公司的总股权将被摊薄。",
        "20.7 如果客户在指定的时间范围内不参与供股，客户的未缴款供股权将会失效。公司将在扣除报价和费用后，出售这些权利并分配任何净收益。如果有的话，过期收益的金额将不会通知投资者，直到报价关闭。因此不能保证客户不会失去收益。",
        "20.8 由供股权证所产生的投资和收益的价值可能会下降，客户可能会收回比原本投资更少的资金。",
        "21 买卖与股票挂钓的工具（“ELI”）的风险",
        "21.1 如客户指示本公司用该户口买卖与股票挂钓的工具，客户确认 ELI 并不保本，而如 ELI 的参考资产的价格与客户的看法不同，则客户可蒙受损失。",
        "21.2 在极端的情况下，客户可损失全部投资。在若干情况下的损失风险甚大，除非客户明白正在进行的买卖的性质以及所须承担的风险，否则不应买卖该等工具。客户并须因应本身的环境及财政状况，审慎考虑究竟有关买卖是否适合。",
        "21.3 客户明白虽然大部分 ELI 一般较普通定期存款或债券的利息为高，但客户的 ELI 的潜在收益可以发行人指定的预先釐定的水平为上限。",
        "21.4 在投资期间内，客户于参考资产并无权利。该／该等参考资产的市价变动未必会导致 ELI 的市价及／或潜在回报有相应的变动。",
        "21.5 客户完全明白投资 ELI 令客户承受股权风险。客户承受正股及股市价格波动，以及股息、企业行动及对手方风险的影响。倘相关工具的价格跌至低于转换价，客户将接纳法律责任，以预先议定的转换价购入相关工具，而非收取与 ELI 的本金。因此，倘ELI 的价值低于客户原本的投资，则客户将收到一项价值下跌的工具，而倘相关工具变得毫无价值，则更可能会失去全部本金或存款。ELI 并非以任何资产或抵押品担保。",
        "21.6 客户完全明白当购买 ELI 时，客户倚赖发行商的信用可靠性。如发行商违约或资不抵债，则不论参考资产的表现，客户将须倚赖客户的分销商代表客户採取行动，以发行商无抵押的债权人身份提出索偿。",
        "21.7 发行商可为其 ELI 提供有限度的庄家安排。但是，如客户尝试于发行商提供的庄家安排下在到期前终止 ELI，则客户可收取一笔大幅低于客户原本的投资金额的款项。与股票挂钓的工具或会“不能转让”，客户或许无法将有关工具平仓或变现。ELI 的发行商亦可担当不同角色，如 ELI 的安排行、市场代理及计算代理。ELI 的发行商、其子公司及联营公司担当不同角色亦可引致利益衝突。",
        "21.8 客户应注意，正股的任何派息可影响其价格，而由于除息定价，可影响 ELI 到期时的回报。客户亦应注意，发行商可因正股的企业行动而对 ELI 作出调整。",
        "21.9 潜在孳息率：客户应就买卖 ELI 相关的费用及开支以及到期时的付款／交付谘询客户的经纪。港交所发佈的潜在孳息率并无将费用及开支计算在内。",
        "22 期货 ETF 涉及的特定风险",
        "22.1 期货合约转仓风险：期货合约是透过期货交易所订立的具约束力协议，于未来的特定时间买卖相关资产。“转仓”是指，当现有期货合约即将到期，以代表同一相关资产但到期日较后的期货合约取代。当期货合约转仓（即卖出近期的期货合约，再买入较长期的期货合约）时，如较长期的期货合约的价格高于即将到期的现有期货合约价格，转仓可能会导致亏损（即负转仓收益“negativerollyield”）。在此情况下，出售近期期货合约所得的收益，并不足以购买相同数量而到期日较后的期货合约，因后者的价格较高，这会对期货 ETF 的资产净值有不利影响。",
        "22.2 持有期货合约数量的法定限制风险：在获认可交易所上市的期货合约受限于法定持仓限制，不能持有多于某一特定数量之期货合约。若期货 ETF 的期货合约持仓已增加至接近有关上限，则可能因无法购买更多期货合约而未能新增 ETF 单位，此情况可能令上市的 ETF 单位的交易价格偏离于其资产净值。",
        "23 人民币计价证券之风险",
        "23.1 人民币不能自由兑换。人民币与外币（包括港元）之间的转换，是受中国的监管限制，并会影响以人民币计价证券的流动性。",
        "23.2 人民币计价的证券可能没有定期交易或活跃市场。因此，客户或许不能及时出售，或大幅折让其产品的价值以作出售。",
        "23.3 如人民币贬值，以港元计价的投资亦会下降。",
        "24 有关透过沪港通及/或深港通交易之特别风险",
        "以下是一些通过本公司透过沪港通及/或深港通（下称“中港通”）买卖上海证券交易所及/或深圳证券交易所之风险。由于涉及风险，客户只应在完全理解中港通之性质及客户将承受之风险才进行有关交易。客户应按经验、目的、财务资源及其他因素小心考虑（及在有需要时资询客户的顾问）该等交易是否适合客户。",
        "24.1 中国相关风险：中国是一新兴市场。投资于中国涉及特别的考虑和风险，包括但不只限于较大的价格波动性、较不发达的监管及法律架构，以及经济、社会及政治不稳定性等。",
        "24.2 股票风险：投资中港通证券的回报率可能会高于短期和较长期债务证券。然而，投资中华通证券的相关风险亦可能较高，原因在于投资中港通证券的表现取决于难以预测的因素，该等因素包括市场突然或长期低迷的可能性以及与个别公司有关的风险。",
        "24.3 流通量风险：无法保证可以就中港通建立或维持一个活跃的交易市场。如果中港通证券的价差很大，客户以期望的价格出售中港通证券的能力可能会受到重大影响。",
        "25 深交所创业板市场风险",
        "25.1 参与深交所创业板市场只限于机构专业投资者。",
        "25.2 深交所创业板股票涉及高投资风险因为在深圳创业板上市的公司通常为初创公司，经营规模及股本较小。由于市场上的股份流通量较小，其股票价格可能更容易受到操纵。因此，它们的股票价格和流动性波动较大。",
        "25.3 深交所创业板的公司上市规则和法规，不如深交所主机板那麽严格。在深交所创业板除牌的情况可能更加普遍和更快。如果客户投资的公司被除牌，这可能对客户产生不利影响。投资于深交所创业板上市的股票可能导致客户的重大损失。",
        "26 上海交易所（上交所）科创板市场风险",
        "26.1 规管差异风险：上交所科创板市场与上交所主板市场在上市、交易、信息披露以及其他事项的规则和指引方面都存在较大差异。例如，就上市条件而言，寻求在科创板市场上市的公司将适用更短的盈利历史、更低的净利润和营业收入，以及更低的经营活动产生的现金流量要求。科创板上市公司较之主板和中小板公司对于股本总额的要求也更低。科创板上市公司的交易安排亦与主板上市公司不同，例如价格限制、最小买卖盘和最大买卖盘。关于上交所科创板与主板的上市条件详情，请参阅上交所网站。",
        "26.2 退市风险：科创板退市制度较主板不同，可能导致科创板市场上市公司退市的情形更多，退市速度更快。",
        "26.3 公司经营风险：科创板市场上市公司一般处于发展初期，经营历史较短，规模较小，经营稳定性较低，抵抗市场风险和行业风险的能力较弱。尽管它们可能拥有更大的发展潜力并可更多地借助于科技创新，其未来表现（尤其是那些尚未有良好盈利记录的公司）存在很大的不确定性。",
        "26.4 大幅股价波动：科创板市场上市公司股价可能随市况变化、投资者投机行为或公司业绩变动等情况而频繁发生大幅波动。流通股本较少的科创板市场上市公司可能较容易被主要股东操纵股价。不稳定的公司业绩亦令此类公司的估值较为困难。",
        "26.5 技术风险：科创板市场上市公司的新技术能否转化为现实中的产品或服务具有不确定性。当其所在的行业正经历快速的技术更新换代时，其产品可能面临被淘汰的危险而令其公司难以为继。",
        "26.6 其他：投资者亦应参阅上海证券交易所科创板股票交易必备条款。每位内地投资者在交易上海科创板股票之前都须认可该揭示书条款。",
        "27 单位信託基金交易的特定风险",
        "27.1 基金单位的价格会波动，甚至变成毫无价值。基金过往的表现并不代表将来表现。",
        "27.2 不同类别基金所附带的风险有所不同。客户在决定是否投资该产品前，应审慎阅读相关产品的销售文件（包括基金说明书、产品资料概览及基金单张等）所披露的细节及风险。主要风险包括但不限于：",
        "(a) 信贷风险：这风险通常适用于所有固定收入（即债券）以及货币市场工具的基金。债券附带发债机构违责的风险，即发行" +
          "商有机会未能如期支付本金和利息。信贷评级机构给予的信贷评级并非对发债机构信用可靠程度的保证。",
        "(b) 流动性风险：此风险在基金内某些证券（包括债券等）可能在巿场上较难买入或沽售出现。未上市或未被评级的证券可能需较长时间或无法于市场上沽出，因此具有较高的流通性风险。这些风险有可能导致投资者招致严重亏损。",
        "(c) 利率风险：如产品投资于债券，就较易受到利率波动的影响。一般来说，利率上升，债券价格便会下跌。投资于债券的基金的价格便有可能下跌。",
        "(d) 市场风险：投资价值可能会因政治、法律、经济条件及利率变化而有波动。这些变化在全部市场及资产类别上都很普遍，客户取回的投资金额有可能少于初次投放的资金。",
        "27.3 投资于高息债券的基金，除以上列举的一般风险外，还须承受其他风险，例如：",
        "(a) 较高的信贷风险：高息债券的评级通常低于投资级别，或不获评级，因此涉及的发债机构违责风险往往较高；",
        "(b) 受制于经济周期的转变：经济下滑时，高息债券价值的跌幅往往会较投资级别债券为大，原因是（i）投资者会较为审慎，" +
          "不愿承担风险；（ii）违责风险加剧。",
        "(c) 资本增长风险：派息基金，特别是某些高息债券基金可能会以资本来支付费用及／或股息。此举有可能令基金可供日后投资的资金减少，削弱资本增长。",
        "(d) 股息分派风险：派息基金，特别是某些高息债券基金可能不会派息，取而代之的是将股息再投资在基金上，又或投资经理可能有酌情权决定是否动用基金的收入及／或资本作分派之用。此外，分派收益高并不意味投资者的总投资可取得正回报或高回报。",
        "(e) 其他主要风险：投资于债券，特别是高息债券的基金，可能尚涉及其他主要风险，包括投资集中于某特定种类的专门性债项或某特定地区市场或主权证券。",
        "27.4 投资于“需具备衍生工具知识”基金的风险：",
        "“需具备衍生工具知识”的基金可广泛地使用金融衍生工具达致其投资目的，可能含有杠杆效应。使用金融衍生工具可令基金承受额外风险，包括但不限于波动性风险及对手风险。基金经理可投资于结构性产品、衍生工具及可投资于非投资级别的债务证券，最高达基金总资产净值 100%。在恶劣情况下，投资可能招致重大损失。",
        "28 债券的特定风险",
        "28.1 债券只在到期日提供 100%本金保证，但要视乎其发行人及/或担保人（如适用）的信贷风险。",
        "28.2 债券不应被视为一般或定期存款。",
        "28.3 债券的价格会波动，甚至变成毫无价值。",
        "28.4 产品主要风险：客户在决定是否投资该产品前，应审慎阅读相关产品认购书（如适用）所披露的细节及风险。主要风险包括但不限于下页所载：",
        "(a) 信贷风险：客户须承担发行人及担保人（如适用）的信贷风险，他们的信贷评级如有任何变动将会影响本债券的价格及价",
        "值。债券附带发债机构违责的风险，即发行人有机会未能如期支付本金和利息。在最坏的情况下如发行人及担保人（如适" +
          "用）破产，客户可能会损失全部投资。信贷评级机构给予的信贷评级并非对发行人信用可靠程度的保证。",
        "(b) 流动性风险：债券的流动性可能有限，及可能无活跃交易，及/或没有经纪在市场提供报价，因此：",
        "(i) 不可以在任何时间均能提供债券的市值及/或参考买入/卖出价，因其将取决于市场的流动性和情况；",
        "(ii) 可能需要较长时间或无法于市场上出售债券；及",
        "(iii) 所执行的卖出价可能与本行参考买入价有很大的差别，对客户不利。",
        "(c) 利率风险：债券较易受到利率波动的影响。一般来说，利率上升，债券价格便会下跌。",
        "(d) 市场风险：投资价值可能会因政治、法律、经济条件及利率变化而有波动。这些变化在全部市场及资产类别上都很普遍，投资者取回的投资金额有可能少于初次投放的资金。",
        "28.5 投资于高息债券，除以上列举的一般风险外，还须承受其他风险，例如：",
        "(a) 较高的信贷风险：高息债券的评级通常低于投资级别，或不获评级，因此涉及的发债机构违责风险往往较高；",
        "(b) 受制于经济周期的转变：经济下滑时，高息债券价值的跌幅往往会较投资级别债券为大，原因是（i）投资者会较为审慎，不愿承担风险；（ii）违责风险加剧。",
        "28.6 某些债券可能别具特点及风险，投资时须格外注意。这些包括：",
        "(a) 永续性债券的风险：永续性债券不设到期日，其利息派付取决于发行人在非常长远的时间内的存续能力，利息或会因根据其条款及细则而有所延迟或终止。一般而言，永续性债券一般为可赎回及/或为后偿债券，客户须要承受再投资风险/或为后偿债券风险，详情如下。",
        "(b) 可提早赎回债券的再投资风险：如果这是可提早赎回的债券，当发行人于债券到期前行使赎回权，客户便会面对再投资风险。客户于再投资时可能会收到较小的孳息率。",
        "(c) 后偿债券的风险：后偿债券于发行人遣债后的清盘过程中获较低之索偿权，因此后偿债券之持有人将承受比优先债券更高的风险。后偿债券为无抵押，其信贷评级及债务的优先次序较优先债券为低。客户应特别注意产品之信贷资料，包括发行人，债券或担保人的信贷评级（视情况而定）。",
        "(d) 浮息及／或延迟派付利息的风险：如果债券具有浮息及／或延迟派付利息的条款，客户便无法确定将收取的利息金额及利息派付的时间。",
        "(e) 可延迟到期日的风险：如果债券具有可延迟到期日的条款，客户便没有一个订明偿还本金的确实时间表。",
        "(f) 可换股或可交换性质的债券的投资风险：属可换股或可交换性质的债券，客户须同时承受股票及债券的投资风险；及／或具有或然撇减或弥补亏损特点的债券。当发生触发事件时，这些债券可能会作全数或部分撇帐，或转换为普通股。"
      ]
    },

    customer_agreement1: {
      page_title: "证券及/或期货客户协议",
      h: "一般条款和条件",
      p1: [
        "高盈证券有限公司",
        "香港尖沙咀港威大厦 6 座 31 樓 3102 室",//---
        "中央编号 BPS863 ，根据《证券及期货条例》获发牌进行第 1 类(证券交易)，第 2 类(期货合约交易) 及第 5 类(就期货合约提供意见) 受规管活动",
        "客户协议书",
        "一般条款和条件"
      ],
      main: [
        "1 定义和诠释",
        "1.1 定义：于此等条款内，除非文义另有所指，下列词语具有以下涵义：" +
          "「账户」指以客户名义于相关公司不时开立和维持的任何一个或多个任何性质的账户，包括但不限 于证券现金账户、股票期权账户、证券保证金账户和期货账户，以按本协议条款规定取得服务及/或 进行交易;",
          "「开户表格」指客户不时按本公司规定或接纳之形式填妥的任何及所有开户表格、客户数据表格及 文件，包括与任何开户表格或文件相关或随附的任何附注和声明，这可能按照本协议不时作出修订；",
          "「协议」包括此等条款、此等条款之附件、开户表格及其他文件；",
          "「反洗钱条例」指《打击洗钱及恐怖分子资金筹集条例》(香港法例第 615 章);",
          "「适用法规」指香港或其他地方本公司、客户或其他相关人士受其规限的任何监管机构、税务机构、 政府机构、交易所、结算所、结算系统或专业团体的任何法律、规例或指令，或任何规则、指示、指 引、守则、常规、程序或惯例(不论是否具有法律效力);",
          "「有联系实体」具有证券及期货条例所赋予之涵义；",
          "「授权人士」对个人客户而言，指该客户及开户表格中指明为授权人士的任何人士，对公司客户而 言，则指开户表格中指明为授权人士的任何人士，而在两种情况下均包括由客户不时以书面声明通"+
          "知本公司的受委任替换或增补授权人士的任何其他人士，上述委任(受本公司的批准所限)  由本公 司实际收到通知时起生效；",
          "「营业日」指香港公司办公的日子(星期六及星期日，以及香港于上午九时正至下午五时正任何时 间悬挂黑色暴雨警告或八号或以上台风讯号的日子除外)；",
          "「中央结算系统」指香港结算营运的中央结算及结算系统；",
          "「结算系统」就任何市场而言，指不时用于进行证券或合约交易的交易结算系统(包括中央结算系 统、衍生工具结算系统及场外衍生产品结算系统);",
          "「结算所」就任何市场而言，指不时为有关买卖的任何证券或合约提供结算及／或交收服务的实体(包括香港结算、联交所期权结算所、香港期货结算及场外结算公司);",
          "「客户」或「你」或「阁下」指已开立及维持账户的人士，并且在文义许可的情况下包括授权人士。 「你的」须据此解释;及",
          "(a) 在客户是自然人的情况下，不论他是否破产，应包括其遗产代理人、财产接管人或受托人;",
          "(b) 在客户是独资经营机构的情况下，不论他是否破产，应包括独资经营者 、其遗产代理人、财产接管人或受托人、以及该商号的继任者；",
          "(c) 在客户是合伙经营的情况下，不论他是否破产，应包括于维持账户期间不时担任该商行合伙人 之合伙人，以及其各自之遗产代理人、财产接管人或受托人、以及该商号的继任者;及",
          "(d) 在客户是公司的情况下，应包括该公司、及其继任者和受让人；",
          "「操守准则」指由证监会发出，并可不时被修订或替代的《证券及期货事务监察委员会持牌人或注 册人操守准则》；",
          "「押记资产」指：",

          "(a)  不时在账户内的一切投资产品、应收帐项、款项及任何其他财产;",
          "(b) 客户现在或将来由本公司、其代名人或任何高盈证券成员不时管有、保管或控制及作任何用途的一切其他资产品、应收帐项、款项及任何财产；",
          "(c) 所有附加或替代的投资产品；以及",
          "(d) 以上任何一项或与其有关并透过赎回、红利、优先、选择或其他形式于任何时间累计或提供的 一切已付或应付股息、利息、权利、权益、款项或财产;",
          "「抵押品」指任何：",
          "(a) 客户在本协议下设立的产权负担；及",
          "(b) 客户授予的其他现存或未来的产权负担，并以本公司、其代名人及/或任何高盈证券成员作为受益人以担保债务的清偿或解除",
          "「本公司」或「我方」或「我们」(个别或统称)指：",
          "高盈证券有限公司(中央编号 BPS863)，一间在香港注册成立并获证监会发牌进 行第一类(证券交易)、第二类(期货合约交易) 及第五类(就期货合约提供意见) 受规管活动的公 司，"+
          "及其继任者和受让人，包括(如文义所指)其代理、代名人、代表、主管人员及雇员",
          "如文义所指乃第一类、第二类及第五类受规管活动，「本公司」或「我方」或「我们」应指高盈证券有限公司。",
          "如需进一步了解详情以及本公司的最新注册状况，请参阅本公司网站。",
          "此外，「我方的」将按此诠释；",
          "「商品」指香港期交所规则、规例及程序界定的商品及／或本公司就本协议而言接纳的任何商品， 不论是否能够交付，包括但不限于农业商品、金属、货币、股份、利率、指数(不论股市指数或其 他) "+
          "或其他金融合约、能源、权利或权限，而如文义所指，包括上述任何一项的合约，而「多种商 品」将按此诠释；",
          "「复杂产品」具有操守准则所赋予之涵义；",
          "「合约」视乎文义指任何在附件 III (期权交易) 描述的期权合约、期货合约(定义见于附件 IX (期 货交易)) 及/或期权合约(定义见于附件 IX (期货交易)) 中按上下文可能要求所描述的期权合约，"+
          " 多份合约将按此诠释；",
          "「法团专业投资者」属于《证券及期货 (专业投资者) 规则》(香港法例第 571D 章) 第 4 、6 或 7 条 所指的信托法团、法团或合伙",
          "「衍生工具结算系统」指香港期交所结算所和联交所期权结算所营运的衍生产品结算及交收系统",
          "「短欠」指任何账户不时的负结余，不论以任何方式及不论如何产生；",
          "「解散」，就一名人士而言，亦包括该名人士解散、结业、清盘或破产，以及根据注册成立、成立、 或驻在或经营业务或拥有资产的任何司法管辖区法律进行的任何同等或类似程序，而「已解散」将 按此诠释；",
          "「电子服务」指本公司及/或其代表为向客户提供服务之目的而提供的任何计算机或电子服务、系统或 设施(包括但不限于短讯服务(俗称短讯)、本公司网站/手机应用程序以及演算交易服务)，包括但 不限于使客户能在香港或其它地方发出执行交易的电子指示及接收信息及通讯的服务；",

          "「产权负担」指任何按揭、押记、质押、债券、留置权、以担保方式转让、财务租赁、递延购买、售 后购回或售后回租安排、押货预支、卖方保留所有权、第三方权利或权益，或就任何资产而给予或招致的其"+
          "他产权负担或抵押权益，或让任何债权人或任何协议对任何其他债权人或协议享有优先权 的任何安排，并包括就设立或授予上述任何一项而订立的任何协议或义务；",
          "「违约事件」指本协议中描述的任何事件，包括但不限于第 21.1 条(违约)  中所列的任何事件以及 附件 I  (保证金融资)第 3.5 条(未能满足追收保证金要求)中所列的事件；",
          "「交易所」，就任何市场而言，指进行投资产品买卖的交易所；",
          "「交易所买卖衍生产品」，指属于香港或证监会不时指定的司法管辖区的交易所内买卖的衍生产品的 复杂产品；",
          "「金融纠纷调解中心」指金融纠纷调解中心有限公司;",
          "「基金」指透过本公司分销或提供的任何单位信托、投资基金、互惠基金或其他集体投资计划；",
          "「期货账户」指于本公司开设以主要用作购入、投资、沽售、买卖、达成、交易、收购、持有、转 让、订立、结算、交收、处置或以其他方式处理商品及／或合约之用途(不时由客户指示本公司执 行)的账户；",
          "「香港期交所结算所」指香港期货结算有限公司及其继任人和受让人，包括，如文义所指，其代理 人、代名人、代表、主管人员及雇员；",
          "「香港交易所」指香港交易及结算所有限公司；",
          "「香港期交所」指香港期货交易所有限公司及其继承人和受让人，包括，如文义所指，其代理、代 名人、代表、主管人员及雇员；",
          "「香港结算」指香港中央结算有限公司 (香港交易所全资子公司)以及其继任人和受让人，包括， 如文义所指，其代理、代名人、代表、主管人员及雇员；",
          "「香港」指中华人民共和国香港特别行政区；",
          "「香港监管机构」指联交所(包括有关结算所)、证监会及／或于香港对本公司或交易拥有司法管辖 权的任何其他监管机构；",
          "「高盈证券」指高盈证券有限公司，其子公司、关联公司及有联系实体；「高盈证券成员」将按此诠释；",
          "「个人专业投资者」属于《证券及期货 (专业投资者) 规则》(香港法例第 571D 章) 第 5 条所指的 个人；",
          "「机构专业投资者」属于证券及期货条例附表 1 第 1 部第 1 条「专业投资者」的定义第 (a) 至 (i)  段所指的人士；",
          "「指示」指任何由客户(无论是本人或通过任何授权人士) 以任何方式(包括但不限于口头、电话、 传真、电邮、互联网或任何其他电子方式(包括通过电子服务) 或任何书面形式) 给予或传达予本公司"+
          "的授权、要求、申请、指示或指令(以任何形式及任何方式发送)，或者是本公司合理地认为是 客户的授权、要求、申请、指示或指令，并包括任何撤销、驳回或修改任何过往的授权、要求、指示"+
          "或指令的授权、要求、指示或指令；",
          "「投资者赔偿基金」指根据证券及期货条例第 236 条成立的投资者赔偿基金；",
          "「投资咨询服务」指本公司就任何投资产品不时向客户提供的任何投资意见或资产策略配置建议；",
          "「投资产品」指证券、合约及其他金融或投资产品 (不论如何描述) ；",

          "「负债」指客户有关任何账户及本协议欠负、结欠本公司、其代名人或任何高盈证券成员或产生的 所有款项、债项、负债及义务，不论实际或或然，现在或未来、当事或附带、有抵押或无抵押，或客"+
          "户于任何账户或不论以任何方式或货币成为或可能向本公司负责(不论作为主要债务人或保证人， 亦不论单独或联同任何其他人士，及不以任何名义、身份、形式或格式)，包括因货币、股票经纪、"+
          "保证金证券交易及其他金融交易产生的所有金钱义务，连同利息(由适用到期日起或在其他情况下， 由请求日期起至本公司全数接获实际及无条件付款日期(包括该日在内))、法律费用及本公司、"+
          "其代名人或任何高盈证券成员有关该款项、负债及义务产生的所有其他成本、收费及开支(包括但不 限于收回或尝试收回该款项、债项、负债及／或义务或强制执行本公司在本协议下的权利及权力索"+
          "偿产生的任何汇兑亏损及开支)；",
          "「登录标识符」指为接达电子服务而与密码结合使用的某些信息；",
          "「市场」指场外市场或任何交易所、适用交易商协会或本公司为投资产品提供的任何市场，不论于 香港或境外；",
          "「重大不利影响」指以下各项发生的重大不利影响：",
          "(a) 客户整体的业务，运营，财产，财务及其他状况或发展前景；",
          "(b) 客户履行其在本协议或其与公司或任何高盈证券成员签订的任何其他协议项下义务的能力;",
          "(c) 任何该等协议的有效性、合法性或可执行性，或本公司在该等协议项下的权利；或",
          "(d)  客户根据该等协议授予的任何抵押的有效性、合法性或可执行性，或任何该等抵押的优先权和 排序;",
          "「其他文件」指客户或本公司就有关本协议产生或预计进行的任何事宜签署、接纳或向另一方发出 的表格、函件、通知、结单、确认书及其他文件，以不时经修订或补充者为准；",
          "「场外交易结算及交收系统」指场外结算公司为支持其结算服务而开发的场外交易结算及交收系统；",
          "「场外结算公司」指联交所成立的香港场外结算有限公司，作为中央交易对手为场外衍生产品交易 提供结算及交收服务；",
          "「密码」指客户密码以及与登录标识符结合使用的其他加密和安全措施，以使客户能够接达电子服 务；",
          "「个人资料 (私隐) 条例」指《个人资料 (私隐) 条例》(香港法例第 486 章) 及根据该条例作出的 所有附属法例、规则、守则和指引；",
          "「中国」指中华人民共和国，但不包括香港、澳门特别行政区以及中华民国(台湾)；",
          "「专业投资者」具有证券及期货条例附表 1 第 1 部第 1 条所赋予之涵义；",
          "「人民币」指中国的法定货币；",
          "「规则」，就任何市场而言，指有关交易所、结算所或结算系统的一般规则、运作程序及其他适用规 则、惯例、常规、程序及规例，以及其不时之修订或补充；",
          "「证券」指 (a) 证券及期货条例所界定的证券；及 (b) 任何机构(不论已注册成立或非注册成立)  或任何政府机构不论任何形式或如何发行于市场买卖及就本协议获本公司接纳的任何股份、股票、"+
          "债权证、借贷股份、基金、债券、票据、单位信托、场外交易衍生产品、存款证或其他商业票据或证 券或其他类似工具，并且按本公司的绝对酌情权，可包括(i)上述任何一项的权利、选择权或权益"+
          "(不论以单位或其他方式说明)；(ii) 上述任何一项的权益或分享权证书、临时或中期证书、收据或 认购或购买权证；或 (iii) 通常称为证券的任何工具；",

          "「证券现金账户」指于本公司的账户，以主要进行及记录本公司按照客户的指示进行的证券交易；",
          "「证券保证金账户」指于本公司的账户，以主要用于执行及记录本公司按照客户指示利用信贷融资 	(定义见于附件 I  (保证金融资))进行的交易；",
          "「证券交易」指本公司按客户指示进行的任何交易，以买入、投资、认购、卖出、交换或以其他方式 买卖或处置任何证券，包括以本公司或本公司代名人的名义持有证券；",
          "「联交所」指香港联合交易所有限公司及其继任人及承让人，包括，如文义所指，其代理、代名人、 代表、主管人员及雇员；",
          "「联交所期权结算所」指香港联合交易所期权结算所有限公司及其继任人及承让人，包括，如文义 所指，其代理、代名人、代表、主管人员及雇员；",
          "「证监会」指香港证券及期货事务监察委员会及其继任人和受让人；",
          "「证券及期货条例」指《证券及期货条例》(香港法例第 571 章)及根据该条例作出的所有附属法例、 规则、守则和指引；",
          "「卖空指令」，就在联交所交易的证券而言，具有证券及期货条例赋予的涵义，以及在其他所有情况 下，是指代表客户卖空任何投资产品的指令；",
          "「股票期权账户」指于本公司的账户，以按照客户指示进行期权交易，并主要受附件 III(期权交易)  所载条款的管辖；",
          "「此等条款」指可能不时修订或补充的一般条款和条件(不包括其附件);",
          "「交易时段」具有第 5.5 条(交易日)所赋予之涵义；",
          "「交易」指根据本协议预计进行、提供或作出、生效或进行的任何交易、买卖、协议、行动、服务；",
          "「美国」指美利坚合众国(为避免歧义，包括其各州、领土、属地以及哥伦比亚区)；及",
          "「美籍人士」包括",
          "(a)  身为美国公民或居民的任何自然人；",
          "(b) 根据美国或其任何政治分部法律组成或注册成立的法团、合伙商号或其他业务机构;",
          "(c) 身为上述美国人士的执行人或受托人管理，或收入(不论来源) 受美国联邦所得税规限的任何 遗产或信托;",
          "(d) 交易商或受信人士为上述人士的实益持有的任何账户(任何遗产或信托除外)；及",
          "(e) 根据任何司法管辖区的法律组成及注册成立的任何合伙商号或法团，为由上述人士组成，主要用于投资于并非根据一九三三年美国证券法注册的证券,",
          "但不包括于美国以外为有效业务原因作为当地从事银行或保险业务及并非主要为投资于根据并非一 九三三年美国证券法注册的证券的受规管分行或代理的美国银行或保险公司任何分行或代理。",
          "1.2 释义 ：于此等条款及本协议内:",
          "(a) 「包括」指包括但不限于;",
          "(b) 「控股公司」及「子公司」将分别具有《公司条例》(香港法例第 622 章)赋予的涵义；",
          "(c) 提述条、分条或附表，为此等条款的条、分条或附表，而提述开户表格指客户或其代表填妥的开户表格，而倘该数据于其后以向本公司发出通知予以修订，指经该通知修订的开户表格；",
          "(d) 提述条例指不时经修订、补充、延伸、规范或重新颁布的香港法例或法律及相关的任何附属法 例；",
          "(e) 提述男性称谓包括女性及中性，而提述单数包括众数，反之亦然，而提述人士包括个人、公司、机构、商号、法团、法人团体、政府、国家或国家实体、组织、合伙商号或其他实体或机构(不 论是否为注册成立，亦不论是否具有法人资格)或前述任何两者或以上；",
          "(f) 条款的标题仅供参考，并不影响其诠释；及",
          "(g) 附件构成本协议整体的一部分，除非另有明确说明，否则附件应与本条款及本协议其他部分一起阅读。",
          "1.3 歧异 ：倘有任何歧异，有关服务、投资产品、安排或交易的条款将按以下次序适用：(i) 有关客户由 其提供或接纳的任何额外或特定表格或文件(除下述(ii)和(iii) 所述部分)；(ii)"+
          "管辖该表格或文 件的相关附件，及 (iii) 适用于该表格或文件的任何一般条款及条件(包括此等条款)。",
          "1.4 适用法规 ：除本协议外，所有服务、产品、安排及交易将受适用法规规限。",
          "1.5 网站 ：本公司网站为www.goingf.hk或其他本公司可能不时通知客户的网站。",
          "2 委任、代理范围及授权",
          "2.1 开户 ：客户应以本公司不时指定之方式开立及维持有关账户，以进行交易。",
          "2.2 本公司作为客户代理人 ：除非本协议或本公司另有说明，客户委任本公司，而本公司同意作为客户 的代理代表客户进行交易。本文所载的任何内容，概不构成本公司作为客户的受托人或受信"+
          "人士或 本公司与客户之间的合伙关系。",
          "本公司作为主事人与结算所交易 ：除非本协议或本公司另有规定，就本公司或任何高盈证券成员于 任何结算所存置的任何账户不论该账户是否全部或部分就本公司代表客户进行的任何交易存置，及"+
          "不论客户是否已向该结算所支付款项，在本公司或任何高盈证券成员与该结算所之间，本公司或该 高盈证券成员(视乎情况而定)作为主事人进行交易。",
          "2.4 本公司拒绝的权利 ：尽管有任何相反之规定，本公司可全权酌情在毋须提供任何原因的情况下拒绝 接纳任何指示及／或拒绝向客户提供其在本协议项下的任何服务。本公司将不会就其不接纳或"+
          "不按 此指示行事或不发出不接纳任何指示的通知以及上述拒绝所产生或有关的任何损失向客户负责。",
          "2.5 本公司的指派 ：本公司可全权酌情决定透过任何高盈证券成员、任何交易所或结算所的成员或参与 者或有关市场的经纪执行客户的交易。本公司可委任任何其他人士为其代名人、托管人、经纪、"+
          "存 托代理或其他代理，旨在或有关向客户提供服务，并可根据本协议指派任何职责予该名人士。所有 该等第三方均享有客户赋予本公司的全部权力及酌情权。本公司获客户授权，向本公司根据本第 2.5 "+
          "条委任的任何人员披露有关客户、其授权人士、账户及交易的任何个人资料及其他数据。在适用法 规许可的最大范围内，本公司将不就该等第三方的行为或不作为向客户负责。",
          "2.6 授权人士发出的指示 ：客户授权本公司接受授权人士就本协议发出或旨在发出的指示。但是，除非 本公司同意或本协议另有指明，有关向第三方转让现金及/或证券的交收指示，必须以书面作出及按"+
          "开户表格所指定的方式 (如有指定) 作出。本公司有权以任何理由拒绝执行客户就任何一项交易发 出的指示。有关授权人士的委任或变更(受本公司的批准所限) 须在本公司实际收到有关通知起不 时生效。"+
          "本公司有权 (但无义务) 执行授权人士代表客户发出或旨在发出的任何指示，但毋须对客 户因此可能遭致的任何损失承担任何责任。本公司无任何义务核证代表客户发出或旨在发出的指示 的真实性，"+
          "亦无义务核实发出指示人士之身份。",

          "2.7 无职责询查目的或适当性 ：本公司无任何职责或义务询查客户或任何授权人士发出或声称发出的任何指示或指令的目的或适当性，亦无任何职责或义务监督根据本协议由任何账户所支出的任何资金 使用。",
          "2.8 授权书 ︰客户同意及谨此不可撤销地委任本公司并赋予其全面的权力及权限作为客户的真正及合法 受权人 (在法律许可的全面范围内) 为客户及代表客户执行本协议的条款，并于本公司认为在履行"+
          "本条款的目的有所需要或合宜之时，以客户或本公司本身的名义采取任何行动及签立任何文件或文 书，包括但不限于下列目的：",
          "(a) 就任何押记资产执行任何转让或转移；",
          "(b) 完成其对任何押记资产的所有权;",
          "(c) 请求、要求、索求、收取、了结及彻底清偿在押记资产项下或因押记资产而引起的到期或将到 期的任何及所有款项及申索的款项；",
          "(d) 提供有效的收据和解除书，并加签与任何押记资产有关的任何支票或其他文书或指令；及",
          "(e) 提出任何申索或采取其认为必要和合宜的任何法律行动或法律程序，以保障在本协议项下设定的担保。",
          "2.9 限制 ：本公司可于不时认为适当时，订立与任何账户有关及给予指示之有关限制，该等限制包括但不限于每日进行交易之最多次数、每笔交易中可处理的不同投资产品的数量和类型、交易中投资产 品的最低价值或金额、客户可以购买或出售投资产品的价格、未平仓合约的持仓限制及基金赎回限 额。",
          "2.10 非委托账户 ：客户确认，本公司不会就为客户作出投资决定及执行交易行使酌情权，除非本公司另行通知客户，在此情况下，客户可能须订立委托账户协议、授权书及/或本公司可能要求的其它文件， 惟不得据此解释为本公司的作为、不作为、指示、允许、默许、批准、安排或同意。",
          "2.11 无建议 ：根据第 24.1 条 (一般) 所载为确保合理合适性外，除非本公司与客户另有约定，本公司并未提供投资咨询服务，因此概不承担任何招揽出售或建议投资产品的咨询谨慎责任或义务。"+
          "如本公 司向客户提供与某些金融产品有关的广告、市场营销或推广材料、营销数据或其他数据讯，该等材 料或信息不会单独构成对该投资产品的招揽或建议。客户基于该等材料或资料采取或不采取任"+
          "何行 动前，应取得独立专业意见 。客户亦确认︰-",
          "(a) 在投资咨询服务过程中提及的任何目标或预期收益不代表对任何投资产品的性能的任何保证，估算或预测;",
          "(b) 投资于任何投资产品均有其风险；及",
          "(c) 本公司可就投资顾问服务不时全权及绝对酌情收取费用。",
          "3 常设授权",
          "3.1 常设授权 ：客户同意按照本公司指定的形式给予本公司不时要求的常设授权，包括但不限于以下各 项：",
          "(a) 《证券及期货(客户证券) 规则》(香港法例第 571H 章)(包括为附件 I  (保证金融资)第 5.1 条(常设授权) 之目的所必需的内容)；及",
          "(b) 《证券及期货(客户款项) 规则》(香港法例第 571I 章)。",
          "3.2 有效期 ：常设授权自出具之日起生效。客户的授权书必须指明有效期，而该段有效期不得超过 12 个 月。若客户是专业投资者，则有关限制并不适用。除非及直至客户以书面形式明确撤回该授权，否 则任何常设授权一经授予，将一直有效。",

          "3.3 撤销 ：在没有任何尚未清偿的负债的情况下，客户可在不少于 10 个营业日前通知公司撤回该常设授权。客户确认，常设授权被撤销或未续期可能导致本公司无法向客户提供服务。",
          "3.4 续期 ：本公司将于常设授权届满前 14 天通知客户，述明除非客户于该授权届满前提出反对，否则该 常设授权将被视为已按最后一次授权的相同条款及条件获续期。",
          "4 指示",
          "4.1 发出指示 ：客户可就有关交易、账户或本公司的服务以电话、传真、电子方式(包括电子服务) 或本 公司不时指定的其他通讯方式发出指示。所有指示都必须遵照本公司和客户之间的安排以书面"+
          "形式 发出并(如须签署) 符合于开户表格向本公司提供的相关式样签署，或以其他方式通知本公司并受 本公司接受(「协议签署安排」)。在任何情况下，客户均须遵守该等验证程序并满足本公司不时"+
          "规定 的其他要求。",
          "4.2 截止时间 ：本公司有权全面地或就任何指定性质或种类的指示，指定收取指示的任何截止时间，可 能与任何市场或任何交易所或结算所指定的任何通常截止时间不同。客户确认及同意，本公司概"+
          "不 会就执行本公司于适用截止时间后收取的任何指示的任何延误或未能执行有关指示承担责任。",
          "4.3 授权人 ：任何一名授权人士获客户授权代表客户就账户发出指示并签署有关账户及其运作的一切协 议及相关文件，直到本公司收到客户内容相反的书面通知为止。客户向本公司承诺将不时及随"+
          "时追 认并确认任何授权人士代表客户或声称代表客户发出或签署的任何指示或协议或文件，包括但不限 于任何授权人士于被撤销授权至本公司实际收到撤销授权通知期间代表客户或声称代表客户发出"+
          "或 签署的任何指示、协议或文件。客户同意，如果本公司在收到任何授权人士代表客户或声称代表客 户发出或签署的任何指示、协议或文件时尚未实际收到该授权人士被撤销授权的通知，则该授权人士"+
          "在被撤销授权之后代表客户或声称代表客户发出或签署的任何指示、协议或文件对本公司的利益 而言为有效及有作用的指示、协议或文件。上述由任何授权人士签署或发出或声称签署或发出的所 有文件"+
          "或指示(不论口头或书面) 一律被视为在该授权人士权限内签署或发出的，对客户具有绝对 及不可推翻的约束力。客户有责任确保所有授权人士均遵守本协议，并在任何情况下对所有指示负 责，即使该等"+
          "指示是由授权人士或其他第三方发出。",
          "4.4 本公司对指示的信赖 ：本公司有权视按照此等条款发出的指示为获客户全权授权的指示处理。本公 司有权(但不受约束) 就本公司真诚认为适当按照该指示执行交易的情况下根据或依据指示行事"+
          "或 采取有关步骤(不论为收购、购买、出售、转移、处置或在其他情况下买卖投资产品)，并获授权约 束客户遵守与本公司或任何其他人士订立的任何协议或其他安排，或促使客户为执行该指示进行任"+
          "何其他种类交易或安排，不论交易或安排的性质、或涉及的投资产品的价值、种类及数量。除与协 议签署安排核对客户及／或授权人士各自的签署(倘指示由客户及／或授权人士签署) 或核对有关 客户"+
          "及／或任何授权人士(倘指示以任何其他方式发出)身份的指定号码、密码及／或任何其他资 料，本公司将无义务核对以任何方式发出任何指示的人士的身份或授权或该指示的真实性。本公司可依赖及按本"+
          "公司真诚地相信为真实的指示行事，而本公司按此基准代表客户进行的任何交易将对 客户具约束力，不论该指示是否就该交易作出或由客户授权。",
          "4.5 与非面对面通讯有关的风险 ：客户确认以电话、传真、电邮或其他电子方式 (包括电子服务) 发出 指示的风险，包括未获授权或由未获授权人士发出或由第三者截获指示的风险。客户接纳所有"+
          "风险， 并授权本公司按照透过该方式接获的任何指示行事。本公司并不就传送或传达指示或价格信息的任 何延误、故障、失误、中断，或暂停传送或传达指示或价格信息或向任何其他方错误传达指示"+
          "或资 讯，或为客户因使用任何特定收发指示方式或本公司按该指示行事而可能蒙受或产生的任何申索、 负债或损失承担任何责任，除非由于本公司或其任何主管人员或雇员的严重疏忽、欺诈或蓄意失责"+
          "所致，及只限于直接及合理预见直接及纯粹由上述行为造成的损失及赔偿(如有)。",
          "4.6 取消或修改指示 ：一旦指示由客户或其代表发出，除非本公司同意，该指示不可予以修订、撤销或 撤回。倘客户所修订、撤销或撤回的指示已全部或部分执行，客户同意就有关交易承担全部责"+
          "任。 就客户或其代表已向本公司发出的任何指示，本公司将无义务就其取消、修订或修改任何指示行事， 而倘原本指示已由本公司真诚地完成，或本公司不能合理可行地按指示取消、修订或修改原本"+
          "指示， 则毋须就客户蒙受或产生的任何损失或开支承担责任或负责。",
          "4.7 概无责任促使作为受信人士合规 ：本公司不负责促使客户遵守规管客户作为受信人士(如适用)的 行为的任何法律或规例。",

          "4.8 优先次序 ：本公司可全权决定在执行客户的指示时的优先次序。",
          "4.9 合并订单 ：在任何适用规例的规限下 ，本公司可毋须向客户发出通知，将客户的订单与客户或与本 公司关连的人士或与本公司的其他客户的订单合并。合并在某些情况下可能对客户不利，而在"+
          "其他 情况下对客户有利。",
          "4.10 香港以外发出指示 ：如客户在香港以外的地方发出任何指示，客户承诺将遵照外地的所有适用法规 发出该等指示，如有疑问，客户应取得独立法律意见。如客户的居住地不在香港，则客户确认按照 适用法规可交易在香港的投资产品，本公司并无职责就此进行核实。",
          "4.11 卖空交易 ：倘若本公司自行全权决定客户已符合所有适用法规，本公司可执行卖空指令。特别是， 对于在联交所或通过联交所交易的卖空指令，本公司必须获满足(i) 已符合证券及期货条例第"+
          " 170 条和第 171 条的规定(总的来说，要求客户具有一项实时可行使及无条件的权利，以将该等证券转 归于其购买人名下)及(ii) 相关证券列于联交所不时发布并更新的可进行卖空的指定证券名单。",
          "5 执行交易",
          "5.1 指示经纪商 ：客户授权本公司指示本公司全权酌情视为合适的执行经纪商、代理、托管人、代名人、 海外经纪商及交易商(包括本公司的分行或有联系者) 执行任何交易，并确认该等人士的业务条"+
          "款 以及执行及结算交易的任何相关交易所、结算所及／或结算系统的适用规则将适用于该等交易。客 户理解并同意，由于本公司需根据协议或其他方式向客户提供服务，本公司可能因客户的投资产品 或"+
          "与客户的投资产品有关而欠第三方义务。该等第三方可能对客户的投资产品和押记资产拥有权利 及权益，并可能影响(a) 本公司解除对此类投资产品对客户的义务的能力(例如，将某些投资产品 或押记资"+
          "产退还给客户)，及/或(b) 客户行使与该投资产品或押记资产有关或与之相关的任何权利 	(包括但不限于其对股票的投票权)  的能力。",
          "5.2 相关法律 ：本公司按照客户指示进行的所有交易，均应按照所有适用法规进行。本公司按照适用法 规采取的所有行动均对客户具有约束力。",
          "5.3 「按最佳条件」或「按市场条件」执行指示 ：客户确认，基于任何市场的市场条件或物理限制，以 及投资产品价格的迅速转变及／或货币汇率的波动，在某些情况下，及即使本公司、执行经纪"+
          "商或 交易商(不论于香港或其他地方) 合理尽力，本公司未必能完全或按客户指定的价格或时间或「按 最佳条件」或「按市场条件」执行客户的指示。倘因市况或本公司未能控制的任何其他原因，本"+
          "公 司未能完全执行任何指示，本公司概不负责，客户接受本公司进行的交易并受其约束。",
          "5.4 履行部分订单及限价单 ：当本公司或获本公司指示的任何人士未能完全执行客户的任何指示，本公 司或该等人士有权在不事先咨询客户或征得其同意的情况下仅执行部分指示。在不影响上文所述"+
          "一 般性的情况下，除非就投资产品于发出指示之时，客户明确指示本公司立即于有关市场送出整个订 单(而本公司接受该指示)，否则经考虑当时市况及市场常规后，尤其是当本公司合理认为订单根据"+
          "当时的市况不能实时执行时，本公司有权拒绝如此行事。",
          "5.5 交易日 ：除非客户向本公司发出任何明确的相反指示(而本公司接受该等指示)，否则客户确认本公  司于某交易日收到的所有指示仅于该交易日(或本公司不时决定缩短或延长的时间) (「交易时"+
          "段」)  有效，而以未履行的任何指示为限，该等指示均就发出买卖盘的市场的最后交易日正式交易时段(在 交易时段内) 结束后失效。",
          "5.6 一直有效的订单 ：一直有效的订单将持续有效以待执行，直至任何下述情况发生为止 ：(i) 订单被客 户取消；(ii) 订单预先确定的有效期已过；或(iii) 本公司自行全权决定取消该订单。"+
          "该订单可在取 消之前的任何时间执行，而客户同意就该等交易承担一切责任。",
          "5.7 利息 ：客户应按本公司不时通知客户的利率及其他条款，支付任何账户内的所有逾期结余、未清金 额、借方结余及于任何时候结欠本公司的任何款项的利息(包括对客户的债项取得判决后产生"+
          "的利 息)，若本公司并无发出该等通知，则按本公司不时厘定的利率支付利息。利息应从相关到期日或在 其他情况下由提出要求之日计起，直至本公司全数收到实际及无条件付款之日(包括该日在内)，"+
          "按 日计算。逾期未付利息将每月按复利计算及利息本身将产生新的利息。",

          "5.8 录音和录音带 ：客户确认，客户与本公司之间的所有电话对话可能在没有自动语音警告提示的情况 下被录音，以便本公司核实客户的指示。客户同意，相关录音带上的录音或者录音的文字记录可以 用作指示内容的最终及不可推翻的证据。",
          "5.9 本公司之记录不可推翻 ：客户确认，本公司之簿册、数据及记录，如无明显错误，均为有关事项的 最终定论及在所有法庭及就一切目的而言，均为不可推翻的证据。",
          "5.10 个人操作账户 ：客户确认，客户将自行(或通过其授权人士) 操作本公司就本协议为客户开立的任 何账户。倘客户拟委任第三方就本协议以任何方式代表客户行事，客户应向本公司提供本公司"+
          "自行 全权决定的可能需要的信息以委任该第三方，而约束该委任的条款及条件将附加于本协议之上，及 视为本协议的一部分。",
          "5.11 价格 ：任何交易的实际买入及卖出价应在进行交易时厘定，而本公司或其代表于任何时间向客户报 价或提供的任何数字(其中一些数字可能是由第三方信息或服务提供商提供给本公司) 仅供参"+
          "考， 以及并不对本公司或客户约束力。为免生疑，本公司有权按客户的任何指示进行交易，即使相关投 资产品的价格在接收指示之时至本公司或其代理人实际进行交易之时已变得对客户不利。",
          "5.12 所有权 ：本公司无义务审查或核实任何投资产品的拥有权或所有权的有效性。",
          "6 交收",
          "6.1 交收 ：除非另有约定或倘本公司已代表客户持有足够的投资产品、现金或其他资产以交收交易，否 则客户应在本公司就有关交易通知客户的时间、地点、金额及方式：",
          "(a) 向本公司支付或提供清算资金，或以交收交易所需的可交付形式向本公司交付相关投资产品；及",
          "(b) 确保本公司将于适用交收日期或本公司就交收交易可能知会客户的时间接获清算资金或可交付的投资产品。",
          "6.2 客户未能交收 ：倘客户未能遵守第 6.1 条(交收)，就交收任何交易之目的，本公司在不损害本公司 任何其他权利或补救及毋须向客户发出进一步通知或征得同意的情况下，有权全权酌情：",
          "(a) 就买入或认购投资产品的交易，按本公司认为合理的价格，卖出或转让该交易所涉及的投资产品及／或卖出或转让任何账户中的任何其他投资产品以履行客户的交收义务，并于任何账户收 取或扣除任何相关成本、费用及开支；或",
          "(b) 就卖出投资产品的交易，按本公司认为合理的价格，借入及／或买入相等于该交易所涉及的投资产品价值的投资产品以履行客户的交收义务；而在第 6.1 条(交收)以外或作为替代，对本 协议下的合并及抵销权利或任何其他权利享有追索权。",
          "6.3 不执行交易的权利：尽管本协议任何其他条文有所规定，本公司有权针对以下用途不执行任何指示：",
          "(a) 买入投资产品，除非客户已向本公司提供清算资金，而本公司认为金额足以结清有关买入交易的相关买入价、费用及支出；及",
          "(b) 卖出投资产品，除非客户已向本公司存入有关投资产品以供交收该卖出交易。",
          "6.4 短欠 ：客户以全面弥偿基准就有关根据第 6.2 条(客户未能交收)买入及/或卖出投资产品所发生的 任何短欠及本公司产生的任何成本、费用或开支(包括法律费用)负责。",
          "6.5 股票借贷 ：为方便客户按时交收，本公司可全权酌情向客户借出投资产品，或代表客户借入投资产 品，以交收客户的卖出指示。本公司亦可按其全权决定的条款代表客户或为客户利益向或从第"+
          "三方(仅为本条之目的，「第三方」) 借出或借入投资产品，不论是以本公司、任何高盈证券成员还是以 其他名义。客户应弥偿本公司及任何高盈证券成员根据上述证券借贷安排所需的任何保证金、担"+
          "保、证券、或抵押品维持及开支。本公司不保证或担保任何卖空交易的可用性或持续可用性。本公司可 全权决定或应第三方要求终止任何该等借贷安排，并立即要求交付或归还涉及的投资产品。客户"+
          "必 须遵从有关交付或归还相关投资产品的任何要求。",
          "7 付款和客户款项",
          "7.1 向客户付款 ：就本公司支付客户之全部款项而言，将按开户表格所载账户详情将款项转入客户之银 行账户，或依本公司选择以其他方式支付。上述任一方式的付款均构成对本公司所承担之付款责任 之完全解除。",
          "7.2 独立账户 ：本公司从客户或任何其他人士收到的所有款项或其他财产(除非适用法规容许，或根据 客户的书面指示，或根据客户不时给予本公司的常设授权，而该等指示或常设授权已为本公司"+
          "所接 受)均与本公司的自有资产分开，及支付予独立账户。",
          "7.3 客户款项利息 ：本公司将以《证券及期货(客户款项) 规则》(香港法例第 571I 章) 允许的任何方式 处理由本公司持有客户款项(定义见于证券及期货条例)而产生的任何利息，且客户同意本公司(以 公司款项)保留该等利息。",
          "7.4 香港以外执行的交易 ：尽管第 7.2 条(独立账户) 有所规定，就在香港以外执行的交易而言，客户授 权并指示本公司向本公司在香港境内或境外的任何金融机构(不论是否持牌银行)维持的任何信托、 客户或其他账户，支付本公司为客户及代表客户从交易不时收取的所有款项(减所有经纪费用及应 计的其他适当费用)，尽管在符合或根据适用法规的情况下任何该等款额可为客户或代表客户再投资 于其他交易。",
          "8 结单及记录",
          "8.1 一般 ：本公司将按照适用法规向客户提供与任何交易有关的成交单据或其他确认书，以及有关账户 的户口结单。",
          "8.2 月结单 ：除非适用法规允许或在特定月份内没有与特定账户有关的交易，并且账户不存在任何未清 余额或持有任何持仓或投资产品， 否则本公司亦将提供有关账户的月结单。",
          "8.3 终论性/客户检查 ：客户应检查本公司发出的每份账户结单及记录。成交单据、交易确认书及户口结 单为当中所载事宜的不可推翻证据(明显错误者除外)，并将视为获客户接纳及对客户具约束力，除 非本公司于成交单据或交易确认书或账户结单日期后 5 个营业日内实际从客户接获书面通知，指称 存在任何遗漏或错误，否则，此后客户不得对该等结单的准确性提出异议。",
          "8.4 单方面修订 ：即使有任何相反规定，本公司可在其认为适当的情况下单方面修订任何该等结单或记 录。",
          "8.5 未收到 ：若(a) 未收到本公司发出的任何户口结单或事务历史记录，或(b) 客户收到任何确认但并未发 出有关指示，则客户应在(a)的情况下于日常业务过程中通常收到户口结单或记录后 2 个营业日内， 或在(b)的情况下在收到该等确认后立即以书面形式通知本公司。",
          "8.6 交付方式 ：在不影响本公司以其他任何方式向客户送达成交单据、交易确认书、户口结单及其他通 知书(统称「交易文件」) 的情况下，客户同意以电子方式(包括透过电子服务) 收取交易文件。客 户可以通过向本公司发出不少于两个月的书面通知(或公司可以接受的较短期限)，撤销其同意以电 子形式接收交易文件。",
          "8.7 衍生产品 ：对于衍生产品，包括期权，公司应客户要求向其提供(a) 产品规格以及涉及此类产品的 任何招股说明书或其他发行文件；及(b) 保证金程序及未经客户同意可能将客户仓位平仓的情况的 说明。",
          "8.8 客户的确认 ：如果客户同意并接受通过电子方式(「接收服务」) 接收交易文件，则客户确认其理解 并接受以下安排：",

          "(a) 使用接收服务需要客户提供和指定的适当的硬件和软件，互联网接收服务以及特定电子邮件地址，移动电话号码或其他电子地址，以接收本公司的电子邮件，短讯或其他电子通知；",
          "(b) 互联网，电子邮件，短讯和其他电子信息服务可能会受到某些科技风险和干扰影响；",
          "(c) 撤销对接收服务的同意应由客户按照第 8.6 条(交付方式)规定的方式预先发出此类通知；和",
          "(d) 客户可能被要求为以下方面支付合理的费用：",
          "(i) 获取不再可通过电子方式(包括电子服务) 接收和下载的任何交易文件的副本；或",
          "(ii) 要求公司除提供接收服务的请求外，还通过其他方式向其提供交易文件。",
          "9 外币",
          "9.1 货币兑换 ：在不影响上文第 2.4 条(本公司拒绝的权利) 的一般性的情况下，本公司保留权利，在毋 须给予任何原因下，拒绝客户需要从一种货币转为另一种货币以进行卖出或买入任何投资产"+
          "品的任 何指示，或在其他情况下拒绝为其他目的(包括为分派股息的目的) 进行货币兑换。倘本公司接纳 客户任何进行卖出或买入任何投资产品指示，或为任何其他目的进行任何货币兑换，本公司应全"+
          "权 决定按照当时现行货币市场汇率进行有关的货币兑换。此外，本公司可于任何账户按本公司全权厘 定为当时现行货币市场汇率的汇率，兑换款项为任何货币及从任何货币兑换款项。在进行货币兑换"+
          "交易时，本公司作为主事人身份行事。该兑换可为下列目的进行︰  (i)执行任何指示或交易，或(ii)  计算、清偿、收响应收客户的任何借项结余或应付客户的贷项结余，或 (iii) 与本协议有关的任"+
          "何其 他目的。",
          "9.2 人民币 ：如有以人民币计价的交易，客户同意并确认：",
          "(a) 人民币受外汇管制且有可能不可兑换的风险；及",
          "(b) 除非本公司另有规定，以人民币计价的交易应以人民币结算。",
          "10 投资产品的保管",
          "10.1 一般 ：客户确认及同意，根据本协议通过结算系统或在结算系统中不时获得和/或持有的投资产品将 在适用法规规限下及按照适用法规持有。",
          "10.2 保管 ：本公司或本公司的任何有联系实体根据本协议持作保管的任何投资产品可由本公司全权及在 适用法规规限下︰",
          "(a)  (如为可注册投资产品) 以客户或本公司或本公司代名人名义注册；",
          "(b) 以保管方式记存于本公司在有关市场于本公司的有联系实体或任何其他合资格为投资产品及相关文件提供保管安排的机构持有并指定为信托或客户账户的独立账户；或",
          "(c) 且在任何上述情况下，概不构成本公司作为无力偿债或清盘用途的资产的部分，惟应于委任临时清盘人、清盘人或类似人员处理本公司全部或任何部分业务或资产后尽快退回予客户。",
          "10.3 托管人 ：客户委任本公司作为客户在本协议规限下向本公司或其任何分托管人或代名人交付并获本 公司接纳的所有现金及投资产品的托管人。本公司有权按其酌情认为适当的条款将该等现金或"+
          "投资 产品存入其他公司或机构。该等现金或投资产品可能与本公司的其他客户的现金或投资产品一并组 合存托(但不会与本公司本身账户持有的现金或投资产品一并组合存托)。",
          "10.4 组合 ：客户确认并同意,当客户的资产与其他人士的资产组合及共同持有时，客户的个人权益不可以 独立文件、记录或拥有权或所有权证据予以识别。",
          "10.5 向客户转让 ：受限于第 10.7 条(完全清偿责任)的规定，本公司在合理可行的情况下将尽快在客户 指示后：",

          "(a) 促使不时于账户的任何投资产品以客户或客户书面通知本公司作为其代名人的人士的名义注册，或倘如此指示，向客户或代名人交付陈述或证明投资产品的文件，据此投资产品将不再于 账户持有；及",
          "(b) 从账户将客户指示指定的任何金额转拨至客户指示的客户银行账户，而该转拨将视为充分解除本公司向客户作出付款的义务。",
          "10.6 转授/分托管人：受限于适用法规，客户不可撤销地授权本公司按第 2.5 条款(公司转授) 所述方式，委任一名或多名转授/分托管人，不论在香港以内或以外，在任何期间内都要履行本公司的托管和保 管职责。",
          "10.7 完全清偿责任 ：本公司在第 10.5 条款(向客户转让)  中的义务应受限于本协议的其他规定，特别是第 16 条款(押记) 的规定，以及本公司要求在客户提取任何款项之前全面清偿所有责任的权利。本 公司可在不通知客户的情况下，在根据第 10.5 条款(向客户转让)进行登记或转让前，以账户结余 金额清偿任何或所有负债，或以其它方式要求客户在根据第 10.5 条款(向客户转让) 进行登记或转 让前支付有关款项。",
          "10.8 表决权等 ：客户在此授权本公司按照其与客户投资产品有关的指示行事，包括行使投票权及投资产品所附带的其他权利。尽管有上述规定，本公司可完全自行以其绝对酌情权决定拒绝根据任何指示行"+
          "事，而无须给予任何理由。本协议的任何规定均不得以任何方式使本公司承担通知客户或就出席 会议采取任何行动和在该等会议上表决的任何责任。除适用法规另有规定外，本公司无义务就其收 到的与投资"+
          "产品相关的通知、通讯、转授书及其他文档，或向客户发送该等文档或发出收到该等文 件的任何通知。本公司有权就其根据客户指示采取的任何行动向客户收取服务费。",
          "10.9 股息等 ：本公司将向相关账户支付客户与投资产品相关的所有股息、分红、利息、息票或利益。",
          "10.10 无义务通知或行使权利 ：在不影响第 10.8 条款(表决权等) 的一般性效力的前提下，如果客户的投资产品以本公司或本公司指定的任何其他人士的名义(但非以其他方式)注册，则本公司可以但并 无义务：",
          "(a) 将本公司收到的与该等投资产品相关的信息、通知及其他通讯通知客户(但无义务在就投资产品中提及的任何事项向本公司发出指示的充足时间内将该等信息、通知及其他通讯转发给客户， 亦无义务调查或参与或采取任何积极行动，但根据客户发出的具体指示(本公司接受该等指示)， 并根据本公司可能要求的条件、赔偿及合理费用拨备进行的除外)，在未收到或延迟收到客户    发出的具体指示的情况下，不得采取行动，并且就相关事项的任何违约选择权应适用；及",
          "(b) 行使、认购、采用或以其他方式处置与客户投资产品相关的公司认为合适的、对客户具有约束力的权利或新事项，除非本公司已实际收到客户的相反指示(且本公司接受该等指示)，但根 据适用法规，本公司不会采取可能导致本公司或其指定人有义务披露权益的任何行动。",
          "10.11 进一步行动 ：客户授权本公司及其代名人在提供托管服务时，采取一切为遵守任何适用法规所需的行动，包括就账户内的现金或投资产品代扣代缴及/或支付应付的税款或税项。客户确认，对于本公 司或其指定人士持有的与投资产品相关的任何催缴、分期付款或其他付款，本公司及其代名人均不 承担任何责任。",
          "10.12  投资产品的返还 ：无论因何种原因终止安全托管服务，本公司有权将客户托管的全部资产返还给客户(风险和费用由客户自行承担)，包括将与本公司最初托管或接受的投资产品序号或标识不一致的 投资产品返还给客户。",
          "10.13 无托管 ：提供安全托管服务并不使本公司成为客户或任何客户资产的受托人，除非任何该等资产以本公司或本公司的代名人的名义登记，在这种情况下，本公司仅作为被动受托人行事。除本协议规 定的义务外，本公司就客户资产不承担任何其他义务。",
          "10.14 客户责任 ：任何投资产品转让时，客户应负责安排第三方将投资产品交付给客户或由客户接收，且任何手续费、转账费或托管费等均由客户自行承担。",

          "10.15 相同类别和面额 ：本公司代表客户购买或取得的投资产品的交付、在安全保管下或以客户名义登记的任何义务应通过以客户或其指定人的名义交付、持有或登记与本公司最初代表客户存储、转让或 取得的投资产品的面额和名义金额相同的同类投资产品的方式履行。",
          "10.16 客户风险 ：本公司和/或其代名人根据本协议为客户或代表客户存放或持有的投资产品应由客户自行承担风险，本公司无义务就任何种类的风险为任何该等产品投保，该等义务应由客户自行承担。",
          "10.17 处置 ：根据《证券及期货(客户证券) 规则》(香港法例第 571H 章) 第 6 (3) 条的规定，本公司获授权为处置或促使本公司的有联系实体处置客户的任何证券或押记资产，以解决客户或代表客户欠 本公司、有联系实体或第三方的任何债务(且公司有绝对的酌情权决定要处置的证券或押记资产)。",
          "11 佣金、收费和支出",
          "11.1 佣金及收费 ：客户应就本公司在本公司提供的收费表中指明或不时另行通知客户的本公司服务(包括提供电子服务)，支付佣金、费用、收费、经纪佣金、溢价或其它报酬。本公司保留不时修改其费 用表及该等其他告示的权利。",
          "11.2 维护费 ：本公司可能会向不时指定的任何期间内就没有交易活动的任何账户上按月收取维护费，本公司将通知客户该相关收费。",
          "11.3 费用及开支 ：客户须就本公司就交易、账户及/或提供服务而招致的所有费用及开支，包括应付予任何经纪人、托管人、代理人及代名人的费用、印花税、过户费、登记费、税项、股票结算费、有关交 易所、结算所或市场征收的征费、利息及其它手续费或开支，负上全面弥偿责任。",
          "11.4 资金转账手续费 ：客户同意，如因任何由客户发起的任何资金转账而引致需要向客户收取行政费、汇款手续费及银行代理费，将由客户承担。客户亦同意，如有任何向本公司支付的款项或当客户将 资金转账到账户时，必须先扣除所有收费及应收费用。客户授权本公司代表支付上述收费及应收费 用 (如适用) 。",
          "11.5  从账户中扣款 ：本公司获客户授权，可随时向任何账户收取或扣除任何佣金、费用、收费、经纪佣金、酬金、征费、税项及客户须支付的其他费用及开支，而无须事先通知客户。",
          "11.6 全额支付 ：客户应在到期日以本公司指定的方式以立即可用的资金(或公司自行确定并可接受的其他资金) 并以本公司自行要求的货币向本公司支付款项，不得进行任何扣除、抵销、反诉、预扣或 设定任何种类的条件，但如果法律强制客户进行该等预扣，则客户应支付的金额应予以增加，以使 本公司实际收到的净额等于如未预扣则本应收到的金额。",
        "12 税项",
          "12.1 客户责任 ：客户全权负责处理并履行所有适用法规项下的所有税务问题、责任和义务。客户应向其税务顾问寻求独立税务专业意见，据以确定自己的纳税立场、责任和义务。本公司不对客户的任何 税务问题、责任或义务提供咨询或处理。",
          "12.2 提供信息要求 ：经本公司合理要求或任何相关司法辖区的税务机关和/或任何其他机关要求，客户应签署并提交公司可能要求的任何表格、证明或文文件，并提供本公司可能要求的必要信息和协助(包 括与共同报告标准相关的信息和协助)。",
          "12.3 外国账户税务合规法案 (FATCA) ：在不影响第 12.2 条款(提供信息要求)的情况下，客户承诺向本公司提供公司要求的信息、文文件和证明，以履行适用的跨司法辖区税务合规规则规定的义务。这 包括但不限于：",
          "(a) 「外国账户税务合规法案 (FATCA)」指：",
          "(i) 《1986 年美国国内收入法》(及其修订)第 1471 条至第 1474 条或其任何修订或后续版 本；",
          "(ii) 政府与监管机构就第(i) 段达成的任何政府间协议、谅解备忘录、承诺及其他安排，包括香港政府签订的协议；",
          "(iii) 本公司与美国国税局或其他监管机构或政府机构根据第(i) 段或与第(i) 段相关签订的协议；",
          "(iv) 美国、香港或其他地方根据任何上述规定通过的任何法律、规则、法规、解释或惯例；及",
          "(b) 税务信息共享安排，指任何本地或外国法律、法规和规则，包括但不限于外国账户税务合规法案及相关规章制度项下的义务，以及影响本公司的其他国际交流安排。",
          "12.4 弥偿 ：在不限制客户提供的任何其他弥偿的原则下，客户应按要求就因客户指示、账户或本公司向 客户提供服务(包括因客户未能遵守本第 12 条款的规定) 而引致的任何责任、合理损失或开支(包 括税款及征费)  向本公司、高盈证券成员及其代理人作出赔偿。",
        "13 金钱和非金钱利益",
          "13.1 金钱利益 ：客户确认，本公司或与本公司有关连的任何人士可从经纪商、产品发行人或其他第三方 处获得金钱利益。",
          "13.2 不可量化：本公司可获得金钱利益，该等金钱利益的金额在交易达成之前或交易达成之时不可量化。",
          "13.3 非金钱利益 ：客户确认并同意，公司或与其有关联的任何人士可能从经纪商、产品发行人或其他第 三方获得公司认为适当的非金钱利益，包括但不限于服务、赞助、广告、研究分析、差旅、住宿和娱 乐。",
          "13.4 独立性 ：除非本协议或公司另有规定，公司不是独立的中介人，理由如下：",
          "(a)  本公司将收取由其他人士(可能包括产品发行人) 就其向客户分销投资产品而提供的费用、佣金或任何其他金钱收益。有关详情，客户应参阅本公司在任何投资产品交易达成之前或达成之 时针对金钱利益的进一步披露；及/或",
          "(b) 本公司将从其他人士处取得非金钱利益，或与本公司可能分销给客户的投资产品的发行人有紧密联系或其他法律或经济关系。",
          "13.5 向第三方付款 ：客户同意授权本公司在适用法规允许的范围内向第三方提供和支付佣金、回扣、商 品、服务和/或其他利益，以交换该第三方推广本公司的服务、推荐客户给本公司及开展其他类似活 动。",
        "14 电子服务",
          "14.1 电子服务 ：公司可不时全权酌情决定向客户提供某些电子服务。如若如此，则本第 14 条应适用。",
          "14.2 正确输入及依赖 ：客户同意本公司有权依赖正确输入的登入标识符及密码，以确定给予本公司的任 何指示是否为客户的指示，并依据该假设行事。客户应对透过电子服务输入所有数据及透过使用电 子服务向本公司发出的所有指示承担全部责任，即使该等数据或指示可能是由经授权或未经授权代 表客户发出该等指示的第三方发出。客户承诺，如在使用登录标识符和密码登录时有任何困难，将 立即通知本公司。",
          "14.3 个人 ：客户应为其登录标识符和密码的唯一授权用户。",
          "14.4 保管 ：客户对其登录标识符和密码的保密性、安全性和保管负全部责任。客户承诺，若客户怀疑该 登入标识符或密码已被泄露、遗失、被盗或未经授权使用，将立即通知本公司。",
          "14.5 禁止性规定 ：客户使用电子服务时不得有下列行为：",

          "(a) 未经本公司明示书面同意，以任何方式翻录、转发、散播、出售、发布、刊登、广播、传阅、利用(无论是为商业利益还是其他目的)从电子服务获得的或通过电子服务获得的数据及/或报 告，且不得将信息用于任何不正当或非法目的或违反适用法规；",
          "(b) 进行任何添加，修改，调整或变更以篡改任何部分或破坏于电子服务上或通过电子服务可获得的任何信息或服务；",
          "(c) 允许将任何设备或软件以任何方式连结或通信，或与任何其他服务或系统结合使用，使得从本 公司获得的任何信息和/或报告可能被该等设备或软件取用，使用，存储或重新分发；及/或",
          "(d) 使用除协议规定或公司可能不时发布的其他指示所规定的电子服务下可用的设施。",
          "14.6 暂停和终止 ：公司可根据其完全及绝对酌情权不时在不通知客户的情况下：",
          "(a) 修订、修改、暂停或终止电子服务的运行和/或该等电子服务的使用条款；",
          "(b) 暂停或终止客户进入或使用电子服务；及/或",
          "(c) 停用登入标识符及密码，并无须对客户负责就客户因上述任何行动而可能蒙受的任何损失、损 害、费用、收费或开支。",
          "14.7 固有漏洞：客户接受并确认，电子系统和技术(包括电子服务及本公司使用的该等其他系统和技术)  在本质上容易出现黑客攻击、中断、延误或故障等现象。如电子服务未能为客户提供时，客户必须 自行采取替代方案以执行指示。",
          "14.8 责任限制 ：本公司对客户不论如何使用电子服务所引致或引起的任何损失，损害，成本，收费或开 支概不负责，包括但不限于：",
          "(a) 丢失或未经授权的使用登录标识符或密码的；",
          "(b) 未经授权使用或进入电子服务；或",
          "(c) 无论出于何种原因，电子服务的任何延误、错误、失败或无法进入或不可用。",
          "14.9 知识产权",
          "(a) 除非另有说明，本公司或某些其他第三方(包括但不限于经纪，合作伙伴或保荐人)(合称为「权利持有人」) 是通过电子服务提供和电子服务上发布的材料的所有知识产权的拥有人或被 授权人。这些内容受到全球版权法和条约的保护。所有此类权利一律保留。",
          "(b) 在使用电子服务时，客户同意不作出任何会违反、侵犯、损害或以任何方式影响权利持有人的 知识产权，包括但不限于本公司网站及软件的所有部份(「知识产权」) 的事情，并应采取所有 必要措施以保障及保护此等知识产权。由电子服务提供或产生的数据或报告中的所有知识产权 	(不论是版权或其他形式的知识产权)均纯粹归属于及将保留为权利持有人的专有财产。",
          "(c) 如未事先获得相关权利持有人许可，客户不得上传，发表，翻录，转发，传播，出售，发布， 广播，传阅，利用或分发通过电子服务提供而受版权或其他知识产权 (以及公开权和私隐权)  保护的任何数据，软件或其他材料，也不得将其或其任何部分用于个人使用或其日常业务以外  用途。",
        "15 留置权",
          "在不影响在本协议项下授予公司的任何其他权力、权限、权利和补偿的情况下，在欠公司、其代 名人和高盈证券或任何关联公司的所有款项均已被全额支付、清偿或解除之前，公司有权以留置权的形"+
          "式保留并预留所有款项、投资产品(包括但不限于为客户或代表客户购买的或客户拥有账户权 益的任何及所有投资产品) 以及公司、其代名人或任何高盈证券成员不时持有的客户的其他财产，无论是为安"+
          "全保管还是为其他目的持有，还是根据本协议或以其他方式持有，公司有权以本公司认为合适的价格收取、出售或变现该等款项、投资产品和财产的全部或任何部分，并在扣除费用后使 用收益清偿客户"+
          "欠公司、其代名人或任何高盈证券成员的任何款项。经公司要求，客户应自行承担 费用和支出，向公司或公司指定的任何其他主体执行将该等金钱、投资产品和财产的法定所有权归 属于公司或公司指定"+
          "的任何其他主体的所有转让并开展所有必要事项。",
        "16 押记",
          "16.1 押记 ：鉴于公司向客户提供的服务，客户作为实益拥有人，特此以第一固定押记的方式将其目前和 未来在所有押记资产中的所有权利、权属、利益、权利主张和权益作押记，以作为客户妥善和"+
          "准时 支付并履行所有负债及客户不时履行所有其他义务的持续担保。如果设定的担保由于任何原因作为 第一固定押记无效，则该担保应作为第一浮动押记生效。本第 16.1 条设立的任何浮动押记应在"+
          "任何 违约事件发生时自动转换为特定的固定押记(在一般法律项下发生浮动押记的情况之外且在不影响 该等情况的情况下)。在不影响上述规定的前提下，公司可在任何时间且不时通过书面通知客户的方"+
          "式，就该等通知中指定的全部或任何部分押记资产将任何浮动押记转换为固定押记。",
          "16.2 无责任 ：公司和公司的代名人不应以任何方式对为强制执行抵押品之目的而采取的任何行动所造成 的任何损失承担任何责任，无论该等损失是否已经造成或产生，无论该等行动是否可以或本可获得 更好的价格，亦无论该等损失是否可以通过推迟或提前采取该等行动的日期而减少或避免。",
          "16.3 损失和责任(集团内部出售) ：本公司在按照届时的市场价格向任何高盈证券成员使用、出售或处置 押记资产或其任何部分时， 不应：",
          "(a) 以任何方式对以任何方式产生的任何损失承担责任；也不应",
          "(b) 对公司、其任何代名人或高盈证券成员的任何利润承担责任，除非公司另行通知客户(无论是在相关的拨款或止赎之前还是之后)，否则不得将其视为对抵押资产的绝对占用或丧失抵押品 赎回权，以排除客户以及其在其中的权益。在此情况下，任何该等占用或丧失抵押品赎回权应 被视为按公允市场价值出售押记资产，负债应减去相当于该等出售收益的金额。",
          "16.4 持续担保 ：抵押品应为持续抵押品，即使账户有任何中期付款或结算，或全部或部分债务已获清偿， 及即使任何账户结束及其后重开，或任何账户其后由客户单独或与其它人士共同开立账户。在不影 响前述规定的情况下 ，即使本协议终止，抵押品仍应存在并继续具有充分效力，直至客户已完全清 偿所有负债为止。",
          "16.5 附加权利 ：第 16.1 条(押记)  中设立的押记应作为公司目前或将来就责任可能持有或采取的任何其 他担保、保证或赔偿的补充，不影响也不受其影响，并可由公司在不事先追索任何该等其他担保、 保证或赔偿的情况下强制执行。",
          "16.6 暂记账户 ：根据抵押品变现的任何款项可存入公司开立的暂记账户的贷方，公司或代名人可全权决 定但无任何义务的情况下同时将该等款项或款项的任何部分用于或用于清偿债务。",
          "16.7 解散无效 ：抵押品不得因本协议的任何修订或变更或因客户的解散、破产或无力偿债而解除。如客 户为商号，而商号已拆伙时，在收到拆伙实际通知前，抵押品对以该商号名义所欠商号之一切债务， 应继续有效；如商号拆伙仅因引入一名或多名合伙人而引致者，则除当时已拆伙之商号之债务及责 任外，抵押品亦对由新合伙人所组成之商号同样适用，一如商号之组织无任何变更。",
          "16.8 客户承诺 ：客户向本公司承诺：",
          "(a) 其不会在任何押记资产或任何账户上设立或允许存在任何产权负担(但依法产生的任何产权负担除外) 或处置任何押记资产或任何账户，但本协议中规定的除外；",
          "(b) 客户应将押记资产的所有证书、文书和所有权证明(在适当的情况下) 连同本公司可能不时要求的所有必要的转让形式存放于公司或其指定的银行；",
          "(c) 客户应签署并交付公司为完善其所有权或归属公司或使公司能够将押记资产的全部利益授予 公司之目的而可能不时要求的进一步转让、押记、授权及其他文件；",

          "(d) 未经公司事先同意，客户不得提取或试图提取全部或任何部分的押记资产；及 ",
          "(e) 客户不得采取或不采取可能损害抵押品效力的任何行动。",
          "16.9 无限制 ：任何适用法规对任何直接或其他出售权、收益运用或对任何其他权利或抵押或其他产权负担的合并施加的任何限制不适用于抵押品、公司或客户向公司提供的任何其他担保。",
          "16.10 授权书 ：客户以担保方式，不可撤销地委任本公司及其任何代表或附属代表为客户的真实合法的代理人(有全权委任替代人及再委任人，包括有权授权如此委任的人就抵押品作出进一步委任)，以客 户的名义或以其他方式，签署、盖章、交付、行使及以其他方式完善及作出下列所有协议、法令及 事情：",
          "(a) 客户就抵押品本身所能做的事；",
          "(b) 客户在抵押品下有义务或可能有义务；及/或",
          "(c) 否则，在公司看来，可能被要求或被视为适当或适当的，或与抵押品授予的所有或任何权利的 充分行使及其有权充分行使抵押品条款的权利。",
          "本授权书随附权益并不可撤销的，在任何债务存续期间将保持不可撤销。客户追认并确认，并同意 追认并确认根据本第  16.10  条指定的任何代理人(或任何替代或转委托人)可合法签署、盖章、交 付、行使或进行的任何协议、行为或事项。",
          "16.11 不得撤销 ：抵押品的任何撤销、解除或结算应以客户或任何其他人士因任何原因撤销、减少、命令退还或偿还有关债务的任何担保、处置、付款或清偿为条件，如果该等条件未获满足，本公司有权 强制执行抵押品，如同该等撤销、解除或结算未发生一般。",
          "16.12 复原 ：如果本公司认为客户或任何其他人支付的款项能够被宣告无效或以其他方式(在客户清算时或以其他方式) 划拨，则该款项不应被视为已支付。此外，本公司可根据其酌情权就任何付款、担 保或其他处置有可能被宣告无效、减少或偿还的任何权利主张作出让步或妥协。",
          "16.13 良好拥有权 ：客户陈述并保证，押记资产由客户实益拥有，客户将拥有良好权利和权属投资产品存放于公司、其代名人或高盈证券成员，该等资产目前及将来均不附带任何种类的任何留置权、押记 或产权负担，目前及将来均不受限于任何选择权，抵押品中包含的任何股票、股份及其他投资产品 目前及将来均已被全额支付。",
          "16.14 权利的行使 ：在公司执行其在任何担保项下的任何权利之前，(i) 公司有权(仅在向客户发出通知的前提下) 行使与押记资产相关的投票权及其他权利，以保护押记资产的价值；及(ii) 除非"+
          "此等条款 另有规定，客户可指示行使附加于押记资产或与押记资产相关的其他权利，但此举不得与客户在本 协议其他义务有所矛盾，或在任何形式下可能影响本公司就抵押品的权利。",
          "16.15 抵押品的保护 ：如果任何人就本协议所载的任何事项或全部或任何部分抵押品或就本协议所载的任何事项或全部或任何部分抵押品针对公司提起任何诉讼或程序或提出任何权利主张或要求，"+
          "本公司 有权采取其认为必要或适当的合理措施，包括拒绝向客户支付或交付构成抵押品一部分的全部或任 何部分的任何款项，以及取消或不遵守客户就全部或任何部分抵押品可能发出或可能发出的任"+
          "何指 令或指示。本第  16.15  条的任何规定均不应被解释为公司就与本协议或抵押品相关的任何行动、程 序、权利主张或要求采取任何措施的义务",
          "16.16 股息 ：客户可收取的构成抵押品全部或一部份的任何股息、分派、利息、款项、权益，客户须以信托形式代本公司持有，并须在本公司要求时支付予本公司。",
          "16.17 不得放弃和无效 ：抵押品不得因本公司未取得任何担保或本公司取得的任何担保的无效性、非法性或不可强制执行性，或因本公司就向客户已作出或将作出的任何预付款的用途而订立的任何现有或 未来协议而受到影响。",
          "16.18 延长期 ：如果客户根据本协议或任何其它协议所声称的任何义务或责任(如有效或可强制执行，该等义务或责任将由第 16.1 条款(押记) 所设定的押记所担保，该等义务或责任因任何原因全"+
          "部或部 份对客户无效或不可强制执行，包括客户权力的任何缺陷或不足或欠缺，或任何不正常或不当行使 权力，或任何声称代表客户行事的人士违反或缺乏授权，或任何法定限制(不论根据《时效条例"+
          "》 	(香港法例第 347 章)还是其他方式)或其他无行为能力，或任何其他事实或情况(无论是否为公 司所知悉)，或如果客户由于任何其他原因没有或不再有法律责任解除其在本协议或任何其他协议中"+
          "承担或声称承担的任何义务或责任，则可终止本协议或任何其他协议中约定的客户的义务或责任。 第 16.1 条款(押记)  中设立的押记应适用于担保该义务或责任或声称的义务或责任，如同该等义务或责"+
          "任完全有效并可强制执行。",
          "16.19 客户重组 ：客户或其作为抵押品的人或其他组织的组成在任何时候发生变更，均不影响抵押品的有 效性或解除担保。如果客户为合伙企业，在公司解散的情况下，抵押品应适用于担保该公司"+
          "或以该 公司的名义发生的所有债务和负债，直至公司收到实际解散通知。但如商号拆伙仅因新合伙人或新 合伙人加入而引致者，除旧商号之债务及责任外，其抵押品仍应继续有效，而「负债」之定义，"+
          "亦适 用于由新商号所欠下或引致之所有款项及所欠债务，犹如商号之组织维持原状一样。",
          "16.20 未生效的抵押品 ：在不影响上述规定的一般性的情况下，抵押品及其担保的金额不会以任何方式受 到以下各项的影响：",
          "(a) 本公司、其代名人或任何高盈证券成员目前或将来在本协议项下或与本协议相关持有的任何其他担保、保证或赔偿或任何其他责任；",
          "(b) 对任何担保、保证或赔偿或其他文件的任何其他变更、修订、放弃或解除；",
          "(c) 本公司、其代名人或任何高盈证券成员强制执行或不强制执行或解除任何担保、保证或赔偿或 其他檔(包括第 16.1 条(押记)中设立的押记);",
          "(d) 本公司、其代名人或任何高盈证券成员给予客户或任何其他主体的任何时间、宽限、弃权或同 意；",
          "(e) 由本公司或任何其他人士向客户提出或未提出任何要求，要求支付本协议项下应付的任何款项；",
          "(f) 客户资不抵债、破产、死亡或精神失常；",
          "(g) 本公司可能与任何其他人实现的任何合并、兼并或重组，或将公司的业务、财产或资产的全部或任何部分出售或转让给任何其他人；",
          "(h) 客户在任何时候针对本公司或任何其他人士可能享有的任何权利主张、抵销或其他权利的存在；",
          "(i) 本公司与客户或任何其他人士达成的任何安排或妥协；",
          "(j) 本协议的任何规定或任何担保、保证或赔偿(包括第 16.1 条(押记) 中设立的押记) 或任何一方在本协议项下或与之相关的任何权利或义务或任何担保、保证或赔偿(包括第  16.1  条(押 记)  中设立的押记) 的不合法、无效或不可强制执行或存在任何缺陷，无论是基于越权、不符 合相关主体的利益、未由任何主体正式授权、签署或交付，还是由于任何其他原因；",
          "(k) 根据有关破产、无力偿债或清盘的任何法律可予撤销或受其影响的任何协议、担保、保证、赔偿、付款或其他交易，或客户以诚信态度作出的任何该等协议、担保、保证、赔偿、付款或其 他交易的解除、和解或清偿，而任何该等解除、和解或清偿应被视为相应地受到限制；或",
          "(l) 本公司或任何其它人士所做或遗漏或疏忽的任何其它事情，或任何其它交易、事实、事情或事 情，若无本条款规定，可能会损害或影响客户在本协议下的责任。",
        "17 客户的陈述、保证和承诺",
          "在客户于本公司维持任何账户及向本公司发出每项指示期间，客户作出本第 17 条所载的陈述、保证 及承诺。",

          "17.1 法人客户等 ：若客户为法人团体、合伙或信托(不论是否为法团) ,客户声明及保证其为依其成立地 法律正式成立或组成(视乎情况而定)及有效存续之法人团体，并有充分权力及法律能力根据"+
          "客户 成立或组成之公司章程之条款签订本协议及履行其于本协议项下之义务；且客户提供予本公司同意 签署本协议之决议(或其他类似文件)之核证副本，是于本协议签署日或之前依其公司章程之规定"+
          "， 在其董事或其他职员(视乎情况而定)正式召集及召开之会议上正式通过，且具全面效力和全面生 效。",
          "17.2 个人利益 ：除非本公司另行明确准许，否则客户为每项交易发出指示的最终责任人，并将获得每项 交易的商业或经济利益和/或承担其商业或经济风险，并以相关投资产品和账户的主事人和实益拥有"+
          "人的身份自行交易，除客户外，任何人对相关投资产品或账户均不享有任何权利或利益。",
          "17.3 能力 ：客户拥有并将拥有完全的权力和能力订立本协议、与公司或高盈证券成员订立的任何其他协 议，并根据该等协议履行其义务，开立并运营每个账户，发出指示，并进行每项交易。",
          "17.4 真实信息 ：由客户或其代表在开户表格或其他方面不时提供的与本协议相关的信息在所有方面均真 实、完整和正确。客户承诺，倘若相关信息发生变更，其将立即通知本公司。",
          "17.5 良好拥有权 ：客户作为实益拥有人对于客户向本公司交付的所有投资产品及其他资产(不论为任何 目的)、指示本公司根据本协议出售或以其他方式处置的所有投资产品及其他资产拥有不受产权负担 约束的所有权。本公司无义务检查或核实任何该等投资产品和资产的所有权，本公司对该等所有权 的任何欠妥不承担任何责任。",
          "17.6 同意 ：客户为签署本协议、在任何市场进行任何交易及履行其在本协议项下的义务而可能需要的所 有同意或可授权均已获得并具全面效力和全面生效。",
          "17.7 有效且具有约束力的义务：本协议构成对客户有效且具有法律约束力的义务，并可根据其条款执行。",
          "17.8 适用法规 ：本协议及其履行和本协议包含的义务目前和将来均不会违反任何适用法规、客户备忘录 和章程细则或细则(如适用)的任何规定，亦不会构成对约束客户的任何协议或安排的违反或违约。",
          "17.9 协议及风险披露声明 ：客户确认已向其提供一份其选择的语言(英文或中文)  的协议的副本，并应 邀阅读本协议的条款。客户声明已充分理解本协议全部内容，已经阅读并理解本公司附件 X  (风险 披露声明) 及其他提供给客户使用其选择语言(英文或中文) 的相关风险披露声明，已获邀请提问， 及明白在有需要时可寻求独立意见并充分接受有关投资产品与交易的风险。",
          "17.10 客户资料 ：经本公司要求，客户应向本公司提供本公司不时为开立、维持、操作及/或关闭任何账户 之目的而要求的有关客户及各获授权人士之身份、客户之财务状况及资金来源或其它相关事"+
          "项之资 料及文檔。客户同意，在本公司收到客户有关开户表格更改的通知之前，本公司可依赖于在开户表 格中提供的数据。如客户或其代表根据本协议或根据本协议订立的任何协议或与任何账户有关的任 何协议提供的信息发生任何重大变更，客户应及时书面通知本公司。",
          "17.11 进一步保证 ：客户向本公司承诺将按本公司合理认为与履行及执行本协议相关所必要或可取而要求 客户进行或签立的任何行动 、契约、文档或事情，包括客户签署一份不可撤销的授权书以委任本公 司为客户的法定代理人，以代表客户执行及签署所有该等行动、契约、文档或事情。",
          "17.12 批准 ：客户同意采取必要或本公司合理认为可取的行动或事情及签立必要或本公司合理认为可取的 文件，以追认或确认公司，其代名人或任何高盈证券成员，或任何他们中的任何人指示的另一实体 适当行使协议或根据该协议订立的或与账户有关的任何协议赋予他们的任何权利或权力所作出的任 何事情。",
          "17.13 无力偿债 ：如客户为个人，客户无破产或提出破产申请；亦无根据《破产条例》(香港法例第 6 章)  提出或获批准有关客户的自愿安排或临时命令。客户为公司或合伙企业时，客户无清盘、破产、解  散、管理或其他类似事项的命令、呈请、通过的决议或会议。",
        "18 客户资料、个人资料及披露",

          "18.1 信息提供 ：客户同意因应公司合理要求立即(i)  向公司提供客户的财务报表；(ii)  向公司披露客户财务状况的任何重大变更；(iii)  向公司提供公司可能合理要求的其他关于客户的信息(包括个人资 料)  ;  (iv)在客户就本协议向公司作出的任何陈述或保证在任何方面不再真实、完整、最新或准确 时书面通知公司；及(v) 在违约事件发生时书面通知公司。",
          "18.2 依法披露 ：客户确认，任何相关司法管辖区的适用法规、监管机构及/或交易所可能要求或要求披露与客户、其授权人士及/或账户有关的个人及其他资料。客户不可撤销地授权本公司及高盈金"+
          "融成员， 无须经客户通知或同意，即可根据适用规例，向有关机关或人士(包括香港监管机构) 披露及提供 所有有关客户、其授权人士及/或账户的资料及文文件。在不影响前述规定的一般性原则下，"+
          "客户同意， 若本公司收到任何有关监管机构的查询，客户应依本公司要求(该要求应包括有关监管机构的联络 详情)，于该等监管机构或本公司规定的期限内，直接向本公司或该等监管机构提供任何有关"+
          "客户及 /或任何最终受益人的资料。客户不能要求本公司或高盈证券成员对该等披露所产生的任何后果承担 责任，客户应按要求偿还本公司及高盈证券成员为满足披露要求而产生的所有费用和支出(包括在"+
          "全额弥偿的基础上发生的法律费用)。",
          "18.3 一般披露 ：受限于第 18.2 条(依法披露) 的规定，本公司将对关于客户和账目的信息保密，但客户授权可(i)向公司认为适合对客户进行信用查询和/或核实所提供信息的任何主体披露相关信息，"+
          "(ii)  向本公司的审计师，法律顾问或其他专业顾问，或本公司任命的任何经纪人，交易商或其他服务提 供商披露相关信息，(iii) 向任何高盈证券成员或本公司的代名人和转授人披露相关信息，(iv)"+
          "向本 公司所有或任何权利或义务(无论是根据协议还是其他方式)  的任何实际或潜在受让人披露相关信 息，(v)  向任何相关市场数据服务或交易所披露相关信息，以使本公司能够遵守其与相关市场数据"+
          "服务提供商或交易所之间关于市场数据使用的许可协议，(vi) 根据不时向客户提供的个人资料收集 声明披露相关信息，及(vii)根据本公司不时修改的公司私隐政策披露相关信息。对于根据本第 18.3"+
          "条进行的任何披露而引起的任何后果，本公司不对客户承担任何责任。",
          "18.4 私隐政策 ：客户确认其已阅读并完全接受公司私隐政策声明，该声明可在本公司的网站获得。",
          "18.5 不披露要求 ：如果不披露、保密、机密、数据私隐或其他类似的适用法规就本协议项下要求客户披露或提供任何有不披露义务的信息，但允许客户放弃该等要求或寻求同意该等披露，则应视为客户 已放弃该等要求，且客户应尽最大努力取得该等同意。",
          "18.6 客户身份规则 ：",
          "(a) 客户须应本公司要求立即告知本公司(i) 最终负责发出与交易有关的指示的个人或实体(法人或其他组织) 的身份、地址、职业和联系方式，(ii) 有可能获得交易的商业或经济利益和/或承 担其商"+
          "业和经济风险的个人或实体(法人或其他组织) 的身份、地址 、职业和联系方式，以及 	(iii)第(i) 项中提及个人或实体的指示。",
          "(b) 对于一个集体投资计划或委托账户，(a)段中所指的「实体」是指一个集体投资计划或账户，且该集体投资计划或账户的管理人不是指那些对该集体投资计划或账户拥有实益权的人(如单 位信托的份额持有人)。",
          "(c) 如果客户是为集体投资计划、委托账户或委托信托进行交易，而客户在其全权代表该计划、帐 户或信托进行投资的权力已予撤销时须尽快可行的情况下通知本公司。在客户全权代客投资的 权力已予撤销的情况下，客户须按本公司要求，立即知会有关该名/或多名曾向客户发出指示的 人士的身份、地址、职业及联络数据。",
          "(d) 如果客户知道其客户正在充当其基础客户的中介人或为该基础客户的利益行事，而客户并不了 解其交易的基础客户的身份、地址、职业和联系方式，客户确认存在以下情形：",
          "(i) 已与其基础客户订立了安排，使客户有权要求立即从其基础客户处获得(a) 段和(b)段 所述的信息，或促使客户获得该等信息；及",
          "(ii) 如本公司就某项交易提出要求，其将立即向执行交易指示的基础客户索要(a)及(b)段所载有的资料，并在从其基础客户处收到数据后尽快向本公司提供或促致该等数据被提 供。",

          "(e) 客户确认，在必要时，其已从其基础客户、集体投资计划、委托账户或委托信托(如与客户/最终受益人不同) 处取得所有相关同意或豁免，以便向相关监管部门披露基础客户、集体投资计 划、委托账户或全权委托信托的身份信息、联络信息，以及上述交易的最终受益人，和账户发 起人的身份信息",
          "(f)客户授权本公司在相关监管机构提出要求时向相关监管机构提供本第 18.6 条所列的数据。",
          "(g) 即使本协议终止，本第 18.6 条应持续有效。",
        "19 指明中介人",
          "19.1 指明中介人的承诺 ：如果客户是反洗钱条例附表 2 第 18  (3) 条涵义内的「指明中介人」，并同意根 据反洗钱条例附表 2 第 18 (1)(a) 条为本公司执行任何相关的尽职调查措施而成为本公司的中介人 	(「指明中介人」)，客户承诺：",
          "(a) 维持打击洗钱及恐怖分子资金筹集法律、法规和准则的规定，内部政策、流程和控制制度，包括对客户及其交易进行持续监控；",
          "(b) 履行及遵守反洗钱条例附表 2 第 2 条中客户尽职调查措施；及",
          "(c) 经海外或本地监管机构或本公司要求，立即提供在开展客户尽职调查措施的过程中获得的任何 文文件或任何数据或信息的记录。",
          "19.2 本公司的依赖 ：指明中介人确认，本公司依赖指明中介人开展相关客户尽职调查措施。指明中介人 同意赔偿本公司与指明中介人履行其在本第 19.2 条项下的义务的任何作为或不作为相关或由该等作 为或不作为引起的所有实际或或有负债、权利主张、要求、损失、损害、税项、费用、收费和支出， 并使本公司免受损害。",
        "20 客户对权益披露的责任",
          "20.1 披露 ：客户确认，客户须自行负责解除任何适用规例对客户施加的向任何适用交易所、监管机构或 其他人士披露任何性质的权益(不论个人、公司、家族或其他)的任何义务。客户需特别注意证券"+
          "及期货条例第 XIII 部、XV 部与《证券及期货(合约限量及须申报的持仓量)规则》(香港法例第 571 章) 之规定。谨提醒客户，客户应负责遵守或确保遵守在证券及期货条例下产生的、与公司代表客"+
          "户开展的任何事项或客户要求代表客户开展的任何事项相关的任何责任或义务。客户确认，其知悉 证券及期货条例中包含的规定，客户将始终遵守或确保遵守该等规定，从而确保公司根据或拟根据客户的"+
          "指示或指示采取的任何行动不会导致违反或侵犯证券及期货条例的任何行为。",
          "20.2 对于披露并无责任提供意见 ：客户确认并同意，本公司无责任告知客户任何披露义务，无论该等义务是普遍产生的还是由于本公司为客户实施的任何交易或持有投资产品或以其他方式由客户或"+
          "代表 客户实施的任何交易而导致的。该等披露义务为客户的个人义务。除本协议明文规定由本公司发出 的任何通知或声明外，本公司无义务以任何形式或通过任何时限发出由客户或客户代表发出的持"+
          "股 通知。因客户或其他人士未能或延迟根据任何适用规例披露权益而引致客户的任何损失、费用或开 支，本公司概不负责。如因客户未能或延迟根据任何适用规例披露权益而引致本公司蒙受或引致的"+
          "任何损失、费用或开支，客户须向本公司作出赔偿。",
          "20.3 美国人士 ：如果客户(a) 为美国人士，或(b) 收购或持有由美国人士实益拥有的任何投资产品，或 为美国人士经营任何账户，或(c) 违反任何适用法规，客户必须立即告知公司。如果客户是"+
          "美国主 体或成为美国主体，本公司有权暂停或终止其在本协议下就任何投资产品向客户提供的任何或所有 服务。本公司亦有权暂停或终止相关账户。对于客户可能就该等中止或终止发生或遭受的任何"+
          "种类 的任何损失、费用、收费或支出，本公司不承担任何责任。此外，本公司有权代表客户进行或办理 与该投资产品有关的任何税务申报。",
        "21 本公司的权利和补偿",

          "21.1 违约 ：下列每一事件均构成一违约事件：",
          "(a) 客户或客户在本协议项下义务的任何保证人或担保人因无力偿还到期债务而破产或无力偿还债务，或自愿或强制进入清算程序，或就其全部或部分资产委任接管人，或就其清盘或类似行 动提出或蒙受申请，或(自愿或非自愿地)成为任何法律项下的任何同等或类似程序的当事人；",
          "(b) 客户(如为个人)死亡，或被司法宣告为精神错乱或丧失行为能力，或(如为公司或合伙企业)解散，或为其债权人的利益达成协议或和解，或停止或威胁停止偿还其债务；",
          "(c) 当公司认为客户违反本协议的任何条款或该客户与公司或任何高盈证券的成员签订的任何其 他协议；",
          "(d) 客户或客户在本协议或其他任何与本公司或任何高盈证券成员之间的协议项下有义务的任何 保证人或担保人未能履行其在任何交易项下的义务或责任(包括未能支付应向公司或任何高盈 金融成员支付的任何款项)；",
          "(e) 客户向公司提供的任何信息或提供的任何陈述或保证在作出或重复作出时在任何方面不完整或不真实；",
          "(f) 就任何客户资产或账户发出扣押或扣押令或同等或类似命令，或作出任何判决，或执行或已执行任何判决；",
          "(g) 就客户的业务、资产或收入的任何部分，产权负担持有人接管或委任接管人、受托人或其他类似人员，或就客户的任何财产实施、执行或起诉扣押、执行或其他法律程序，且未在 7 天内全 部移除、解除或支付；或",
          "(h) 就客戶或客戶的全部或任何部分資產或業務委任管理人、清算人或類似人員，或作就客户或客户的全部或任何部分资产或业务委任管理人、清算人或类似人员，或作出行政命令；出行政命令；",
          "(i) 未经本公司事前书面同意，客户之任何账户有借方结余；",
          "(j) 客户违反任何适用法规，包括任何交易所的细则、规则或规例；",
          "(k) 客户签署本协议所需的任何同意、授权或董事会决议被全部或部分撤销、暂停、终止或不再完全有效；",
          "(l) 发生(本公司自行认为) 以下任一情况：(a) 可能损害或合理预计将损害本公司在本协议项下 的任何权利、任何利益或客户利益的任何事件，(b) 对本公司利益或客户利益不利的任何市场 情况的存在或延续，(c) 任何与本公司相关扰乱任何市场公平与秩序的行为，及(d) 任何与本 公司相关关乎任何市场或投资产品的任何市场不当行为(或本公司认为此等市场不当行为逼 切)、；",
          "(m)  本公司自行认为具有或可能具有重大不利影响的任何事件或一系列事件；",
          "(n) 本协议或其任何部分根据第 27 条款(终止) 或本协议的任何其他条款终止；",
          "(o) 客户转让或声称转让本协议任何部分的全部或任何部分的利益；",
          "(p) 就客户在本协议下的负债、义务或责任而设立的任何证券或其任何部分被宣告无效、停止有效、受到危害或受到不利影响，或任何人士就该等证券所包括的任何资产或财产而提出任何诉讼或提出"+
          "任何申索，或该等资产或财产的市值恶化、下降或贬值；",
          "(q) 任何第三方就任何账户中的任何金钱、资金、投资产品或其他资产主张权利、权利或权益；",
          "(r) 客户出售其全部或绝大部分业务或资产；",
          "(s) 本公司对客户的公司结构、业务、资产、财务或生成状况或前景的唯一和绝对意见发生任何不利变化；",

          "(t) 客户不同意本公司根据第 36.2 条款(修订) 对本协议所作之修订，或本公司及客户未能解决客户根据第 36.2 条款(修订) 所提出之异议；",
          "(u) 客户履行其在任何投资产品和/或本协议或与本公司或任何高盈证券成员的任何其他协议项下的任何义务是或变得不合法；",
          "(v) 本公司在本协议项下提供任何服务是或变得不合法；及",
          "(w) 尽管未发生违约事件，本公司认为有必要行使其在违约事件发生的情况下可能拥有的任何权力，以获得自身的保护。",
          "21.2 补偿 ：在不影响本公司可能享有的任何其他权利或补偿的前提下，如果发生任何违约事件，则在没有事先要求、请求或通知客户的情况下：",
          "(a) 客户欠本公司的所有款项应按要求立即支付，并按第 5.7 条(利息)规定的方式，不时支付未偿还的款项的利息；",
          "(b) 本公司进一步履行其在本协议项下对客户未履行的任何义务(无论是为付款还是其他目的) 应以客户已全面履行其在本协议项下对本公司承担的所有义务为前提；及",
          "(c) 本公司有权在任何时间以任何方式，在没有进一步通知，要求或征得客户同意的情况下，根据 其绝对酌情权下：",
          "(i) 终止本协议的全部或任何部分；",
          "(ii) 强制执行抵押品；",
          "(iii) 关闭或暂停任何或所有账户；",
          "(iv) 挪用、出售、变现、赎回、清算、转让、抵销、处置或以其他方式处理本公司绝对酌情权的所有或任何款项、担保资产、任何账户中的投资产品及本公司持有客户的其他财产，并 由客户自行承担风险和费用，且本公司无需就客户发生的任何损失或损害承担任何责任；",
          "(v) 抵销、合并或整合客户在本公司(包括账户)或任何高盈证券成员开立的任何性质的账户， 以及将本公司在本协议项下欠客户的任何责任和义务与客户的任何责任相抵销或合并。 本公司被授权用任何该等账户的结余金额购买为实现该等抵销或使用而可能需要的任何 其他货币；",
          "(vi) 暂停或终止本公司的所有或任何服务；",
          "(vii) 取消客户所有或任何未完成或未执行的指示；",
          "(viii) 修改、变更、撤回、停止或取消分别给予或授予客户的任何授信、预付款、信用或贷款或 其任何部分；",
          "(ix) 要求支付、偿还、清偿、满足、履行或履行客户欠本公司或任何高盈证券成员的金额、利息、金额、款项或基金；",
          "(x) 取消任何或所有未完成订单或代表客户作出的任何其他承诺；",
          "(xi) 关闭本公司与客户之间的任何或所有合同，并代表客户收取货物；",
          "(xii) 代表客户行使本公司持有的任何合同；",
          "(xiii) 通过购买和/或借用投资产品弥补任何淡仓；",

          "(xiv) 在适用的情况下，从任何账户买入之前卖空的投资产品；",
          "(xv) 通过出售，变现，赎回，转让或处置投资产品在公司清算任何长仓；和/或",
          "(xvi) 以公司绝对酌情决定的任何价格或条款，平仓或清算客户在任何账户中任何投资产品中 的部分或全部未平仓持仓。",
          "21.3 收益的使用 ：本公司有绝对酌情权将本公司实际收到的净收益(在扣除行使本协议授予其的权力所 发生的所有费用、成本和支出(包括但不限于本第 21 条款(公司的权利和补偿))) 以本公司认为适 当的顺序或方式用于清偿客户届时未履行的责任。",
          "21.4 绝对酌情权 ：公司对行使本协议授予其的权利(包括但不限于本第 21 条款(公司的权利和补偿))  的所有相关事项拥有绝对酌情权，并且可以在公司认为合适的任何时间和任何方式，以单独或"+
          "共同 方式，适当地出售，变现，赎回，清算，转让，抵销，处置或以其他方式处理客户的任何投资产品或 其他资产。",
          "21.5 短欠 ：客户应对本公司行使其在本协议项下的权利后可能存在的任何短欠以及本公司发生的任何相 关费用和支出承担责任(包括在全额弥偿的基础上发生的法律费用)。经要求，客户应立即向"+
          "本公司 支付等于该等短欠的金额以及本公司为该等金额提供资金的费用，以及自要求之日起至本公司收到 实际无条件全额付款之日止，按公司不时规定的利率计算的利息(包括在任何判决之前和之后)。",
          "21.6 债务催收代理人 ：本公司有权随时及不时聘用债务催收代理人收取客户就本协议应付但未付的任何 款项，而客户授权本公司向该等代理人披露有关客户、其被授权人、账户及交易的任何或所有个"+
          "人 及其他数据，而公司无须就该等披露或该等代理人的任何违约、疏忽、行动、行为、不当行为及/或 作为承担任何责任(不论是在合约或侵权方面)。客户须就本公司及其高级职员、雇员及代理人在聘"+
          "用债务催收代理人及关闭任何账户的过程中可能合理招致的一切合理费用及开支作出全面弥偿。",
          "21.7 平仓：就第 21.2 条款 (补偿)或协议其他条款中的任何平仓或清算客户的持仓而言：-",
          "(a) 无论以何种方式发生，本公司均不承担任何相关损失的任何责任；",
          "(b) 本公司有权向本公司或任何高盈证券成员出售或处置证券或其他任何部分，对任何相关损失不承担任何责任(无论以何种方式发生)，或对本公司和/或任何高盈证券成员获得的利益作出任 何说明；及",
          "(c) 如平仓所得款项不足以弥补客户对本公司之欠款，客户应立即清偿所欠本公司之全部剩余款项。",
        "22 责任和弥偿",
          "22.1 责任免除：客户同意，对于客户可能因交易或本协议或与交易或本协议相关而发生的任何权利主张、 诉讼、起诉、程序、损失、损害、义务、责任、费用、收费及开支(包括因本公司委任的任何经纪人"+
          "及交易商所进行的交易，因第 5.1 条(指示经纪商) 中列明的任何第三方的行使的任何权利，或因本 协议第 5.3 条款(「按最佳条件」或「按市场条件」执行指示) 或第 28 条(不可抗力)) ，除因本公司"+
          "或高盈证券成员或其各自的任何董事、管理人员、或雇员的重大疏忽、欺诈或故意违约外，本公司 或高盈证券或其各自的任何董事、雇员或代理人均不承担任何责任。在不影响上述规定的一般性效力的前提"+
          "下，本公司无须就任何交易或本协议引起的或与之相关的任何税项(包括任何预扣税)、关 税、征税或征税承担责任。",
          "22.2 一般弥偿 ：客户应弥偿公司、高盈证券及其各自的董事、管理人员、员工和代理与履行其在本协议 项下的服务相关或由于客户违反或违背其在本协议的任何规定项下的义务而可能针对公司、"+
          "任何高盈证券成员其各自的任何董事、管理人员、员工和代理施加、发生或声称的任何种类或性质的任何 和所有责任、义务、损失、损害、处罚、要求、权利主张、程序、判决、诉讼、费用、法律"+
          "费用(在 全额弥偿的基础上) 及其他支出和支出，但由公司、高盈证券成员或其各自的任何董事、管理人员 或员工的重大过失、欺诈或故意违约导致的除外，并且仅限于由该等重大过失、欺诈或故意"+
          "违约直 接且单独引起的直接且合理可预见的损失和损害(如有)。",

          "22.3 进一步弥偿 ：在不影响第 22.2 条款(一般弥偿) 的一般性效力的前提下，(i) 公司不承担任何责任， 并且(ii) 客户应按要求对本公司和高盈证券及其各自的董事、管理人员、员工和代理"+
          "可能承担的、 发生的或声称的与下列各项相关的任何种类或性质的任何和所有责任、义务、损失、损害、罚款、 要求、权利主张、程序、判决、诉讼、费用、法律费用(在全额弥偿的基础上) 及其"+
          "他支出和杂费作 出赔偿及：",
          "(a) 买方或任何其他主体由于客户对任何投资产品或其他资产的所有权存在任何缺陷而提出的任何索赔；",
          "(b) 本公司代表客户购买、出售、持有或以其他方式处理的任何投资产品的所有权或权属方面的任何欠妥；",
          "(c) 本公司接受、依靠和/或根据第 2.6 条款(被授权人士发出的指示)中提及的指示行事；",
          "(d) 本公司根据客户选择的任何方式，按照客户给出或据称由客户给出或指示给出的指示行事；",
          "(e) 本公司在第 5.11 条款(价格)所述的情况下按照实现交易的任何指示行事；",
          "(f) 客户未能在相关结算日履行其结算交易的义务或未能支付本协议项下应向本公司支付的任何其他款项；和/或",
          "(g) 本公司对本协议授予其的任何权利和权力的行使，无论是关于该等权利或权力的行使时间或方式还是其他方面；",
          "(h) 任何申请(定义见附件 II  (申购新发行证券)) ;",
          "(i) 向客户追讨债务；",
          "(j) 关闭账户；",
          "(k) 客户作出的任何陈述或保证不真实；或",
          "(l) 依法到期但尚未存入账户的投资性产品。",
          "22.4 信息的可靠性 ：在适用法规允许的最大范围内，所有信息，无论是由本公司还是第三方服务提供商 	(如市场资料和报价服务) 根据本协议向客户提供，无论是通过电子方式(包括电子服务) 还是其 他方式，均按「现状」和「可获得」的基础提供及仅供一般参考。客户同意，在本公司尽力确保该等 信息的准确性和可靠性的同时，本公司不保证任何该等信息的准确性、可靠性、及时性、完整性或 正确排序，本公司不对信息的任何不准确、遗漏或不完整或对该等信息的任何依赖所导致的任何损 失承担任何责任。",
          "22.5 投资者赔偿基金：如果本公司或其任何管理人员、员工未能履行其在本协议项下对客户承担的义务， 客户确认并接受，其(i) 在根据证券及期货条例设立的投资者赔偿基金项下要求赔偿的权利受限于 证券及期货条例的规定，及(ii)在香港以外的任何市场要求赔偿的权利受限于相关市场的适用法规。",
          "22.6 金融纠纷调解中心 ：如果客户合理地认为公司未能在合理的时间内纠正客户的投诉，则建议客户有 权将纠纷转介给金融纠纷调解中心。",
          "22.7 违法排除 ：尽管本协议有任何相反规定，但如果这是违法时，公司无法以任何方式排除或限制其对 客户的责任。",
        "23 公司权益",
          "23.1 公司在交易中的重大权益 ：在为客户进行任何交易时，本公司、其代名人和/或高盈证券成员可能拥 有与交易或相关投资产品相关的重大权益、关系或安排，在遵守任何适用法规的前提下，本公司或 其代名人或任何高盈证券成员均无义务向客户披露该等权益、关系或安排(包括其性质或范围)。客 户同意，尽管有任何该等权益、关系或安排，本公司可为客户与其任何代名人或高盈证券成员或通 过其任何代名人或高盈证券成员实现交易，本公司或其任何代名人或高盈证券成员可：",

          "(a) 在为客户进行的任何交易中，以其本身账户且以主事人身份作为交易对手方；",
          "(b) 在投资产品中持仓或担任相关投资产品的承销机构、保荐人或其他角色时实施交易；",
          "(c) 可建立与客户指令相反的仓位，不管是出于自己本身或代其他客户作出之决定；或",
          "(d) 配对客户与其他客户的买卖盘。",
          "23.2 不会对利润提出申索 ：在本公司或其任何指定人员或高盈证券成员不存在欺诈或故意不当行为的情 况下，对于客户就第 23.1 条款(本公司在交易中的重大权益)  中提及的任何交易针对本公司或其任 何代名人或高盈证券成员提出的任何权利主张，包括就本公司或其任何代名人或高盈证券成员与该 等交易相关赚取或收到的任何薪酬、佣金、利润或任何其他利益提出的任何权利主张，本公司对客 户不承担任何责任。",
          "23.3 以自己账户进行交易 ：本协议的任何规定均不得被视为禁止或阻止本公司 (a) 以任何身份为任何其 他主体行事，(b) 购买、持有或为自身利益交易任何投资产品，即使账户中可能包含类似投资产品，"+
          "(c) 或为本公司自身利益购买本公司为自身账户持有的投资产品，或为本公司自身账户购买构成帐 户一部分的投资产品，但前提是，在任何情况下，该等购买条款对客户的优惠程度均不逊于届时交 易公平进行时本应优惠程度。客户确认，受限于任何适用的监管要求，本公司、其董事和/或员工可 为其自身账户或其任何高盈证券成员的账户的利益进行交易。",
          "23.4 无披露职责 ：本协议中的任何规定均不使本公司承担向客户披露其在以任何身份为任何其他人行事 过程中注意到的任何事实或事情的任何职责，除非适用法规要求进行该等披露。",
          "23.5 公司的其他权益 ：客户同意，本公司在世界任何地方的交易所或市场代表客户执行卖出或买入指令 时，本公司、其董事、管理人员、雇员、代名人和/或任何场内经纪可为任何该等人士拥有直接或间 接权益的账户进行买入或卖出，但须遵守当时有效的交易所或市场的章程、规则、规定、惯例、裁 决和解释中所包含的限制和条件(如有)，并须遵守该等交易所或市场合法颁布的任何适用法规中所 包含的限制和条件(如有)。",
          "23.6 潜在冲突 ：本公司(及部分高盈证券的成员)有或可能从事范围广泛的金融服务及其他相关业务。 因此，本公司可能与另一方有重大利益或任何安排或任何类型的关系，而这可能会导致其对客户的 责任发生冲突。客户确认存在该等潜在的利益冲突，并同意本协议不会妨碍本公司按上述规定开展 业务。本公司应采取合理措施，确保在涉及潜在利益冲突的任何交易中公平对待客户。",
        "24 合适性及专业投资者状态",
          "24.1 一般 ：如果本公司向客户招揽销售任何投资产品或向客户建议任何投资产品，该等投资产品必须在 考虑客户的财务状况、投资经验和投资目标(「客户财务信息」)  的情况下合理适合客户。此等条款 或任何其他文件中本公司可能要求客户签署的任何其他规定，以及本公司可能要求客户作出的减损 本第 24.1 条款的任何声明均不会减损本第 24.1 条款的规定。",
          "24.2 未经任何招揽或建议 ：如果客户未经本公司任何招揽或建议或与本公司的任何建议不一致而进行买 和/或卖投资产品的交易，本公司无任何义务或责任(适用法规要求的若干有限情况除外) 评估，或 确保该投资产品适合客户，在该等情况下，客户确认及同意其会自行评估并确认交易对其的合适性。",
          "24.3 未经任何招揽或建议下的免责 ：本公司概不会就客户或任何其它人士就 24.2 条款(未经任何招揽或 建议)所述的任何该等交易招致或蒙受的任何损失(包括间接或结果性损失)、费用或损害负责。",
          "24.4 最新的客户信息 ：在进行买卖投资产品交易时，客户确认其向本公司提供的任何信息(包括客户财 务信息) 均为完整、准确及最新。本公司在评估合适性时，将依赖于客户的确认。",
          "24.5 客户的考虑因素 ：客户在进行该等买和/或卖投资产品交易之前，应：",
          "(a) 考虑自身情况及了解投资产品的性质、期限及风险，如对投资产品有任何疑问，客户应联系本公司；",
          "(b) 知悉本公司不承担确保其招揽或建议的该等投资产品仍然适合客户的任何持续责任；",
          "(c)  知悉如果客户、该等投资产品或该等投资产品的发行人或一般市场条件所涉及的情形发生变化， 该等投资产品可能不再适合该客户；及",
          "(d) 知悉本公司不会就客户的投资提供法律、税务或会计建议，因此，客户应在必要时考虑就投资 产品独立地征求专业意见(包括法律、税务和会计建议)。",
          "24.6 衍生品 ：客户了解并确认衍生品投资一般不适合对衍生产品并未具有知识的客户。如本公司将客户 归类为对衍生产品并未具有知识的客户：",
          "(a) 如客户决定购买在交易所交易的衍生产品，客户确认本公司已以口头或书面形式(包括电子方式)向客户解释有关产品的风险；及",
          "(b) 如客户购买未在交易所交易的衍生产品且本公司并未招揽或建议该争议衍生产品，客户确认，特别考虑到客户是对衍生产品并未具有知识的投资者， 本公司已就相关交易向其发出警告。",
          "24.7 专业投资者",
          "(a) 如果客户是专业投资者，则取决于专业投资者的类型，在满足若干条件后，本公司可(在处理该专业投资者时)无需根据操守准则对其履行其他情况下本公司要遵守的义务。",
          "(b) 关于个人专业投资者和法团专业投资者，为了让本公司评估其是否可以和/或可以将(或继续将)客户视为专业投资者，客户必须填写「专业投资者评估表和通知」并向本公司提供本公司不时 要求的此类信息。",
          "(c) 关于机构专业投资者，本公司可能在向该机构专业投资者发出机构专业投资者通知时将其视为 机构专业投资者。",
          "(d) 如果(i)「专业投资者评估表和通知」或上述(c)段提及的通知的条款与(ii) 本协议的任何 其他条款与不一致，则以前者的条款为准。",
        "25 联名账户",
          "25.1 联名账户 ：若账户为联名账户，即账户以多于一人名义开立：",
          "(a) 「客户」应包括上述各类人员(「联名客户」)，联名客户在本协议中的责任为连带责任；",
          "(b) 就任何一名或多名联名客户提出的任何付款要求应被视为对每一名及所有联名客户的有效付款要求；",
          "(c) 本公司可免除或解除任何一名或多名联名客户在本协议项下的责任，或与任何联名客户达成和 解，或接受任何联名客户的成分，或与任何联名客户作出任何其他安排，而不免除或解除或以 其他方式损害或影响公司针对任何其他联名客户的权利和补偿；",
          "(d) 任何联名客户的死亡、丧失行为能力或解散不得影响本协议；",
          "(e) 任何一位或多位联名客户或其个人代表根据第 27 条(终止)终止本协议不影响其他联名客户的持续责任；",
          "(f) 公司对每一联名客户的财产享有留置权。公司的留置权应作为公司根据本协议享有的权利和补偿的补充；",
          "(g) 每一联名客户单独及分别地有权根据本协议向公司发出指示或行使客户的所有权利、权力及酌情权，并代表其他联名客户与公司交易，如同每一联名客户为唯一账户持有人，并对所有联名客户具"+
          "约束力。公司被授权按照任何一名联名客户的指示行事，不得被要求就该等指示向其他 联名客户发出通知或从其他联名客户取得授权；",

          "(h) 公司无任何责任查询或监察任何联名客户在任何账户内的任何款项或财产的运用或处置；",
          "(i) 联名客户以具有幸存权的联权共有人而非分权共有人订立协议；",
          "(j) 如果任何联名客户身故，该联名客户在账户中的全部权益应根据本协议规定的相同条款归属于存续的联名客户，在本公司实际收到该联名客户死亡通知之前，已故人士对本公司承担之任何责任并不"+
          "予解除，且本公司有权对其遗产强制执行本公司的权利。已在本公司实际收到该联名 客户死亡通知之前，已故人士对本公司承担之任何责任并不予解除，且本公司有权对其遗产强 制执行本公司的权利。"+
          "已故联名客户或存续的联名客户的遗产应立即书面通知公司相关联名客 户的死亡以及该等死亡导致的被授权人身份的任何变更。公司应根据本协议的条款按照存续的 联名客户的顺序持有客户的资产，"+
          "但前提是，存续的联名客户出示并交付令公司满意的相关联 名客户身故证明，以及遵守法律项下所有适用要求的证明(包括关于缴纳或清缴遗产税的所有 义务)，公司可采取并要求公司为保护公司在任何"+
          "适用法律项下与任何税项、责任、罚款或损 失相关的利益而可能合理指定的措施和文件及/或弥偿；",
          "(k) 各联名客户应受本协议约束，而不论联名客户之间的任何安排或协议，亦不论本协议可能对任何一名或多名联名客户无效或不可强制执行(不论本公司是否知悉该等缺陷)；",
          "(l) 任何客户向本公司发出的任何通知或通讯应对公司生效，本公司向任何联名客户发出的任何通 知或通讯应对所有联名客户生效；",
          "(m) 向任何一名联名客户支付的任何款项应构成本公司对每一名联名客户有效和完全的义务解除， 无论该等款项是在任何一名或多名联名客户死亡之前还是之后支付。",
        "26 单项及连续协议",
          "本协议及其所有修订应为持续性的，并应单独及共同适用于每一及所有账户及交易。",
        "27 终止",
          "27.1 客户提出的终止 ：客户可以通过填写本公司规定的终止表格、将其交付给本公司并完成所有本公司 可能要求的其他程序来终止协议(或其任何部分)，包括终止在本公司开立的账户。本公司将在接受 客户提出的终止后通知客户。",
          "27.2 本公司提出的终止 ：即使有任何相反规定，本公司保留在任何时间中止或终止本协议及其所有或任 何服务(包括账户)  的权利，而无需给予任何通知或理由。经监管机构或其他机构要求，公司也可 能被要求采取上述行动。",
          "27.3 终止的影响 ：在本协议因任何原因终止时，客户应立即向本公司支付的所有款项。公司不再有代表 客户进行任何交易的任何义务，并有权取消客户的所有或任何未执行的指示，即使客户有任何相反 的指示。终止不得影响本公司、高盈证券成员或任何第三方在终止前在本协议项下采取的行动。",
          "27.4 客户资产的返还：客户在清偿所有负债后的剩余现金收入及款项，应在可行的情况下尽快归还客户， 风险和费用由客户自行承担。客户未能变现或未处置的投资产品及其他资产，应当与其所拥有的权 利凭证一同向客户交付，风险和费用由客户自行承担。"+
          "对于客户因该等退货和交付而发生的任何损 失或损害，本公司不承担任何责任。客户可通过通知公司，选择放弃任何该等现金收入、款项、投 资产品及其他资产。",
          "27.5 权利累积 ：本公司的任何服务或本协议的暂停或终止，不应影响本公司就客户的任何义务或责任所 享有的权利及补偿，包括本公司在该等暂停或终止前根据本协议结算客户或客户代表客户所"+
          "进行的 任何交易或发生的任何债务的权利，亦不应影响本公司对本公司所拥有或控制的客户财产的任何权 利，不论该等财产是以保管方式保管、保证金或其它目的而持有，亦不论该等财产是根据本协"+
          "议(特 别是第 21 条(本公司的权利及补救)) 或其它规定而持有，只要客户对本公司负有任何尚未清偿的责任。",
          "27.6 客户的持续义务 ：即使公司的任何服务或本协议暂停或终止，客户应继续受本协议规定的约束，但 前提是，该等规定涉及仍有待履行或解除的任何义务或责任。终止不得终止或影响客户在本协议项 下或与任何投资产品相关作出的任何保证、允诺、声称、声明、承诺和弥偿。",
        "28 不可抗力",
          "因政府限制、有关交易所或市场实施紧急程序、交易中断、内乱、恐怖主义行为或恐吓行为、自然 灾害、战争、罢工或其他非本公司所能控制的情况而直接或间接导致客户受损，本公司不承担任何 直接或间接责任。",
        "29 合并、并入和抵销",
          "29.1 合并及综合账户 ：在不影响本公司或任何高盈证券成员之任何其他权利，或本公司或任何高盈证券 成员与客户之间不时存在的任何其他协议享有之权利的情况下，本公司可毋需事先通知客户，"+
          "随时 将客户在本公司或任何高盈证券成员开设之任何户口(不论是否在香港开设，及不论是何种货币)  之全部或任何资金、投资产品或其他财产(不论是个人或与任何其他人士共同持有，及不论是否已"+
          "到期或受通知所限) 进行抵销、转让或运用，且客户亦授权每一高盈证券成员按本公司或其他相关 高盈证券成员要求向其转让或发放上述资金、投资产品或其他财产，以清偿客户之债务。当此种结 合、"+
          "合并、抵销或转移要求将一种货币兑换为另一种货币时，应当使用本公司以当时相关市场通行 的汇率为基础确定的汇率。出于上述目的，客户授权公司及高盈证券成员彼此共享有关此类账户的 任何和所有数据。",
          "29.2 提款 ：如果客户指示公司向客户提取或转移任何款项、投资产品或其他财产，公司可从在公司或任 何高盈证券成员开立的任何账户中提取或转移任何该等款项、投资产品或其他财产。",
        "30 通讯和通知",
          "30.1 致客户的通讯(以书面形式) ：除非本协议另有规定，本公司致客户的任何通讯或通知应以书面形式 发出或作出至客户最后已知的地址、传真号码或电邮地址 (视乎情况而定) 或透过电子方式(包括 电子服务) 发出或作出，而(i) 如以邮寄方式交付，则于投递后 72 小时后，"+
          "即足以证明该通讯或通 知已正确填写地址并投递，且已被客户收到或(ii)如以传真、电邮或透过电子方式(包括电子服务)  交付，则立即被视为已被客户收到。",
          "30.2 致客户的通讯(电话) ：除非本协议另有规定，本公司亦可通过电话向客户发出任何通讯或通知，并 应在通过电话发出通讯或通知后立即被视为已被客户收到。",
          "30.3 致公司的通讯(书面)  :客户致本公司的任何通讯或通知应采用书面形式，并发送至本公司最后已知 的地址、传真号码或电子邮件地址，并应仅在本公司实际收到并确认该等通讯或通知时被视为已由 本公司收到。",
          "30.4 致公司的通讯(电话)：除本协议另有约定外，客户亦可以以电话方式向本公司发出任何通讯或通知， 经本公司向客户确认后，方视为本公司已收到该通讯或通知。",
        "31 关键时间",
          "时间是客户履行与本协议有关的所有义务的关键因素。如果客户向本公司寄送的任何有关账户或本 公司发出的任何指令的文件因任何原因未注明日期，则本公司在收到该等文件时加盖在该等文件上 的时间戳记所示的时间和日期即为该等文件日期的结论性。",
        "32 自动顺延",
          "各方同意，如果本公司同意或有义务采取、采取或进行任何事项、行动或交易的任何日期(「行动日」)  为非营业日，则行动日应自动顺延至下一个营业日。",

        "33 可分割性",
          "本协议的每一条规定均可分割且与其他规定不同。本协议的任何条款如因任何原因在任何司法辖区 不合法、无效或不可强制执行，仅在该等不合法、无效或不可强制执行的范围内无效，不得影响其 余条款的合法性、有效性或可强制执行性或该等条款在任何其他司法辖区的合法性、有效性或可强 制执行性。",
        "34 转让",
          "未经本公司事先书面同意，客户不得出让或转让其在本协议或任何投资产品项下的权利和/或义务。 本公司可在不获得客户事先同意的情况下出让或转让其在本协议项下的任何权利和/或义务。",
        "35 继任者和受让人",
          "35.1 继任者和受让人：即使本公司被任何其他主体吸收合并或与任何其他主体合并，本协议应及于本公 司、其继任者和受让人之利益。本协议应对客户及其继承人、执行人、管理人、遗产代理人、继任者 和获准受让人(视具体情况而定)具有约束力。",
          "35.2 独资或合伙企业的承继：协议在客户业务发生变更或承继后继续有效，在合伙企业或商号情形下， 对合伙人及其个人代表具有约束力，在个人情形下，对其个人代表、接管人或受托人不论是否破产， 均具有约束力。",
        "36 杂项条文",
          "36.1 变更通知 ：如果与本公司或本公司的服务相关的名称、地址或许可信息、利息收费、费用及本协议 中规定的或与本协议相关的其他费用发生任何重大变更，本公司应立即通知客户。该等事项的示例 如下：",
          "(a) 本公司的全名及地址，包括其在证监会的牌照状态及其中央编号(由证监会指定的唯一标识符)；",
          "(b) 公司向客户提供或呈现的服务的性质；",
          "(c) 客户应支付给本公司的报酬(及支付的依据)；",
          "(d) 在公司向客户提供保证金或卖空安排的情况下，保证金要求的详情、利息费用、追收保证金以 及未经客户同意可能将客户仓位平仓的情况。",
          "36.2 修订 ：本公司可以其酌情权决定并通过通知客户修订、删除或替代本协议的任何条款或在本协议增 加新条款，并说明该等修订、删除、替代或增加。该等变更应被视为已纳入本协议，并在(a) 客户"+
          "继续使用本协议项下提供的任何服务，及(b) 本公司可能通知客户的日期(以较早发生者为准) 对 客户具有约束力。如果客户不同意该等变更，客户不得使用本协议项下提供的任何服务，并应在(b)  中所述日期前以书面形式向本公司提出异议。",
          "36.3 投诉 ：针对本公司的任何投诉均应以书面形式向本公司提出。",
          "36.4 欺诈 ：如果客户怀疑存在欺诈或未经授权进入任何账户的情况，客户应立即通知本公司。",
          "36.5 英文文本优先 ：如果英文文本和中文文本存在任何不一致，应以英文文本为准。",
          "36.6 权利累积 ：任何一方在本协议项下的权利、权力、补偿和特权是累积的，不排除法律或其他方面规 定的任何其他权利、权力、补偿和特权。",
        "37 遵守规章制度",
          "37.1 一般规定 ：在有关交易所、结算所或市场执行的每项交易，均须缴付该交易所、结算所或市场不时 征收的任何交易手续费、税款、征费或其它费用，而客户须负责缴付。",

          "37.2 适用法规 ：本协议应受限于证券及期货条例及任何其他适用法规。",
          "37.3 香港联合交易所 ：就在香港联合交易所达成的交易而言：",
          "(a) 香港联合交易所、香港中央结算有限公司和联交所期权结算所的规则应对客户和本公司具有约束力，如果规则和本协议之间有任何冲突，则以规则为准；",
          "(b) 在联交所进行的每项交易均需收取交易费用，该费用应由客户承担；及",
          "(c) 在香港联合交易所执行的每项交易须缴付香港联合交易所不时征收的其他税项，而该等其他税 项须由客户承担。",
          "37.4 场外衍生品交易 ：就场外衍生品交易而言，场外结算规则对客户和本公司均有约束力(如适用)，若 规则与本协议有任何冲突，则以规则为准。",
          "37.5 外地市场 ：凡在香港以外任何市场进行的交易，有关交易所、结算所或市场的规则对客户和本公司 均有约束力，并在规则与本协议有任何抵触时，以规则为准。",
          "37.6 报告职责:当本公司有合理理由怀疑客户违反适用规例的任何重大违反、侵犯或不合规规定时，本公 司有责任立即向有关机关或人士(包括香港监管机构) 报告，提供涉嫌违反、侵犯或不合规的详情 及有关资料及文件。客户不得要求公司或其高盈证券对该等报告所产生的任何后果承担责任。",
        "38 确认和独立意见",
          "38.1 确认 ：客户确认其已阅读并理解本协议，且客户同意受本协议约束。",
          "38.2 独立意见 ：客户同意，就任何交易向其认为适当的顾问寻求独立意见(包括法律意见) 是客户的责 任，特别是为附件 II (申购新发行证券) 之目的，客户确认，本公司已邀请客户就每份申请寻求独立 的法律及其他专业意见，客户仅有责任获得其认为适当的建议。",
        "39 通融",
          "39.1 通融 ：本公司方面未有行使或延迟行使本公司可能拥有的任何权力、权利或补偿不得构成对该等权 力、权利或补偿的放弃。本公司在任何时间未坚持严格遵守本协议或本协议的任何条款或本公司继 续进行该等行为在任何情况下均不得构成或被视为本公司对其任何权利或特权的一般或具体放弃， 除非该等放弃以书面形式作出并由本公司签署。",
          "39.2 事先要求 ：在本协议规定的任何时间，本公司的事先投标、对原始或额外保证金的要求或任何种类 的催缴、或本公司的先前未完成的要求或催缴、或关于该等出售或购买的时间和地点的通知不应被 视为本公司放弃出售、购买或平仓任何持仓或变现任何客户的投资产品或被抵押资产的权利。",
        "40 适用法律、司法管辖区和争议解决",
          "40.1 适用法律 ：本协议及各方的所有权利、义务和责任应受香港法律管辖，并依其进行解释。",
          "40.2 司法管辖区 ：香港法院对因本协议产生的或与之相关的任何争议(包括关于本协议的存在、效力或 终止的任何争议)(「争议」) 具有专属司法管辖权。各方同意，香港法院是解决争议的最适当和最合 宜的法院，因此，任何一方不得提出相反主张。尽管有上述规定，仍不得阻止本公司在任何其他有 管辖权的法院就争议提起诉讼。在适用法规允许的范围内，本公司可在任何数量的司法辖区同时提 起法律程序。",
          "40.3 法律程序文件的通知 ：如果客户在香港没有营业地或不是香港居民，本公司可要求客户在香港委任 一人为本公司的客户法律程序文件代理人，代表客户接收及确认在香港送达的任何法律程序文"+
          "件通 知。客户同意，任何法律程序文件如按照客户指定的地址交付至该法律程序文件代理人，则应被视 为已充分送达该法律程序文件。如果客户须委任法律文件接收代理人，而任何人士因任何原因不再"+
          "担任法律文件接收代理人，客户应立即委任继任的法律文件接收代理人，并书面通知本公司该委任。如果客户未能提供其法律程序文件代理人的详情，客户不可撤销地授权本公司代表其指定该代理人。 本公司应立即将该等委任通知客户，并提供该等代理人的详情。",
          "40.4 第三方的权利 ：本协议的任何规定均无意为《合约(第三者权利) 条例》(香港法例第 623 章) 之目的授予任何第三方强制执行本协议的任何条款或授予任何第三方在本协议项下的任何利益的任何权 利，下述范围除外：",
          "(a) 本协议另有明确说明；",
          "(b) 获准的继任者和受让人可享有并强制执行该等权利或利益；",
          "(c) 任何高盈证券成员均可强制执行本协议的任何条款并享有本协议授予其的任何利益。",

        "附件 I ：保证金融资",
        "本附件 I  适用于本公司提供的与证券保证金融资贷款有关的服务。本附件为本协议的补充条款并应与以及可 能不时修订的适用于公司提供的服务的任何其他条款和条件一同阅读。它是本协议的组成部分。",
        "1 定义和诠释：",
          "在本附件 I 中，除非文义另有所指，下列词语具有下列涵义：",
          "「合资格证券」是指本公司全权酌情决定为形成保证金之目的可接受的投资产品；",
          "「保证金」是指在现时或其后任何时间本公司全权酌情决定要求或根据适用法规要求，向本公司或 其代名人或高盈证券成员支付、存托、转让或促使转让或持有以作为证券保证金融资贷款担保的款 项及合资格证券；",
          "「追收保证金通知」具有本附件第 3.1 条(追收保证金通知)中规定的涵义；",
          "「保证金比率」是指客户获准以保证金从本公司借取(或以其他方式自本公司取得其他方式的财务 通融)的合资格证券市值(由本公司全权酌情决定)的百分率；及",
          "「证券保证金融资贷款」是指本公司根据本协议的规定以及本公司与客户不时约定的指定条款不时 向客户提供的循环信贷额度，包括从证券保证金账户中借记的所有金额。",
        "2 证券保证金融资贷款",
          "2.1 目的 ：证券保证金融资贷款的目的是为客户通过其证券保证金账户不时取得或持有的投资产品(本 公司接纳的)提供资金。",
          "2.2 上限和酌情权 ：证券保证金融资贷款的贷款上限应为本公司不时厘定的金额。公司可全权酌情决定 在任何时间增加或减少证券保证金融资贷款的贷款上限，提高或降低保证金比率，取消或终止"+
          "证券 保证金融资贷款，拒绝在证券保证金融资贷款下支付或垫支任何款项(无论是否已超过客户的贷款 上限)，并有权要求客户立即支付欠本公司的与证券保证金融资贷款相关的所有金钱和款项，无论是 本金、利息还是其他结欠。",
          "2.3 到期金额 ：在无明显错误的情况下 ，公司签发的说明客户在任何特定时间在证券保证金融资设施项 下到期应付给公司的金额的文件应为决定性的，并对客户具有约束力。",
          "2.4 结算 ：本公司获授权动用证券保证金融资额度，以结算因客户购买投资产品及任何相关佣金、费用 及开支而应付本公司的任何款项。",
        "3 保证金",
          "3.1 追收保证金通知 ：客户应于所有时候监控并维持足够的保证金，以满足任何保证金要求(无论是由 交易所，结算所或监管机构根据适用法规以及由公司实施的保证金要求)，并应本公司要求，以本公"+
          "司完全酌情权认为有必要的金额、形式、方式和时限支付或存入额外保证金，以就保证金比率和证 券保证金融资提供充分的担保(“追收保证金通知”)。",
          "3.2 金额 ：以保证金形式要求的金额不应低于但可超过适用法规可能要求的金额。",
          "3.3 通知 ：客户同意，在本公司根据本条款第 30 条(通讯及通知) 向客户发出该保证金要求的通知后， 保证金催缴应被视为适当追缴。尽管有上述规定，本公司并无义务通知客户其未能维持足够的保证 金，"+
          "并且在发生这种情况的情况下，无须另行通知或要求客户就有权采取本附件 I 第 3.5 条(未能满 足追收保证金要求)中指定的任何措施。",
          "3.4 保证金的支付和存入 ：保证金的支付和存入必须：",
          "(a) 就款项而言，应根据本条款第 11.6 款(全额支付)的规定进行支付；及",

          "(b) 就合资格证券而言，为客户合法及实益拥有，及客户对存放证券拥有良好的权利及所有权，且目前及将来均不附带任何种类的任何留置权、押记或产权负担。",
          "3.5 未能满足追收保证金要求 ：客户同意，任何时候未能满足保证金要求或维持足够的保证金将构成违 约事件，并且在发生此类事件时，公司有权自行决定且无需另行通知，可采取本条款第"+
          "21.2 条(补 偿) 中指定的任何一项或多项措施，包括在任何时候，在任何时间，公司确定的方式和价格或条款。 客户进一步同意：",
          "(a)  对于本公司根据本条款第 21.2 条(补偿) 采取的清算或采取行动可能引起的任何亏损，并应根据本条款第 21.5 条(短欠)向本公司支付等于该短欠的金额以及公司根据本条款而采取的任何 行动或进行的交易产生的任何其他费用和支出；",
          "(b) 公司，任何高盈证券成员或其任何董事，雇员或代理商均不对客户因公司根据本条款采取的行动或进行的交易而蒙受的任何损失承担责任(无论采取何种方式发生)，包括公司最初延迟执 行但随后影响到此类平仓或清算的情况；和",
          "(c) 在适用的范围内，本条款的第 21.7 条(平仓)应适用于本条。",
          "3.6 持续担保 ：保证金应构成担保抵押品的一部分，作为以公司为受益人的持续担保抵押品，用于支付 和清偿客户在证券保证金融资额度项下或以其他方式到期或欠公司的所有负债。",
        "4 证券保证金融资设施的运营",
          "4.1 抵押品 ：为避免疑义，在公司向客户授予任何证券保证金融资贷款的情况下，抵押品还应担保由该 等证券保证金融资贷款产生的或与之相关的责任(无需客户签署任何其他文档)。",
          "4.2 利息 ：应根据条款第 5.7 条(利息)  的规定对证券保证金融资项下的所有未付款项计收利息。",
          "4.3 拒绝提取 ：只要客户对本公司仍有任何未偿债务，公司有权拒绝提取任何或所有保证金。",
          "4.4 终止 ：证券保证金融资设施将在以下任何一项或多项事件发生时终止：",
          "(a) 本附件 I 第 5.1 款(常设授权)中提及的客户常设授权的撤销；或",
          "(b) 该常设授权在期满时或被要求续期时未续期；或",
          "(c) 根据条款进行的任何终止，以及为此目的发出的任何终止通知应被视为证券保证金融资设施的 终止通知。",
        "5 处理保证金",
          "5.1 常设授权 ：《证券及期货(客户证券) 规则》(香港法例第 571H 章) 规定，本公司不得因任何用途的 贷款或垫款而存入或出借保证金，但经客户书面特别授权的除外。根据本条款第 3.1 条(常设授权)  的规定，客户已同意给予本公司该等特定书面授权。",
          "5.2 一般例外情况 ：尽管有本附件 I 第 5.1 条(常设授权) 的规定，客户授权本公司根据条款第 10 条(投 资产品的安全托管)  的规定将客户保证金存入任何相关结算系统、本公司的指定人或其他实体并为"+
          "强制执行本附件 I 项下设立的保证金之目的以本公司认为适当的任何方式处理客户保证金(包括出 售本附件 I 允许的任何抵押品以根据本协议的规定变现客户应向本公司支付的任何款项)。",
          "5.3 再抵押 ：客户确认并同意，本公司可在获得客户书面授权后，将该保证金再抵押给任何其他人，作 为该其他人向本公司提供财务融资的抵押品。",
          "5.4 第三方留置权 ：如果保证金被出借给第三方或存放在第三方，该第三方将对保证金享有留置权或押 记。尽管本公司对在客户授权下出借或存入的该等保证金对客户负责，但第三方的违约行为可能导 致该等保证金的损失。",

          "5.5 证券保证金账户与证券现金账户 ：与证券保证金账户不同，证券现金账户不涉及证券保证金融资设 施。如果客户不需要证券保证金融资融资，或不希望本公司出借或追再抵押保证金，客户不应签署 相关的常设授权文档，也不应要求本公司开立证券保证金账户。",
        "6 风险披露声明",
          "客户确认其已经阅读并理解本公司就提供证券保证金融资贷款相关服务载于附件 X(风险披露声明)  或以其他方式提供予客户并的使用客户选择语言(英文或中文) 风险披露声明，客户已受邀阅读该"+
          "等风险披露声明、发出提问及在有需要时寻求独立意见并充分接受有关证券保证金融资贷款的风险。",
        "附件 II：申购新发行证券",
          "本附件 II 适用于本公司提供与申购新发行证券和相关贷款有关服务。本附件为本协议的补充条款并应与以及 可能不时修订的适用于公司提供的服务的任何其他条款和条件一同阅读。它是协议的组成部分。",
        "1 定义和诠释",
          "在本附件 II 中，除非文义另有所指，下列词语具有下列涵义：",
          "「获分配证券」指每份受理认购申请所涉及的全部证券；",
          "「申购」指公司或其指定人士作为代理代表客户根据本附件 II 第 2 条(申购)  的规定就发售证券的 认购提出的任何和每项申请；",
          "「申购贷款」指公司根据本附件 II 第 7 条(申购融资) 为客户提供的每一项申购相关融资安排；",
          "「申购金额」就每份申购而言，指等于申购的发售证券的价值总额，加上客户就申购应付的所有费 用、收费和支出(包括交易征费、佣金、开户手续费及适用的其他费用);",
          "「手续费」就每笔申购贷款而言，指公司可能不时通知客户的与申购贷款相关的手续费金额(如有) ;",
          "「发行人」：指其证券在交易所公开发行募集的公司或其他法人。",
          "「发行」指发行人发行新股或公开发售证券的任何行为；",
          "「发售证券」指每一次发行证券，发行人向公众募集并公开发行的证券；及",
          "「相关主体」就每一要约而言，指发行人、保荐人、承销商、配售代理人、登记处、中央托管人、收 款银行及该要约涉及的其他中间机构、联交所、证监会、结算所、任何其他相关监管机构和/或主体。",
        "2 申购",
          "2.1 申购 ：客户要求并授权公司或其代名人作为客户代理，不时根据本附件 II 提出申请，但须经客户与 公司就以下各项达成协议有关申购的：",
          "(a) 发售证券的数量；",
          "(b) 发行人的名称；及",
          "(c) 申购金额",
          "2.2 拒绝申购的决定权 ：本公司保留绝对酌情权以任何理由拒绝任何申购，包括在相关时间客户的账户 中没有足够的资金来结算申请金额和手续费或为此目的预先安排。",
          "2.3 客户代理人 ：如果公司或其指定人士提交申请，公司或其指定人士为申购发售证券之目的作为客户 的代理人提交申请，除非公司或其指定人士(视具体情况而定) 并非发行人或相关要约涉及的其他 方的代理人，但通过要约的发售文档另行明示或通过要约文档另行通知客户除外。",
          "2.4 申购要求 ：客户必须确保每份申请符合相关要约的发行人规定的任何最低、最高、面值和/或其他要 求(无论是关于发售证券的数量还是价值还是申请的数量)。公司将不会处理未完全符合所有该等要 求的任何申请。",
          "2.5 批量申购 ：若申请构成本公司或其代名人批量申请的一部分，不论是以本人名义还是以其他客户名 义提交，客户确认并同意如下事项：",
          "(a) 该等批量申购可能因与客户和申购无关的原因而被拒绝，在不存在欺诈、重大过失或故意违约的情况下，公司及其指定人士不因该等拒绝而对客户或任何其他人士承担任何责任；",

          "(b) 如果由于客户未能遵守其在本协议项下的任何义务或以其他方式与申购(包括客户作出的任何陈述和保证不真实或变得不真实) 或与客户相关的任何其他因素而导致批量申请被拒绝，客户应赔偿"+
          "公司及其代名人可能遭受或发生的或针对公司或其代名人提出的所有损失、损害、费用、 收费、支出(包括全部弥偿的法律费用)、权利主张或要求。客户确认，客户亦可能须就受该等 未能履约或受"+
          "其他因子影响的其他人士所蒙受的损害负责；及",

          //百度整体翻译
          "（c）在批量申购仅被部分接受的情况下,客户同意公司或其指定人有权自行决定在公司或其指定人"+

          "中分配获分配证券,包括在批量申购项下在公司及其指定人的客户之间平均分配获分配证券,"+

          "并且客户不得就批量申购向公司或其指定人的另一客户主张获分配证券或主张优先权。",

          "2.6不得撤回：客户确认并同意,一旦公司或其指定人士代表客户提交任何申购,或以其他方式由公司"+

          "或其指定人士处理任何申购,该等申购可能无法被撤回、取消或修改。",

          "3公司的责任",

          "3.1无认许：公司及其指定人士对于任何招股说明书、发行文件、申请表和/或与任何要约相关的其他档"+

          "的内容不承担任何责任,不对该等内容负责,未曾且不得被视为已授权、认许或核实该等内容。",

          "3.2不是投资顾问：除非另行书面委任,公司及其指定人士不是客户就任何发行或申购的投资顾问,对"+

          "于客户因任何发行或申购而可能遭受的任何损失不承担任何责任。客户确认,每项申购均由客户自行判断及自行承担风险。",

          "3.3无陈述：公司及其指定人士对于任何要约中发售证券的配售结果不作出任何承诺、保证或陈述,在"+

          "任何情况下,公司及其指定人士对分配结果或因任何原因全部或部分拒绝任何申请的任何行为不承担任何责任。",

          "4通知和批准",

          "4.1申购的批准：发行人应全权负责批准或不批准申购,并公布发售证券的分配结果。分配结果的具体"+

          "公布安排可能与其他要约存在差异,客户应当通过阅读相关招股说明书了解具体安排。公司或其指"+

          "定人将以公司认为适当的方式将申请的结果通知客户。",

          "4.2获分配证券的处置：除非公司或其指定人收到客户发出的相反通知,并就任何申请支付客户欠公司"+

          "或其指定人的所有款项（在公司或其指定人在向客户发出的配售通知中可能指定的时间内（在不影"+

          "响客户要求时还款的权利或任何其他权利或补偿的情况下））,公司及其指定人有权但无义务,在未"+

          "通知客户或获得客户同意的情况下,以其认为适当的方式、按其认为适当的价格、不受任何限制和"+

          "权利主张约束且不承担任何损失的情况下,出售或以其认为适当的优先级将该等出售或处置的收"+

          "益用于清偿任何负债,包括与获分配证券的出售或处置相关发生的费用,以及公司及其指定人与申"+

          "请相关发生的所有其他费用、手续费、客户就申购贷款应付的利息、申购贷款的未偿还本金金額和"+

          "申请額,剩馀的金额（如有）应支付给客户或按客户指令支付。获分配证券所得资金或处置证券发"+

          "生亏损时,客户应负责弥补,并按要求向本公司或其名义持有人进行支付。",

          "4.3付款和解除：如果客户根据本附件II第4.2条（获分配证券的处置）的规定向公司或其指定人士发"+

          "出任何通知,客户应在发出此类通知时按要求向公司或其代名人付款,或应要求以其他方式向客户"+

          "支付与相关申请有关的所有欠公司或其代名人的款项（包括任何相关人士指定的所有费用、收费和"+

          "开支）。公司没有义务发行或促使其代名人向客户发行与已分配证券有关的证书,或促使其将贷记至"+

          "客户指定账户的入账,除非并且直到本公司及其代名人完全满意地收到了客户欠其的所有款项。",

          "5退款",

          "5.1不成功申购：如果申购已提交但全部或部分未获批准,受限于本附件II第5.4条（融资费用）和第"+

          "7条（申购融资）的规定,公司或其指定的人士将安排在发行人公布的退款日以本条所述的相同方式"+

          "退还申请金额（或适用余额,视具体情况而定）。",

          "5.2较低的发行价格：如果发售证券的发行价格（由发行人最终确定）低于客户最初支付的申购金额,"+

          "公司或其指定人将安排根据相关要约的条款和条件向客户退还申购金额的剩余部分,但须遵守本附"+

          "件II第5.4条（融资费用）和第7条（申购融资）的规定。",

          "5.3费用：与申请有关的所有手续费及所有其它费用均不可退还,即使相关发行方的上市被延迟或取消也不可退还。",

          "5.4融资费用：如果公司已就申请向客户提供申购贷款,客户不可撤消地同意并确认,公司或其指定人"+

          "（视具体情况而定）有权将任何退款金额用于结算客户欠公司的任何款项,具体方式见本附件II第"+

          "4.2条（获分配证券的处置）。",

          "6客户的承诺和责任",

          "6.1不禁止：客户向公司及其任何指定人士并为公司及其任何指定人士的利益保证,客户不是被任何相"+

          "关人士或任何适用规例禁止提出申请或拥有发售证券的人士,客户以主事人身份而非代表受该等禁"+

          "止的任何人士或任何其他人士提出每份申请。",

          "6.2发售文件：就每份申请而言,客户明白及应接受及遵守相关申请表、招股说明书及/或发售文件及与"+

          "该等发售有关的任何其他文件所载有关发售的所有条款及条件。客户同意受公司或其指定人士提出"+

          "的申请所涉及的每项要约的条款和条件（并根据要求作出所有陈述、保证、确认和承诺）的约束。"+

          "客户应当以招股说明书等招股文档为依据作出投资决定。公司无义务向客户提供该等招股说明书及其他发行文档。",

          "6.3多项申请：客户向公司及其代名人陈述并保证,就任何申请（a）（在不允许多项申请认购要约证券"+

          "的情况下）而言,客户过去和将来均未作出、目前和将来均未作出、目前和将来均不会促使：多于"+

          "一份认购发售证券的申请,不论为本身或任何其他人士的利益,及（b）客户并未被分配（不论为本"+

          "身或任何其他人士的利益）与申请书中申请的股分或认股权证或权益属同一类别或类型的任何股分"+

          "或认股权证或权益。客户确认,客户违反本条规定的任何陈述和保证或本条规定的任何陈述和保证"+

          "不准确,除申请被拒绝之外,还可能导致公司或其指定人士代表其自身或其他客户提交的其他申请"+

          "被拒绝。经要求,客户应赔偿公司及其指定人士由于该等违约或不准确而遭受的所有损失。客户确"+

          "认并接受,公司、其指定人及相关人士就相关申请将依赖本条中载明的陈述和保证。",

          "6.4一般陈述：就每份申请而言,客户向公司及其指定人士陈述并保证：",

          "（a）客户为独立第三方,不涉及发行人和/或其各自的任何子公司的任何董事、首席执行官、大股东"+

          "或任何该等子公司的紧密联系人（定义见《联交所证券上市规则》）,亦未与前述主体一致行动。"+

          "此外,客户的认购并未由任何该等人士直接或间接提供资金或支持；",

          "（b）客户在认购发售证券前未持有发行人的任何权益；及",

          "（c）客户不是美国人士,且客户认购不会要求发行人和/或公司或其指定人士遵守香港以外任何区"+

          "域的任何法律或法规项下的任何要求。",

          "6.5其他陈述：除客户就每份申购向公司或其指定人士作出或将作出的其他陈述、保证和承诺之外,客"+

          "户向公司及其指定人士作出就申购发售证券的申请人必须作出的所有陈述、保证和承诺（无论是向"+

          "任何主体还是向所有相关主体作出的陈述、保证和承诺）。",

          "6.6进一步保证：客户确认并理解,与每份发行或申请相关的法律和监管要求及市场惯例可能会不时发"+

          "生变化。客户承诺根据公司或其指定人士可能不时决定的法律和监管要求与市场惯例向公司及其指"+

          "定人士提供相关的信息,作出相关的披露,采取步骤,并作出相关的陈述、保证与承诺。客户还应遵守该等要求和惯例。",

          "6.7公司的陈述：如果公司或其指定人（视具体情况而定）就任何发行或申购被要求就客户或任何其他"+

          "事项向任何一名或多名相关主体作出任何承诺、陈述和保证,客户授权公司及其指定人仅依赖客户"+

          "向公司或其指定人作出的任何相应承诺、陈述和保证而去作出该等承诺、陈述和保证。客户应受任"+

          "何相关人士作出的所有适用公告及适用于每项发行或申购及发行获分配证券的所有适用规例的约束。",

          "6.8公司代表客户行事：在不影响条款第2.8条（授权书）的情况下,客户授权公司及其指定人士代表客"+

          "户签署为提出任何申购之目的而需要签署的所有档并开展的所有事项。客户接受公司和/或其指定人"+

          "作为代理人代表客户就每份申购所做的所有事情。在本公司或代名人作为客户代理人的情况下,客"+

          "户应接受每次申购中所申购的发售证券或更少的数量会分配到本公司或代名人。客户赔偿本公司及"+

          "其代名人在任何与本申请相关的任何损失或索赔。",

          "6.9披露：如果适用法规要求或与相关发行或申请相关要求或要求披露,客户授权公司及其指定人士向"+

          "任何相关主体披露关于客户和相关申请的所有信息。",

          "7申购融资",

          "7.1申购融资：客户可申请并要求公司不时向客户提供用于申购的申购贷款,但须受限于本附件II的规"+

          "定,并受限于客户和公司就相关申购就下列事项达成的协议：",

          "（a）申购贷款本金；",

          "（b）利率；",

          "（c）印花税及所有其他收费；及",

          "（d）手续费。",

          "7.2公司绝对酌情权：任何申购贷款的提供和提取由公司自行决定,并受限于本协议。公司可在任何时"+

          "候拒绝提供申购贷款,而无需给予任何理由。",

          "7.3保证金：如果客户以保证金形式向本公司支付任何款项,本公司可将该款项存入客户的相关账户,"+

          "并可在申购被接受时将该款项用于支付应付的保证金。客户同意,公司实际收到的任何该等保证金"+

          "应在申购贷款的任何金额被如此使用之前用于清偿申请金额。",

          "7.4费用和支出：客户将在公司要求时立即向公司支付申购贷款、相关利息、手续费、与申购贷款相关的所有费用、收费和支出。",

          "7.5申购贷款用途：申购贷款仅供客户申购使用。尽管申购由公司或其指定人代表客户提交,客户对申"+
          "购贷款的任何金额或将申购贷款用于相关申购以外的任何目的不享有任何性质的任何权利、权属、权益或权利主张。",

          "7.6提取：如果公司向客户提供申购贷款,公司将申购贷款金额贷记至相关账户。如果任何贷款申请将"+

          "由公司的指定人士提出,公司的指定人士应始终为公司托管相关申购贷款的金额,以待向发行人付"+

          "款或按发行人的指令付款。",

          "7.7偿还：申购贷款应连同相关配售和公开发行文档中规定的所有利息及任何其他未偿还金额在相关配"+

          "售和公开发行文件中规定的退款日全额偿还。",

          "7.8提前还款：除非公司另行同意,客户无权在相关配售和公开发行文档中规定的还款日之前部分或全"+

          "部偿还申购贷款及任何其他相关债务。",

          "7.9优先权：尽管有本附件II的任何其他规定,公司有优先权在任何时间要求立即偿还任何申购贷款的"+

          "任何未偿还金额,并取消任何申购贷款。",

          "7.10押记：考虑到公司根据相关申请向客户提供申购贷款,在向公司分配并发行获分配证券时（公司或"+

          "代名人作为客户的代理人）,作为实益拥有人的客户特此押记（以第一固定押记方式）、转让、抵押"+

          "和/或质押,并同意向公司押记、转让、抵押和/或质押客户对获分配证券的所有权利、权属和权益,"+

          "作为客户就申购贷款和申请应向公司或其指定人支付的所有款项以及客户向公司或其指定人履行的"+

          "任何其他义务的持续担保。本押记设立的担保应延伸并涵盖任何及所有股息、权证、股分、股票、"+

          "权利、利益、利息、分配、增值及其他金钱和财产,该等金钱和财产在任何时间通过与获分配证券"+

          "有关的替代、赎回、红利、优先权、期权或其他方式产生或提供。",

          "7.11向第三方进一步押记：受限于本附件II第7.10条（押记）构成的担保,客户授权公司在任何及所有"+

          "获分配证券上以任何第三方为受益人押记、质押或以其他方式授予任何性质的担保权益,作为公司"+

          "向第三方提供的为申购贷款的全部或部分提供资金的任何信贷安排的担保。",

          "7.12进一步担保：考虑到公司向客户提供申购贷款,作为实益拥有人的客户以第一固定押记的方式向公"+

          "司押记、出让、抵押和质押,并同意以向公司押记、出让、抵押和质押的方式向公司押记、出让、抵"+

          "押和质押客户在公司开立的每个账户的结余（包括账户的任何续期或重新指定）中不时拥有的所有"+

          "权利、权属和权益,作为客户就申购贷款和申请应向公司及其指定人支付的所有款项的持续担保。",

          "7.13担保的性质：由本附件II第7.10条（押记）和第7.12条（进一步担保）构成的每项担保均为持续性"+

          "担保,并担保客户不时欠公司的所有负债的最终余额,即使所有或任何该等负债在任何中期得到偿"+

          "还或清偿。每份担保是对公司持有的任何其他担保的补充,不应受到公司持有的任何其他担保的影"+

          "响,并可强制执行。对合并担保权益权利的任何限制不适用于本附件II第7.10条（押记）或第7.12"+

          "条（进一步担保）构成的任何担保。",

          "7.14进一步保证：客户应自费签署所有转让文档、授权书、委托书和/或其他文档,并开展公司或其指定"+

          "人为完善公司或其指定人对获分配证券的所有权和/或为归属或使公司或其指定人能够以公司的名"+

          "义或以公司指定人和/或任何买方的名义归属该等获分配证券,或为获得、提交并强制执行本附件II"+

          "中授予公司的担保物和/或权利和补偿的全部利益之目的而可能要求的所有行动和事项。公司及其提"+

          "名人有权行使本附件II中授予公司或其提名人的所有权利和权力,包括出售获分配证券的权利。",

          "7.15付款的用途：就任何申购贷款或用途向公司或其指定人士支付的任何款项可用于清偿该等贷款或用"+

          "途,或存入公司或其指定人士为保留其证明客户的全部负债的权利而决定的账户的贷方。",

          "附件III：期权交易",

          "本附件III适用于本公司提供的与期权交易有关的服务。本附件为本协议的补充条款并应与以及可能不时修订"+

          "的适用于公司提供的服务的任何其他条款和条件一同阅读。它是协议的组成部分。",

          "1定义和诠释：在本附件中,除非上下文另有要求,下列表述应具有以下涵义：",

          "「工作日」是指相关交易所开市交易的任何日期,除却星期六、星期日、公共假期以及相关交易所"+

          "宣布为非交易日的任何其他日期；",

          "「行使价」亦称为「履约价」,是指在期权合约中指定的每单位价格的目标证券,在行使该期权时可"+

          "以购买或出售目标证券；",

          "「到期日」是指可以在合约到期日前可以行使该期权合约的最后一天。如果该到期日并非工作日,"+

          "除非另有说明,否则该到期日会自动顺延至下一个工作日；",

          "「价内期权」是指具有正内在价值的期权。具体而言,如在在美国交易所进行交易的期权的内在价"+

          "值最少等于$0.01美元,则该期权便视为价内；",

          "期权的「内在价值」是指由本公司所确定的标的股票的内在价值超过（在认购期权的情况下）或低"+

          "于（在认沽期权的情况下）行使价；",

          "「保证金」指作为客户在本附件项下对公司的义务担保的现金、投资产品及或公司可接受的其他资产；",

          "「期权金」指持有人就期权合约的签订应支付给期权合约的发行人的金额；",

          "「联交所客户合约」具有联交所期权交易规则中所定义的「客户合约」的涵义；",

          "「联交所合约」具有期权交易规则中所定义的「合约」的涵义；",

          "「联交所综合账户」具有期权交易规则中所定义的「综合账户」的涵义；",

          "「联交所期权合约」具有期权交易规则中所定义的「期权合约」的涵义；",

          "「联交所期权交易所参与者」具有联交所期权交易规则中所定义的「期权交易所参与者」的涵义；",

          "「联交所期权系统」是指香港联合交易所、联交所期权结算所为香港联合交易所期权业务交易提供"+

          "的期权交易系统、期权结算系统等；",

          "「联交所期权买卖交易所参与人」具有联交所期权交易规则中所定义的「期权买卖交易参与人」的涵义；",

          "「联交所期权交易规则」指《香港联合交易所期权交易规则》及其不时修订或补充；",

          "「联交所标准合约」指《香港联合交易所期权交易规则》第六附件所载的香港联合交易所不时指定"+

          "的适用于联交所期权合约的标准条款和条件；",

          "「联交所期权交易业务」,具有《期权交易规则》中所定义的「香港联合交易所期权交易业务」；及",

          "「联交所期权结算所抵押品」具有《联交所期权结算所结算规则》中定义的涵义。",

          "2法律法规",

          "2.1法律等规定：所有期权交易均应遵守交易所在地的法律、规则、法规、交易所、市场和结算所（如"+

          "有）的惯例和使用。客户不得单独或者与他人共同违反交易所、市场和结算所可能不时规定的持仓"+

          "或者行权限制。本公司或交易所、市场或结算所采取的所有行动对客户均有约束力。",

          "2.2遵守法律：客户应遵守有关交易所,市场和票据交换所有关所有期权交易的所有适用法规。",

          "2.3交易限制：为有助于维护期权合约市场的公平有序,或者为保护投资者之目的,交易所或任何其他"+

          "相关监管机构、政府机构或专业机构,以其酌情权并不时限制特定期权的交易或执行期权合约。",

          "2.4放弃/行权限制：",

          "（a）就任何联交所期权合约而言,客户不能在合约到期日前行使该期权合约或放弃该期权合约,除"+

          "非客户以书面方式指示本公司并获接受；和",

          "（b）就任何联交所期权合约以外的期权合约而言,客户不能放弃该期权合约,除非客户以书面方式指示本公司并获接受。",

          "2.5截止时间：相关交易所、市场和结算所执行交付行权指示的截止时间,该等时间对客户具有约束力。",

          "2.6保密：本公司将对与账户相关的信息保密,但可根据本公司的私隐政策声明和/或本协议的其他适用",

          "条款向相关方和/或证监会、香港联合交易所、香港交易所和任何交易所或任何其他相关监管机构提"+

          "供任何该等信息,以遵守其要求或信息要求。",

          "2.7限制：本公司可对客户在任何时候可能拥有的未平仓合约或交割义务设置限制。",

          "3期权交易（一般性）",

          "3.1客户的利益：客户确认,（i）账户仅为客户的账户及利益而设,而非为任何其他人士的利益而设；或"+

          "（ii）客户已以书面形式向本公司披露账户为其利益而设的人士的姓名；或（iii）就香港联合交易所",

          "期权交易业务而言,客户已要求本公司将账户作为香港联合交易所的综合账户运作,并将应本公司",

          "的要求立即通知本公司其在联交所期权合约中拥有最终实益权益的任何人士的身份。",

          "3.2执行：在不违反本公司规定的截止时间的前提下及本附件III的第2.4条（放弃/行权限制）：在执行"+

          "期权交易的交易所设定的交易时间内,可以接受在工作日当天执行的执行指示；及在任何特定期权"+

          "合约到期日前的营业日,公司将按照执行期权交易的交易所设定的交易时间接受行权指示。",

          "3.3无到期通知：本公司无义务事先通知客户期权到期日,客户仅有责任采取行动执行期权合约。客户"+

          "应知晓执行期权的交易时间和任何非交易日,以确保期权能够及时行权。如果客户未在相关机构和"+

          "交易所规定的时间内向本公司提供任何行权指示（本公司无义务通知）,客户应放弃并免除本公司、"+

          "其管理人员、雇员和代理人因任何期权合约未被行权而令客户蒙受损失的任何及所有索偿。",

          "3.4相关证券：本公司无义务向客户传达与期权涵盖的相关证券或与之相关的任何证券相关的任何信息,"+

          "或与期权相关的任何信息,无论该等信息届时或之后已知或可用。客户须自行负责以适当及适时的"+

          "方式行使客户的任何认沽期权或认购期权的任何权利、特权或义务。",
          "3.5证券保证金账户期权：若客户在证券保证金账户卖出或买入期权,则：",

          "（a）就认购期权而言,如对客户行使认购期权,则客户须将该等证券存放于证券保证金账户,直至"+

          "期权期届满,且不得出售或撤回该等证券。如期权被行使,本公司可向买方交付该等证券而无须事先通知客户；及",

          "（b）就任何认沽期权而言,如对客户行使该等认沽期权,则客户须在证券保证金账户内持有足够的"+

          "资金以支付买入的证券,直至期权期届满为止,且不得提取该等资金或将其用作任何其他用途。"+

          "如期权被行使,本公司可使用该等资金购买该等证券,而无须事先通知客户。",

          "3.6本公司自身账户：本公司及高盈证券成员可为其自身账户交易期权以及与该等期权相关的证券。该"+

          "等交易可每日连续进行,并可在账户进行任何期权交易之前、同时或之后进行。在该等交易中,本"+

          "公司及高盈证券成员可进行与（a）客户在账户中可能持有的仓位,或（b）本公司及高盈证券成员向"+

          "客户推荐的交易,或（c）本公司及高盈证券成员可为客户实施的交易类似或不同的期权仓位或其相"+

          "关证券。客户明白此类交易可能会对客户的利益产生不利影响。",

          "3.7期权长仓截止期限：如果客户执行一份期权长仓合约,客户同意支付期权合约规定的全部执行价格。"+

          "客户的期权长仓有机会到期及变得一文不值。如客户未能在相应的行使截止期限前发出指示,则其"+

          "每一价内值期权长仓将会自动于到期日时行权。因此,如客户不希望行使任何此类价内期权长仓,"+

          "则客户必须在该未平仓的期权合约到期日前自行平仓。",

          "3.8行使指定分配通知：公司应公平分配期权合约的行权指定分配通知。",

          "3.9期权合约的义务：客户应根据其所参与的每一份期权合约支付相对应的费用及交付,并履行其名义下"+

          "的所有义务。客户在任何时候须自行承担因遵守或未遵守该期限合约的后果所带来的风险。具体而"+

          "言,如客户的期权头寸已被行使或转让,则必须承担相应义务（包括结算义务）及承担任何由此而生的损失（如有）。",

          "4保证金和担保",

          "4.1担保：任何账户中持有的所有证券和资金应根据条款第16条款（押记）进行押记。",

          "4.2保证金：客户同意向本公司提供保证金。该等保证金应按照本公司不时提出的要求支付或交付,保"+

          "证金所要求的金额不应低于或需要超过适用法规要求的金额（特别是关于客户未平仓合约和交割义"+

          "务的规则）,并可能要求提供进一步的保证金,以反映市值的变化及/或管理公司的信贷风险和其他风险。",

          "4.3交付权限：经要求,客户应向本公司提供本公司在规则项下可能要求的权限,以授权本公司直"+

          "接或通过香港联合交易所期权买卖交易所参与人向联交所期权结算所交付该等证券,作为与联交所"+

          "期权交易业务相关的联交所期权结算所担保品,而该等授权是由客户向本公司或本公司自行不时决"+

          "定的其他相关人士发出的指示所导致的；仅就期权交易而言,公司无权从客户那里进一步借入或借"+

          "出客户的证券,或者以其他方式（根据客户的指示或客户的指示除外）占有客户的任何证券,以用于任何其他目的。",

          "4.4随时有足够的资产：客户在发出交易期权合约的指示时必须先确保其账户内已有足够的资产,并且"+

          "客户在整个期权合约期内须一直保持有足够资产,直至该期权合约到期或被行使为止。",

          "5期权金和佣金",

          "就根据客户指示而生效的所有期权合约而言,客户须在本公司通知的期限内,向本公司缴付期权金、"+

          "本公司的佣金及香港联合交易所或有关交易所、市场或结算所征收的任何其他收费及适用的征费；"+

          "本公司可从任何账户扣除该等期权金、佣金、押记及征费。",

          "6香港联合交易所期权交易相关的具体规则",

          "在不影响并补充本附件III的其他条款的情况下,本第6条款应在本公司为客户或为客户之利益开展"+

          "联交所期权交易业务时适用。",

          "6.1现状：倘若本公司是已登记的联交所期权经纪交易所参与者和香港结算的直接结算参与者,本公司"+

          "将通知客户这一事实。本条款所述的主要负责客户事务的期权员工或期权代表的全名应是账户开立"+

          "流程提及人士或是本公司可不时通知客户指定的其他人士。",

          "6.2适用规则：所有香港联合交易所交易期权业务应根据适用于本公司的规则实施,包括但不限于香港"+

          "联合交易所期权交易规则、联交所期权结算所结算规则和香港结算的规则；特别是,联交所期权结"+

          "算所在规则项下有权调整联交所合约的条款,本公司应通知客户任何影响客户为一方的联交所客户"+

          "合约的该等调整,本公司、香港联合交易所、联交所期权结算所或香港结算根据该等规则采取的所"+

          "有行动应对客户具有约束力。",

          "6.3香港联合交易所标准合约：相关期权系列的联交所标准合约的条款应适用于本公司与客户之间的每"+

          "份联交所客户合约,所有联交所客户合约应根据规则设立、行使、结算和解除。",

          "6.4平仓/放弃：客户确认：",

          "（a）本公司可能会被要求平仓或放弃联交所客户合约,如本公司认为行使该联交所期权合约会有可"+

          "能导致客户短仓的情况出现及该客户未能在该期权到期日前至少2个工作日前平仓或增加持仓。",

          "（b）本公司可能被要求平仓或放弃联交所客户合约,以遵守香港联合交易所施加的持仓限制；及",

          "（c）如果本公司（或本公司经其开展联交所期权交易业务的联交所期权交易所参与者）违约,香港"+

          "联合交易所的违约程序有可能导致客户与其他联交所期权交易所参与者之间联交所客户合约"+

          "被平仓、放弃或者由联交所客户合约替代。",

          "6.5对发行人的变更：如果某一期权类别的标的证券的发行人的资本结构或构成发生变更,或在任何其"+

          "他异常情况下,联交所期权结算所可在其认为必要和可取的情况下对该期权类别的条款和条件进行"+

          "调整,以确保香港联合交易所期权类别未平仓合约的所有当事人得到公平对待。所有该等调整应对客户具有约束力。",

          "6.6替换：根据客户的要求,本公司可以同意根据规则,将自己与客户之间的联交所客户合同替换为客"+

          "户与另一家联交所期权交易所参与者之间的联交所客户合同。",

          "6.7义务：客户行使或针对客户行使联交所客户合同》时,客户应根据联交所标准合同并在公司已通知"+

          "客户的情况下,根据相关合同履行客户的交付义务。",

          "6.8主事人：尽管所有联交所期权合约都将在联交所行使,但客户和本公司应根据联交所客户合同作为主事人订立合同。",

          "6.9产品规格：本公司同意在客户要求时向客户提供联交所期权合约的产品规格。",

          "6.10投资者赔偿基金：若本公司未按本附件III的规定履行对客户的赔偿义务,受投资者赔偿基金不时条"+

          "款的限制,客户有权向根据证券及期货条例设立的投资者赔偿基金索赔。",

          "6.11公司的业务：公司应将可能会影响公司根据本第6条向客户提供的服务的公司业务重大变化通知客户。",

          "6.12长仓到期日：在相关到期日,且仅在到期日,香港联合交易所期权系统将为价内或高于联交所期权"+

          "结算所订明的价内值的所有开放长仓自动生成行权指令。客户可指示本公司根据联交所期权结算所"+

          "的运行结算程序在系统关闭到期日前取代该等「自动生成的行权指令」。",

          "6.13协议：客户要确认其已阅读并同意本附件III的条款,该等条款已以客户选择的语言向客户解释。",

          "6.14持仓报告：如果持有或控制的仓位达到须报告水平,客户须自行全权负责通知联交所。如果客户决"+

          "定通过本公司通知联交所,客户必须告知本公司其在其他代理或经纪处持有的全部持仓,以便本公"+

          "司能够代表客户向联交所提交通知。或者,客户也可要求本公司向联交所单独报告其在本公司持有"+

          "账户的持仓,即使客户在该账户中的持仓未超过须报告水平。",

          "6.15弥偿：在不限制客户提供任何其他弥偿的原则下,客户同意弥偿本公司及其雇员及代理人因客户违"+

          "反其于本附件下的任何义务而引致的所有损失及开支,包括向客户追收债款及关闭有关账户的合理费用。",

          "7违约",

          "如果客户未能遵守客户的任何义务和/或履行责任,包括未能提供保证金,在不影响本公司可能享有"+

          "的任何其他权利的情况下,本公司可：",

          "（a）拒绝接受客户就联交所期权交易业务或其他期权合约的进一步指令；",

          "（b）平仓、放弃或行使香港联合交易所客户合约或与公司签订的其他期权合约的部分或全部",

          "（c）订立任何期权合约或投资产品的任何交易,以清偿产生的义务或对冲本公司因客户未能履行义务而面临的风险；",

          "（d）处置部分或全部保证金,并用其收益清偿债务；及",

          "（e）所有债务清偿后的剩馀收益应支付给客户。",

          "8风险披露声明",

          "客户确认已经阅读并理解本公司就提供期权交易相关服务的风险披露声明,见于附件X（风险披露"+

          "声明）及其他本公司提供给客户的使用其选择语言（英文或中文）的相关风险披露声明,客户已受"+

          "邀阅读该等风险披露声明、提问,在有需要时寻求独立意见并充分接受有关期权交易的风险。",

          "附件IV：基金销售服务",

          "本附件适用于本公司提供的基金销售服务。本附件为本协议的补充条款并应与以及可能不时修订的适用于公"+

          "司提供的服务的任何其他条款和条件一同阅读。它是协议的组成部分。",

          "1定义和诠释：",

          "在本附件中,除非上下文另有要求,本协议中定义的术语在本文中使用时应具有相同涵义。在本附件中：",

          "「交易流程」指公司与基金或相关基金的基金经理就基金份额的认购、转换、赎回及其他附带事项"+

          "不时约定的任何程序；",
          "「基金销售服务」指本公司根据客户之指示,就任何基金之任何单位之购买、认购、转换、转让、赎"+

          "回或出售,以及有关款项或款项之处理,所提供之服务；及",

          "「单位」指基金中的任何股分或单位。",

          "2认购和赎回申请及付款",

          "2.1一般性指示：认购、购买、赎回、出售或转换任何单位的任何指示（无论是全部还是部分）必须按公"+

          "司规定的方式作出,并随附公司可能不时要求的任何必要文档。",

          "2.2公司的酌情权：所有与单位认购、转换或赎回相关的指示以及由此产生的交易和支付均应遵守交易"+

          "流程及或公司不时规定的任何其他要求。公司有权无须通知客户,亦无须给予任何理由,无视任何"+

          "未能符合交易程序的指示或公司的其他要求,或执行该等指示及为符合交易程序或公司不时规定的"+

          "其他要求而对该等指示作出的必要修改。",

          "2.3公司的执行：公司将尽快执行任何指示,但该等指示的执行可能与基金相关发售文档中规定的时间"+

          "不一致。客户确认,公司可每日或不时地将客户向公司下达的订单与公司其他客户下达的订单合并"+

          "计算,以便公司向相关基金经理、基金或产品发行人下达该等订单以供执行。",

          "2.4截止时间：受限于账户的持续运作,如果本公司在其不时全权决定的相关基金的交易截止时间前收"+

          "到有效及完整的指示（连同所有款项、所需的数据及文档）,一般将于本公司收到该等指示之日处理"+

          "该等指示。若在本次交易截止后或香港出现8号（或以上）台风信号或黑色暴雨警告信号当日收到"+

          "指令（及资金）,通常按基金发售文档的约定（或基金管理人、基金或产品发行人等另行确定）于基"+

          "金的下一交易日执行。如果公司合理地认为有理由延迟或拒绝处理或接受任何指示,公司保留延迟"+

          "或拒绝处理或接受任何指示的权利。",

          "2.5仅供参考的价格：基金的实际买入价（“实际买入价”）和卖出价应在交易生效和结算时确定,本公司"+

          "或其代表在指示时可能向客户报价或提供的任何数值（“报价”）仅供参考,对本公司不具有约束力。"+

          "基金的实际买入价可以高于或低于报价。",

          "2.6不代表基金行事：公司无权代表任何基金管理人、基金或产品发行人接受认购、转换或赎回任何单"+

          "位的指示（或申请）。公司收到该等指示、必要的付款及任何其他文件并不构成相关基金管理人、基"+

          "金或产品发行人接受该等指示。",

          "2.7第三方：客户确认,任何从本公司收到指令的基金经理、基金或产品发行人均无义务接受该指令的"+

          "部分或全部。本公司不对基金管理人、基金及产品发行人拒绝或者拖延接受指令而给客户造成的损"+

          "失（包括投资机会损失）承担保证责任。",

          "2.8交收：客户确认：（a）客户就每笔购买或认购单位的指令应向本公司（或本公司指定的其他人士）支"+

          "付的购买价款、认购款项或费用,应从证券现金账户（或由客户不时另行指定并通知本公司的其他"+

          "账户）中扣除；及（b）本公司就每笔出售、赎回或以其他方式处置单位的指令而收到的赎回款项,"+

          "在任何情况下均应按照有关基金募集文件（或基金管理人、基金或产品发行人不时另行决定）规定"+

          "的交收期,支付或存入证券现金账户。",

          "2.9资金不足：客户进一步同意,对于单位的购买或认购,如果账户中指定支付的资金不足,或者在公"+

          "司规定的时间内未收到已清算资金（不含任何扣除或预扣款项）,公司保留拒绝或延迟处理任何订单的权利。",

          "3投资的权属和登记",

          "3.1一般：如果客户认购基金单位,该等单位将以公司的名义或以公司的名义与客户的名义共同登记,"+

          "或仅以客户的名义登记（视具体情况而定）。本公司将不会是阁下在基金的任何投资的受益人。",

          "3.2单位证书：不会向客户签发单位证书。客户将被发送一份其认购/获得（或处置）任何单位的确认。",

          "4终止",

          "在与公司的账户终止或基金销售服务终止时,客户将被视为已向公司发出指示,且根据其酌情权：",

          "（a）促使托管人为客户账户持有的任何单位在基金账户终止生效日被赎回或以其他方式处理,或者"+

          "如果该日不是客户账户的交易日或在该等基金的发售档中规定的最晚交易时间之后,则在下一"+

          "个交易日（“生效日”）赎回或交易收益（在结清欠公司和高盈证券的任何未偿还债务、成本和"+

          "费用后）的任何单位汇给客户和/或结清客户、公司或任何托管人发生的任何负债；",

          "（b）促使托管人为客户账户当时持有的任何单位于生效日直接划拨至客户名下（如适用）；及",

          "（c）取消任何未执行的交易。",

          "附件V:债券交易",

          "1申请",

          "本附件V适用于本公司提供的与债券交易有关的服务。本附件为本协议的补充条款并应与以及可能"+

          "不时修订的适用于公司提供的服务的任何其他条款和条件一同阅读。它是协议的组成部分。",

          "2债券交易",

          "2.1酌情权：公司有绝对酌情权拒绝向客户提供债券交易服务和/或附加与基金账户或向客户提供债券交"+

          "易服务有关的任何条件。",

          "2.2不能成功执行或延迟执行：本公司对于任何不能成功执行或延迟执行的客户债券交易指示,并不负"+

          "有任何责任。所有未执行的订单将在交易期结束时失效。",

          "2.3代理人：除非另有规定,本公司在所有债券交易中都是以代理人身份行事。",

          "2.4托管人：客户委任本公司（或任何实体,包括香港以外的实体,并由本公司指定）为客户的托管人,"+

          "并为客户所投资的债券登记于托管人名下,由托管人代表客户购入及持有。",

          "2.5价格：债券的实际买入和卖出价须在交易进行时确定,而本公司或其代表可随时向客户报价或提供"+

          "价位,均属参考性质,对本公司并不具约束力。",

          "2.6约束性：债券交易的所有指示于提交时已是最终的决定并对客户有约束性,但取决于是否被本公司"+

          "接纳及视乎最终交易而定。",

          "2.7派息日：债券的实际派息日可能与其原定派息日有所不同,要视乎不同因素,包括并不限于要视乎"+

          "发行人、及本公司所委托的托管机构/信托机构所行使的酌情权,及相关银行的转账程序和其他因素。",

          "3客户声明",

          "客户声明他或她：",

          "3.1非存款：完全明白债券不是银行存款,及不会受到本公司或高盈证券所保证,或构成任何责任；",

          "3.2风险披露声明：客户确认已经阅读并理解本公司就提供债券交易相关服务的风险披露声明,见于附"+

          "件X（风险披露声明）及其他本公司提供给客户的使用其选择语言（英文或中文）的相关风险披露"+

          "声明,客户已受邀阅读该等风险披露声明、提问,在有需要时寻求独立意见并充分接受有关债券交易的风险；",

          "3.3相关资讯：已获得,并已细阅债券说明书及/或其最新产品销售文件或信息及/或查阅最新产品销售文"+

          "件或信息（视乎何种情况而定,「有关信息」）,并同意所载的条款。客户完全知悉及理解有关信息所"+

          "载的条款,包括但不限于有关投资债券的风险和限制。本公司已呈请客户细阅有关信息,如需要,"+

          "可提出问题或资询独立意见。",

          "3.4不提供意见：完全明白上述的有关信息不拟提供,亦不可赖以作为税务、法律或会计意见、或有关"+

          "债券的信用或其他评价,也不得构成任何债券预期回报的保证或担保。客户应咨询其税务、法律、"+

          "会计、投资、财务及/或其他顾问；",

          "3.5没有被禁止：并非为或代表销售文件所订明被禁止购买或持有该债券的个人或团体；",

          "3.6地域限制：并非为销售文件所订明被禁止投资国家的公民或居民；",

          "3.7有限流动性：明白债券的流动性可能有限,及可能无活跃交易,及/或没有经纪在市场提供报价,因"+

          "此（i）债券的参考买入/卖出价不可以在任何时间均能被提供,因其将取决于市场的流动性和情况；"+

          "（ii）可能需要较长时间或无法于市场上出售债券；及（iii）所执行的卖出价可能与本公司提供的参"+

          "考买入价有很大的差别；",

          "3.8损失：全部承担及负责投资债券损失的风险；和",

          "3.9信息准确性：明白本公司就债券交易服务中提供的任何信息是按「现状」、「可提供」的状态提供,"+

          "且仅供一般信息使用。客户同意此类信息,如市场数据和报价均由第三方提供,而本公司并不保证"+

          "此类信息的准确性、可靠性、时效性、完整性或顺序。本公司毋须就因此类信息的任何不准确、遗"+

          "漏或不完整而产生的任何损失负责或承担责任,无论该信息是由本公司还是第三方提供。",

          "3.10波动的市场状况：明白由于市场状况、任何市场的实质限制及证券价格急速变动,即使本公司、执"+

          "行经纪和交易商（无论是在香港或其他地方）作出合理的努力,透过本公司作为代理人进行交易,"+

          "本公司可能无法完全执行客户的指示,交易指示未必可以于任何特定时间、于客户指定的时间、「最"+

          "佳价」或「市场价」执行。客户同意在任何情况下均接纳代客户进行的交易,并受其约束,亦同意本"+

          "公司毋须就因未能或无法遵守客户指示的任何条款而产生的任何损失负责。",

          "附件VI:中华通条款及细则",

          "本附件VI适用于通过中华通进行的中华通证券交易。本附件为本协议的补充条款并应与以及可能不时修订的"+

          "适用于公司提供的服务的任何其他条款和条件一同阅读,并构成本协议不可分割的一部分。",

          "1定义和诠释：",

          "在本附件VII中,除非上下文另有要求,下列表述应具有以下涵义：",

          "「中国创业板证券」指于中国深圳交易所创业板市场交易之任何证券；",

          "「市场要求」指所有不时适用于沪港通（“沪港通”）或深港通（“深港通”）服务和透过使用该等服务"+
          "所进行的任何交易的一切相关法律、法规和规则及监管机构或政府机构、交易所、市场、结算所及"+

          "其他主管机构的要求及请求（包括但不限于联交所、上交所、深交所、证监会、中国证券监督管理"+

          "委员会以及其各自的子公司及联属人、）；",

          "「上交所」指上海证券交易所；及",

          "「深交所」指深圳证券交易所。",

          "2沪港及深港通服务",

          "2.1借继续使用本公司提供的沪港或深港通服务,客户向本公司确认其已详阅、明白并同意此等特别条"+

          "款以及接受所有与使用该等服务及透过该等服务进行交易的相关风险如下：",

          "（a）客户须遵守并独自承担责任以遵守所有市场要求。除非法律另有规定,本公司无须应市场要求"+

          "之改变而更新此等特别条款。",

          "（b）尤其是,客户须充分了解并遵守所有不时在内地适用的市场要求,特别是有关短线交易利润、"+

          "限制进行场外交易及转移、持股限制及披露责露责任的市场要求,包括但不限于关于在上交所"+

          "或深交所上市的A股的规定（该规定被修改时,本公司恕不另行通知）：",

          "（i）有关持有或控制中国内地上市公司已发行股分达5%的投资者须于三个工作天内作出权"+

          "益披露及于该三个工作天内不得买卖该公司股分的要求；且对其持有的股分的任何变动"+

          "作出披露的要求及遵守有关买卖限制；及",

          "（ii）适用于香港及/或海外投资者的单一境外投资者的10%持股限制（中国内地上市公司已发"+

          "行股分的10%）及所有境外投资者的30%总持股权限制（中国内地上市公司已发行股分"+

          "的30%）及相关强制出售的安排。",

          "（c）客户承认除在市场要求容许的情况下,在交易日买入的上交所证券或深交所证券不能于同一天"+

          "卖出,而且如客户拟于个别交易日出售上交所证券或深交所证券,则须于该交易日开市前确保"+

          "客户在本公司设立的户口内存有足够的上交所证券或深交所证券。客户不可对上交所证券或深"+

          "交所证券进行无备兑卖空活动。",

          "（d）客户承认设有交易前检查：如客户拟于个别交易日出售股分,须于该交易日开市前将股分转移"+

          "至公司的相应中央结算系统户口。",

          "（e）客户承认所有上交所证券及深交所证券交易必须在上交所及深交所进行,不设场外交易或非自动对盘交易。",

          "（f）除本公司另行许可外,客户同意不会透过使用沪港或深港通服务进行孖展交易、股票借贷及/或"+

          "卖空活动,而客户就任何上交所证券或深交所证券向本公司发出的任何买卖盘均被视为已向本"+

          "公司声明及确认,该买卖盘不涉及孖展交易、股票借贷或卖空。当客户透过使用沪港或深港通"+

          "服务进行孖展交易、股票借贷及/或卖空活动,客户必须充分了解适用于该等活动的限制、要求"+

          "及条件。特别是,客户承认该等活动的交易服务可能在市场要求所订立的情况下被暂停、限制"+

          "或停止（例如交易的活动量超出于市场要求所规定的限额或发生或怀疑发生任何不正常的交易"+

          "活动）,而且客户只可对合资格的上交所证券或深交所证券进行孖展交易及卖空活动。客户可"+

          "参考不时在联交所之网页（www.hkex.com.hk）公布的合资格上交所证券或深交所证券名单。",

          "（g）客户承认唯机构专业投资者方可进行中国创业板证券交易。客户向本公司保证不会进行中国创"+

          "业板证券交易,除非其为机构专业投资者,或直至此进行中国创业板证券交易的限制解除为止。"+

          "如客户为一中介人作为代理代表其相关客户向本公司发出落盘指示,客户向本公司承诺,其将"+

          "确保透过客户进行中国创业板证券交易的该等相关客户均是机构专业投资者,直至此进行中国"+

          "创业板证券交易的限制解除为止。如（i）客户或,如客户为一中介人,其相关客户违反此进行"+

          "中国创业板证券的交易限制；或（ii）客户违反任何于此之承诺,本公司可全权酌情取消客户的"+

          "落盘或卖出客户的中国创业板证券而无须另行通知客户。本公司将毋须就本公司行使其于此所"+

          "赋予的权利及权力产生的任何损失负责,除非基于本公司或其任何主管人员、雇员或联属人的"+

          "严重疏忽、欺诈或蓄意失责所致,及只限于直接及合理预见直接及纯粹由上述行为造成的损失"+

          "及赔偿（如有）。尽管上文有所规定,在符合韍场要求下,如一非机构专业投资者客户因任何权"+

          "利（包括认购配股或公开要约的权利）或权益分配、换股、收购、其他公司行动或特殊情况而"+

          "取得中国创业板证券,本公司可全权酌情决定是否接纳该非机构专业投资者客户的指示出售相"+

          "关中国创业板证券。",

          "（h）客户承认联交所、上交所或深交所及其各别的子公司及联属人有权在市场要求所订立的情况下"+

          "拒绝提供与沪港或深港通服务有关之服务（如客户、本公司及/或其代理人之中任何一方违反任"+

          "何市场要求或作出任何不正常交易行为）,而且本公司可按其绝对酌情权或会应上交所或深交"+

          "所要求拒绝接受客户的任何指示或停止提供所有或部分之沪港或深港通服务,而无须另行任何事前通知。",

          "（i）客户同意（i）本公司为确保遵从或促使遵从市场要求及避免或减轻本公司可能因此而招致或蒙"+

          "受的损失；（ii）在客户违反任何市场要求或本协议之条款的情况下或（iii）在发生任何超出本"+

          "公司或其代理人的合理控制能力的任何紧急或不可抗力的事故（如香港悬挂八号台风信号）时,"+

          "本公司可按其绝包括但不限于强制出售有关证券,限定、限制或拒绝交易,取消交易或由客户"+

          "发出的其他指示及暂停、限制或停止提供所有或部分之沪港或深港通服务,而无须另行任何事前通知。",

          "（j）客户同意,为执行客户的指示或行使本公司在此等特别条款下或在客户的任何账户下的权利为"+

          "目的之情况下,本公司可（在任何时候按其独有及绝对酌情权及并无责任的情况下）将客户任"+

          "何账户内或客户所结存的任何币别的任何金额兑换成任何其他货币。汇兑损失和兑换成本须由客户承担。",

          "（k）客户承认监管机构、上交所、深交所、联交所以及上交所、深交所及联交所各自的子公司及联"+

          "属人有权在市场要求被违反或怀疑被违反时进行调查,并同意本公司可按该等机构之要求提供"+

          "数据及材料（包括但不限于与客户、客户账户及其他与最初负责发出交易的指示及从该宗交易"+

          "取得商业或经济利益及/或承担其商业或经济风险的人士（不论是否为法律实体）有关的数据、"+

          "身份及个人资料,以及有关该等人士下单或交易的数据）,及向客户发出警告,以作配合调查、"+

          "监察及遵从市场要求之用。",

          "（l）客户同意与客户有关的或由客户所提供之个人资料可按照本公司向客户提供的收集个人资料"+

          "声明及本协议其他适用条款使用及转移至香港以外地区,而且客户承诺及表述其已经就所述使"+

          "用和转移个人资料事宜取得其所需要的一切有关人士的同意,以及遵守《个人资料（私隐）条例》。",

          "（m）客户承认客户或任何其他方面因为沪港或深港通服务或透过使用该等服务进行任何交易而直"+

          "接或间接蒙受或招致任何损失、损害或责任,联交所、上交所、深交所及其各别的子公司、联"+

          "属人、董事、雇员及代理人概不负责。",

          "（n）客户可以最少七个营业日前通知本公司终止使用沪港或深港通服务。本公司可随时终止客户使"+

          "用沪港或深港通服务,而无需提前通知客户。",

          "（o）客户同意以主事人的身份负责承担涉及客户使用沪港或深港通服务或者涉及透过使用该等服"+

          "务所进行的交易的一切有关义务和责任,无论在何种情况下,本公司及其代理人都不须对可能"+

          "委托客户作为其代理人代其行事的任何人士承担任何责任。客户同意本公司可处置或促使本公"+

          "司的有联系实体处置任何不时代客户收取或持有的证券或证券抵押品,以解除由客户或代客户"+

          "对本公司、其有联系实体或第三者所负的法律责任。",

          "（p）尽管以上所述,本公司可以按其绝对酌情权自行决定是否为确保或者促使遵守任何市场要求或"+

          "者为本公司认为适当的其他任何目的,而不时增加或修改与沪港或深港通服务有关的任何条款。"+

          "此外,客户也同意,沪港或深港通服务是针对中国内地的某些特定的市场或交易所而提供的,"+

          "并受本公司不时附加及在有关的市场附件中载明的条款所约束。上述附加条款及修订后的条款"+

          "均构成本协议不可分割的组成部分,并且应与本协议一起阅读。倘客户继续使用沪港或深港通"+

          "服务,即被视为构成客户已经接受该等附加条款及修订后的条款。本公司可以将该等附加条款"+

          "及/或修订后的条款在本公司的网站上发布,也可以采用本公司认为适当的其他任何方式通知客户。",

          "（q）客户承认已获邀仔细阅读和考虑本公司不时提供给客户的有关风险披露声明书中的条款,该等"+

          "风险披露声明书载明与使用沪港或深港通服务有关的风险,同时,本公司也已经邀请客户就该"+

          "等风险披露声明书提出问题并征求独立的意见（如适用）。",

          "（r）就客户使用沪港或深港通服务,客户同意补偿和向本公司及其代理人支付客户不时与本公司约"+

          "定或者本公司或其代理人按任何市场要求规定所招致的一切佣金及费用、收费、开支、征费、"+

          "税款、罚金和其他各种税费。客户同意本公司及其代理人无须就任何与客户或代客户进行的交"+

          "易或业务所获取的或向任何人士提供的佣金、报酬、回佣或其他利益向客户作出任何交代。",

          "（s）倘由于（i）任何政府或监管机构、交易所、市场、结算所或其他主管机构的限制、失误、违约"+

          "或行为；（ii）交易所提供的任何服务被暂停、限制或停止；（iii）结算所中断或未能结算和清算"+
          "任何交易；（iv）发生骚乱、骚动、战争、水灾、台风、地震、火灾或爆炸；（v）第三者电子传"+

          "输系统或其他电子系统被中断、延迟、失误、暂停或错误；或（vi）超过本公司或其代理人的合"+

          "理控制能力的其他任何原因而直接或间接地导致本公司及其代理人未能履行其对沪港或深港"+

          "通服务分别应当承担的义务,则本公司及其代理人不需要对该等未能履行的义务承担任何责任。"+

          "本公司保留权利,在发生任何上述事件以后,按其绝对酌情权决定暂停、限制或者停止提供全"+

          "部或者部分之沪港或深港通服务,而毋须作出任何通知,并且如订单经已配对及执行,客户仍须承担交收责任。",

          "（t）对于涉及沪港或深港通服务的无论何种间接的、因此而产生的、附带的、特别的或惩罚性的损"+

          "害、损失、负债、费用或开支（包括但不限于任何利润损失）而言,本公司不需要向客户承担任何责任。",

          "（u）在客户开始及继续使用沪港或深港通服务时,本附件VI即生效并构成本协议不可分割的一部"+

          "分。本附件VI条款为约束客户及本公司之间的账户关系的条款及条件的附加条款,而且如两"+

          "者有歧异,以本附件VI条款为准。",

          "3免责声明",

          "甲部：",

          "有关沪港通服务的免责声明",

          "上海证券交易所尽力保证所提供信息的准确和可靠度,但不能确保其绝对准确和可靠,亦不对因信息不准确或"+

          "遗漏而导致的任何损失或损害承担责任。",

          "及",

          "香港联合交易所有限公司、其控股公司及／或该等控股公司的任何子公司均尽力保证所提供信息的准确和可"+

          "靠度,但不能确保其绝对准确和可靠,亦不对因信息不准确或遗漏而导致的任何损失或损害承担责任。",

          "乙部：",

          "有关深港通服务的免责声明",

          "深圳证券交易所尽力保证所提供信息的准确和可靠度,但不能确保其绝对准确和可靠,亦不对因信息不准确或"+

          "遗漏而导致的任何损失或损害承担责任。",

          "及",

          "香港联合交易所有限公司、其控股公司及／或该等控股公司的任何子公司均尽力保证所提供信息的准确和可"+

          "靠度,但不能确保其绝对准确和可靠,亦不对因信息不准确或遗漏而导致的任何损失或损害承担责任。",

          "附件VII：上市前交易",

          "本附件VII适用于本公司就上市前交易提供的服务。本附件为本协议的补充条款并应与以及可能不时修订的"+

          "适用于公司提供的服务的任何其他条款和条件一同阅读。它是协议的组成部分。",

          "1定义和诠释：",

          "在本附件VII中,除非上下文另有要求,下列表述应具有以下涵义：",

          "「获分配证券」指有关申请首次公开招股而被接纳的证券；",

          "「香港结算规则」指香港结算不时生效之一般规则、运作程序及其他适用的规则、程序及规例；",

          "「首次公开招股」指联交所新上市及/或发行的证券之公开发售；",

          "「获配对指令」具有本附件VII中第3.4条（获配对指令）所定义的意思；",

          "「平台营运者」指本公司可不时通知客户的平台营运者；",

          "「上市前平台」指由平台营运者营运而透过本公司提供上市前交易服务的电子交易平台；",

          "「上市前交易」指任何获分配证券的交易或购买、投资、出售、收购、清算、结算或以其他方式处置"+

          "任何获分配证券的协议,及获分配证券在联交所正式上市前的一般交易；",

          "「上市前交易时段」指交易日当天可于上市前平台进行上市前交易的交易时段,亦即下午4:15开始"+

          "至下午6:30的时段或其他由平台营运者不时指定的交易时段；及",

          "「交易日」指,就任何获分配证券而言,在联交所正式上市前一工作日或由平台营运者可不时指定的其他交易日。",

          "2适用规则及规例",

          "2.1适用规则及规例：本公司代表客户作出或签订的所有上市前交易指示及任何上市前交易指示均应遵"+

          "守,且客户应受下列指示约束：",

          "（a）本协议；",

          "（b）不时有效的平台营运者条例、规章、程序和政策；",

          "（c）联交所的组织章程大纲及章程细则、联交所规则、香港结算规则及联交所的常规、惯例、裁定及程序；及",

          "（d）其他适用法规（包括证券及期货条例）。",

          "2.2冲突：如果本协议的任何规定与本附件VII第2.1条（适用规则及规例）第（b）、（c）和（d）段中"+

          "包含的任何内容发生任何冲突或不一致,本公司可自行决定采取或拒绝采取任何行动,或要求客户"+

          "采取或不采取任何行动以确保遵守后者。",

          "3上市前交易",

          "3.1一般：客户承认并同意,就上市前交易：",

          "（a）本公司作为客户的代理人行事；",

          "（b）本公司自身并不经营上市前交易的灰色市场,而是通过上市前平台处理指令；",

          "（c）客户只可在交易日的上市前交易时段内发出指示；",

          "（d）客户的指示可由本公司及／或平台营运者全权酌情决定部分执行或完全不执行。",

          "3.2平台营运者的酌情权：即使存在任何相反规定,平台营运者可随时自行决定在不通知或提及客户的"+

          "情况下,在不限制且不向客户承担任何责任的情况下进行以下任何操作,该等行为应对客户具有约束力：",

          "（a）调整上市前交易时段的交易时间；",

          "（b）限制或停止任何交易日的上市前交易；",

          "（c）以任何方式限制、更改、暂停或终止上市前平台；",

          "（d）就与上市前交易有关的任何指示设定任何限制；及/或",

          "（e）拒绝处理或接受与上市前交易有关的指示。",

          "3.3本公司的酌情权：本公司可随时自行决定在不通知或提及客户的情况下,在不限制且不向客户承担"+

          "任何责任的情况下就与上市前交易有关的任何指示设定任何限制；及/或拒绝处理或接受与上市前交易有关的指示。",

          "3.4获配对指令：受限于本附件VII第3.6条（取消/推迟上市）的规定,公司和平台营运者接受并经上"+

          "市前平台匹配的所有上市前交易指令（“匹配指令”）将由平台营运者完成。",

          "3.5未获配对的指令：在上市前交易完结时,所有未获配对或只有部份未获配对的上市前交易指示及指令将被取消。",

          "3.6取消/推迟上市：如果相关获分配证券未能上市,所有与该等获分配证券（包括获配对指令）相关的"+

          "所有上市前交易指示将自动取消,该等指示不会被处理。如果该等获分配证券的正式上市被推迟,"+

          "获配对指令将持续有效,但将由平台营运者在推迟后的上市日或其认为适当的其他时点实施。",

          "3.7无陈述或保证：公司未就客户的上市前交易指示或上市前平台作出任何性质的任何陈述或保证。",

          "4结算",

          "4.1交付及支付：当客户卖出获分配证券时,客户应向本公司交付该等获分配证券,且该等证券已足额"+

          "缴付及无产权负担,且客户对该等证券拥有良好及有效的所有权。客户购买获分配证券的,应当向"+

          "客户支付。每项该等交付和付款应以公司或平台营运者不时指示的方式进行。",

          "4.2未能交付或支付：在不影响公司在本协议项下的任何权利的前提下,如果客户未能按照本附件VII第",

          "4.1条（交付和付款）规定的方式进行交付或付款,则公司有权在不进一步通知或要求的情况下：",

          "（a）以本公司绝对酌情权决定的价格借入及/或购买交付所需的获分配证券,向客户的任何账户收"+

          "取相关费用,交付获分配证券以履行客户的义务,并将收到的交付款项存入任何账户；及/或",

          "（b）作为第（a）段的补充或替代,行使本协议条款第29条（合并、并入和抵销）所载的合并及抵"+

          "销权,以结算上市前交易。",

          "4.3短欠：客户应按全面弥偿基准赔偿公司根据本附件VII购买和出售获分配证券所发生的损失和任何"+

          "费用或支出（包括法律费用）所导致的任何短欠。",

          "4.4交易对手风险：客户知晓并接受,所有上市前交易均为场外交易,如果交易对手方不能履行结算义"+

          "务,将面临交易对手风险。",

          "4.5结算风险：公司未就任何匹配订单的结算作出任何陈述、保证或担保。公司或平台营运者可能认为"+

          "不宜采取任何行动以避免匹配订单的任何结算失败的情况,在该等情况下：",

          "（a）如客户是获分配证券的买家,客户只有权取回已支付的结算资金",

          "（b）如客户是获分配证券的卖家,客户只有权取回为该等出售而交付的获分配证券；及在每种情况"+

          "下,客户都将负责所有因交易对手不能履行结算责任而产生的损失及开支。",

          "5责任限制",

          "5.1责任免除：客户同意,公司、平台营运者及其各自的任何董事、员工或代理均不对客户由于任何下"+

          "列各项或与任何下列各项相关而可能发生的任何权利主张、讼案、诉讼、程序、损失、损害、义务、"+

          "责任、费用、收费和支出承担责任,由于此类人员的重大过失、欺诈或故意违约的情况除外：",

          "（a）上市前平台的任何干扰、拦截、中止、延迟、损失、不可用、毁坏、故障、中断或其他故障,",

          "包括但不限于任何通信网络或电脑故障、任何第三方信息或服务提供者的作为或不作为、内务"+

          "管理、电脑病毒、任何主体（包括黑客）未经授权的访问、升级或预防或补救维护活动、机械"+

          "故障、停电、故障或设备、安装或设施不足,或任何法律、法规、规章、准则、指令、监管指"+

          "引或政府命令（无论是否具有法律效力）；",

          "（b）客户通过任何通信网络提供商的任何系统、设备或工具或在任何通信网络提供商的任何系统、"+

          "设备或工具中传输、张贴和/或存储关于客户、上市前平台和/或上市前交易的任何信息和/或数据；",

          "（c）未能结算获配对指令；",

          "（d）公司或平台营运者不接受、进行、不执行、也不行使客户的上市前交易指令；",
          "（e）公司或平台营运者根据本附件VII采取的任何行动,包括任何使用、收入、利润、储蓄或机会"+

          "的损失或任何其他附带的、后果性的、特殊的或间接的损失或损害。",

          "附件VIII：电子直接付款授权服务",

          "本附件VIII适用于公司向客户提供的将使客户能够进行转让（定义见下文）的电子直接付款授权服务（电子"+

          "直接付款授权）。本附件VIII补充并应与一般条款和适用于公司提供的服务的任何其他条款和条件及其可能不"+

          "时的修订一起阅读。它是客户协议的其中一个组成部分。",

          "1定义和诠释：在本附件VIII中,除非上下文另有规定,下列表述应具有以下含义：",

          "「银行」指根据《银行条例》（香港法例第155章）获授权在其处开立及保有指定账户的银行、受限"+

          "牌照银行或接受存款公司；",

          "「指定账户」指客户以其名义在银行开立的账户,根据客户指示从该账户进行转账；",

          "「电子直接付款授权」指客户发起的电子直接付款授权,使用结算公司快速支付系统授权公司根据"+

          "客户指示以指示银行从相应的指定账户向账户转账,详见本附件VIII第2.1条（申请）；",

          "「电子直接付款授权服务」指结算公司提供的服务,作为结算公司快速支付系统的一部分,以促进"+

          "参与者的客户建立并使用电子直接付款授权；",

          "「结算公司」指香港银行同业结算有限公司及其继承人及受让人；",

          "「结算公司快速支付系统」或「快速支付系统」指结算公司为（a）处理直接借记和贷记、转账及其"+

          "他支付交易；及（b）交换并处理与电子直接付款授权服务相关的指令而不时提供、管理并运行的更"+

          "快支付系统及相关设施和服务；",

          "「指示」指客户向银行发出或获其授权,指示银行办理转账之指示；",

          "「参与者」,是指结算公司快速支付系统的参与者,可以是银行或其他金融机构、零售支付系统运营"+

          "者、储值支付工具持牌人,也可以是结算公司不时接受的其他结算公司快速支付系统的参与者；及",

          "「转账」指根据电子直接付款授权项下的一项或多项指示不时从指定账户向账户进行的资金转账。",

          "2电子直接付款授权",

          "2.1申请：客户可通过公司向银行（由公司标明）申请电子直接付款授权服务。公司将协助向该行转交"+

          "电子直接付款授权设置申请指示、数据和信息。申请经银行核准后,客户可以直接向公司发出指示"+

          "以进行转账。客户可能有一个或多个指定账户来进行转账。如果贵行拒绝电子直接付款授权设置申"+

          "请,公司将通知客户结果,也不承担任何责任。",

          "2.2信息：客户应以公司不时规定的形式和方式提供该等信息并完成该等程序,以便公司协助客户向银"+

          "行申请电子直接付款授权设置。每个用作设置电子直接付款授权的指定账户的持有人必须与账户持"+

          "有人相同。联名银行账户将不被接受。",

          "2.3取消：如果客户已设立电子直接付款授权,但在一段时间内未根据该授权进行任何转账（由公司决"+

          "定）,则公司有权在任何时间取消电子直接付款授权,而无需事先通知客户,即使该授权尚未到期或"+

          "不受限于到期日或终止日。相关银行亦可随时自行决定取消电子直接付款授权。如客户对银行就电"+

          "子直接付款授权、任何指示或任何转账所采取的任何行动有任何查询或争议,客户必须直接与相关"+

          "银行解决该等查询或争议。",

          "2.4默认设置：在设置电子直接付款授权时,任何指示的默认设置如下：「转账周期」将设置为「每笔付"+

          "款」,「转账限额」将设置为「无上限」,「到期日」将设置为「无期限」。如果客户不接受这些预设设"+

          "置,客户不应通过公司继续进行电子直接付款授权设置申请。",

          "2.5修改默认设置：客户可不时直接指示银行修改本附件VIII第2.4条（默认设置）所载的指示的预设,"+

          "但须符合银行不时订明的程序和要求。",

          "2.6有效期：指示将持续有效,直至（a）被客户修改或取消；或（b）在指示中指明的日期到期（如有）,"+

          "以先发生者为准。客户可根据银行不时规定的程序和要求取消指示。",

          "3指令不可撤消",

          "就任何转账而言,一旦客户确认及提交指示,该指示及随之而来的转账不可撤消,并对客户具约束力。",

          "4确认",

          "4.1时间期间：客户同意,每笔指示所载之转账款项将于有关银行不时指定之时间期间内存入账户。",

          "4.2指示的更改：如客户欲更改任何指示,客户须立即通知本行作出该等更改。",

          "4.3费用：客户对电子直接付款授权服务的使用受限于公司或相关银行可能不时向客户收取的任何费用和收费（如有）。",

          "4.4其他条款和条件：客户理解,电子直接付款授权服务也可能受限于相关银行和/或参与者的条款和条"+

          "件,客户在使用电子直接付款授权服务之前应阅读并同意该等条款和条件。公司不承担因该等银行"+

          "和/或参与者的条款和条件而产生的任何责任。",

          "4.5无陈述：公司将尽合理努力确保电子直接付款授权服务可以提供,但对于电子直接付款授权服务的"+

          "任何种类的运行、功能和可靠性,本公司不作出任何陈述、认可或保证。此外,公司不保证相关银"+

          "行和/或参与者将能够实现电子直接付款授权项下的指示或转账,因为这取决于该等银行和/或参与者"+

          "的系统、运行以及公司无法控制的其他条件或情况的功能和可靠性。",

          "4.6免责：对于客户或任何其他主体可能发生或蒙受（无论是直接地还是间接地）的与电子直接付款授"+

          "权服务的任何使用或公司对任何指示或转账的执行相关的任何种类的损失、损害、费用或支出,本公司不承担责任。",

          "4.7终止：本公司保留在无理由的情况下取消、终止或中止全部或部分电子直接付款授权服务的权利。"+

          "客户同意,对于客户或任何其他人士因本公司行使上述权利而可能招致或蒙受的任何种类的任何损"+

          "失、损害、费用或开支,本公司概不负责。",

          "4.8有效性：客户应确保账户、每个指定账户和每个电子直接付款授权在其使用电子直接付款授权服务"+

          "的整个期间保持有效。",

          "5客户信息的收集和使用",

          "5.1信息提供：为使用电子直接付款授权服务之目的,客户可能被要求向本公司提供其被授权人的个人"+

          "数据及其他信息（「客户信息」）。",

          "5.2客户信息的使用：客户同意,本公司可为电子直接付款授权服务之目的收集、使用、处理、保留或"+

          "转移任何客户信息。此等用途包括但不限于下列一项或多项：",

          "（a）为客户提供电子直接付款授权服务,维护和运行电子直接付款授权服务；",

          "（b）处理并执行与电子直接付款授权服务相关的不时的指示和请求；",

          "（c）为经营电子直接付款授权服务之目的,向任何银行、结算公司及其他参与者披露或转账客户资料以供使用；",

          "（d）符合任何适用法规项下的披露要求；及",

          "（e）上述各项附带的或与之相关的目的。",

          "5.3进一步传播：客户理解并同意,结算公司、本公司、任何银行或任何其他参与者均可为提供和运营"+

          "电子直接付款授权服务之目的,向其客户及使用结算公司快速支付系统的任何其他第三方进一步披"+

          "露或转移客户信息。",

          "5.4同意：若客户资料包括除客户以外的任何人士（例如任何被授权人士）的个人资料或其他数据,客"+

          "户确认其将就结算公司、本公司、有关银行及本第4条款列明的其他参与者使用（包括披露及转移）"+

          "其个人资料及其他数据的事宜,而取得该等人士的同意。",

          "6责任限制",

          "6.1一般限制：本公司对客户或任何其他主体可能发生或遭受的由使用电子直接付款授权服务或处理或"+

          "执行客户发出的电子直接付款授权服务相关的指示或请求引起或与之相关的任何种类的任何损失、"+

          "损害或支出不承担责任,但发生或遭受的任何损失、损害或支出是直接且可合理预见的,并且仅由"+

          "本公司的重大过失或故意违约或其管理人员、员工或代理的重大过失或故意违约直接引起的除外。"+

          "在任何情况下,对于任何利润损失或任何特殊、间接、偶然、后果性或惩罚性损失或损害（无论该"+

          "等损失或损害是否可预见或可能发生）,本公司、高盈证券成员或许可方及其各自的管理人员、员工"+

          "和代理人均不对客户或任何其他主体承担责任。",

          "6.2具体限制：就电子直接付款授权服务或电子直接付款授权服务而言,本公司不对客户或任何其他主"+

          "体可能发生或遭受的由任何下列事项引起或与任何下列事项相关的任何种类的损失、损害或费用承担责任：",

          "（a）结算公司快速支付系统、任何银行和/或参加人或因公司合理控制之外的任何情况造成的任何"+

          "延迟、无法使用、中断、故障、错误；及",

          "（b）客户由于任何指示不明确或不完整和/或由于电子直接付款授权服务的任何错误或故障而无法行事。",

          "附件IX：期货交易",

          "本附件IX适用于期货合约和期权合约的交易。本附件补充并应与一般条款和适用于公司提供的服务的任何其"+

          "他条款和条件及其可能不时的修订一起阅读。它是客户协议的其中一个组成部分。",

          "1定义和诠释：",

          "在本附件IX中,除非上下文另有要求,下列词语应具有以下含义：",

          "「核淮债务证券」指由香港特别行政区政府为外汇基金而发行之外汇基金票据、美利坚合众国政府"+

          "发行之国库券（美国财政部可通知赎回之债券本金（TCAL）及独立交易之证券注册利息及本金"+

          "（STRIPS）除外）,以及由香港期交所不时批准作为保证金的其他债务证券或票据；",

          "「核准证券」指盈富基金单位及由香港期交所不时批准作为保证金之该等其他证券；",

          "「董事会」指香港期交所不时之董事会,或（按文义所指）于正式召开并已有足够法定人数的董事"+
          "会会议上出席及投票的大多数董事,或董事会任何正式委任的委员会；",

          "「工作日」是指香港期货交易所或外国期货交易所（视具体情况而定）开市交易的任何日期,但星"+

          "期六、星期日、公共假期以及香港期货交易所或外国期货交易所（视具体情况而定）宣布为非工作"+

          "日的任何其他日期除外；",

          "「结算所」指香港期货结算有限公司；",

          "「结算所规则」指结算所的规则和适用程序,以及不时有效的对其作出的任何修订、补充、变更或修改；",

          "「合约」是指一份期货合约和/或期权合约,根据上下文的要求,「合约」应作相应的解释；",

          "「外国结算所」指结算或交收所、公司、组织或机构（由外国期货交易所指定、授权或聘请或成立"+

          "或经营,为该外国期货交易所提供结算和交收服务）,包括其代理人、代名人、代表、职员和雇员；",

          "「外国结算系统」指由有关外国结算所不时经营的结算和交收系统；",

          "「外国期货交易所」指香港以外国家或地区之法例容许,在该等国家或地区经营之任何期货市场；",

          "「外国规则」具有本附件第3.3条款（外国法规）中规定的涵义；",

          "「外国交易」是指与将在外国期货交易所执行的合约相关的任何交易；",

          "「期货合约」指相关交易所规则所定义的期货合约和/或在任何交易所执行的合约,其效力为：",

          "（a）一方同意在约定的未来时间以约定的价格向另一方交付约定的商品或数量的商品；或",

          "（b）当事人约定在将来某一时间根据约定商品的价值是高是低或高于或低于订立合约时约定的水"+

          "平进行调整,差额部分由订立合约的交易所的规则确定；",

          "「指示」具体而言是指与合约有关的指示；",

          "「追收保证金通知」具有本附件第8.1条款（追收保证金通知）中规定的涵义；",

          "「市场」指香港期货交易所根据规则第201条款不时设立及营运的其中一个市场；",

          "「期权合约」指有关交易所规则所定义的期权合约及/或一方（「第一方」）与另一方（「第二方」）在"+

          "交易所签订的合约,根据该合约：",

          "（a）第一方授予第二方在约定的将来某一日或之前或在约定的将来某一日（视情况而定）以约定价"+

          "格向第一方购买约定商品或某一商品数量的权利,但不是义务；如果第二方行使其购买权利,则：",

          "（i）第一方有义务按照约定的价格交付商品；或",

          "（ii）第二方收到商品价值高于约定价格的款项（如有）,该款项应根据合约订立所在的相关交"+

          "易所的规则确定；或",

          "（b）第一方授予第二方在约定的未来某一日或之前或在约定的未来某一日（视情况而定）按约定价"+

          "格向第一方出售约定商品或商品数量的权利,但并无义务；如果第二方行使其出售权利,则：",

          "（iii）第一方有义务按照约定的价格收取商品；或",

          "（iv）第二方收到一笔可参照约定价格高于商品价值的金额（如有）的款项,该笔款项应根据订"+

          "立合约的相关交易所的规则确定；",

          "「法规」指董事会为监管市场活动不时订明的任何名称及包含于任何条文之内的规例,或按文义所"+

          "指,适用于某特定市场的规例；",

          "「规则」指香港期货交易所的规则、规例以及不时有效的对规例的任何修订、补充、变更或修改；",

          "「盈富基金单位」指根据（1）美国道富环球金融资产（香港）有限公司作为经理人、（2）美国道富"+

          "银行及信托公司作为受托人及（3）外汇基金投资有限公司作为发起人于一九九九年十月二十三日订"+

          "立之信托契据（可不时予以修改或补充）所设立名为「香港盈富基金」之单位信托计划而发行之单位；及",

          "「变价调整」就香港期货交易所成交的合约而言,指由结算所及/或本公司代客户按结算所规则第408"+

          "至411条款的规定每日计算的应付及/或应收予结算所及/或本公司的款项。",

          "2开户",

          "2.1账户开立：客户指示并授权本公司为签订和/或交易合约之目的开立和维持一个期货账户。",

          "2.2公司的酌情权：本公司同意,其将不时应客户的要求,酌情允许客户开立期货账户,并将为客户订"+

          "立和/或交易合约之目的,维持该账户的名称、号码或其他。",

          "2.3现状：倘若本公司是已登记的期交所参与者和香港期交所结算所的直接结算参与者,本公司将通知"+

          "客户这一事实（及入围期交所参与者名录）。",

          "2.4主要负责人员：主要负责客户在期交所合约订立事务人员的全名（及其执照和注册数据）应是账户"+

          "开立流程中指定的人士或是本公司可不时通知客户指定的其他人士。",

          "3条款及条件之适用范围",

          "3.1适用：本附件适用于本公司代客户于香港期交所或任何外国期货交易所签立或将签立之一切合约,"+

          "并视为收纳于（不论是口头或书面）本公司与客户之间所订立之每份合约内。客户以书面或其他方"+

          "式（不论是明示、暗示或按惯例或于交易过程表明）建议或提述之任何其他条款及条件,或本公司"+

          "与客户先前已据此订立合约,均不包括于此适用范围内。",

          "3.2受限于规则：于香港期交所订立之所有合约及本公司与客户之间之所有交易,均对双方具约束力,"+

          "并须依据香港期交所之程序、香港期交所之组织章程大纲及细则之条文以及规则履行并受其规限。",

          "3.3外国规则：外国交易应当遵守有关市场、外国期货交易所、外国结算系统、外国结算所等制定的规"+

          "章制度、规则、附例、宪法和程序（以下统称外国规则）。对于不同市场和交易所的交易,客户可能"+

          "有不同水平和类别的保护。在不影响上述规定的一般效力的前提下,所有外国交易应受限于下列其他规定：",

          "（a）每笔外国交易均收取交易费用,相关费用应当由客户自行负担。",

          "（b）每笔海外交易均受限于外国期货交易所可能不时征收的税项；",

          "（c）客户确认本公司受《外国规则》的约束,该规则允许相关外国期货交易所采取措施限制未平仓,"+

          "或代表该外国期货交易所认为正在累积对任何特定市场有或可能不利于或可能对任何市场的"+

          "公平和有序运作产生不利影响的客户平仓；",

          "（d）客户确认,如果本公司作为外国结算所的交易所成员或参与者的权利被暂停或撤消,有关外国"+

          "结算所可采取一切必要措施,将本公司代表客户持有的任何未平仓合约及其在本公司账户内的"+

          "资金和证券,转移给另一外国期货交易所的一个会员或参与者；和",

          "（e）客户承认并接受,如果本公司超过根据《外国规则》施加的任何交易限额或持仓限制,相关机构"+

          "有权要求本公司平仓或将该等数量的未平仓进行转移至另外一名成员（可能包括客户的全部或"+

          "部分未平仓）,直至相关机构认为本公司遵守持仓限制。",

          "4先决和一般事项",

          "4.1发行文件：对于在香港期货交易所交易的合约,本公司将在客户要求下向客户提供合约说明书及关"+

          "于该等产品之任何章程或其他发行文件。",

          "4.2授权：客户应确保获得适用于任何合约的任何政府或其他监管机构或部门的所有必要授权、批准和"+

          "同意,并确保该等授权、批准和同意的条款和所有适用法规。",

          "4.3实际履行：客户经本公司签订的每份合约均是客户已清楚理解其实际表现下所订立。客户应被视为"+

          "必履行该合约的义务。",

          "4.4酌情权：本公司可全权决定在不给予任何理由的情况下,拒绝代表客户执行任何指示,或与客户签订任何合约。",

          "4.5投资者赔偿基金：就香港期交所之合约而言,客户承认,如本公司作出失责行为,令客户于香港期"+

          "交所之交易中蒙受金钱损失,投资者赔偿基金之责任仅限于证券及期货条例及有关附属法例所规定"+

          "之有效索偿,并受证券及期货（投资者赔偿－赔偿限额）规则所订明之金额上限所规限,故此不能"+

          "保证因该等失责行为而招致之任何金钱损失可从投资者赔偿基金中获得悉数或部份补偿,或必定获任何补偿。",

          "4.6限制：就香港期交所之交易而言,客户承认,本公司须受规则之约束,该等规则容许香港期交所采"+

          "取措施,在香港期交所认为客户正累积对某一个或多个特定市场或可能造成损害或对某个或多个市"+

          "场之公平及有秩序运作造成不利影响（视情况而定）之持仓时,限制或要求本公司结清其代该等客"+

          "户订立之有关合约平仓。",

          "4.7利息：客户无权因客户在期货账户中的任何贷方余额而获得本公司可能收到的任何利息。根据第5.7"+

          "条款（利息）,客户须就期货账户的所有借方结余支付利息。",

          "4.8作为主事人交易：就香港期交所之交易而言,客户承认,本公司在结算所持有之任何户口,不论代"+

          "表客户进行商品期货交易而持有该户口的全部或一部分,亦不论由客户缴付或存放之款项或核准债"+

          "务证券或核准证券是否已缴付或存放于结算所,在本公司与结算所之间,本公司乃以主事人身份进"+

          "行买卖,故此该户口并非表示以客户为受益人之任何信托或其他衡平法权益,缴付或存放于结算所"+

          "之款项、核准债务证券及核准证券乃不受本条中所述信托之约束。",

          "4.9获批准证券/获批准的债务证券：就香港期交所交易之合约而言,本公司从客户或任何其他人士（包"+

          "括结算所）收取之所有款项、核准债务证券或核准证券,乃根据操守准则附表4第7至12段所述方"+

          "式而持有。客户授权本公司按照操守准则附表4第14至15段所指定方式运用任何该等款项、核准"+

          "债务证券或核准证券。尤其是本公司可运用该等款项、核准债务证券或核准证券以履行本公司因代"+

          "客户进行商品期货交易所引致或附带其对任何方面人士之责任。",

          "4.10相反之仓盘：受限于证券及期货条例的规定及任何适用法规,本公司可就任何合约采取与客户指示"+

          "相反之仓盘,不论是为本公司自身还是为高盈证券成员或本公司的其他客户,但该项买卖须透过香"+
          "港期交所设施,根据任何其他商品、期货或期权交易所之规则或设施,依照该等其他交易所之规则"+

          "及规例,以具竞争力方式进行。",

          "4.11延迟：客户确认,在若干情况下,本公司会因香港期交所或其他外国期货交易所之实际环境限制及"+

          "商品价格急剧变动而延迟作价或延迟买卖,而本公司可能于付出合理努力后仍未能于任何指定时间"+

          "按所报价格进行买卖。客户同意,本公司无须因未能遵照客户指示之任何条款（包括由于客户试图"+

          "撤回或修改指示而重复执行指示）而引致之任何损失承担责任。",

          "4.12部分履行：客户确认,倘若本公司于付出合理努力后仍未能全面地执行任何指示,本公司有权只履"+

          "行部分指示,无须事先征询客户给予确认。当客户提出执行指令之要求后,客户即须接受指示已予"+

          "履行、部分履行或不履行之任何后果,并受其约束。",

          "4.13截止：任何客户指示如未能于有关交易所收市或有关交易所规定之其他届满日期或客户与本公司同"+

          "意之其他较后时间之前获得执行,则视作自动取消。",

          "4.14最优价：客户确认,鉴于执行交易之香港期交所或其他外国期货交易所之买卖惯例,或许不能永远"+

          "按「最佳」或「市场」价格执行指令,客户同意,在任何情况下均受本公司按照客户指示所执行交易之约束。",

          "4.15信用调查：客户特此授权本公司对客户进行资信查询（如为个人客户,则为个人信用调查）及其他"+

          "调查,以确定客户的财务状况和投资目的。客户应使本公司了解其财务状况,并应立即向本公司报"+

          "告表明其（a）资不抵债,（b）可能资不抵债,或（c）有任何违规或渎职行为的任何信息。应按本公"+

          "司要求,客户应当提供与前述事项相关的所有数据和文件,包括资产证明、收入来源证明等。",

          "4.16合并/分拆：客户授权本公司,于任何时间及由本公司全权决定,为取得更佳之执行价及／或减少作"+

          "出指示之次数,将客户有关代为买／卖合约之指示,与本公司自其他客户接获之类似指示合并及／"+

          "或分拆处理。客户同意,假若可供买卖之合约数目不足以满足合并处理之买卖指令,实际作出买／"+

          "卖之合约数目将按本公司接获指令之次序归于有关客户。",

          "4.17优先权：在适用法律及规例及市场情况之规限下,本公司经考虑接获指令之先后次序下,有全权决"+

          "定执行其客户指令之次序,客户不得对有关本公司执行任何收到客户指示的优先次序,提出异议。",

          "4.18大额未平仓合约：当客户经其在本公司的户口持有/控制商品期货合约,及倘若香港期交所董事会根"+

          "据规则第628条决定该户口的未平仓总额为「大额未平仓合约」,本公司有责任向香港期交所申报。"+

          "然而,客户在任何时候就进行与商品期货合约有关的交易,而在本公司以外,在其他香港期交所参与"+

          "者开立一个或多个户口,及该户口的未平仓总额为「大额未平仓合约」,客户应即时向香港期交所申"+

          "报该「大额未平仓合约」,并向香港期交所提供其所规定的与该「大额未平仓合约」有关的数据（包"+

          "括客户及最终实益拥有人的名称,或（如属公司或团体）该公司或团体股本的最终实益拥有人个人"+

          "的名称,包括透过代名人或信托形式持有利益的受益人）,及向香港期交所提供其所要求的任何其他"+

          "数据。客户确认及承认本公司根据规则在某些情况下有责任向香港期交所申报从客户取得与其「大"+

          "額未平仓合约」相关的数据,及客户特此同意本公司向香港期交所提供该等数据。",

          "4.19报告：客户应履行所有适用及不时生效的所有通报、持仓申报及大额持仓申报要求（包括但不限于"+

          "香港法例第571Y章《证券及期货（合约限量及须申报的持仓量）规则》下的要求）,及不应超过根"+

          "据相关市场及交易所订明关于合约限量及须申报的持仓量规则所载之有关期货类别及种类的限额"+

          "（如有）。客户有责任了解不时适用的该等要求。客户承认本公司对客户未能遵守该等要求概不负责"+

          "（适用法例或法规要求除外）。",

          "4.20交割：在不损害本协议下本公司权利的前提下,如本公司认为存在变动或预期变动,本公司可在未经客"+

          "户同意的情况下将客户户口内所有或任何持仓平仓：（a）由于国家或国际货币、金融、经济或政治条"+

          "件或外汇管制,已经导致或认为可能导致香港和/或海外股票市场、商品或期货市场出现重大或不利"+

          "波动；或。（b）已经或可能在性质上影响本公司或客户的状况与操作。",

          "5权限",

          "5.1披露：经香港期货交易所或证监会或任何司法辖区的任何其他交易所、政府或监管部门（合称「相"+

          "关监管机构」）要求,本公司应披露相关监管机构可能要求的客户的姓名、实益身份及其他信息。客"+

          "户承诺在本公司指定的时间内向本公司披露为本公司遵守规则、外国规则、证监会和/或相关监管机"+

          "构的要求而可能要求的关于客户自身的其他信息。客户不可撤消地授权公司作出任何该等披露。就"+

          "于香港期交所之交易而言,假若本公司未能遵照香港期交所规则第606（a）或613（a）条之披露规"+

          "定,香港期交所行政总裁可要求代客户平仓或就该客户所持仓盘收取附加保证金。",

          "5.2酌情权行动：本公司可在任何时间采取下列一项或多项经本公司酌情权决定的行动,以确保本公司"+

          "遵守适用法规：（a）扣除或扣起账户内部份应缴付账户的金额；（b）立即终止账户及停止本公司与"+

          "客户的全部或部份关系,而不作另行通知；（c）提供（不论司在账户终止之前及或之后）客户的税务"+

          "数据予任何其他司法管辖区的机构,以确保本公司遵守有关法律及条例",

          "5.3结算所：就于香港期交所交易的合约而言,客户确认,假若本公司作为香港期交所之交易所参与者"+

          "之权利遭暂停或撤消,结算所可作出一切所需行动,以便将本公司代客户持有之任何未平仓盘及存"+

          "放于其在本公司持有之户口之任何款项及证券移转往香港期交所另一参与者。",

          "5.4代理人：客户同意,除非本公司在有关交易的合同说明或建议中以其他方式通知客户,否则本公司"+

          "仅在执行客户指示时充当客户的代理人。",

          "6一般留置权：在不影响条款第15条款（留置权）的情况下：",

          "6.1一般留置权：客户授予本公司对所有或任何代客户不时持有（不论是为了安全保管或其他目的而持"+

          "有）的款项（包括保证金）、核准证券,核准债务证券及其它资产（统称为「资产」）拥有一般留置"+

          "权,以用作解除客户就本公司代客户进行买卖合约而所须承担的责任。",

          "6.2固定收费：客户特此同意,把客户的所有资产以第一固定押记方式作为客户支付或清偿阁下亏欠本"+

          "公司的任何债项的持续抵押。",

          "6.3清算：客户特此授权本公司可无须事先通知并按其绝对酌情权厘定的价格和方式出售任何资产,以"+

          "解除客户对本公司的债项。本公司有权决定终止哪些合约或相关合约。在所有债项被全数支付或清"+

          "偿后,本公司可应客户之要求及在客户支付有关费用的情况下,发还所有资产的权利、所有权及利益给客户。",

          "7交付",

          "客户应根据本公司发出的任何指示,迅速交付其在任何合约项下可交付的任何款项、证券、金融票"+

          "据、文件或其他商品或财产,以应付保证金催缴及适用于香港期货交易所交易的任何合约的变更调"+

          "整要求,或满足适用于任何外国期货交易所的保证金要求。",

          "8保证金及存入",

          "8.1追收保证金通知：客户须应本公司不时酌情权决定之要求向本公司缴付或存入本附件第7条（交付）"+

          "拟议的金额和/或其他证券,作为保证金和/或为客户在本公司的一个或多个账户进行的变更调整,以"+

          "便行使其与之相关的权利（「追收保证金通知」）。就在香港期货交易所交易的合约而言,本公司可能"+

          "被要求向香港期货交易所和证监会报告在本公司指定的期限内未满足连续两次保证金催缴及变更调"+

          "整要求的所有未平仓合约的详情。本公司可以要求客户缴交比香港期交所及／或结算所指定更多之"+

          "保证金及变价调整要求,以及可就本公司指定期间内未能履行追收保证金通知及变价调整要求或未"+

          "能在作出该等追收保证金通知或要求时缴付保证金之所有未平仓合约平仓。",

          "8.2联系客户方式：本公司发出保证金通知后,将以最大的努力及时与客户联系。客户同意,在本公司"+

          "根据本合约条款第30条款（通信及通知）向客户发出该等追收保证金通知后,保证金催缴应被视为适当进行。",

          "8.3账户间的划拨：在适用法例及规则之规限下,本公司可于无须事先知会客户,不时将本公司代客户"+

          "持有之所有或任何部分款项或其他抵押品,在客户于本公司之不同户口之间转拨,或转拨往设于香"+

          "港期交所结算或非结算会员之任何户口内,由本公司全权决定认为必需或适合者,以符合客户之任"+

          "何保证金要求。本公司于作出任何该等转拨时将知会客户。",

          "8.4质押：本公司将以质押方式持有作为客户对本公司之任何保证金、存款或其他责任之抵押品之任何"+

          "档或其他财产,除非明文表示其持有之抵押品乃受制于若干其他抵押安排,则作别论。",

          "9费用及收费",

          "9.1费用及收费：客户须向本公司缴付不时厘定及知会客户之香港期交所或任何外国期货交易所就商品"+

          "期货合约订明之佣金及交易费用,以及本公司附加收费。请另行参阅载列于本公司网站向客户收取"+

          "之佣金及费用之详情。",

          "9.2投资者赔偿基金的征收：每份香港期交所合约均须缴付投资者赔偿基金征费及根据证券及期货条例"+

          "征收之费用,该两项征费均须由客户承担。",

          "10交易通知及报告",

          "10.1交易通知及报告：本公司将于交易执行后两个工作日内,给予交易确认书及对帐单予客户的方式,"+
          "向客户报告执行商品期货交易之情况,包括购入或出售的合约的数目、相关资产、到期月份、行使"+

          "价、期权形式（认沽或认购）、版号,以及该等合约属平仓合约或开仓合约；及该等合约内载每手所"+

          "包括的资产单位及有关价格。",

          "10.2责任：客户同意,本公司无须就因客户延迟向本公司报告错漏而引致之任何损害或市场波动承担责任。",

          "10.3超额支付：假如户口中出现多付款项或合约,客户同意于获悉时立即知会本公司,并同意不会转移"+

          "有关款项或合约（或如已转移,须立即退还）。",

          "11违约事件",

          "11.1违约：为本协定之目的,下列每一事件也应构成违约事件：",

          "（a）就任何合约而言,客户违反或未能遵守或在其适当的时间和日期履行其任何规定（在不影响前"+

          "述规定的一般性原则下,包括本协议的任何规定）,或客户转让或声称转让任何合约的全部或部分利益；",

          "（b）客户未能符合追收保证金通知（无论是初始、维持或附加）的要求,或未能或拒绝遵守公司根据"+

          "本协定提出的任何请求、通知或要求,或公司至少尝试要求客户进行追收保证金通知,且任何原"+

          "因无法直接与客户沟通；",

          "（c）本公司以酌情权认定客户存放作为保证金之任何款项或抵押品,就客户所订立或拟订立之合约"+

          "价值而言并不足够；或",

          "（d）客户履行其在任何合约项下的任何义务属于或成为不合法；及/或",

          "（e）在公司或任何高盈证券成员目前或将来承担香港期货交易所、外国期货交易所、结算所或任何"+

          "适用法规规定的采取本附件第11.2条（补偿）中提及的任何行动的任何义务的任何时间。",

          "11.2补偿：在不影响本公司可能享有的任何其他权利或补偿的前提下,若发生任何违约事件,则在不事"+

          "先向客户发出要求的情况下：",

          "（a）本公司无义务（于采取补救方法之前）就任何合约向客户支付作为担保而持有的任何款项或交付任何资产；",

          "（b）本公司有权暂停履行其以任何方式产生的对客户承担的任何义务,无论是在任何合约项下还是"+

          "在其他项下,包括支付届时到期或其后可能到期的任何一笔或多笔款项；",

          "（c）本公司有权认为就必需或适宜之方式结清所有或任何现有合约（尽管合约尚未到期结算）,并"+

          "采取其认为必需之其他步骤以保障其利益,但在任何情况下,本公司均无责任行使任何该等权"+

          "利,或在对客户有利之时间或以有利于客户之方式行使该等权利；",

          "（d）本公司有权将账户内任何未平仓合约平仓,履行或维持有关未平仓合约；及就这目的交付或接"+

          "受交付合约之相关商品、沽出或平仓任何合约、订立长仓或短仓之跨价期或马鞍式组合,或作"+

          "出以上任何项目的组合",

          "（e）本公司可以行使因本公司代表客户持有的任何现有合约而产生的任何选择（即沽出或认购）；",

          "（f）本公司可采取该行为,并作出其唯一及绝对酌情权认为必要或可取的行为、事项或事项,以遵守"+

          "或履行、取消或履行本公司对客户的任何义务,或客户和/或本公司对香港期货交易所、结算所"+

          "或任何外国期货交易所的任何义务；",

          "（g）本公司可以将任何属于客户在本公司保管或控制下的资产（以直接或通过担保或担保方式）以"+

          "履行客户对本公司承担的任何义务；及/或",

          "（h）本公司可要求或强制执行可能为公司或任何高盈证券成员签发、制造或创建的或有利于本公司的任何抵押品；",

          "12终止",

          "12.1终止：尽管有第27.1（客户提出的终止）条款的规定,客户只能在期货账户中没有未完成的合约情况下终止本附件。",

          "12.2终止的后果：本附件的终止：",

          "（a）不得影响本公司于终止前依据本协议而订立之任何交易；及",

          "（b）不得影响任何一方就未平仓合约或对本公司有尚未完成责任之合约之权利或责任,亦不得影响"+

          "本公司对其持有之一切存款、保证金及其他款项之权利,而本协议将继续适用于以上各项。",

          "13转让",

          "未经本公司事先书面同意,客户不得转让、委托、分包、转移或以其他方式处置本协议或任何合约"+

          "项下的任何权利。客户在每一合约项下的权利应受限于因本协议适用于每一合约项下的每项交易以"+

          "及客户与本公司签订的每一合约而产生的所有权利、责任和义务。",

          "14综合账户",

          "14.1总账户：客户是总合账户,且不是香港期货交易所交易参与人的,对其在香港期货交易所成交的合约,客户应当：",

          "（a）于客户与客户就综合户口而接获指示之一名人士（多名人士）进行买卖时,遵从及强制执行规"+

          "则及结算所规则订明之保证金及变价调整规定及程序,犹如客户乃香港期交所一名交易所参与"+

          "者,而为其户口或利益而发出指示之该名（等）人士乃为客户；",

          "（b）促使为履行有关指示而订立交易所合约（定义见规则）,从而在任何情况下,按指示进行的任"+

          "何买卖的形式,均不会构成香港或任何其他适用的司法管辖区的法例所指的非法买卖商品市场"+

          "的报价差额,或有关的买卖方式亦不会构成或涉及投注、打赌、博彩或就该等项目而进行的赌"+

          "博,从而违反香港法例或任何适用法律；及",

          "（c）确保客户从其接获指示之人士遵从规则订明之保证金及变价调整规定,令致在香港期交所与本"+

          "公司之间,本公司应负责确保该等规定已获综合户口中透过其传达指示之所有人士遵从,犹如"+

          "各人均为该综合户口之客户。",

          "15其他规定",

          "15.1不一致：倘若本协议内任何条款与香港期交所、结算所或对本协定目标事项具司法管辖权之任何当"+

          "局之任何现行或未来法例、规则或规例有抵触,该项条文将视作已根据任何该等法例、规则或规例"+

          "而撤消或修改。而本协议于所有其他方面将继续维持十足效力及作用。",

          "15.2风险披露：客户确认,（a）附件X（风险披露声明）中的风险披露声明是以客户选择的语言（英文或"+

          "中文）提供的,（b）如客户认为有必要,客户可以阅读风险披露,向专业顾问提出问题并接受独立"+

          "咨询意见,以及（c）客户已经理解风险披露。客户承认,这些风险披露声明可能会不时发生变化。",

          "附件X：风险披露声明",

          "客户务须细阅此等风险披露声明。此等声明为本协议及开户表格的组成部份。客户执行开户表格,即表示确认"+

          "其已阅读并细阅其选择语言版本（英文或中文）的此等风险披露声明,并获邀阅读该声明、提出问题及在有此"+

          "意愿的情况下征求独立的意见,以及确认其明白与账户有关的投资及交易可能产生的风险。",

          "此等风险披露声明没有亦不旨在披露与账户有关的所有投资及交易的一切风险及相关考虑因素。客户于全面"+

          "了解所涉及的风险,并从客户本身的顾问取得客户认为适当的独立意见前,应避免作出任何投资或交易。本公"+

          "司并非客户的财务顾问,亦不应被视作客户的财务顾问。",

          "1证券交易的风险",

          "投资附带风险,过往业绩并非未来表现的指标。证券价格有时可能会非常波动。证券价格可升可跌,甚至变成"+

          "毫无价值。买卖证券未必一定能够赚取利润,反而可能会招致损失。",

          "2期货及期权交易的风险",

          "2.1买卖期货合约或期权的亏蚀风险可以极大。在若干情况下,客户所蒙受的亏蚀可能会超过最初存入的保证金数额。",

          "2.2即使客户设定了备用指示,例如「止蚀」或「限价」等指示,亦未必能够避免损失。市场情况可能使该等指示无法执行。",

          "2.3客户可能会在短时间内被要求存入额外的保证金。假如未能在指定的时间内提供所需数额,客户的"+

          "未平仓合约可能会被平仓。然而,客户仍然要客户的账户内任何因此而出现的短欠数额负责。",

          "2.4因此,客户在买卖前应研究及理解期货合约及期权,以及根据本身的财政状况及投资目标,仔细考"+

          "虑这种买卖是否适合自己。",

          "2.5如果客户买卖期权,便应熟悉行使期权及期权到期时的程序,以及客户在行使期权及期权到期时的权利与责任。",

          "2.6期权涉及高风险,未必适合所有投资者。投资者应确保在参与期权市场之前了解这些风险。",

          "2.7有些期权在到期日方可行使（欧式期权的行使）,其他期权可于到期前的任何时间行使（美式期权的"+

          "行使）。有些期权在行使时须以正股交收,而其他期权在行使时则须支付现金。",

          "2.8客户知悉期权乃损耗性资产,期权持有人可能会损失该期权的全部期权金。作为期权持有人,如欲"+

          "赚取利润,必须行使期权或在市场将期权长仓平仓。在某些情况下,因市场流通量不足,买卖期权会出现困难。",

          "2.9作为期权沽出人,客户随时可能要缴付额外的按金。期权沽出人与期权持有人不同,正股价的起跌"+

          "可令沽出人蒙受无限损失,而期权金乃沽出人的唯一回报。",

          "2.10此外,美式认购（认沽）期权的沽出人可能需要在到期前的任何时候交收正股或支付现金代价,该"+

          "价格为行使价乘以正股数目的积,上述责任可能与沽出期权所收到的期权金的价值完全不成比例,"+

          "而有关的通知期亦可能甚短。",

          "3买卖创业板股分的风险",

          "3.1创业板股分涉及很高的投资风险。尤其是该等公司可在无需具备盈利往绩及无需预测未来盈利的情"+

          "况下在创业板上市。创业板股分可能非常波动及流通性很低。",

          "3.2客户只应在审慎及仔细考虑后,才作出有关的投资决定。创业板市场的较高风险性质及其他特点,"+

          "意味着这个市场较适合专业及其他熟悉投资技巧的投资者。",

          "3.3现时有关创业板股分的数据只可以在香港联合交易所有限公司所操作的互联网网站上找到。创业板"+

          "上市公司一般毋须在宪报指定的报章刊登付费公告。",

          "3.4假如客户对本风险披露声明的内容或创业板市场的性质及在创业板买卖的股分所涉风险有不明白之"+
          "处,应寻求独立的专业意见。",

          "4在香港以外地方收取或持有的客户资产的风险",

          "4.1本公司在香港以外地方收取或持有的客户资产,是受到有关海外司法管辖区的适用法律及规例所监"+

          "管的。这些法律及规例与《证券及期货条例》（第571章）及根据该条例制订的规则可能有所不同。",

          "4.2因此,有关客户资产将可能不会享有赋予在香港收取或持有的客户资产的相同保障。",

          "5在香港联合交易所有限公司买卖纳斯达克–美国证券交易所证券的风险",

          "5.1按照纳斯达克–美国证券交易所试验计划（「试验计划」）挂牌买卖的证券是为熟悉投资技巧的投资者"+

          "而设的。客户在买卖该项试验计划的证券之前,应先咨询本公司的意见和熟悉该项试验计划。客户"+

          "应知悉,按照该项试验计划挂牌买卖的证券并非以香港联合交易所有限公司的主板或创业板作第一"+

          "或第二上市的证券类别加以监管。",

          "6使用网上交易协议下之电子服务的风险",

          "6.1如果客户透过电子服务进行买卖,客户便须承受该电子服务系统带来的风险,包括有关系统硬件和"+

          "软件可能会失灵的风险。系统失灵可能会导致客户的买卖盘不能根据指示执行,甚或完全不获执行。",

          "6.2由于未可预计的流量挤塞和其他原因,电子服务可能并不可靠的,及存在通过电子服务进行的交易"+

          "在传输和接收客户的指示或其他信息过程中可能会被耽误、延迟执行客户的指示或有关指示以有别"+

          "于客户发出指示时的市价执行、指示在传输时被中断或停顿等风险。",

          "6.3在通信过程中也存在误解或错误的风险,以及在发出了指示后,通常也不一定可以取消。由于此类"+

          "中断、耽误或被第三方入侵而使客户遭受的任何损失,本公司概不承担责任。如果客户不准备接受"+

          "此类中断或耽误引致的风险,客户不应透过电子服务来作出任何指示。",

          "6.4通过电子服务向客户提供的市场数据和其他信息可能是本公司从第三者获得的。虽然本公司相信这"+

          "些数据和信息是可靠的,但本公司或该等第三者都不会保证这些数据和信息的准确性、完整性和即时性。",

          "7保证金买卖的风险",

          "7.1借存放抵押品而为交易取得融资的亏损风险可能极大。客户所蒙受的亏蚀可能会超过客户存放于本"+

          "公司作为抵押品的现金及任何其他资产。",

          "7.2市场情况可能使备用交易指示,例如「止蚀」或「限价」指示无法执行。",

          "7.3客户可能会在短时间内被要求存入额外的保证金款额或缴付利息。假如客户未能在指定的时间内支"+

          "付所需的保证金款额或利息,客户的抵押品可能会在未经客户的同意下被出售。",

          "7.4客户应密切留意账户状况,在市场波动下,本公司未必能联络客户或提供足够时间予客户存钱,而"+

          "客户的持仓将有可能被强制平仓。此外,客户将要为客户的账户内因此而出现的任何短欠数额及需缴付的利息负责。",

          "7.5因此,客户应根据本身的财政状况及投资目标,仔细考虑这种融资安排是否适合客户。",

          "8提供将客户的证券抵押品等再质押的授权书的风险",

          "8.1本公司提供授权书,容许其按照某份证券借贷协议书使用客户的证券或证券抵押品、将客户的证券"+

          "抵押品再质押以取得财务通融,或将客户的证券抵押品存放为用以履行及清偿其交收责任及债务的抵押品,存在一定风险。",

          "8.2假如客户的证券或抵押品是由本公司收取或持有的,则上述安排仅限于客户已就此给予书面同意的"+

          "情况下方行有效。此外,除非客户是专业投资者,客户的授权书必须指明有效期,该段有效期不得"+

          "超逾12个月。若客户是专业投资者,则有关限制并不适用。",

          "8.3此外,假如本公司在有关授权的期限届满前最少14日向客户发出有关授权将被视为已续期的提示,"+

          "而客户对于在有关授权的期限届满前以此方式将该授权延续不表示反对,则客户的授权将会在没有"+

          "客户的书面同意下被视为已续期。",

          "8.4现时并无任何法例规定客户必须签署这些授权书。然而,本公司可能需要授权书,以便例如向客户"+

          "提供保证金贷款或获准将客户的证券或证券抵押品借出予第三方或作为抵押品存放于第三方。本公"+

          "司应向客户解释将为何种目的而使用授权书。",

          "8.5倘若客户签署授权书,而客户的证券或证券抵押品已借出予或存放予第三方,该等第三方将对客户"+

          "的证券或证券抵押品具有留置权或作出押记。虽然本公司根据客户的授权书而借出或存放属于客户"+

          "的证券或证券抵押品须对客户负责,但若本公司的违责行为可能会导致客户损失客户的证券或证券抵押品。",

          "8.6本公司提供不涉及证券借贷的证券现金账户。假如客户毋需使用保证金贷款,或不希望本身证券或"+

          "证券抵押品被借出或遭抵押,则切勿签署上述的授权书,并应要求开立该等证券现金账户。",

          "9提供代存邮件或将邮件转交第三方的授权书的风险",

          "假如你向本公司提供授权书,允许本公司代存邮件或将邮件转交予第三方,那么你便须尽速亲身收"+

          "取所有关于你账户的成交单据及结单,并加以详细阅读,以确保可及时侦察到任何差异或错误。",

          "10关于境外证券买卖,包括在中国内地上市股票的风险",

          "10.1客户在进行任何境外证券交易前,应先了解将境外证券交易的性质和客户就此须承担的风险程度。",

          "10.2尤其是,尽管本公司是联交所的交易所参与者,但境外证券买卖不受联交所监管,也不受投资者赔偿基金保护。",

          "10.3客户应就本身的投资经验、投资目标、财政资源及其他相关条件,小心衡量自己是否适合参与该等"+

          "买卖。假如客户存有疑问,应寻求独立的专业意见。",

          "11外币交易的风险",

          "11.1以外币计算产品的买卖所带来的利润或招致的亏损（不论交易是否在客户本身所在的司法管辖区或"+

          "其他司法管辖区进行）,均会在需要将产品的单位货币兑换成另一种货币时受到汇率波动的影响。",

          "11.2客户明白若所买卖结构性产品的相关资产并非以港币为单位,其尚要面对外汇风险。货币兑换率的"+

          "波动可对相关资产的价值造成负面影响,连带影响结构性产品的价格。",

          '12交易所交易票据（"ETNs"）的风险',

          "12.1 ETN是一种由承销银行发行的无担保、非次级债务证券,旨在为投资者提供各个市场基准的回报。"+

          "ETN的回报通常与一个市场基准或策略的表现挂钩,并扣除适用的费用。与其他债务证券类似,ETN"+

          "有到期日,且仅以发行人信用作为支持。",

          "12.2客户可以透过交易所买卖ETN或于预定到期日收取现金付款,或视乎基准指数的表现有机会直接向"+

          "发行人提早赎回ETN（须扣除适用的费用）。然而,客户于赎回时可能受ETN的提早赎回条件限制,例如最少赎回数量。",

          "12.3本公司并不保证客户于到期日或发行人提早回购时可收回投资本金或任何投资回报。对于ETN,正"+

          "面表现的月份或无法抵销其中某些极不利之月度表现。",

          "12.4 ETN发行人有权随时按回购价值赎回ETN。",

          "12.5若于任何时候ETN的回购价值为零,客户的投资则变得毫无价值。ETN可能流通性不足,不能保证"+

          "客户可随时按其意愿,以目标价格买卖。",

          "12.6尽管ETF与ETN均有追踪基准指数的特性,但ETN属于债务证券,并不实际拥有其追踪的任何资"+

          "产,拥有的仅是发行人向投资者分配理论上存在的基准指数所反映的回报之承诺。ETN对投资组合"+

          "的多元化程度有限,投资者须受集中于特定指数及指数成份的集中性风险。鉴于ETN属无抵押品的"+

          "债务工具,若ETN发行商发生违约或破产,最大潜在损失可能是投资额的百分之一百及无法获得任何利润。",

          "12.7即使受追踪的相关指数没有变化,发行人信用评级降级亦会导致ETN的价值下跌。因此,买卖ETN"+

          "的客户直接面临发行人的信用风险,且在发行人宣布破产的情况下仅拥有无担保的破产索偿权。",

          "12.8本金金额须扣除定期收纳的投资者费用或任何适用的费用,该等费用会对回报产生不利影响。",

          "12.9个别ETN可能会采用杠杆,而ETN的价值会因应其对于相关资产的杠杆比率而迅速变化。客户应"+

          "注意ETN的价值可能会跌至零,客户可能损失所有的投资本金。",

          "13违约风险及交易对手风险",

          "13.1所有产品都具有违约风险及/或交易对手风险。违约风险是指发行商未能根据协定缴付。遇上经济不"+

          "景,发行商未必能成功借贷继续经营或偿还旧债。信贷评级是评价结构性产品违约风险最常用的工"+

          "具。信贷评级代表信贷评级机构于某一持定时间内的意见,而信贷评级往往会因应发行商的财政状"+

          "况或市场情况的改变而作出调整。",

          "13.2交易对手风险指交易方无力履行其财务合约责任,虽然信贷评级的评级有一定的可靠性,客户除了"+

          "要参考发行商的信贷评级外,更要仔细留意产品的结构本身是否涉及衍生工具,以免招致损失。",

          "14集体投资计划的风险",

          "14.1集体投资计划可广泛地（最多100%）投资于金融衍生工具,定息证券及/或结构性产品（包括但不限"+

          "于信用违约掉期、次等投资级别债务、按揭抵押证券及其他资产抵押证券）、并涉及不同的风险（包"+

          "括但不限于交易对手风险、流通性风险、信用风险及市场风险）。",

          "14.2集体投资计划可能使用衍生工具的交易策略可能招致损失的部份原因包括但不限于：市场状况动荡、"+

          "衍生工具与取决其价格的证券走势关连性不完美、市场缺乏流动性,以及交易对手方的违责风险。",

          "15衍生产品和结构性产品交易的一般风险",

          "15.1发行商失责风险：倘若结构性产品发行商破产而未能履行其对所发行证券的责任,客户只被视为无"+
          "抵押债权人,对发行商任何资产均无优先索偿权。因此,客户须特别留意结构性产品发行商的财力及信用。",

          "15.2非抵押产品风险：非抵押结构性产品并没有资产担保。倘若发行商破产,客户可以损失其全数投资。"+

          "客户须细阅上市文件以确定产品是否属非抵押性质,及该产品是否适合自己。",

          "15.3杠杆风险：衍生权证及牛熊证均是杠杆产品,其价值可按相对相关资产的杠杆比率而快速改变。客"+

          "户须留意,衍生权证及牛熊证的价值可以跌至零,届时当初投资的资金将会尽失。",

          "15.4有效期的考虑：结构性产品设有到期日,到期后的产品即一文不值。客户须留意产品的到期时间,"+

          "确保所选产品尚余的有效期能配合其交易策略。",

          "15.5特殊价格移动：结构性产品的价格或会因为外来因素（如市场供求）而有别于其理论价,因此实际"+

          "成交价可以高过亦可以低过理论价。",

          "15.6流通量风险：联交所规定所有结构性产品发行商要为每一只个别产品委任一名流通量提供者。流通"+

          "量提供者的职责在为产品提供两边开盘方便买卖。若有流通量提供者失责或停止履行职责,有关产"+

          "品的客户或就不能进行买卖,直至有新的流通量提供者委任出来止。",

          "16买卖衍生权证的特定风险",

          "16.1时间损耗风险：假若其他情况不变,衍生权证愈接近到期日,价值会愈低,因此不能视为长线投资。",

          "16.2波幅风险：衍生权证的价格可随相关资产价格的引申波幅而升跌,客户须注意相关资产的波幅。",

          "16.3非长期有效：与股票不同,衍生权证有到期日,并非长期有效。衍生权证到期时如非价内权证,则不会有价值。",

          "16.4成交额：衍生权证成交额高不应被认作为其价值会上升。除了市场力量外,衍生权证的价值还受其"+

          "它因素影响,包括相关资产价格及波幅、剩馀到期时间、利率及预期股息。",

          "17买卖牛熊证的特定风险",

          "17.1强制收回风险：客户买卖牛熊证,须留意牛熊证可以即日「取消」或强制收回的特色。若牛熊证的"+

          "相关资产值等同上市文件所述的强制收回价/水平,牛熊证即停止买卖。届时,客户只能收回已停止"+

          "买卖的牛熊证由产品发行商按上市文件所述计算出来的剩余价值（注意：剩余价值可以是零）。",

          "17.2融资成本：牛熊证的发行价已包括融资成本。融资成本会随牛熊证接近到期日而逐渐减少。牛熊证"+

          "的年期愈长,总融资成本愈高。若一天牛熊证被收回,客户即损失牛熊证整个有效期的融资成本。"+

          "融资成本的计算程序载于牛熊证的上市文件。",

          "17.3限定的有效期：牛熊证有一固定有效期,并于指定日期到期。有效期可以是3个月至5年不等。若"+

          "在到期前遭提早收回牛熊证的有效期将变得更短。期间牛熊证的价值会随着相关资产价格的变动而"+

          "波动,于到期后或遭提早收回后更可能会变得没有价值。",

          "17.4相关资产的走势：牛熊证的价格变动虽然趋向紧贴相关资产的价格变动,但在某些情况下未必与相"+

          "关资产价格的变动同步（即对冲值不一定等于1）。牛熊证的价格受多个因素所影响,包括其本身的"+

          "供求、财务费用及距离到期的时限。此外,个别牛熊证的对冲值亦不会经常接近1,特别是当相关资"+

          "产的价格接近收回价时。",

          "17.5接近收回价时的交易：相关资产价格接近收回价时,牛熊证的价格可能会变得更加波动,买卖差价"+

          "可能会较阔,流通量亦可能较低。牛熊证随时会被收回而交易终止。由于任何在强制收回事件后始"+

          "执行的交易将不被承认并会被取消,而强制收回事件发生的时间与牛熊证停止买卖之间可能有时差,"+

          "一些在强制收回事件发生后才达成的交易即使已被证券商确认最后亦会被取消,因此客户买卖接近"+

          "收回价的牛熊证时需额外小心。",

          "17.6海外资产发行的牛熊证：若属海外资产发行的牛熊证,强制收回事件可能会于香港交易所交易时段以外的时间发生。",

          "18交易所买卖基金的特定风险",

          "18.1市场风险：交易所买卖基金主要为追踪某些指数、行业/领域又或资产组别（如股票、债券或商品）"+

          "的表现。交易所买卖基金经理可用不同策略达至目标,但通常也不能在跌市中酌情采取防守策略。"+

          "客户必须要有因为相关指数/资产的波动而蒙受损失的准备。",

          "18.2追踪误差：这是指交易所买卖基金的表现与相关指数/资产的表现脱节,原因可以来自交易所买卖基"+

          "金的交易费及其他费用、相关指数/资产改变组合、交易所买卖基金经理的复制策略等等因素。（常见"+

          "的复制策略包括完全复制/选具代表性样本以及综合复制。）",

          "18.3以折让或溢价交易：交易所买卖基金的价格可能会高于或低于其资产净值,当中主要是供求因素的"+

          "问题,在市场大幅波动兼变化不定期间尤其多见,专门追踪一些对直接投资设限的市场/行业的交易"+

          "所买卖基金亦可能会有此情况。",

          "18.4流通量风险：证券庄家是负责提供流通量、方便买卖交易所买卖基金的交易所参与者。尽管交易所"+

          "买卖基金多有一个或以上的证券庄家,但若有证券庄家失责或停止履行职责,客户或就不能进行买卖。",

          "18.5由衍生工具构成的ETF风险：",

          '（a）交易所买卖基金（"ETF"）可投资于衍生工具。由衍生工具构成的ETF可投资于CAAP、指数' +

          "期货合约及其他金融衍生工具。",

          "（b）投资于金融衍生工具不等同直接投资于组成基础指数之相关资产。",

          "（c）金融衍生工具乃一种合约。由衍生工具构成的ETF及其交易对手（即与由衍生工具构成的ETF"+

          "达成协议之人士）根据衍生工具合约之条款同意在合约中列明之特定情况下或发生特定事件时"+

          "向对方支付若干款项。金融衍生工具之价值视乎或来自或参考相关资产之价值（例如证券或指数）而定。",

          "（d）若干金融衍生工具可能产生杠杆效应,令由衍生工具构成的ETF承受更大风险及增加其成本。"+

          "金融衍生工具或会较容易受到影响有关投资价值之因素所影响。因此,金融衍生工具价格变化"+

          "幅度甚大,并偶尔会出现急速之大幅价格变动。故此,金融衍生工具出现相对较为轻微之价格"+

          "变动,有可能即时导致由衍生工具构成的ETF蒙受重大损失（或收益）。与只投资传统证券相"+

          "比,由衍生工具构成的ETF可能会因投资金融衍生工具而蒙受大于或可能相等于金融衍生工具全部价值的损失。",

          "（e）此外,不少金融衍生工具均不在证券交易所买卖,这意味着由衍生工具构成的ETF较难出售其"+

          "金融衍生工具投资以筹措现金及╱或已变现收益或损失或对该等金融衍生工具进行准确估值。"+

          "出售或购买不在证券交易所买卖之金融衍生工具均须私下协商,且一般并非由中央结算机构担"+

          "保、每日盯市、结算及隔离账户审查机制、中介机构最低资本规定或政府机关监管,亦可能较"+

          "难找到自愿之买方╱卖方,原因是并无监管规定要求市场作价者确保该等金融衍生工具有持续市场。",

          "18.6衍生工具之交易对手风险：如有关衍生工具风险一节所述,金融衍生工具乃一种合约。根据多份金"+

          "融衍生工具合约将予支付之款项并非通过中央结算机构支付,亦非获中央结算机构作担保。因此,"+

          "由衍生工具构成的ETF因投资金融衍生工具而须承受其交易对手不愿或未能根据合约履行付款（及"+

          "其他）责任之风险。倘金融衍生工具之交易对手涉及任何无力偿还债务事件,金融衍生工具之价值"+

          "或会大幅下跌,甚至不具任何价值,由衍生工具构成的ETF或迟迟无法收回款项,原因是投资于金"+

          "融衍生工具不等同直接投资于组成基础指数之相关资产。",

          "18.7期货买卖风险：期货乃高度杠杆化,意指期货合约价格的较小变动或会导致高于实缴保证金比例的"+

          "利润或损失,及或会导致超过预缴任何保证金数额的不可估量的进一步损失。不少期货合约买卖须"+

          "遵守每日价格波动限制,即禁止于特定日期按基于上一日收市价的规定价格范围以外之价格进行期"+

          "货交易。这或会产生流动性风险,原因是管理人于不断变动的市场变现期货持仓或会成本高昂或行不通。",

          "18.8「CAAP」指以美元为单位之中国A股连接产品,即为（a）基础指数所挂钩或不挂钩之A股；或"+

          "（b）基础指数,挂钩之金融衍生工具（例如认股权证、票据或参与证明）。",

          "19杠杆及反向产品的主要风险",

          "19.1投资风险：买卖杠杆及反向产品涉及投资风险及并非为所有投资者而设。不保证可取回投资本金。",

          "19.2波动风险：杠杆及反向产品涉及使用杠杆和重新平衡活动,因而其价格可能会比传统的交易所买卖基金（ETF）更波动。",

          "19.3不同于传统的ETF：杠杆及反向产品与传统的ETF不同,具有不同的特性及风险。",

          "19.4长线持有的风险：杠杆及反向产品并非为持有超过重新平衡活动的间距,一般为一天而设。在每日"+

          "重新平衡及复合效应下,有关产品超过一天的表现会从幅度或方向上偏离相关指数同期的杠杆或相"+

          "反表现。在市况波动时有关偏离会更明显。随着一段时间受到每日重新平衡活动、相关指数波动,"+

          "以及复合效应对每日回报的影响,可能会出现相关指数上升或表现平稳,但杠杆产品却录得亏损。"+

          "同样地亦有可能会出现相关指数下跌或表现平稳,但反向产品却录得亏损。",

          "19.5重新平衡活动的风险：杠杆及反向产品不保证每天都可以重新平衡其投资组合,以实现其投资目标。"+

          "市场中断、规管限制或市场异常波动可能会对产品的重新平衡活动造成不利影响。",

          "19.6即日投资风险：杠杆及反向产品的杠杆倍数会随交易日市场走势而改变,但直至交易日完结都不会"+

          "重新平衡。因此杠杆及反向产品于交易日内的回报有可能会多于或少于相关指数的杠杆或相反回报。",
          "19.7重整组合的风险：相对传统的ETF,每日重新平衡活动会令杠杆及反向产品的投资交易次数较频密,"+

          "因而增加经纪佣金和其他买卖开支。",

          "19.8关联风险：费用、开支、交易成本及使用衍生工具的成本,可令有关产品的单日表现,与相关指数"+

          "的单日杠杆/反向表现的关联度下降。",

          "19.9终止运作风险：如所有证券庄家均辞任,杠杆及反向产品必须终止运作。杠杆及反向产品必须在最"+

          "后一名证券庄家辞任生效时同时终止运作。",

          "19.10杠杆风险（仅适用于杠杆产品）：在杠杆效应下,当相关指数变动,或者当相关指数的计价货币不同"+

          "于有关杠杆产品的基准货币,而有关货币的汇价出现波动时,会令杠杆产品的盈利和亏损倍增。",

          "19.11有别于传统的回报模式（仅适用于反向产品）：反向产品旨在提供与相关指数相反的单日回报。如果"+

          "有关指数长时间上升,或者当相关指数的计价货币不同于有关反向产品的基准货币,而该计价货币"+

          "的汇价长时间上升时,反向产品可能会损失大部分或所有价值。",

          "19.12反向产品与沽空（仅适用于反向产品）：投资反向产品并不等同于建立短仓。因为涉及重新平衡活动,"+

          "反向产品的表现可能会偏离短仓表现,特别是当市况波动和走势经常摇摆不定的时候。",

          "20供股权证的风险",

          "20.1供股权证是公司向现有股东一次性发行股分,让他们有机会通过在未来的某个日期以折扣价购买額"+

          "外的新股,来维持所有权的原有比例不被稀释。",

          "20.2直至购买新股的日期为止,客户可以按照与普通股交易的方式进行供股权证交易。如果客户不打算"+

          "行使认购权,可以在公开市场上出售。",

          "20.3认购权一旦行使,便不能再次使用。如果客户在这段时间内不行使认购权,认购权将会失效。",

          "20.4面对有折扣提供的股票很容易受到诱惑,但客户不应假设这是买平货,而是应先了解资金筹集的背"+

          "后原因,才作出明智的决定。",

          "20.5一家公司可能会使用供股来弥补债务,特别是当他们无法从其他来源借钱时。客户应留意管理层有"+

          "否透露任何潜在的问题。",

          "20.6如果客户决定不行使新股认购权,则由于所发行股分数量的增加,客户所持有公司的总股权将被摊薄。",

          "20.7如果客户在指定的时间范围内不参与供股,客户的未缴款供股权将会失效。公司将在扣除报价和费"+

          "用后,出售这些权利并分配任何净收益。如果有的话,过期收益的金额将不会通知投资者,直到报"+

          "价关闭。因此不能保证客户不会失去收益。",

          "20.8由供股权证所产生的投资和收益的价值可能会下降,客户可能会收回比原本投资更少的资金。",

          "21买卖与股票挂钓的工具（「ELI」）的风险",

          "21.1如客户指示本公司用该户口买卖与股票挂钓的工具,客户确认ELI并不保本,而如ELI的参考资产"+

          "的价格与客户的看法不同,则客户可蒙受损失。",

          "21.2在极端的情况下,客户可损失全部投资。在若干情况下的损失风险甚大,除非客户明白正在进行的"+

          "买卖的性质以及所须承担的风险,否则不应买卖该等工具。客户并须因应本身的环境及财政状况,"+

          "审慎考虑究竟有关买卖是否适合。",

          "21.3客户明白虽然大部分ELI一般较普通定期存款或债券的利息为高,但客户的ELI的潜在收益可以发"+

          "行人指定的预先厘定的水平为上限。",

          "21.4在投资期间内,客户于参考资产并无权利。该／该等参考资产的市价变动未必会导致ELI的市价及"+

          "／或潜在回报有相应的变动。",

          "21.5客户完全明白投资ELI令客户承受股权风险。客户承受正股及股市价格波动,以及股息、企业行动"+

          "及对手方风险的影响。倘相关工具的价格跌至低于转换价,客户将接纳法律责任,以预先议定的转"+

          "换价购入相关工具,而非收取与ELI的本金。因此,倘ELI的价值低于客户原本的投资,则客户将"+

          "收到一项价值下跌的工具,而倘相关工具变得毫无价值,则更可能会失去全部本金或存款。ELI并非"+

          "以任何资产或抵押品担保。",

          "21.6客户完全明白当购买ELI时,客户倚赖发行商的信用可靠性。如发行商违约或资不抵债,则不论参"+

          "考资产的表现,客户将须倚赖客户的分销商代表客户采取行动,以发行商无抵押的债权人身份提出索偿。",

          "21.7发行商可为其ELI提供有限度的庄家安排。但是,如客户尝试于发行商提供的庄家安排下在到期前"+

          "终止ELI,则客户可收取一笔大幅低于客户原本的投资金额的款项。与股票挂钓的工具或会「不能转"+

          "让」,客户或许无法将有关工具平仓或变现。ELI的发行商亦可担当不同角色,如ELI的安排行、市"+

          "场代理及计算代理。ELI的发行商、其子公司及联营公司担当不同角色亦可引致利益冲突。",

          "21.8客户应注意,正股的任何派息可影响其价格,而由于除息定价,可影响ELI到期时的回报。客户亦"+

          "应注意,发行商可因正股的企业行动而对ELI作出调整。",

          "21.9潜在孳息率：客户应就买卖ELI相关的费用及开支以及到期时的付款／交付咨询客户的经纪。港交"+

          "所发布的潜在孳息率并无将费用及开支计算在内。",

          "22期货ETF涉及的特定风险",

          "22.1期货合约转仓风险：期货合约是透过期货交易所订立的具约束力协议,于未来的特定时间买卖相关"+

          "资产。「转仓」是指,当现有期货合约即将到期,以代表同一相关资产但到期日较后的期货合约取代。"+

          "当期货合约转仓（即卖出近期的期货合约,再买入较长期的期货合约）时,如较长期的期货合约的"+

          "价格高于即将到期的现有期货合约价格,转仓可能会导致亏损（即负转仓收益「negativerollyield」）。"+

          "在此情况下,出售近期期货合约所得的收益,并不足以购买相同数量而到期日较后的期货合约,因"+

          "后者的价格较高,这会对期货ETF的资产净值有不利影响。",

          "22.2持有期货合约数量的法定限制风险：在获认可交易所上市的期货合约受限于法定持仓限制,不能持"+

          "有多于某一特定数量之期货合约。若期货ETF的期货合约持仓已增加至接近有关上限,则可能因无"+

          "法购买更多期货合约而未能新增ETF单位,此情况可能令上市的ETF单位的交易价格偏离于其资产净值。",

          "23人民币计价证券之风险",

          "23.1人民币不能自由兑换。人民币与外币（包括港元）之间的转换,是受中国的监管限制,并会影响以"+

          "人民币计价证券的流动性。",

          "23.2人民币计价的证券可能没有定期交易或活跃市场。因此,客户或许不能及时出售,或大幅折让其产"+

          "品的价值以作出售。",

          "23.3如人民币贬值,以港元计价的投资亦会下降。",

          "24有关透过沪港通及/或深港通交易之特别风险",

          "以下是一些通过本公司透过沪港通及/或深港通（下称“中港通”）买卖上海证券交易所及/或深圳证券"+

          "交易所之风险。由于涉及风险,客户只应在完全理解中港通之性质及客户将承受之风险才进行有关"+

          "交易。客户应按经验、目的、财务资源及其他因素小心考虑（及在有需要时资询客户的顾问）该等"+

          "交易是否适合客户。",

          "24.1中国相关风险：中国是一新兴市场。投资于中国涉及特别的考虑和风险,包括但不只限于较大的价"+

          "格波动性、较不发达的监管及法律构架,以及经济、社会及政治不稳定性等。",

          "24.2股票风险：投资中港通证券的回报率可能会高于短期和较长期债务证券。然而,投资中华通证券的"+

          "相关风险亦可能较高,原因在于投资中港通证券的表现取决于难以预测的因素,该等因素包括市场"+

          "突然或长期低迷的可能性以及与个别公司有关的风险。",

          "24.3流通量风险：无法保证可以就中港通建立或维持一个活跃的交易市场。如果中港通证券的价差很大,"+

          "客户以期望的价格出售中港通证券的能力可能会受到重大影响。",

          "25深交所创业板市场风险",

          "25.1参与深交所创业板市场只限于机构专业投资者。",

          "25.2深交所创业板股票涉及高投资风险因为在深圳创业板上市的公司通常为初创公司,经营规模及股本"+

          "较小。由于市场上的股分流通量较小,其股票价格可能更容易受到操纵。因此,它们的股票价格和流动性波动较大。",

          "25.3深交所创业板的公司上市规则和法规,不如深交所主板那么严格。在深交所创业板除牌的情况可"+

          "能更加普遍和更快。如果客户投资的公司被除牌,这可能对客户产生不利影响。投资于深交所创业"+

          "板上市的股票可能导致客户的重大损失。",

          "26上海交易所（上交所）科创板市场风险",

          "26.1规管差异风险：上交所科创板市场与上交所主板市场在上市、交易、信息披露以及其他事项的规则"+

          "和指引方面都存在较大差异。例如,就上市条件而言,寻求在科创板市场上市的公司将适用更短的"+

          "盈利历史、更低的净利润和营业收入,以及更低的经营活动产生的现金流量要求。科创板上市公司"+

          "较之主板和中小板公司对于股本总额的要求也更低。科创板上市公司的交易安排亦与主板上市公司"+

          "不同,例如价格限制、最小买卖盘和最大买卖盘。关于上交所科创板与主板的上市条件详情,请参阅上交所网站。",

          "26.2退市风险：科创板退市制度较主板不同,可能导致科创板市场上市公司退市的情形更多,退市速度更快。",

          "26.3公司经营风险：科创板市场上市公司一般处于发展初期,经营历史较短,规模较小,经营稳定性较"+

          "低,抵抗市场风险和行业风险的能力较弱。尽管它们可能拥有更大的发展潜质并可更多地借助于科"+
          "技创新,其未来表现（尤其是那些尚未有良好盈利记录的公司）存在很大的不确定性。",

          "26.4大幅股价波动：科创板市场上市公司股价可能随市况变化、投资者投机行为或公司业绩变动等情况"+

          "而频繁发生大幅波动。流通股本较少的科创板市场上市公司可能较容易被主要股东操纵股价。不稳"+

          "定的公司业绩亦令此类公司的估值较为困难。",

          "26.5技术风险：科创板市场上市公司的新技术能否转化为现实中的产品或服务具有不确定性。当其所在"+

          "的行业正经历快速的技术更新换代时,其产品可能面临被淘汰的危险而令其公司难以为继。",

          "26.6其他：投资者亦应参阅上海证券交易所科创板股票交易必备条款。每位内地投资者在交易上海科创"+

          "板股票之前都须认可该揭示书条款。",

          "27单位信托基金交易的特定风险",

          "27.1基金单位的价格会波动,甚至变成毫无价值。基金过往的表现并不代表将来表现。",

          "27.2不同类别基金所附带的风险有所不同。客户在决定是否投资该产品前,应审慎阅读相关产品的销售"+

          "文件（包括基金说明书、产品数据概览及基金单张等）所披露的细节及风险。主要风险包括但不限于：",

          "（a）信贷风险：这风险通常适用于所有固定收入（即债券）以及货币市场工具的基金。债券附带发"+

          "债机构违责的风险,即发行商有机会未能如期支付本金和利息。信贷评级机构给予的信贷评级"+

          "并非对发债机构信用可靠程度的保证。",

          "（b）流动性风险：此风险在基金内某些证券（包括债券等）可能在韍场上较难买入或沽售出现。未"+

          "上市或未被评级的证券可能需较长时间或无法于市场上沽出,因此具有较高的流通性风险。这"+

          "些风险有可能导致投资者招致严重亏损。",

          "（c）利率风险：如产品投资于债券,就较易受到利率波动的影响。一般来说,利率上升,债券价格"+

          "便会下跌。投资于债券的基金的价格便有可能下跌。",

          "（d）市场风险：投资价值可能会因政治、法律、经济条件及利率变化而有波动。这些变化在全部市"+

          "场及资产类别上都很普遍,客户取回的投资金额有可能少于初次投放的资金。",

          "27.3投资于高息债券的基金,除以上列举的一般风险外,还须承受其他风险,例如：",

          "（a）较高的信贷风险：高息债券的评级通常低于投资级别,或不获评级,因此涉及的发债机构违责风险往往较高；",

          "（b）受制于经济周期的转变：经济下滑时,高息债券价值的跌幅往往会较投资级别债券为大,原因"+

          "是（i）投资者会较为审慎,不愿承担风险；（ii）违责风险加剧。",

          "（c）资本增长风险：派息基金,特别是某些高息债券基金可能会以资本来支付费用及／或股息。此"+

          "举有可能令基金可供日后投资的资金减少,削弱资本增长。",

          "（d）股息分派风险：派息基金,特别是某些高息债券基金可能不会派息,取而代之的是将股息再投"+

          "资在基金上,又或投资经理可能有酌情权决定是否动用基金的收入及／或资本作分派之用。此"+

          "外,分派收益高并不意味投资者的总投资可取得正回报或高回报。",

          "（e）其他主要风险：投资于债券,特别是高息债券的基金,可能尚涉及其他主要风险,包括投资集"+

          "中于某特定种类的专门性债项或某特定地区市场或主权证券。",

          "27.4投资于「需具备衍生工具知识」基金的风险：",

          "「需具备衍生工具知识」的基金可广泛地使用金融衍生工具达致其投资目的,可能含有杠杆效应。"+

          "使用金融衍生工具可令基金承受额外风险,包括但不限于波动性风险及对手风险。基金经理可投资"+

          "于结构性产品、衍生工具及可投资于非投资级别的债务证券,最高达基金总资产净值100%。在恶劣"+

          "情况下,投资可能招致重大损失。",

          "28债券的特定风险",



          "28.1债券只在到期日提供100%本金保证,但要视乎其发行人及/或担保人（如适用）的信贷风险。",

          "28.2债券不应被视为一般或定期存款。",

          "28.3债券的价格会波动,甚至变成毫无价值。",

          "28.4产品主要风险：客户在决定是否投资该产品前,应审慎阅读相关产品认购书（如适用）所披露的细"+

          "节及风险。主要风险包括但不限于下页所载：",

          "（a）信贷风险：客户须承担发行人及担保人（如适用）的信贷风险,他们的信贷评级如有任何变动"+

          "将会影响本债券的价格及价值。债券附带发债机构违责的风险,即发行人有机会未能如期支付"+

          "本金和利息。在最坏的情况下如发行人及担保人（如适用）破产,客户可能会损失全部投资。"+

          "信贷评级机构给予的信贷评级并非对发行人信用可靠程度的保证。",

          "（b）流动性风险：债券的流动性可能有限,及可能无活跃交易,及/或没有经纪在市场提供报价,因此：",

          "（i）不可以在任何时间均能提供债券的市值及/或参考买入/卖出价,因其将取决于市场的流动性和情况；",

          "（ii）可能需要较长时间或无法于市场上出售债券；及",

          "（iii）所执行的卖出价可能与本行参考买入价有很大的差别,对客户不利。",

          "（c）利率风险：债券较易受到利率波动的影响。一般来说,利率上升,债券价格便会下跌。",

          "（d）市场风险：投资价值可能会因政治、法律、经济条件及利率变化而有波动。这些变化在全部市"+

          "场及资产类别上都很普遍,投资者取回的投资金额有可能少于初次投放的资金。",

          "28.5投资于高息债券,除以上列举的一般风险外,还须承受其他风险,例如：",

          "（a）较高的信贷风险：高息债券的评级通常低于投资级别,或不获评级,因此涉及的发债机构违责风险往往较高；",

          "（b）受制于经济周期的转变：经济下滑时,高息债券价值的跌幅往往会较投资级别债券为大,原因"+

          "是（i）投资者会较为审慎,不愿承担风险；（ii）违责风险加剧。",

          "28.6某些债券可能别具特点及风险,投资时须格外注意。这些包括：",

          "（a）永续性债券的风险：永续性债券不设到期日,其利息派付取决于发行人在非常长远的时间内的"+

          "存续能力,利息或会因根据其条款及细则而有所延迟或终止。一般而言,永续性债券一般为可"+

          "赎回及/或为后偿债券,客户须要承受再投资风险/或为后偿债券风险,详情如下。",

          "（b）可提早赎回债券的再投资风险：如果这是可提早赎回的债券,当发行人于债券到期前行使赎回"+

          "权,客户便会面对再投资风险。客户于再投资时可能会收到较小的孳息率。",

          "（c）后偿债券的风险：后偿债券于发行人遣债后的清盘过程中获较低之索偿权,因此后偿债券之持"+

          "有人将承受比优先债券更高的风险。后偿债券为无抵押,其信贷评级及债务的优先次序较优先"+

          "债券为低。客户应特别注意产品之信贷数据,包括发行人,债券或担保人的信贷评级（视情况而定）。",

          "（d）浮息及／或延迟派付利息的风险：如果债券具有浮息及／或延迟派付利息的条款,客户便无法"+

          "确定将收取的利息金额及利息派付的时间。",

          "（e）可延迟到期日的风险：如果债券具有可延迟到期日的条款,客户便没有一个订明偿还本金的确实时间表。",

          "（f）可换股或可交换性质的债券的投资风险：属可换股或可交换性质的债券,客户须同时承受股票"+

          "及债券的投资风险；及／或具有或然撇减或弥补亏损特点的债券。当发生触发事件时,这些债"+
          "券可能会作全数或部分撇帐,或转换为普通股。"

        // "(c) 在批量申購僅被部分接受的情況下，客戶同意公司或其指定人有權自行決定在公司或其指定人" +
        //   "中分配獲分配證券，包括在批量申購項下在公司及其指定人的客戶之間平均分配獲分配證券，" +
        //   "並且客戶不得就批量申購向公司或其指定人的另一客戶主張獲分配證券或主張優先權。",
        // "2.6 不得撤回：客戶確認並同意，一旦公司或其指定人士代表客戶提交任何申購，或以其他方式由公司" +
        //   "或其指定人士處理任何申購，該等申購可能無法被撤回、取消或修改。",
        // "3 公司的責任",
        // "3.1 無認許：公司及其指定人士對於任何招股說明書、發行文件、申請表和/或與任何要約相關的其他檔" +
        //   "的內容不承擔任何責任，不對該等內容負責，未曾且不得被視為已授權、認許或核實該等內容。",
        // "3.2 不是投資顧問：除非另行書面委任，公司及其指定人士不是客戶就任何發行或申購的投資顧問，對" +
        //   "於客戶因任何發行或申購而可能遭受的任何損失不承擔任何責任。客戶確認，每項申購均由客戶自行判斷及自行承擔風險。",
        // "3.3 無陳述：公司及其指定人士對於任何要約中發售證券的配售結果不作出任何承諾、保證或陳述，在" +
        //   "任何情況下，公司及其指定人士對分配結果或因任何原因全部或部分拒絕任何申請的任何行為不承擔任何責任。",
        // "4 通知和批准",
        // "4.1 申購的批准：發行人應全權負責批准或不批准申購，並公佈發售證券的分配結果。分配結果的具體" +
        //   "公佈安排可能與其他要約存在差異，客戶應當通過閱讀相關招股說明書了解具體安排。公司或其指" +
        //   "定人將以公司認為適當的方式將申請的結果通知客戶。",
        // "4.2 獲分配證券的處置：除非公司或其指定人收到客戶發出的相反通知，並就任何申請支付客戶欠公司" +
        //   "或其指定人的所有款項（在公司或其指定人在向客戶發出的配售通知中可能指定的時間內（在不影" +
        //   "響客戶要求時還款的權利或任何其他權利或補償的情況下）），公司及其指定人有權但無義務，在未" +
        //   "通知客戶或獲得客戶同意的情況下，以其認為適當的方式、按其認為適當的價格、不受任何限制和" +
        //   "權利主張約束且不承擔任何損失的情況下，出售或以其認為適當的優先順序將該等出售或處置的收" +
        //   "益用於清償任何負債，包括與獲分配證券的出售或處置相關發生的費用，以及公司及其指定人與申" +
        //   "請相關發生的所有其他費用、手續費、客戶就申購貸款應付的利息、申購貸款的未償還本金金額和" +
        //   "申請額，剩餘的金額（如有）應支付給客戶或按客戶指令支付。獲分配證券所得資金或處置證券發" +
        //   "生虧損時，客戶應負責彌補，並按要求向本公司或其名義持有人進行支付。",
        // "4.3 付款和解除：如果客戶根據本附件 II 第 4.2 條（獲分配證券的處置）的規定向公司或其指定人士發" +
        //   "出任何通知，客戶應在發出此類通知時按要求向公司或其代名人付款，或應要求以其他方式向客戶" +
        //   "支付與相關申請有關的所有欠公司或其代名人的款項（包括任何相關人士指定的所有費用、收費和" +
        //   "開支）。公司沒有義務發行或促使其代名人向客戶發行與已分配證券有關的證書，或促使其將貸記至" +
        //   "客戶指定帳戶的入賬，除非並且直到本公司及其代名人完全滿意地收到了客戶欠其的所有款項。",
        // "5 退款",
        // "5.1 不成功申購：如果申購已提交但全部或部分未獲批准，受限於本附件 II 第 5.4 條（融資費用）和第" +
        //   "7 條（申購融資）的規定，公司或其指定的人士將安排在發行人公佈的退款日以本條所述的相同方式" +
        //   "退還申請金額（或適用餘額，視具體情況而定）。",
        // "5.2 較低的發行價格：如果發售證券的發行價格（由發行人最終確定）低於客戶最初支付的申購金額，" +
        //   "公司或其指定人將安排根據相關要約的條款和條件向客戶退還申購金額的剩餘部分，但須遵守本附" +
        //   "件 II 第 5.4 條（融資費用）和第 7 條（申購融資）的規定。",
        // "5.3 費用：與申請有關的所有手續費及所有其它費用均不可退還，即使相關發行方的上市被延遲或取消也不可退還。",
        // "5.4 融資費用：如果公司已就申請向客戶提供申購貸款，客戶不可撤銷地同意並確認，公司或其指定人" +
        //   "（視具體情況而定）有權將任何退款金額用於結算客戶欠公司的任何款項，具體方式見本附件 II 第" +
        //   "4.2 條（獲分配證券的處置）。",
        // "6 客戶的承諾和責任",
        // "6.1 不禁止：客戶向公司及其任何指定人士並為公司及其任何指定人士的利益保證，客戶不是被任何相" +
        //   "關人士或任何適用規例禁止提出申請或擁有發售證券的人士，客戶以主事人身份而非代表受該等禁" +
        //   "止的任何人士或任何其他人士提出每份申請。",
        // "6.2 發售文件：就每份申請而言，客戶明白及應接受及遵守相關申請表、招股說明書及/或發售文件及與" +
        //   "該等發售有關的任何其他文件所載有關發售的所有條款及條件。客戶同意受公司或其指定人士提出" +
        //   "的申請所涉及的每項要約的條款和條件（並根據要求作出所有陳述、保證、確認和承諾）的約束。" +
        //   "客戶應當以招股說明書等招股文檔為依據作出投資決定。公司無義務向客戶提供該等招股說明書及其他發行文檔。",
        // "6.3 多項申請：客戶向公司及其代名人陳述並保證，就任何申請（a）（在不允許多項申請認購要約證券" +
        //   "的情況下）而言，客戶過去和將來均未作出、目前和將來均未作出、目前和將來均不會促使：多於" +
        //   "一份認購發售證券的申請，不論為本身或任何其他人士的利益，及（b）客戶並未被分配（不論為本" +
        //   "身或任何其他人士的利益）與申請書中申請的股份或認股權證或權益屬同一類別或類型的任何股份" +
        //   "或認股權證或權益。客戶確認，客戶違反本條規定的任何陳述和保證或本條規定的任何陳述和保證" +
        //   "不準確，除申請被拒絕之外，還可能導致公司或其指定人士代表其自身或其他客戶提交的其他申請" +
        //   "被拒絕。經要求，客戶應賠償公司及其指定人士由於該等違約或不準確而遭受的所有損失。客戶確" +
        //   "認並接受，公司、其指定人及相關人士就相關申請將依賴本條中載明的陳述和保證。",
        // "6.4 一般陳述：就每份申請而言，客戶向公司及其指定人士陳述並保證：",
        // "(a) 客戶為獨立第三方，不涉及發行人和/或其各自的任何子公司的任何董事、首席執行官、大股東" +
        //   "或任何該等子公司的緊密聯繫人（定義見《聯交所證券上市規則》），亦未與前述主體一致行動。" +
        //   "此外，客戶的認購並未由任何該等人士直接或間接提供資金或支持；",
        // "(b) 客戶在認購發售證券前未持有發行人的任何權益；及",
        // "(c) 客戶不是美國人士，且客戶認購不會要求發行人和/或公司或其指定人士遵守香港以外任何區" +
        //   "域的任何法律或法規項下的任何要求。",
        // "6.5 其他陳述：除客戶就每份申購向公司或其指定人士作出或將作出的其他陳述、保證和承諾之外，客" +
        //   "戶向公司及其指定人士作出就申購發售證券的申請人必須作出的所有陳述、保證和承諾（無論是向" +
        //   "任何主體還是向所有相關主體作出的陳述、保證和承諾）。",
        // "6.6 進一步保證：客戶確認並理解，與每份發行或申請相關的法律和監管要求及市場慣例可能會不時發" +
        //   "生變化。客戶承諾根據公司或其指定人士可能不時決定的法律和監管要求與市場慣例向公司及其指" +
        //   "定人士提供相關的資訊，作出相關的披露，採取步驟，並作出相關的陳述、保證與承諾。客戶還應遵守該等要求和慣例。",
        // "6.7 公司的陳述：如果公司或其指定人（視具體情況而定）就任何發行或申購被要求就客戶或任何其他" +
        //   "事項向任何一名或多名相關主體作出任何承諾、陳述和保證，客戶授權公司及其指定人僅依賴客戶" +
        //   "向公司或其指定人作出的任何相應承諾、陳述和保證而去作出該等承諾、陳述和保證。客戶應受任" +
        //   "何相關人士作出的所有適用公告及適用於每項發行或申購及發行獲分配證券的所有適用規例的約束。",
        // "6.8 公司代表客戶行事：在不影響條款第 2.8 條（授權書）的情況下，客戶授權公司及其指定人士代表客" +
        //   "戶簽署為提出任何申購之目的而需要簽署的所有檔並開展的所有事項。客戶接受公司和/或其指定人" +
        //   "作為代理人代表客戶就每份申購所做的所有事情。在本公司或代名人作為客戶代理人的情況下，客" +
        //   "戶應接受每次申購中所申購的發售證券或更少的數量會分配到本公司或代名人。客戶賠償本公司及" +
        //   "其代名人在任何與本申請相關的任何損失或索賠。",

        // "6.9 披露：如果適用法規要求或與相關發行或申請相關要求或要求披露，客戶授權公司及其指定人士向" +
        //   "任何相關主體披露關於客戶和相關申請的所有資訊。",
        // "7 申購融資",
        // "7.1 申購融資：客戶可申請並要求公司不時向客戶提供用於申購的申購貸款，但須受限於本附件 II 的規" +
        //   "定，並受限於客戶和公司就相關申購就下列事項達成的協議：",
        // "(a) 申購貸款本金；",
        // "(b) 利率；",
        // "(c) 印花稅及所有其他收費；及",
        // "(d) 手續費。",
        // "7.2 公司絕對酌情權：任何申購貸款的提供和提取由公司自行決定，並受限於本協議。公司可在任何時" +
        //   "候拒絕提供申購貸款，而無需給予任何理由。",
        // "7.3 保證金：如果客戶以保證金形式向本公司支付任何款項，本公司可將該款項存入客戶的相關帳戶，" +
        //   "並可在申購被接受時將該款項用於支付應付的保證金。客戶同意，公司實際收到的任何該等保證金" +
        //   "應在申購貸款的任何金額被如此使用之前用於清償申請金額。",
        // "7.4 費用和支出：客戶將在公司要求時立即向公司支付申購貸款、相關利息、手續費、與申購貸款相關 的所有費用、收費和支出。",
        // "7.5 申購貸款用途：申購貸款僅供客戶申購使用。儘管申購由公司或其指定人代表客戶提交，客戶對申" +
        //   "購貸款的任何金額或將申購貸款用於相關申購以外的任何目的不享有任何性質的任何權利、權屬、權益或權利主張。",
        // "7.6 提取：如果公司向客戶提供申購貸款，公司將申購貸款金額貸記至相關帳戶。如果任何貸款申請將" +
        //   "由公司的指定人士提出，公司的指定人士應始終為公司託管相關申購貸款的金額，以待向發行人付" +
        //   "款或按發行人的指令付款。",
        // "7.7 償還：申購貸款應連同相關配售和公開發行文檔中規定的所有利息及任何其他未償還金額在相關配" +
        //   "售和公開發行文件中規定的退款日全額償還。",
        // "7.8 提前還款：除非公司另行同意，客戶無權在相關配售和公開發行文檔中規定的還款日之前部分或全" +
        //   "部償還申購貸款及任何其他相關債務。",
        // "7.9 優先權：儘管有本附件 II 的任何其他規定，公司有優先權在任何時間要求立即償還任何申購貸款的" +
        //   "任何未償還金額，並取消任何申購貸款。",
        // "7.10 押記：考慮到公司根據相關申請向客戶提供申購貸款，在向公司分配並發行獲分配證券時（公司或" +
        //   "代名人作為客戶的代理人），作為實益擁有人的客戶特此押記（以第一固定押記方式）、轉讓、抵押" +
        //   "和/或質押，並同意向公司押記、轉讓、抵押和/或質押客戶對獲分配證券的所有權利、權屬和權益，" +
        //   "作為客戶就申購貸款和申請應向公司或其指定人支付的所有款項以及客戶向公司或其指定人履行的" +
        //   "任何其他義務的持續擔保。本押記設立的擔保應延伸並涵蓋任何及所有股息、權證、股份、股票、" +
        //   "權利、利益、利息、分配、增值及其他金錢和財產，該等金錢和財產在任何時間通過與獲分配證券" +
        //   "有關的替代、贖回、紅利、優先權、期權或其他方式產生或提供。",
        // "7.11 向第三方進一步押記：受限於本附件 II 第 7.10 條（押記）構成的擔保，客戶授權公司在任何及所有" +
        //   "獲分配證券上以任何第三方為受益人押記、質押或以其他方式授予任何性質的擔保權益，作為公司" +
        //   "向第三方提供的為申購貸款的全部或部分提供資金的任何信貸安排的擔保。",
        // "7.12 進一步擔保：考慮到公司向客戶提供申購貸款，作為實益擁有人的客戶以第一固定押記的方式向公" +
        //   "司押記、出讓、抵押和質押，並同意以向公司押記、出讓、抵押和質押的方式向公司押記、出讓、抵" +
        //   "押和質押客戶在公司開立的每個帳戶的結餘（包括帳戶的任何續期或重新指定）中不時擁有的所有" +
        //   "權利、權屬和權益，作為客戶就申購貸款和申請應向公司及其指定人支付的所有款項的持續擔保。",
        // "7.13 擔保的性質：由本附件 II 第 7.10 條（押記）和第 7.12 條（進一步擔保）構成的每項擔保均為持續性" +
        //   "擔保，並擔保客戶不時欠公司的所有負債的最終餘額，即使所有或任何該等負債在任何中期得到償" +
        //   "還或清償。每份擔保是對公司持有的任何其他擔保的補充，不應受到公司持有的任何其他擔保的影" +
        //   "響，並可強制執行。對合併擔保權益權利的任何限制不適用於本附件 II 第 7.10 條（押記）或第 7.12" +
        //   "條（進一步擔保）構成的任何擔保。",
        // "7.14 進一步保證：客戶應自費簽署所有轉讓文檔、授權書、委託書和/或其他文檔，並開展公司或其指定" +
        //   "人為完善公司或其指定人對獲分配證券的所有權和/或為歸屬或使公司或其指定人能夠以公司的名" +
        //   "義或以公司指定人和/或任何買方的名義歸屬該等獲分配證券，或為獲得、提交並強制執行本附件 II" +
        //   "中授予公司的擔保物和/或權利和補償的全部利益之目的而可能要求的所有行動和事項。公司及其提" +
        //   "名人有權行使本附件 II 中授予公司或其提名人的所有權利和權力，包括出售獲分配證券的權利。",
        // "7.15 付款的用途：就任何申購貸款或用途向公司或其指定人士支付的任何款項可用於清償該等貸款或用" +
        //   "途，或存入公司或其指定人士為保留其證明客戶的全部負債的權利而決定的帳戶的貸方。",

        // "附件 III：期權交易",
        // "本附件 III 適用於本公司提供的與期權交易有關的服務。本附件為本協議的補充條款並應與以及可能不時修訂" +
        //   "的適用於公司提供的服務的任何其他條款和條件一同閱讀。它是協議的組成部分。",
        // "1 定義和詮釋：在本附件中，除非上下文另有要求，下列表述應具有以下涵義：",
        // "「工作日」是指相關交易所開市交易的任何日期，除卻星期六、星期日、公共假期以及相關交易所" +
        //   "宣佈為非交易日的任何其他日期；",
        // "「行使價」亦稱為「履約價」，是指在期權合約中指定的每單位價格的目標證券，在行使該期權時可" +
        //   "以購買或出售目標證券；",
        // "「到期日」是指可以在合約到期日前可以行使該期權合約的最後一天。如果該到期日並非工作日，" +
        //   "除非另有說明，否則該到期日會自動順延至下一個工作日；",
        // "「價內期權」是指具有正內在價值的期權。具體而言，如在在美國交易所進行交易的期權的內在價" +
        //   "值最少等於$0.01 美元，則該期權便視為價內；",
        // "期權的「內在價值」是指由本公司所確定的標的股票的內在價值超過（在認購期權的情況下）或低" +
        //   "於（在認沽期權的情況下）行使價；",
        // "「保證金」指作為客戶在本附件項下對公司的義務擔保的現金、投資產品及或公司可接受的其他資產；",
        // "「期權金」指持有人就期權合約的簽訂應支付給期權合約的發行人的金額；",
        // "「聯交所客戶合約」具有聯交所期權交易規則中所定義的「客戶合約」的涵義；",
        // "「聯交所合約」具有期權交易規則中所定義的「合約」的涵義；",
        // "「聯交所綜合帳戶」具有期權交易規則中所定義的「綜合帳戶」的涵義；",
        // "「聯交所期權合約」具有期權交易規則中所定義的「期權合約」的涵義；",
        // "「聯交所期權交易所參與者」具有聯交所期權交易規則中所定義的「期權交易所參與者」的涵義；",
        // "「聯交所期權系統」是指香港聯合交易所、聯交所期權結算所為香港聯合交易所期權業務交易提供" +
        //   "的期權交易系統、期權結算系統等；",
        // "「聯交所期權買賣交易所參與人」具有聯交所期權交易規則中所定義的「期權買賣交易參與人」的涵義；",
        // "「聯交所期權交易規則」指《香港聯合交易所期權交易規則》及其不時修訂或補充；",
        // "「聯交所標準合約」指《香港聯合交易所期權交易規則》第六附件所載的香港聯合交易所不時指定" +
        //   "的適用於聯交所期權合約的標準條款和條件；",
        // "「聯交所期權交易業務」，具有《期權交易規則》中所定義的「香港聯合交易所期權交易業務」；及",
        // "「聯交所期權結算所抵押品」具有《聯交所期權結算所結算規則》中定義的涵義。",
        // "2 法律法規",
        // "2.1 法律等規定：所有期權交易均應遵守交易所在地的法律、規則、法規、交易所、市場和結算所（如" +
        //   "有）的慣例和使用。客戶不得單獨或者與他人共同違反交易所、市場和結算所可能不時規定的持倉" +
        //   "或者行權限制。本公司或交易所、市場或結算所採取的所有行動對客戶均有約束力。",
        // "2.2 遵守法律：客戶應遵守有關交易所，市場和票據交換所有關所有期權交易的所有適用法規。",
        // "2.3 交易限制：為有助於維護期權合約市場的公平有序，或者為保護投資者之目的，交易所或任何其他" +
        //   "相關監管機構、政府機構或專業機構，以其酌情權並不時限制特定期權的交易或執行期權合約。",
        // "2.4 放棄/行權限制：",
        // "(a) 就任何聯交所期權合約而言，客戶不能在合約到期日前行使該期權合約或放棄該期權合約，除" +
        //   "非客戶以書面方式指示本公司並獲接受；和",
        // "(b) 就任何聯交所期權合約以外的期權合約而言，客戶不能放棄該期權合約，除非客戶以書面方式指示本公司並獲接受。",
        // "2.5 截止時間：相關交易所、市場和結算所執行交付行權指示的截止時間，該等時間對客戶具有約束力。",
        // "2.6 保密：本公司將對與帳戶相關的資訊保密，但可根據本公司的私隱政策聲明和/或本協議的其他適用",
        // "條款向相關方和/或證監會、香港聯合交易所、香港交易所和任何交易所或任何其他相關監管機構提" +
        //   "供任何該等資訊，以遵守其要求或資訊要求。",
        // "2.7 限制：本公司可對客戶在任何時候可能擁有的未平倉合約或交割義務設置限制。",
        // "3 期權交易（一般性）",
        // "3.1 客戶的利益：客戶確認，（i）帳戶僅為客戶的帳戶及利益而設，而非為任何其他人士的利益而設；或" +
        //   "（ii）客戶已以書面形式向本公司披露帳戶為其利益而設的人士的姓名；或（iii）就香港聯合交易所",
        // "期權交易業務而言，客戶已要求本公司將帳戶作為香港聯合交易所的綜合帳戶運作，並將應本公司",
        // "的要求立即通知本公司其在聯交所期權合約中擁有最終實益權益的任何人士的身份。",
        // "3.2 執行：在不違反本公司規定的截止時間的前提下及本附件 III 的第 2.4 條（放棄/行權限制）：在執行" +
        //   "期權交易的交易所設定的交易時間內，可以接受在工作日當天執行的執行指示；及在任何特定期權" +
        //   "合約到期日前的營業日，公司將按照執行期權交易的交易所設定的交易時間接受行權指示。",
        // "3.3 無到期通知：本公司無義務事先通知客戶期權到期日，客戶僅有責任採取行動執行期權合約。客戶" +
        //   "應知曉執行期權的交易時間和任何非交易日，以確保期權能夠及時行權。如果客戶未在相關機構和" +
        //   "交易所規定的時間內向本公司提供任何行權指示（本公司無義務通知）,客戶應放棄並免除本公司、" +
        //   "其管理人員、雇員和代理人因任何期權合約未被行權而令客戶蒙受損失的任何及所有索償。",
        // "3.4 相關證券：本公司無義務向客戶傳達與期權涵蓋的相關證券或與之相關的任何證券相關的任何資訊，" +
        //   "或與期權相關的任何資訊，無論該等資訊屆時或之後已知或可用。客戶須自行負責以適當及適時的" +
        //   "方式行使客戶的任何認沽期權或認購期權的任何權利、特權或義務。",
        // "3.5 證券保證金帳戶期權：若客戶在證券保證金帳戶賣出或買入期權，則：",
        // "(a) 就認購期權而言，如對客戶行使認購期權，則客戶須將該等證券存放於證券保證金帳戶，直至" +
        //   "期權期屆滿，且不得出售或撤回該等證券。如期權被行使，本公司可向買方交付該等證券而無須事先通知客戶；及",
        // "(b) 就任何認沽期權而言，如對客戶行使該等認沽期權，則客戶須在證券保證金帳戶內持有足夠的" +
        //   "資金以支付買入的證券，直至期權期屆滿為止，且不得提取該等資金或將其用作任何其他用途。" +
        //   "如期權被行使，本公司可使用該等資金購買該等證券，而無須事先通知客戶。",
        // "3.6 本公司自身帳戶：本公司及高盈证券成員可為其自身帳戶交易期權以及與該等期權相關的證券。該" +
        //   "等交易可每日連續進行，並可在帳戶進行任何期權交易之前、同時或之後進行。在該等交易中，本" +
        //   "公司及高盈证券成員可進行與（a）客戶在帳戶中可能持有的倉位，或（b）本公司及高盈证券成員向" +
        //   "客戶推薦的交易，或（c）本公司及高盈证券成員可為客戶實施的交易類似或不同的期權倉位或其相" +
        //   "關證券。客戶明白此類交易可能會對客戶的利益產生不利影響。",

        // "3.7 期權長倉截止期限：如果客戶執行一份期權長倉合約，客戶同意支付期權合約規定的全部執行價格。" +
        //   "客戶的期權長倉有機會到期及變得一文不值。如客戶未能在相應的行使截止期限前發出指示，則其" +
        //   "每一價內值期權長倉將會自動于到期日時行權。因此，如客戶不希望行使任何此類價內期權長倉，" +
        //   "則客戶必須在該未平倉的期權合約到期日前自行平倉。",
        // "3.8 行使指定分配通知：公司應公平分配期權合約的行權指定分配通知。",
        // "3.9 期權合約的義務:客戶應根據其所參與的每一份期權合約支付相對應的費用及交付，並履行其名義下" +
        //   "的所有義務。客戶在任何時候須自行承擔因遵守或未遵守該期限合約的後果所帶來的風險。具體而" +
        //   "言，如客戶的期權頭寸已被行使或轉讓，則必須承擔相應義務（包括結算義務）及承擔任何由此而生的損失（如有）。",
        // "4 保證金和擔保",
        // "4.1 擔保：任何帳戶中持有的所有證券和資金應根據條款第 16 條款（押記）進行押記。",
        // "4.2 保證金：客戶同意向本公司提供保證金。該等保證金應按照本公司不時提出的要求支付或交付，保" +
        //   "證金所要求的金額不應低於或需要超過適用法規要求的金額（特別是關於客戶未平倉合約和交割義" +
        //   "務的規則），並可能要求提供進一步的保證金，以反映市值的變化及/或管理公司的信貸風險和其他風險。",
        // "4.3 交付許可權：經要求，客戶應向本公司提供本公司在規則項下可能要求的許可權，以授權本公司直" +
        //   "接或通過香港聯合交易所期權買賣交易所參與人向聯交所期權結算所交付該等證券，作為與聯交所" +
        //   "期權交易業務相關的聯交所期權結算所擔保品，而該等授權是由客戶向本公司或本公司自行不時決" +
        //   "定的其他相關人士發出的指示所導致的；僅就期權交易而言，公司無權從客戶那裡進一步借入或借" +
        //   "出客戶的證券，或者以其他方式（根據客戶的指示或客戶的指示除外）佔有客戶的任何證券，以用於任何其他目的。",
        // "4.4 隨時有足夠的資產：客戶在發出交易期權合約的指示時必須先確保其帳戶內已有足夠的資產，並且" +
        //   "客戶在整個期權合約期內須一直保持有足夠資產，直至該期權合約到期或被行使為止。",
        // "5 期權金和佣金",
        // "就根據客戶指示而生效的所有期權合約而言，客戶須在本公司通知的期限內，向本公司繳付期權金、" +
        //   "本公司的佣金及香港聯合交易所或有關交易所、市場或結算所徵收的任何其他收費及適用的征費；" +
        //   "本公司可從任何帳戶扣除該等期權金、佣金、押記及征費。",
        // "6 香港聯合交易所期權交易相關的具體規則",
        // "在不影響並補充本附件 III 的其他條款的情況下，本第 6 條款應在本公司為客戶或為客戶之利益開展" +
        //   "聯交所期權交易業務時適用。",
        // "6.1 現狀：倘若本公司是已登記的聯交所期權經紀交易所參與者和香港結算的直接結算參與者，本公司" +
        //   "將通知客戶這一事實。本條款所述的主要負責客戶事務的期權員工或期權代表的全名應是帳戶開立" +
        //   "流程提及人士或是本公司可不時通知客戶指定的其他人士。",
        // "6.2 適用規則：所有香港聯合交易所交易期權業務應根據適用於本公司的規則實施，包括但不限於香港" +
        //   "聯合交易所期權交易規則、聯交所期權結算所結算規則和香港結算的規則；特別是，聯交所期權結" +
        //   "算所在規則項下有權調整聯交所合約的條款，本公司應通知客戶任何影響客戶為一方的聯交所客戶" +
        //   "合約的該等調整，本公司、香港聯合交易所、聯交所期權結算所或香港結算根據該等規則採取的所" +
        //   "有行動應對客戶具有約束力。",
        // "6.3 香港聯合交易所標準合約：相關期權系列的聯交所標準合約的條款應適用於本公司與客戶之間的每" +
        //   "份聯交所客戶合約，所有聯交所客戶合約應根據規則設立、行使、結算和解除。",
        // "6.4 平倉/放棄：客戶確認：",
        // "(a) 本公司可能會被要求平倉或放棄聯交所客戶合約，如本公司認為行使該聯交所期權合約會有可" +
        //   "能導致客戶短倉的情況出現及該客戶未能在該期權到期日前至少 2 個工作日前平倉或增加持倉。",
        // "(b) 本公司可能被要求平倉或放棄聯交所客戶合約，以遵守香港聯合交易所施加的持倉限制；及",
        // "(c) 如果本公司（或本公司經其開展聯交所期權交易業務的聯交所期權交易所參與者）違約，香港" +
        //   "聯合交易所的違約程序有可能導致客戶與其他聯交所期權交易所參與者之間聯交所客戶合約" +
        //   "被平倉、放棄或者由聯交所客戶合約替代。",
        // "6.5 對發行人的變更：如果某一期權類別的標的證券的發行人的資本結構或構成發生變更，或在任何其" +
        //   "他異常情況下，聯交所期權結算所可在其認為必要和可取的情況下對該期權類別的條款和條件進行" +
        //   "調整，以確保香港聯合交易所期權類別未平倉合約的所有當事人得到公平對待。所有該等調整應對客戶具有約束力。",
        // "6.6 替換：根據客戶的要求，本公司可以同意根據規則，將自己與客戶之間的聯交所客戶合同替換為客" +
        //   "戶與另一家聯交所期權交易所參與者之間的聯交所客戶合同。",
        // "6.7 義務：客戶行使或針對客戶行使聯交所客戶合同》時，客戶應根據聯交所標準合同並在公司已通知" +
        //   "客戶的情況下，根據相關合同履行客戶的交付義務。",
        // "6.8 主事人：儘管所有聯交所期權合約都將在聯交所行使，但客戶和本公司應根據聯交所客戶合同作為主事人訂立合同。",
        // "6.9 產品規格：本公司同意在客戶要求時向客戶提供聯交所期權合約的產品規格。",
        // "6.10 投資者賠償基金：若本公司未按本附件 III 的規定履行對客戶的賠償義務，受投資者賠償基金不時條" +
        //   "款的限制，客戶有權向根據證券及期貨條例設立的投資者賠償基金索賠。",
        // "6.11 公司的業務：公司應將可能會影響公司根據本第 6 條向客戶提供的服務的公司業務重大變化通知客戶。",
        // "6.12 長倉到期日：在相關到期日，且僅在到期日，香港聯合交易所期權系統將為價內或高於聯交所期權" +
        //   "結算所訂明的價內值的所有開放長倉自動生成行權指令。客戶可指示本公司根據聯交所期權結算所" +
        //   "的運行結算程式在系統關閉到期日前取代該等「自動生成的行權指令」。",
        // "6.13 協議：客戶要確認其已閱讀並同意本附件 III 的條款，該等條款已以客戶選擇的語言向客戶解釋。",
        // "6.14 持倉報告：如果持有或控制的倉位達到須報告水平，客戶須自行全權負責通知聯交所。如果客戶決" +
        //   "定通過本公司通知聯交所，客戶必須告知本公司其在其他代理或經紀處持有的全部持倉，以便本公" +
        //   "司能夠代表客戶向聯交所提交通知。或者，客戶也可要求本公司向聯交所單獨報告其在本公司持有" +
        //   "帳戶的持倉，即使客戶在該帳戶中的持倉未超過須報告水平。",
        // "6.15 彌償：在不限制客戶提供任何其他彌償的原則下，客戶同意彌償本公司及其雇員及代理人因客戶違" +
        //   "反其於本附件下的任何義務而引致的所有損失及開支，包括向客戶追收債款及關閉有關帳戶的合理費用。",
        // "7 違約",
        // "如果客戶未能遵守客戶的任何義務和/或履行責任，包括未能提供保證金，在不影響本公司可能享有" +
        //   "的任何其他權利的情況下，本公司可：",
        // "(a) 拒絕接受客戶就聯交所期權交易業務或其他期權合約的進一步指令；",
        // "(b) 平倉、放棄或行使香港聯合交易所客戶合約或與公司簽訂的其他期權合約的部分或全部",

        // "(c) 訂立任何期權合約或投資產品的任何交易，以清償產生的義務或對沖本公司因客戶未能履行義務而面臨的風險；",
        // "(d) 處置部分或全部保證金，並用其收益清償債務；及",
        // "(e) 所有債務清償後的剩餘收益應支付給客戶。",
        // "8 風險披露聲明",
        // "客戶確認已經閱讀並理解本公司就提供期權交易相關服務的風險披露聲明，見於附件 X（風險披露" +
        //   "聲明）及其他本公司提供給客戶的使用其選擇語言（英文或中文）的相關風險披露聲明，客戶已受" +
        //   "邀閲讀該等風險披露聲明、提問，在有需要時尋求獨立意見並充分接受有關期權交易的風險。",
        // "附件 IV：基金銷售服務",
        // "本附件適用於本公司提供的基金銷售服務。本附件為本協議的補充條款並應與以及可能不時修訂的適用於公" +
        //   "司提供的服務的任何其他條款和條件一同閱讀。它是協議的組成部分。",
        // "1 定義和詮釋：",
        // "在本附件中，除非上下文另有要求，本協議中定義的術語在本文中使用時應具有相同涵義。在本附件中：",
        // "「交易流程」指公司與基金或相關基金的基金經理就基金份額的認購、轉換、贖回及其他附帶事項" +
        //   "不時約定的任何程式；",
        // "「基金銷售服務」指本公司根據客戶之指示，就任何基金之任何單位之購買、認購、轉換、轉讓、贖" +
        //   "回或出售，以及有關款項或款項之處理，所提供之服務；及",
        // "「單位」指基金中的任何股份或單位。",
        // "2 認購和贖回申請及付款",
        // "2.1 一般性指示：認購、購買、贖回、出售或轉換任何單位的任何指示（無論是全部還是部分）必須按公" +
        //   "司規定的方式作出，並隨附公司可能不時要求的任何必要文檔。",
        // "2.2 公司的酌情權：所有與單位認購、轉換或贖回相關的指示以及由此產生的交易和支付均應遵守交易" +
        //   "流程及或公司不時規定的任何其他要求。公司有權無須通知客戶，亦無須給予任何理由，無視任何" +
        //   "未能符合交易程序的指示或公司的其他要求，或執行該等指示及為符合交易程序或公司不時規定的" +
        //   "其他要求而對該等指示作出的必要修改。",
        // "2.3 公司的執行：公司將儘快執行任何指示，但該等指示的執行可能與基金相關發售文檔中規定的時間" +
        //   "不一致。客戶確認，公司可每日或不時地將客戶向公司下達的訂單與公司其他客戶下達的訂單合併" +
        //   "計算，以便公司向相關基金經理、基金或產品發行人下達該等訂單以供執行。",
        // "2.4 截止時間：受限於帳戶的持續運作，如果本公司在其不時全權決定的相關基金的交易截止時間前收" +
        //   "到有效及完整的指示（連同所有款項、所需的資料及文檔），一般將於本公司收到該等指示之日處理" +
        //   "該等指示。若在本次交易截止後或香港出現 8 號（或以上）颱風信號或黑色暴雨警告信號當日收到" +
        //   "指令（及資金），通常按基金發售文檔的約定（或基金管理人、基金或產品發行人等另行確定）於基" +
        //   "金的下一交易日執行。如果公司合理地認為有理由延遲或拒絕處理或接受任何指示，公司保留延遲" +
        //   "或拒絕處理或接受任何指示的權利。",
        // "2.5 僅供參考的價格：基金的實際買入價（“實際買入價”）和賣出價應在交易生效和結算時確定，本公司" +
        //   "或其代表在指示時可能向客戶報價或提供的任何數值（“報價”）僅供參考，對本公司不具有約束力。" +
        //   "基金的實際買入價可以高於或低於報價。",
        // "2.6 不代表基金行事：公司無權代表任何基金管理人、基金或產品發行人接受認購、轉換或贖回任何單" +
        //   "位的指示（或申請）。公司收到該等指示、必要的付款及任何其他文件並不構成相關基金管理人、基" +
        //   "金或產品發行人接受該等指示。",
        // "2.7 第三方：客戶確認，任何從本公司收到指令的基金經理、基金或產品發行人均無義務接受該指令的" +
        //   "部分或全部。本公司不對基金管理人、基金及產品發行人拒絕或者拖延接受指令而給客戶造成的損" +
        //   "失（包括投資機會損失）承擔保證責任。",
        // "2.8 交收：客戶確認：（a）客戶就每筆購買或認購單位的指令應向本公司（或本公司指定的其他人士）支" +
        //   "付的購買價款、認購款項或費用，應從證券現金帳戶（或由客戶不時另行指定並通知本公司的其他" +
        //   "帳戶）中扣除；及（b）本公司就每筆出售、贖回或以其他方式處置單位的指令而收到的贖回款項，" +
        //   "在任何情況下均應按照有關基金募集文件（或基金管理人、基金或產品發行人不時另行決定）規定" +
        //   "的交收期，支付或存入證券現金帳戶。",

        // "2.9 資金不足：客戶進一步同意，對於單位的購買或認購，如果帳戶中指定支付的資金不足，或者在公" +
        //   "司規定的時間內未收到已清算資金（不含任何扣除或預扣款項），公司保留拒絕或延遲處理任何訂單的權利。",
        // "3 投資的權屬和登記",
        // "3.1 一般：如果客戶認購基金單位，該等單位將以公司的名義或以公司的名義與客戶的名義共同登記，" +
        //   "或僅以客戶的名義登記（視具體情況而定）。本公司將不會是閣下在基金的任何投資的受益人。",
        // "3.2 單位證書：不會向客戶簽發單位證書。客戶將被發送一份其認購/獲得（或處置）任何單位的確認。",
        // "4 終止",
        // "在與公司的帳戶終止或基金銷售服務終止時，客戶將被視為已向公司發出指示，且根據其酌情權：",
        // "(a) 促使託管人為客戶帳戶持有的任何單位在基金帳戶終止生效日被贖回或以其他方式處理，或者" +
        //   "如果該日不是客戶帳戶的交易日或在該等基金的發售檔中規定的最晚交易時間之後，則在下一" +
        //   "個交易日（“生效日”）贖回或交易收益（在結清欠公司和高盈证券的任何未償還債務、成本和" +
        //   "費用後）的任何單位匯給客戶和/或結清客戶、公司或任何託管人發生的任何負債；",
        // "(b) 促使託管人為客戶帳戶當時持有的任何單位於生效日直接劃撥至客戶名下（如適用）；及",
        // "(c) 取消任何未執行的交易。",
        // "附件 V:債券交易",
        // "1 申請",
        // "本附件 V 適用於本公司提供的與債券交易有關的服務。本附件為本協議的補充條款並應與以及可能" +
        //   "不時修訂的適用於公司提供的服務的任何其他條款和條件一同閱讀。它是協議的組成部分。",
        // "2 債券交易",
        // "2.1 酌情權：公司有絕對酌情權拒絕向客戶提供債券交易服務和/或附加與基金帳戶或向客戶提供債券交" +
        //   "易服務有關的任何條件。",
        // "2.2 不能成功執行或延遲執行：本公司對於任何不能成功執行或延遲執行的客戶債券交易指示，並不負" +
        //   "有任何責任。所有未執行的訂單將在交易期結束時失效。",
        // "2.3 代理人：除非另有規定，本公司在所有債券交易中都是以代理人身份行事。",
        // "2.4 託管人：客戶委任本公司（或任何實體，包括香港以外的實體，並由本公司指定）為客戶的託管人，" +
        //   "並為客戶所投資的債券登記於託管人名下，由託管人代表客戶購入及持有。",
        // "2.5 價格：債券的實際買入和賣出價須在交易進行時確定，而本公司或其代表可隨時向客戶報價或提供" +
        //   "價位，均屬參考性質，對本公司並不具約束力。",
        // "2.6 約束性：債券交易的所有指示於提交時已是最終的決定並對客戶有約束性，但取決於是否被本公司" +
        //   "接納及視乎最終交易而定。",
        // "2.7 派息日：債券的實際派息日可能與其原定派息日有所不同，要視乎不同因素，包括並不限於要視乎" +
        //   "發行人、及本公司所委託的託管機構/信託機構所行使的酌情權，及相關銀行的轉帳程序和其他因素。",
        // "3 客戶聲明",
        // "客户聲明他或她:",
        // "3.1 非存款:完全明白債券不是銀行存款，及不會受到本公司或高盈证券所保證，或構成任何責任；",
        // "3.2 風險披露聲明：客戶確認已經閱讀並理解本公司就提供債券交易相關服務的風險披露聲明，見於附" +
        //   "件 X（風險披露聲明）及其他本公司提供給客戶的使用其選擇語言（英文或中文）的相關風險披露" +
        //   "聲明，客戶已受邀閲讀該等風險披露聲明、提問，在有需要時尋求獨立意見並充分接受有關債券交易的風險；",
        // "3.3 相關資訊：已獲得，並已細閱債券說明書及/或其最新產品銷售文件或資訊及/或查閱最新產品銷售文" +
        //   "件或資訊（視乎何種情況而定，「有關資訊」），並同意所載的條款。客戶完全知悉及理解有關資訊所" +
        //   "載的條款，包括但不限於有關投資債券的風險和限制。本公司已呈請客戶細閱有關資訊，如需要，" +
        //   "可提出問題或資詢獨立意見。",
        // "3.4 不提供意見：完全明白上述的有關資訊不擬提供，亦不可賴以作為稅務、法律或會計意見、或有關" +
        //   "債券的信用或其他評估，也不得構成任何債券預期回報的保證或擔保。客戶應諮詢其稅務、法律、" +
        //   "會計、投資、財務及/或其他顧問；",
        // "3.5 沒有被禁止：並非為或代表銷售文件所訂明被禁止購買或持有該債券的個人或團體；",
        // "3.6 地域限制：並非為銷售文件所訂明被禁止投資國家的公民或居民；",
        // "3.7 有限流動性：明白債券的流動性可能有限，及可能無活躍交易，及/或沒有經紀在市場提供報價，因" +
        //   "此（i）債券的參考買入/賣出價不可以在任何時間均能被提供，因其將取決於市場的流動性和情况；" +
        //   "（ii）可能需要較長時間或無法於市場上出售債券；及（iii）所執行的賣出價可能與本公司提供的參"+
        // "考買入價有很大的差別；",

        // "3.8 損失：全部承擔及負責投資債券損失的風險；和",
        // "3.9 資訊準確性：明白本公司就債券交易服務中提供的任何資訊是按「現狀」、「可提供」的狀態提供，" +
        //   "且僅供一般資訊使用。客户同意此類資訊，如市場數據和報價均由第三方提供，而本公司並不保證" +
        //   "此類資訊的準確性、可靠性、時效性、完整性或順序。本公司毋須就因此類資訊的任何不準確、遺" +
        //   "漏或不完整而產生的任何損失負責或承擔責任，無論該資訊是由本公司還是第三方提供。",
        // "3.10 波動的市場狀况：明白由於市場狀况、任何市場的實質限制及證券價格急速變動，即使本公司、執" +
        //   "行經紀和交易商（無論是在香港或其他地方）作出合理的努力，透過本公司作為代理人進行交易，" +
        //   "本公司可能無法完全執行客戶的指示，交易指示未必可以於任何特定時間、於客戶指定的時間、「最" +
        //   "佳價」或「市場價」執行。客戶同意在任何情況下均接納代客戶進行的交易，並受其約束，亦同意本" +
        //   "公司毋須就因未能或無法遵守客戶指示的任何條款而產生的任何損失負責。",

        // "附件 VI:中華通條款及細則",
        // "本附件 VI 適用於通過中華通進行的中華通證券交易。本附件為本協議的補充條款並應與以及可能不時修訂的" +
        //   "適用於公司提供的服務的任何其他條款和條件一同閱讀，並構成本協議不可分割的一部分。",
        // "1 定義和詮釋：",
        // "在本附件 VII 中，除非上下文另有要求，下列表述應具有以下涵義：",
        // "「中國創業板證券」指於中國深圳交易所創業板市場交易之任何證券；",
        // "「市場要求」指所有不時適用於滬港通（“滬港通”）或深港通（“深港通”）服務和透過使用該等服務" +
        //   "所進行的任何交易的一切相關法律、法規和規則及監管機構或政府機構、交易所、市場、結算所及" +
        //   "其他主管機構的要求及請求（包括但不限於聯交所、上交所、深交所、證監會、中國證券監督管理" +
        //   "委員會以及其各自的子公司及聯屬人、）；",
        // "「上交所」指上海證券交易所；及",
        // "「深交所」指深圳證券交易所。",
        // "2 滬港及深港通服務",
        // "2.1 藉繼續使用本公司提供的滬港或深港通服務，客戶向本公司確認其已詳閱、明白並同意此等特別條" +
        //   "款以及接受所有與使用該等服務及透過該等服務進行交易的相關風險如下：",
        // "(a) 客戶須遵守並獨自承擔責任以遵守所有市場要求。除非法律另有規定，本公司無須應市場要求" +
        //   "之改變而更新此等特別條款。",
        // "(b) 尤其是，客戶須充分了解並遵守所有不時在內地適用的市場要求，特別是有關短線交易利潤、" +
        //   "限制進行場外交易及轉移、持股限制及披露責露責任的市場要求，包括但不限於關於在上交所" +
        //   "或深交所上市的 A 股的規定（該規定被修改時，本公司恕不另行通知）：",
        // "(i) 有關持有或控制中國內地上市公司已發行股份達 5％的投資者須於三個工作天內作出權" +
        //   "益披露及於該三個工作天內不得買賣該公司股份的要求；且對其持有的股份的任何變動" +
        //   "作出披露的要求及遵守有關買賣限制;及",
        // "(ii) 適用於香港及/或海外投資者的單一境外投資者的 10％持股限制（中國內地上市公司已發" +
        //   "行股份的 10％）及所有境外投資者的 30％總持股權限制（中國內地上市公司已發行股份" +
        //   "的 30％）及相關強制出售的安排。",
        // "(c) 客戶承認除在市場要求容許的情況下，在交易日買入的上交所證券或深交所證券不能於同一天" +
        //   "賣出，而且如客戶擬於個別交易日出售上交所證券或深交所證券，則須於該交易日開市前確保" +
        //   "客戶在本公司設立的戶口內存有足夠的上交所證券或深交所證券。客戶不可對上交所證券或深" +
        //   "交所證券進行無備兌賣空活動。",
        // "(d) 客戶承認設有交易前檢查：如客戶擬於個別交易日出售股份，須於該交易日開市前將股份轉移" +
        //   "至公司的相應中央結算系統戶口。",
        // "(e) 客戶承認所有上交所證券及深交所證券交易必須在上交所及深交所進行，不設場外交易或非自動對盤交易。",
        // "(f) 除本公司另行許可外，客戶同意不會透過使用滬港或深港通服務進行孖展交易、股票借貸及/或" +
        //   "賣空活動，而客戶就任何上交所證券或深交所證券向本公司發出的任何買賣盤均被視為已向本" +
        //   "公司聲明及確認，該買賣盤不涉及孖展交易、股票借貸或賣空。當客戶透過使用滬港或深港通" +
        //   "服務進行孖展交易、股票借貸及/或賣空活動，客戶必須充分了解適用於該等活動的限制、要求" +
        //   "及條件。特別是，客戶承認該等活動的交易服務可能在市場要求所訂立的情況下被暫停、限制" +
        //   "或停止（例如交易的活動量超出於市場要求所規定的限額或發生或懷疑發生任何不正常的交易" +
        //   "活動），而且客戶只可對合資格的上交所證券或深交所證券進行孖展交易及賣空活動。客戶可" +
        //   "參考不時在聯交所之網頁（www.hkex.com.hk）公佈的合資格上交所證券或深交所證券名單。",

        // "(g) 客戶承認唯機構專業投資者方可進行中國創業板證券交易。客戶向本公司保證不會進行中國創" +
        //   "業板證券交易，除非其為機構專業投資者，或直至此進行中國創業板證券交易的限制解除為止。" +
        //   "如客戶為一中介人作為代理代表其相關客戶向本公司發出落盤指示，客戶向本公司承諾，其將" +
        //   "確保透過客戶進行中國創業板證券交易的該等相關客戶均是機構專業投資者，直至此進行中國" +
        //   "創業板證券交易的限制解除為止。如（i）客戶或，如客戶為一中介人，其相關客戶違反此進行" +
        //   "中國創業板證券的交易限制；或（ii）客戶違反任何於此之承諾，本公司可全權酌情取消客戶的" +
        //   "落盤或賣出客戶的中國創業板證券而無須另行通知客戶。本公司將毋須就本公司行使其於此所" +
        //   "賦予的權利及權力產生的任何損失負責，除非基於本公司或其任何主管人員、僱員或聯屬人的" +
        //   "嚴重疏忽、欺詐或蓄意失責所致，及只限於直接及合理預見直接及純粹由上述行為造成的損失" +
        //   "及賠償（如有）。儘管上文有所規定，在符合巿場要求下，如一非機構專業投資者客戶因任何權" +
        //   "利（包括認購配股或公開要約的權利）或權益分配、換股、收購、其他公司行動或特殊情況而" +
        //   "取得中國創業板證券，本公司可全權酌情決定是否接納該非機構專業投資者客戶的指示出售相" +
        //   "關中國創業板證券。",
        // "(h) 客戶承認聯交所、上交所或深交所及其各別的子公司及聯屬人有權在市場要求所訂立的情況下" +
        //   "拒絕提供與滬港或深港通服務有關之服務（如客戶、本公司及/或其代理人之中任何一方違反任" +
        //   "何市場要求或作出任何不正常交易行為），而且本公司可按其絕對酌情權或會應上交所或深交" +
        //   "所要求拒絕接受客戶的任何指示或停止提供所有或部分之滬港或深港通服務，而無須另行任何事前通知。",
        // "(i) 客戶同意（i）本公司為確保遵從或促使遵從市場要求及避免或減輕本公司可能因此而招致或蒙" +
        //   "受的損失;（ii）在客戶違反任何市場要求或本協議之條款的情況下或（iii）在發生任何超出本" +
        //   "公司或其代理人的合理控制能力的任何緊急或不可抗力的事故（如香港懸掛八號颱風訊號）時，" +
        //   "本公司可按其絕包括但不限於強制出售有關證券，限定、限制或拒絕交易，取消交易或由客戶" +
        //   "發出的其他指示及暫停、限制或停止提供所有或部分之滬港或深港通服務，而無須另行任何事前通知。",
        // "(j) 客戶同意，為執行客戶的指示或行使本公司在此等特別條款下或在客戶的任何帳戶下的權利為" +
        //   "目的之情況下，本公司可（在任何時候按其獨有及絕對酌情權及並無責任的情況下）將客戶任" +
        //   "何帳戶內或客戶所結存的任何幣別的任何金額兌換成任何其他貨幣。匯兌損失和兌換成本須由客戶承擔。",
        // "(k) 客戶承認監管機構、上交所、深交所、聯交所以及上交所、深交所及聯交所各自的子公司及聯" +
        //   "屬人有權在市場要求被違反或懷疑被違反時進行調查，並同意本公司可按該等機構之要求提供" +
        //   "資料及材料（包括但不限於與客戶、客戶帳戶及其他與最初負責發出交易的指示及從該宗交易" +
        //   "取得商業或經濟利益及/或承擔其商業或經濟風險的人士（不論是否為法律實體）有關的資料、" +
        //   "身份及個人資料，以及有關該等人士下單或交易的資料），及向客戶發出警告，以作配合調查、" +
        //   "監察及遵從市場要求之用。",
        // "(l) 客戶同意與客戶有關的或由客戶所提供之個人資料可按照本公司向客戶提供的收集個人資料" +
        //   "聲明及本協議其他適用條款使用及轉移至香港以外地區，而且客戶承諾及表述其已經就所述使" +
        //   "用和轉移個人資料事宜取得其所需要的一切有關人士的同意，以及遵守《個人資料（私隱）條例》。",
        // "(m) 客戶承認客戶或任何其他方面因為滬港或深港通服務或透過使用該等服務進行任何交易而直" +
        //   "接或間接蒙受或招致任何損失、損害或責任，聯交所、上交所、深交所及其各別的子公司、聯" +
        //   "屬人、董事、僱員及代理人概不負責。",
        // "(n) 客戶可以最少七個營業日前通知本公司終止使用滬港或深港通服務。本公司可隨時終止客戶使" +
        //   "用滬港或深港通服務，而無需提前通知客戶。",
        // "(o) 客戶同意以主事人的身份負責承擔涉及客戶使用滬港或深港通服務或者涉及透過使用該等服" +
        //   "務所進行的交易的一切有關義務和責任，無論在何種情況下，本公司及其代理人都不須對可能" +
        //   "委託客戶作為其代理人代其行事的任何人士承擔任何責任。客戶同意本公司可處置或促使本公" +
        //   "司的有聯繫實體處置任何不時代客戶收取或持有的證券或證券抵押品，以解除由客戶或代客戶" +
        //   "對本公司、其有聯繫實體或第三者所負的法律責任。",
        // "(p) 儘管以上所述，本公司可以按其絕對酌情權自行決定是否為確保或者促使遵守任何市場要求或" +
        //   "者為本公司認為適當的其他任何目的，而不時增加或修改與滬港或深港通服務有關的任何條款。" +
        //   "此外，客戶也同意，滬港或深港通服務是針對中國內地的某些特定的市場或交易所而提供的，" +
        //   "並受本公司不時附加及在有關的市場附件中載明的條款所約束。上述附加條款及修訂後的條款" +
        //   "均構成本協議不可分割的組成部分，並且應與本協議一起閱讀。倘客戶繼續使用滬港或深港通" +
        //   "服務，即被視為構成客戶已經接受該等附加條款及修訂後的條款。本公司可以將該等附加條款" +
        //   "及/或修訂後的條款在本公司的網站上發佈，也可以採用本公司認為適當的其他任何方式通知客戶。",
        // "(q) 客戶承認已獲邀仔細閱讀和考慮本公司不時提供給客戶的有關風險披露聲明書中的條款，該等" +
        //   "風險披露聲明書載明與使用滬港或深港通服務有關的風險，同時，本公司也已經邀請客戶就該" +
        //   "等風險披露聲明書提出問題並徵求獨立的意見（如適用）。",
        // "(r) 就客戶使用滬港或深港通服務，客戶同意補償和向本公司及其代理人支付客戶不時與本公司約" +
        //   "定或者本公司或其代理人按任何市場要求規定所招致的一切佣金及費用、收費、開支、徵費、" +
        //   "稅款、罰金和其他各種稅費。客戶同意本公司及其代理人無須就任何與客戶或代客戶進行的交" +
        //   "易或業務所獲取的或向任何人士提供的佣金、報酬、回佣或其他利益向客戶作出任何交代。",
        // "(s) 倘由於（i）任何政府或監管機構、交易所、市場、結算所或其他主管機構的限制、失誤、違約" +
        //   "或行為;（ii）交易所提供的任何服務被暫停、限制或停止;（iii）結算所中斷或未能結算和清算" +
        //   "任何交易;（iv）發生騷亂、騷動、戰爭、水災、颱風、地震、火災或爆炸;（v）第三者電子傳" +
        //   "輸系統或其他電子系統被中斷、延遲、失誤、暫停或錯誤;或（vi）超過本公司或其代理人的合" +
        //   "理控制能力的其他任何原因而直接或間接地導致本公司及其代理人未能履行其對滬港或深港" +
        //   "通服務分別應當承擔的義務，則本公司及其代理人不需要對該等未能履行的義務承擔任何責任。" +
        //   "本公司保留權利，在發生任何上述事件以後，按其絕對酌情權決定暫停、限制或者停止提供全" +
        //   "部或者部分之滬港或深港通服務，而毋須作出任何通知，並且如訂單經已配對及執行，客戶仍須承擔交收責任。",
        // "(t) 對於涉及滬港或深港通服務的無論何種間接的、因此而產生的、附帶的、特別的或懲罰性的損" +
        //   "害、損失、負債、費用或開支（包括但不限於任何利潤損失）而言，本公司不需要向客戶承擔任何責任。",
        // "(u) 在客戶開始及繼續使用滬港或深港通服務時，本附件 VI 即生效並構成本協議不可分割的一部" +
        //   "分。本附件 VI 條款為約束客戶及本公司之間的帳戶關係的條款及條件的附加條款，而且如兩" +
        //   "者有歧異，以本附件 VI 條款為準。",

        // "3 免責聲明",
        // "甲部：",
        // "有關滬港通服務的免責聲明",
        // "上海證券交易所盡力保證所提供資訊的準確和可靠度，但不能確保其絕對準確和可靠，亦不對因資訊不準確或" +
        //   "遺漏而導致的任何損失或損害承擔責任。",
        // "及",
        // "香港聯合交易所有限公司、其控股公司及／或該等控股公司的任何子公司均盡力保證所提供資訊的準確和可" +
        //   "靠度，但不能確保其絕對準確和可靠，亦不對因資訊不準確或遺漏而導致的任何損失或損害承擔責任。",
        // "乙部：",
        // "有關深港通服務的免責聲明",
        // "深圳證券交易所盡力保證所提供資訊的準確和可靠度，但不能確保其絕對準確和可靠，亦不對因資訊不準確或" +
        //   "遺漏而導致的任何損失或損害承擔責任。",
        // "及",
        // "香港聯合交易所有限公司、其控股公司及／或該等控股公司的任何子公司均盡力保證所提供資訊的準確和可" +
        //   "靠度，但不能確保其絕對準確和可靠，亦不對因資訊不準確或遺漏而導致的任何損失或損害承擔責任。",
        // "附件 VII：上市前交易",
        // "本附件 VII 適用於本公司就上市前交易提供的服務。本附件為本協議的補充條款並應與以及可能不時修訂的" +
        //   "適用於公司提供的服務的任何其他條款和條件一同閱讀。它是協議的組成部分。",
        // "1 定義和詮釋：",
        // "在本附件 VII 中，除非上下文另有要求，下列表述應具有以下涵義：",
        // "「獲分配證券」指有關申請首次公開招股而被接納的證券；",
        // "「香港結算規則」指香港結算不時生效之一般規則、運作程序及其他適用的規則、程序及規例；",
        // "「首次公開招股」指聯交所新上市及/或發行的證券之公開發售；",
        // "「獲配對指令」具有本附件 VII 中第 3.4 條（獲配對指令）所定義的意思；",
        // "「平台營運者」指本公司可不時通知客戶的平台營運者；",
        // "「上市前平台」指由平台營運者營運而透過本公司提供上市前交易服務的電子交易平台；",
        // "「上市前交易」指任何獲分配證券的交易或購買、投資、出售、收購、清算、結算或以其他方式處置" +
        //   "任何獲分配證券的協議，及獲分配證券在聯交所正式上市前的一般交易；",
        // "「上市前交易時段」指交易日當天可於上市前平台進行上市前交易的交易時段，亦即下午 4:15 開始" +
        //   "至下午 6:30 的時段或其他由平台營運者不時指定的交易時段；及",
        // "「交易日」指，就任何獲分配證券而言，在聯交所正式上市前一工作日或由平台營運者可不時指定的其他交易日。",
        // "2 適用規則及規例",
        // "2.1 適用規則及規例：本公司代表客戶作出或簽訂的所有上市前交易指示及任何上市前交易指示均應遵" +
        //   "守，且客戶應受下列指示約束：",
        // "(a) 本協議；",
        // "(b) 不時有效的平台營運者條例、規章、程式和政策；",
        // "(c) 聯交所的組織章程大綱及章程細則、聯交所規則、香港結算規則及聯交所的常規、慣例、裁定及程序；及",
        // "(d) 其他適用法規（包括證券及期貨條例）。",
        // "2.2 衝突：如果本協議的任何規定與本附件 VII 第 2.1 條（適用規則及規例）第（b）、（c）和（d）段中" +
        //   "包含的任何內容發生任何衝突或不一致，本公司可自行決定採取或拒絕採取任何行動，或要求客戶" +
        //   "採取或不採取任何行動以確保遵守後者。",
        // "3 上市前交易",
        // "3.1 一般：客戶承認並同意，就上市前交易：",
        // "(a) 本公司作爲客戶的代理人行事；",
        // "(b) 本公司自身並不經營上市前交易的灰色市場，而是通過上市前平台處理指令；",
        // "(c) 客戶只可在交易日的上市前交易時段內發出指示；",

        // "(d) 客戶的指示可由本公司及／或平台營運者全權酌情決定部分執行或完全不執行。",
        // "3.2 平台營運者的酌情權：即使存在任何相反規定，平台營運者可隨時自行決定在不通知或提及客戶的" +
        //   "情況下，在不限制且不向客戶承擔任何責任的情況下進行以下任何操作，該等行爲應對客戶具有約束力：",
        // "(a) 調整上市前交易時段的交易時間；",
        // "(b) 限制或停止任何交易日的上市前交易；",
        // "(c) 以任何方式限制、更改、暫停或終止上市前平台；",
        // "(d) 就與上市前交易有關的任何指示設定任何限制；及/或",
        // "(e) 拒絕處理或接受與上市前交易有關的指示。",
        // "3.3 本公司的酌情權：本公司可隨時自行決定在不通知或提及客戶的情況下，在不限制且不向客戶承擔" +
        //   "任何責任的情況下就與上市前交易有關的任何指示設定任何限制；及/或拒絕處理或接受與上市前交易有關的指示。",
        // "3.4 獲配對指令：受限於本附件 VII 第 3.6 條（取消/推遲上市）的規定，公司和平台營運者接受並經上" +
        //   "市前平台匹配的所有上市前交易指令（“匹配指令”）將由平台營運者完成。",
        // "3.5 未獲配對的指令：在上市前交易完結時，所有未獲配對或只有部份未獲配對的上市前交易指示及指令將被取消。",
        // "3.6 取消/推遲上市：如果相關獲分配證券未能上市，所有與該等獲分配證券（包括獲配對指令）相關的" +
        //   "所有上市前交易指示將自動取消，該等指示不會被處理。如果該等獲分配證券的正式上市被推遲，" +
        //   "獲配對指令將持續有效，但將由平台營運者在推遲後的上市日或其認爲適當的其他時點實施。",
        // "3.7 無陳述或保證：公司未就客戶的上市前交易指示或上市前平台作出任何性質的任何陳述或保證。",
        // "4 結算",
        // "4.1 交付及支付：當客戶賣出獲分配證券時，客戶應向本公司交付該等獲分配證券，且該等證券已足額" +
        //   "繳付及無產權負擔，且客戶對該等證券擁有良好及有效的所有權。客戶購買獲分配證券的，應當向" +
        //   "客戶支付。每項該等交付和付款應以公司或平台營運者不時指示的方式進行。",
        // "4.2 未能交付或支付：在不影響公司在本協議項下的任何權利的前提下，如果客戶未能按照本附件 VII 第",
        // "4.1 條（交付和付款）規定的方式進行交付或付款，則公司有權在不進一步通知或要求的情況下：",
        // "(a) 以本公司絕對酌情權決定的價格借入及/或購買交付所需的獲分配證券，向客戶的任何帳戶收" +
        //   "取相關費用，交付獲分配證券以履行客戶的義務，並將收到的交付款項存入任何帳戶；及/或",
        // "(b) 作為第（a）段的補充或替代，行使本協議條款第 29 條（合併、併入和抵銷）所載的合併及抵" +
        //   "銷權，以結算上市前交易。",
        // "4.3 短欠：客戶應按全面彌償基準賠償公司根據本附件 VII 購買和出售獲分配證券所發生的損失和任何" +
        //   "費用或支出（包括法律費用）所導致的任何短欠。",
        // "4.4 交易對手風險：客戶知曉並接受，所有上市前交易均為場外交易，如果交易對手方不能履行結算義" +
        //   "務，將面臨交易對手風險。",
        // "4.5 結算風險：公司未就任何匹配訂單的結算作出任何陳述、保證或擔保。公司或平台營運者可能認為" +
        //   "不宜採取任何行動以避免匹配訂單的任何結算失敗的情況，在該等情況下：",
        // "(a) 如客戶是獲分配證券的買家，客戶只有權取回已支付的結算資金",
        // "(b) 如客戶是獲分配證券的賣家，客戶只有權取回為該等出售而交付的獲分配證券；及在每種情況" +
        //   "下，客戶都將負責所有因交易對手不能履行結算責任而產生的損失及開支。",
        // "5 責任限制",
        // "5.1 責任免除：客戶同意，公司、平台營運者及其各自的任何董事、員工或代理均不對客戶由於任何下" +
        //   "列各項或與任何下列各項相關而可能發生的任何權利主張、訟案、訴訟、程序、損失、損害、義務、" +
        //   "責任、費用、收費和支出承擔責任，由於此類人員的重大過失、欺詐或故意違約的情況除外：",
        // "(a) 上市前平台的任何干擾、攔截、中止、延遲、損失、不可用、毀壞、故障、中斷或其他故障，",
        // "包括但不限於任何通訊網路或電腦故障、任何第三方資訊或服務提供者的作為或不作為、內務" +
        //   "管理、電腦病毒、任何主體（包括駭客）未經授權的訪問、升級或預防或補救維護活動、機械" +
        //   "故障、停電、故障或設備、安裝或設施不足，或任何法律、法規、規章、準則、指令、監管指" +
        //   "引或政府命令（無論是否具有法律效力）;",
        // "(b) 客戶通過任何通訊網路提供商的任何系統、設備或工具或在任何通訊網路提供商的任何系統、" +
        //   "設備或工具中傳輸、張貼和/或存儲關於客戶、上市前平台和/或上市前交易的任何資訊和/或資料；",
        // "(c) 未能結算獲配對指令；",
        // "(d) 公司或平台營運者不接受、進行、不執行、也不行使客戶的上市前交易指令;",
        // "(e) 公司或平台營運者根據本附件 VII 採取的任何行動，包括任何使用、收入、利潤、儲蓄或機會" +
        //   "的損失或任何其他附帶的、後果性的、特殊的或間接的損失或損害。",

        // "附件 VIII：電子直接付款授權服務",
        // "本附件 VIII 適用於公司向客戶提供的將使客戶能夠進行轉讓（定義見下文）的電子直接付款授權服務（電子" +
        //   "直接付款授權）。本附件 VIII 補充並應與一般條款和適用於公司提供的服務的任何其他條款和條件及其可能不" +
        //   "時的修訂一起閱讀。它是客戶協議的其中一個組成部分。",
        // "1 定義和詮釋：在本附件 VIII 中，除非上下文另有規定，下列表述應具有以下含義：",
        // "「銀行」指根據《銀行條例》（香港法例第 155 章）獲授權在其處開立及保有指定帳戶的銀行、受限" +
        //   "牌照銀行或接受存款公司；",
        // "「指定帳戶」指客戶以其名義在銀行開立的帳戶，根據客戶指示從該帳戶進行轉帳；",
        // "「電子直接付款授權」指客戶發起的電子直接付款授權，使用結算公司快速支付系統授權公司根據" +
        //   "客戶指示以指示銀行從相應的指定帳戶向帳戶轉帳，詳見本附件 VIII 第 2.1 條（申請）;",
        // "「電子直接付款授權服務」指結算公司提供的服務，作為結算公司快速支付系統的一部分，以促進" +
        //   "參與者的客戶建立並使用電子直接付款授權;",
        // "「結算公司」指香港銀行同業結算有限公司及其繼承人及受讓人；",
        // "「結算公司快速支付系統」或「快速支付系統」指結算公司為（a）處理直接借記和貸記、轉帳及其" +
        //   "他支付交易；及（b）交換並處理與電子直接付款授權服務相關的指令而不時提供、管理並運行的更" +
        //   "快支付系統及相關設施和服務；",
        // "「指示」指客戶向銀行發出或獲其授權，指示銀行辦理轉帳之指示；",
        // "「參與者」，是指結算公司快速支付系統的參與者，可以是銀行或其他金融機構、零售支付系統運營" +
        //   "者、儲值支付工具持牌人，也可以是結算公司不時接受的其他結算公司快速支付系統的參與者；及",
        // "「轉帳」指根據電子直接付款授權項下的一項或多項指示不時從指定帳戶向帳戶進行的資金轉帳。",
        // "2 電子直接付款授權",
        // "2.1 申請：客戶可通過公司向銀行（由公司選定）申請電子直接付款授權服務。公司將協助向該行轉交" +
        //   "電子直接付款授權設置申請指示、資料和資訊。申請經銀行核准後，客戶可以直接向公司發出指示" +
        //   "以進行轉帳。客戶可能有一個或多個指定帳戶來進行轉帳。如果貴行拒絕電子直接付款授權設置申" +
        //   "請，公司將通知客戶結果，也不承擔任何責任。",
        // "2.2 信息：客戶應以公司不時規定的形式和方式提供該等資訊並完成該等程序，以便公司協助客戶向銀" +
        //   "行申請電子直接付款授權設置。每個用作設置電子直接付款授權的指定帳戶的持有人必須與帳戶持" +
        //   "有人相同。聯名銀行帳戶將不被接受。",
        // "2.3 取消：如果客戶已設立電子直接付款授權，但在一段時間內未根據該授權進行任何轉帳（由公司決" +
        //   "定），則公司有權在任何時間取消電子直接付款授權，而無需事先通知客戶，即使該授權尚未到期或" +
        //   "不受限於到期日或終止日。相關銀行亦可隨時自行決定取消電子直接付款授權。如客戶對銀行就電" +
        //   "子直接付款授權、任何指示或任何轉帳所採取的任何行動有任何查詢或爭議，客戶必須直接與相關" +
        //   "銀行解決該等查詢或爭議。",
        // "2.4 默認設置：在設置電子直接付款授權時，任何指示的默認設置如下：「轉帳週期」將設置為「每筆付" +
        //   "款」，「轉帳限額」將設置為「無上限」，「到期日」將設置為「無期限」。如果客戶不接受這些預設設" +
        //   "置，客戶不應通過公司繼續進行電子直接付款授權設置申請。",
        // "2.5 修改默認設置：客戶可不時直接指示銀行修改本附件 VIII 第 2.4 條（默認設置）所載的指示的預設，" +
        //   "但須符合銀行不時訂明的程序和要求。",
        // "2.6 有效期：指示將持續有效，直至（a）被客戶修改或取消；或（b）在指示中指明的日期到期（如有），" +
        //   "以先發生者為准。客戶可根據銀行不時規定的程序和要求取消指示。",
        // "3 指令不可撤銷",
        // "就任何轉帳而言，一旦客戶確認及提交指示，該指示及隨之而來的轉帳不可撤銷，並對客戶具約束力。",
        // "4 確認",
        // "4.1 時間期間：客戶同意，每筆指示所載之轉帳款項將於有關銀行不時指定之時間期間內存入帳戶。",
        // "4.2 指示的更改：如客戶欲更改任何指示，客戶須立即通知本行作出該等更改。",
        // "4.3 費用：客戶對電子直接付款授權服務的使用受限於公司或相關銀行可能不時向客戶收取的任何費用和收費（如有）。",
        // "4.4 其他條款和條件：客戶理解，電子直接付款授權服務也可能受限於相關銀行和/或參與者的條款和條" +
        //   "件，客戶在使用電子直接付款授權服務之前應閱讀並同意該等條款和條件。公司不承擔因該等銀行" +
        //   "和/或參與者的條款和條件而產生的任何責任。",
        // "4.5 無陳述：公司將盡合理努力確保電子直接付款授權服務可以提供，但對於電子直接付款授權服務的" +
        //   "任何種類的運行、功能和可靠性，本公司不作出任何陳述、認可或保證。此外，公司不保證相關銀" +
        //   "行和/或參與者將能夠實現電子直接付款授權項下的指示或轉帳，因為這取決於該等銀行和/或參與者" +
        //   "的系統、運行以及公司無法控制的其他條件或情況的功能和可靠性。",
        // "4.6 免責：對於客戶或任何其他主體可能發生或蒙受（無論是直接地還是間接地）的與電子直接付款授" +
        //   "權服務的任何使用或公司對任何指示或轉帳的執行相關的任何種類的損失、損害、費用或支出，本公司不承擔責任。",
        // "4.7 終止：本公司保留在無理由的情況下取消、終止或中止全部或部分電子直接付款授權服務的權利。" +
        //   "客戶同意，對於客戶或任何其他人士因本公司行使上述權利而可能招致或蒙受的任何種類的任何損" +
        //   "失、損害、費用或開支，本公司概不負責。",
        // "4.8 有效性：客戶應確保帳戶、每個指定帳戶和每個電子直接付款授權在其使用電子直接付款授權服務" +
        //   "的整個期間保持有效。",
        // "5 客戶資訊的收集和使用",
        // "5.1 資訊提供：為使用電子直接付款授權服務之目的，客戶可能被要求向本公司提供其被授權人的個人" +
        //   "資料及其他資訊（「客戶資訊」）。",
        // "5.2 客戶資訊的使用：客戶同意，本公司可為電子直接付款授權服務之目的收集、使用、處理、保留或" +
        //   "轉移任何客戶資訊。此等用途包括但不限於下列一項或多項：",
        // "(a) 為客戶提供電子直接付款授權服務，維護和運行電子直接付款授權服務；",
        // "(b) 處理並執行與電子直接付款授權服務相關的不時的指示和請求；",
        // "(c) 為經營電子直接付款授權服務之目的，向任何銀行、結算公司及其他參與者披露或轉帳客戶資料以供使用；",
        // "(d) 符合任何適用法規項下的披露要求；及",
        // "(e) 上述各項附帶的或與之相關的目的。",
        // "5.3 進一步傳播：客戶理解並同意，結算公司、本公司、任何銀行或任何其他參與者均可為提供和運營" +
        //   "電子直接付款授權服務之目的，向其客戶及使用結算公司快速支付系統的任何其他第三方進一步披" +
        //   "露或轉移客戶資訊。",

        // "5.4 同意：若客戶資料包括除客戶以外的任何人士（例如任何被授權人士）的個人資料或其他資料，客" +
        //   "戶確認其將就結算公司、本公司、有關銀行及本第 4 條款列明的其他參與者使用（包括披露及轉移）" +
        //   "其個人資料及其他資料的事宜，而取得該等人士的同意。",
        // "6 責任限制",
        // "6.1 一般限制：本公司對客戶或任何其他主體可能發生或遭受的由使用電子直接付款授權服務或處理或" +
        //   "執行客戶發出的電子直接付款授權服務相關的指示或請求引起或與之相關的任何種類的任何損失、" +
        //   "損害或支出不承擔責任，但發生或遭受的任何損失、損害或支出是直接且可合理預見的，並且僅由" +
        //   "本公司的重大過失或故意違約或其管理人員、員工或代理的重大過失或故意違約直接引起的除外。" +
        //   "在任何情況下，對於任何利潤損失或任何特殊、間接、偶然、後果性或懲罰性損失或損害（無論該" +
        //   "等損失或損害是否可預見或可能發生），本公司、高盈证券成員或許可方及其各自的管理人員、員工" +
        //   "和代理人均不對客戶或任何其他主體承擔責任。",
        // "6.2 具體限制：就電子直接付款授權服務或電子直接付款授權服務而言，本公司不對客戶或任何其他主" +
        //   "體可能發生或遭受的由任何下列事項引起或與任何下列事項相關的任何種類的損失、損害或費用承擔責任：",
        // "(a) 結算公司快速支付系統、任何銀行和/或參加人或因公司合理控制之外的任何情況造成的任何" +
        //   "延遲、無法使用、中斷、故障、錯誤；及",
        // "(b) 客戶由於任何指示不明確或不完整和/或由於電子直接付款授權服務的任何錯誤或故障而無法行事。",

        // "附件 IX：期貨交易",
        // "本附件 IX 適用於期貨合約和期權合約的交易。本附件補充並應與一般條款和適用於公司提供的服務的任何其" +
        //   "他條款和條件及其可能不時的修訂一起閱讀。它是客戶協議的其中一個組成部分。",
        // "1 定義和詮釋：",
        // "在本附件 IX 中，除非上下文另有要求，下列詞語應具有以下含義：",
        // "「核淮債務證券」指由香港特別行政區政府為外匯基金而發行之外匯基金票據、美利堅合眾國政府" +
        //   "發行之國庫券（美國財政部可通知贖回之債券本金（TCAL）及獨立交易之證券註冊利息及本金" +
        //   "（STRIPS）除外），以及由香港期交所不時批准作為保證金的其他債務證券或票據；",
        // "「核准證券」指盈富基金單位及由香港期交所不時批准作為保證金之該等其他證券；",
        // "「董事會」指香港期交所不時之董事會，或（按文義所指）於正式召開並已有足夠法定人數的董事" +
        //   "會會議上出席及投票的大多數董事，或董事會任何正式委任的委員會；",
        // "「工作日」是指香港期貨交易所或外國期貨交易所（視具體情況而定）開市交易的任何日期，但星" +
        //   "期六、星期日、公共假期以及香港期貨交易所或外國期貨交易所（視具體情況而定）宣佈為非工作" +
        //   "日的任何其他日期除外；",
        // "「結算所」指香港期貨結算有限公司；",
        // "「結算所規則」指結算所的規則和適用程序，以及不時有效的對其作出的任何修訂、補充、變更或修改；",
        // "「合約」是指一份期貨合約和/或期權合約，根據上下文的要求，「合約」應作相應的解釋；",
        // "「外國結算所」指結算或交收所、公司、組織或機構（由外國期貨交易所指定、授權或聘請或成立" +
        //   "或經營,為該外國期貨交易所提供結算和交收服務）,包括其代理人、代名人、代表、職員和僱員；",
        // "「外國結算系統」指由有關外國結算所不時經營的結算和交收系統；",
        // "「外國期貨交易所」指香港以外國家或地區之法例容許，在該等國家或地區經營之任何期貨市場；",
        // "「外國規則」具有本附件第 3.3 條款（外國法規）中規定的涵義；",
        // "「外國交易」是指與將在外國期貨交易所執行的合約相關的任何交易；",
        // "「期貨合約」指相關交易所規則所定義的期貨合約和/或在任何交易所執行的合約，其效力為：",
        // "(a) 一方同意在約定的未來時間以約定的價格向另一方交付約定的商品或數量的商品；或",
        // "(b) 當事人約定在將來某一時間根據約定商品的價值是高是低或高於或低於訂立合約時約定的水" +
        //   "平進行調整，差額部分由訂立合約的交易所的規則確定；",
        // "「指示」具體而言是指與合約有關的指示；",
        // "「追收保證金通知」具有本附件第 8.1 條款（追收保證金通知）中規定的涵義；",
        // "「市場」指香港期貨交易所根據規則第 201 條款不時設立及營運的其中一個市場；",
        // "「期權合約」指有關交易所規則所定義的期權合約及/或一方（「第一方」）與另一方（「第二方」）在" +
        //   "交易所簽訂的合約，根據該合約：",
        // "(a) 第一方授予第二方在約定的將來某一日或之前或在約定的將來某一日（視情況而定）以約定價" +
        //   "格向第一方購買約定商品或某一商品數量的權利，但不是義務；如果第二方行使其購買權利，則： ",

        // "(i) 第一方有義務按照約定的價格交付商品；或",
        // "(ii) 第二方收到商品價值高於約定價格的款項（如有），該款項應根據合約訂立所在的相關交" +
        //   "易所的規則確定；或",
        // "(b) 第一方授予第二方在約定的未來某一日或之前或在約定的未來某一日（視情況而定）按約定價" +
        //   "格向第一方出售約定商品或商品數量的權利，但並無義務；如果第二方行使其出售權利，則：",
        // "(iii) 第一方有義務按照約定的價格收取商品；或",
        // "(iv) 第二方收到一筆可參照約定價格高於商品價值的金額（如有）的款項，該筆款項應根據訂" +
        //   "立合約的相關交易所的規則確定；",
        // "「法規」指董事會為監管市場活動不時訂明的任何名稱及包含於任何條文之內的規例，或按文義所" +
        //   "指，適用於某特定市場的規例；",
        // "「規則」指香港期貨交易所的規則、規例以及不時有效的對規例的任何修訂、補充、變更或修改；",
        // "「盈富基金單位」指根據（1）美國道富環球金融資產（香港）有限公司作為經理人、（2）美國道富" +
        //   "銀行及信託公司作為受託人及（3）外匯基金投資有限公司作為發起人於一九九九年十月二十三日訂" +
        //   "立之信託契據（可不時予以修改或補充）所設立名為「香港盈富基金」之單位信託計劃而發行之單位；及",
        // "「變價調整」就香港期貨交易所成交的合約而言，指由結算所及/或本公司代客戶按結算所規則第 408" +
        //   "至 411 條款的規定每日計算的應付及/或應收予結算所及/或本公司的款項。",
        // "2 開戶",
        // "2.1 帳戶開立：客戶指示並授權本公司為簽訂和/或交易合約之目的開立和維持一個期貨帳戶。",
        // "2.2 公司的酌情權：本公司同意，其將不時應客戶的要求，酌情允許客戶開立期貨帳戶，並將為客戶訂" +
        //   "立和/或交易合約之目的，維持該帳戶的名稱、號碼或其他。",
        // "2.3 現狀：倘若本公司是已登記的期交所參與者和香港期交所結算所的直接結算參與者，本公司將通知" +
        //   "客戶這一事實（及入圍期交所參與者名錄）。",
        // "2.4 主要負責人員：主要負責客戶在期交所合約訂立事務人員的全名（及其執照和註冊資料）應是帳戶" +
        //   "開立流程中指定的人士或是本公司可不時通知客戶指定的其他人士。",
        // "3 條款及條件之適用範圍",
        // "3.1 適用：本附件適用於本公司代客戶於香港期交所或任何外國期貨交易所簽立或將簽立之一切合約，" +
        //   "並視為收納於（不論是口頭或書面）本公司與客戶之間所訂立之每份合約內。客戶以書面或其他方" +
        //   "式（不論是明示、暗示或按慣例或於交易過程表明）建議或提述之任何其他條款及條件，或本公司" +
        //   "與客戶先前已據此訂立合約，均不包括於此適用範圍內。",
        // "3.2 受限於規則：於香港期交所訂立之所有合約及本公司與客戶之間之所有交易，均對雙方具約束力，" +
        //   "並須依據香港期交所之程序、香港期交所之組織章程大綱及細則之條文以及規則履行並受其規限。",
        // "3.3 外國規則：外國交易應當遵守有關市場、外國期貨交易所、外國結算系統、外國結算所等制定的規" +
        //   "章制度、規則、附例、憲法和程序（以下統稱外國規則）。對於不同市場和交易所的交易，客戶可能" +
        //   "有不同水平和類別的保護。在不影響上述規定的一般效力的前提下，所有外國交易應受限於下列其他規定：",

        // "(a) 每筆外國交易均收取交易費用，相關費用應當由客戶自行負擔。",
        // "(b) 每筆海外交易均受限於外國期貨交易所可能不時徵收的稅項；",
        // "(c) 客戶確認本公司受《外國規則》的約束,該規則允許相關外國期貨交易所採取措施限制未平倉," +
        //   "或代表該外國期貨交易所認為正在累積對任何特定市場有或可能不利於或可能對任何市場的" +
        //   "公平和有序運作產生不利影響的客戶平倉;",
        // "(d) 客戶確認，如果本公司作為外國結算所的交易所成員或參與者的權利被暫停或撤銷,有關外國" +
        //   "結算所可採取一切必要措施,將本公司代表客戶持有的任何未平倉合約及其在本公司帳戶內的" +
        //   "資金和證券，轉移給另一外國期貨交易所的一個會員或參與者;和",
        // "(e) 客戶承認並接受,如果本公司超過根據《外國規則》施加的任何交易限額或持倉限制,相關機構" +
        //   "有權要求本公司平倉或將該等數量的未平倉進行轉移至另外一名成員（可能包括客戶的全部或" +
        //   "部分未平倉），直至相關機構認為本公司遵守持倉限制。",
        // "4 先决和一般事項",
        // "4.1 發行文件：對於在香港期貨交易所交易的合約，本公司將在客戶要求下向客戶提供合約說明書及關" +
        //   "於該等產品之任何章程或其他發行文件。",
        // "4.2 授權：客戶應確保獲得適用於任何合約的任何政府或其他監管機構或部門的所有必要授權、批准和" +
        //   "同意，並確保該等授權、批准和同意的條款和所有適用法規。",
        // "4.3 實際履行：客戶經本公司簽訂的每份合約均是客戶已清楚理解其實際表現下所訂立。客戶應被視為" +
        //   "必履行該合約的義務。",
        // "4.4 酌情權：本公司可全權決定在不給予任何理由的情況下，拒絕代表客戶執行任何指示，或與客戶簽訂任何合約。",
        // "4.5 投資者賠償基金：就香港期交所之合約而言，客戶承認，如本公司作出失責行為，令客戶於香港期" +
        //   "交所之交易中蒙受金錢損失，投資者賠償基金之責任僅限於證券及期貨條例及有關附屬法例所規定" +
        //   "之有效索償，並受證券及期貨（投資者賠償－賠償限額）規則所訂明之金額上限所規限，故此不能" +
        //   "保證因該等失責行為而招致之任何金錢損失可從投資者賠償基金中獲得悉數或部份補償，或必定獲任何補償。",
        // "4.6 限制：就香港期交所之交易而言，客戶承認，本公司須受規則之約束，該等規則容許香港期交所採" +
        //   "取措施，在香港期交所認為客戶正累積對某一個或多個特定市場或可能造成損害或對某個或多個市" +
        //   "場之公平及有秩序運作造成不利影響（視情況而定）之持倉時，限制或要求本公司結清其代該等客" +
        //   "戶訂立之有關合約平倉。",
        // "4.7 利息：客戶無權因客戶在期貨帳戶中的任何貸方餘額而獲得本公司可能收到的任何利息。根據第 5.7" +
        //   "條款（利息），客戶須就期貨帳戶的所有借方結餘支付利息。",
        // "4.8 作為主事人交易：就香港期交所之交易而言，客戶承認，本公司在結算所持有之任何戶口，不論代" +
        //   "表客戶進行商品期貨交易而持有該戶口的全部或一部分，亦不論由客戶繳付或存放之款項或核准債" +
        //   "務證券或核准證券是否已繳付或存放於結算所，在本公司與結算所之間，本公司乃以主事人身份進" +
        //   "行買賣，故此該戶口並非表示以客戶為受益人之任何信託或其他衡平法權益，繳付或存放於結算所" +
        //   "之款項、核准債務證券及核准證券乃不受本條中所述信託之約束。",
        // "4.9 獲批准證券/獲批准的債務證券：就香港期交所交易之合約而言，本公司從客戶或任何其他人士（包" +
        //   "括結算所）收取之所有款項、核准債務證券或核准證券，乃根據操守準則附表 4 第 7 至 12 段所述方" +
        //   "式而持有。客戶授權本公司按照操守準則附表 4 第 14 至 15 段所指定方式運用任何該等款項、核准" +
        //   "債務證券或核准證券。尤其是本公司可運用該等款項、核准債務證券或核准證券以履行本公司因代" +
        //   "客戶進行商品期貨交易所引致或附帶其對任何方面人士之責任。",

        // "4.10 相反之倉盤：受限於證券及期貨條例的規定及任何適用法規，本公司可就任何合約採取與客戶指示" +
        //   "相反之倉盤，不論是為本公司自身還是為高盈证券成員或本公司的其他客戶，但該項買賣須透過香" +
        //   "港期交所設施，根據任何其他商品、期貨或期權交易所之規則或設施，依照該等其他交易所之規則" +
        //   "及規例，以具競爭力方式進行。",
        // "4.11 延遲：客戶確認，在若干情況下，本公司會因香港期交所或其他外國期貨交易所之實際環境限制及" +
        //   "商品價格急劇變動而延遲作價或延遲買賣，而本公司可能於付出合理努力後仍未能於任何指定時間" +
        //   "按所報價格進行買賣。客戶同意，本公司無須因未能遵照客戶指示之任何條款（包括由於客戶試圖" +
        //   "撤回或修改指示而重複執行指示）而引致之任何損失承擔責任。",
        // "4.12 部分履行：客戶確認，倘若本公司於付出合理努力後仍未能全面地執行任何指示，本公司有權只履" +
        //   "行部分指示，無須事先徵詢客戶給予確認。當客戶提出執行指令之要求後，客戶即須接受指示已予" +
        //   "履行、部分履行或不履行之任何後果，並受其約束。",
        // "4.13 截止：任何客戶指示如未能於有關交易所收市或有關交易所規定之其他屆滿日期或客戶與本公司同" +
        //   "意之其他較後時間之前獲得執行，則視作自動取消。",
        // "4.14 最優價：客戶確認，鑒於執行交易之香港期交所或其他外國期貨交易所之買賣慣例，或許不能永遠" +
        //   "按「最佳」或「市場」價格執行指令，客戶同意，在任何情況下均受本公司按照客戶指示所執行交易之約束。",
        // "4.15 信用調查：客戶特此授權本公司對客戶進行資信查詢（如為個人客戶，則為個人信用調查）及其他" +
        //   "調查，以確定客戶的財務狀況和投資目的。客戶應使本公司了解其財務狀況，並應立即向本公司報" +
        //   "告表明其（a）資不抵債，（b）可能資不抵債，或（c）有任何違規或瀆職行為的任何資訊。應按本公" +
        //   "司要求，客戶應當提供與前述事項相關的所有資料和文件，包括資產證明、收入來源證明等。",
        // "4.16 合併/分拆：客戶授權本公司，於任何時間及由本公司全權決定，為取得更佳之執行價及／或減少作" +
        //   "出指示之次數，將客戶有關代為買／賣合約之指示，與本公司自其他客戶接獲之類似指示合併及／" +
        //   "或分拆處理。客戶同意，假若可供買賣之合約數目不足以滿足合併處理之買賣指令，實際作出買／" +
        //   "賣之合約數目將按本公司接獲指令之次序歸於有關客戶。",
        // "4.17 優先權：在適用法律及規例及市場情況之規限下，本公司經考慮接獲指令之先後次序下，有全權決" +
        //   "定執行其客戶指令之次序，客戶不得對有關本公司執行任何收到客戶指示的優先次序，提出異議。",
        // "4.18 大額未平倉合約：當客戶經其在本公司的戶口持有/控制商品期貨合約，及倘若香港期交所董事會根" +
        //   "據規則第 628 條決定該戶口的未平倉總額為「大額未平倉合約」，本公司有責任向香港期交所申報。" +
        //   "然而，客戶在任何時候就進行與商品期貨合約有關的交易,而在本公司以外，在其他香港期交所參與" +
        //   "者開立一個或多個戶口，及該戶口的未平倉總額為「大額未平倉合約」，客戶應即時向香港期交所申" +
        //   "報該「大額未平倉合約」，並向香港期交所提供其所規定的與該「大額未平倉合約」有關的資料（包" +
        //   "括客戶及最終實益擁有人的名稱，或（如屬公司或團體）該公司或團體股本的最終實益擁有人個人" +
        //   "的名稱，包括透過代名人或信託形式持有利益的受益人），及向香港期交所提供其所要求的任何其他" +
        //   "資料。客戶確認及承認本公司根據規則在某些情況下有責任向香港期交所申報從客戶取得與其「大" +
        //   "額未平倉合約」相關的資料，及客戶特此同意本公司向香港期交所提供該等資料。",
        // "4.19 報告：客戶應履行所有適用及不時生效的所有通報、持倉申報及大額持倉申報要求（包括但不限於" +
        //   "香港法例第 571Y 章《證券及期貨（合約限量及須申報的持倉量）規則》下的要求），及不應超過根" +
        //   "據相關市場及交易所訂明關於合約限量及須申報的持倉量規則所載之有關期貨類別及種類的限額" +
        //   "（如有）。客戶有責任了解不時適用的該等要求。客戶承認本公司對客戶未能遵守該等要求概不負責" +
        //   "（適用法例或法規要求除外）。",
        // "4.20 交割：在不損害本協議下本公司權利的前提下,如本公司認為存在變動或預期變動,本公司可在未經客" +
        //   "戶同意的情況下將客戶戶口內所有或任何持倉平倉:（a）由於國家或國際貨幣、金融、經濟或政治條" +
        //   "件或外匯管制，已經導致或認為可能導致香港和/或海外股票市場、商品或期貨市場出現重大或不利" +
        //   "波動;或。（b）已經或可能在性質上影響本公司或客戶的狀況與操作。",

        // "5 許可權",
        // "5.1 披露：經香港期貨交易所或證監會或任何司法轄區的任何其他交易所、政府或監管部門（合稱「相" +
        //   "關監管機構」）要求，本公司應披露相關監管機構可能要求的客戶的姓名、實益身份及其他資訊。客" +
        //   "戶承諾在本公司指定的時間內向本公司披露為本公司遵守規則、外國規則、證監會和/或相關監管機" +
        //   "構的要求而可能要求的關於客戶自身的其他資訊。客戶不可撤銷地授權公司作出任何該等披露。就" +
        //   "於香港期交所之交易而言，假若本公司未能遵照香港期交所規則第 606（a）或 613（a）條之披露規" +
        //   "定，香港期交所行政總裁可要求代客戶平倉或就該客戶所持倉盤收取附加保證金。",
        // "5.2 酌情權行動：本公司可在任何時間採取下列一項或多項經本公司酌情權決定的行動，以確保本公司" +
        //   "遵守適用法規：（a）扣除或扣起帳戶內部份應繳付帳戶的金額；（b）立即終止帳戶及停止本公司與" +
        //   "客戶的全部或部份關係，而不作另行通知；（c）提供（不論司在帳戶終止之前及或之後）客戶的稅務" +
        //   "資料予任何其他司法管轄區的機構，以確保本公司遵守有關法律及條例",
        // "5.3 結算所：就於香港期交所交易的合約而言，客戶確認，假若本公司作為香港期交所之交易所參與者" +
        //   "之權利遭暫停或撤銷，結算所可作出一切所需行動，以便將本公司代客戶持有之任何未平倉盤及存" +
        //   "放於其在本公司持有之戶口之任何款項及證券移轉往香港期交所另一參與者。",
        // "5.4 代理人：客戶同意，除非本公司在有關交易的合同說明或建議中以其他方式通知客戶，否則本公司" +
        //   "僅在執行客戶指示時充當客戶的代理人。",
        // "6 一般留置權：在不影響條款第 15 條款（留置權）的情況下：",
        // "6.1 一般留置權：客戶授予本公司對所有或任何代客戶不時持有（不論是為了安全保管或其他目的而持" +
        //   "有）的款項（包括保證金）、核准證券，核准債務證券及其它資產（統稱為「資產」）擁有一般留置" +
        //   "權，以用作解除客戶就本公司代客戶進行買賣合約而所須承擔的責任。",
        // "6.2 固定收費：客戶特此同意，把客戶的所有資產以第一固定押記方式作為客戶支付或清償閣下虧欠本" +
        //   "公司的任何債項的持續抵押。",
        // "6.3 清算：客戶特此授權本公司可無須事先通知並按其絕對酌情權厘定的價格和方式出售任何資產，以" +
        //   "解除客戶對本公司的債項。本公司有權決定終止哪些合約或相關合約。在所有債項被全數支付或清" +
        //   "償後，本公司可應客戶之要求及在客戶支付有關費用的情況下，發還所有資產的權利、所有權及利益給客戶。",
        // "7 交付",
        // "客戶應根據本公司發出的任何指示，迅速交付其在任何合約項下可交付的任何款項、證券、金融票" +
        //   "據、文件或其他商品或財產，以應付保證金催繳及適用於香港期貨交易所交易的任何合約的變更調" +
        //   "整要求，或滿足適用於任何外國期貨交易所的保證金要求。",
        // "8 保證金及存入",
        // "8.1 追收保證金通知：客戶須應本公司不時酌情權決定之要求向本公司繳付或存入本附件第 7 條（交付）" +
        //   "擬議的金額和/或其他證券，作為保證金和/或為客戶在本公司的一個或多個帳戶進行的變更調整，以" +
        //   "便行使其與之相關的權利（「追收保證金通知」）。就在香港期貨交易所交易的合約而言，本公司可能" +
        //   "被要求向香港期貨交易所和證監會報告在本公司指定的期限內未滿足連續兩次保證金催繳及變更調" +
        //   "整要求的所有未平倉合約的詳情。本公司可以要求客戶繳交比香港期交所及／或結算所指定更多之" +
        //   "保證金及變價調整要求，以及可就本公司指定期間內未能履行追收保證金通知及變價調整要求或未" +
        //   "能在作出該等追收保證金通知或要求時繳付保證金之所有未平倉合約平倉。",
        // "8.2 聯繫客戶方式：本公司發出保證金通知後，將以最大的努力及時與客戶聯繫。客戶同意，在本公司" +
        //   "根據本合約條款第 30 條款（通訊及通知）向客戶發出該等追收保證金通知後，保證金催繳應被視為適當進行。",
        // "8.3 帳戶間的劃撥：在適用法例及規則之規限下，本公司可於無須事先知會客戶，不時將本公司代客戶" +
        //   "持有之所有或任何部分款項或其他抵押品，在客戶於本公司之不同戶口之間轉撥，或轉撥往設於香" +
        //   "港期交所結算或非結算會員之任何戶口內，由本公司全權決定認為必需或適合者，以符合客戶之任" +
        //   "何保證金要求。本公司於作出任何該等轉撥時將知會客戶。",

        // "8.4 質押：本公司將以質押方式持有作為客戶對本公司之任何保證金、存款或其他責任之抵押品之任何" +
        //   "檔或其他財產，除非明文表示其持有之抵押品乃受制於若干其他抵押安排，則作別論。",
        // "9 費用及收費",
        // "9.1 費用及收費：客戶須向本公司繳付不時厘定及知會客戶之香港期交所或任何外國期貨交易所就商品" +
        //   "期貨合約訂明之佣金及交易費用，以及本公司附加收費。請另行參閱載列於本公司網站向客戶收取" +
        //   "之佣金及費用之詳情。",
        // "9.2 投資者賠償基金的徵收：每份香港期交所合約均須繳付投資者賠償基金征費及根據證券及期貨條例" +
        //   "徵收之費用，該兩項征費均須由客戶承擔。",
        // "10 交易通知及報告",
        // "10.1 交易通知及報告：本公司將於交易執行後兩個工作日內，給予交易確認書及對賬單予客戶的方式，" +
        //   "向客戶報告執行商品期貨交易之情況，包括購入或出售的合約的數目、相關資產、到期月份、行使" +
        //   "價、期權形式（認沽或認購）、版號，以及該等合約屬平倉合約或開倉合約；及該等合約內載每手所" +
        //   "包括的資產單位及有關價格。",
        // "10.2 責任：客戶同意，本公司無須就因客戶延遲向本公司報告錯漏而引致之任何損害或市場波動承擔責任。",
        // "10.3 超額支付：假如戶口中出現多付款項或合約，客戶同意於獲悉時立即知會本公司，並同意不會轉移" +
        //   "有關款項或合約（或如已轉移，須立即退還）。",
        // "11 違約事件",
        // "11.1 違約：為本協定之目的，下列每一事件也應構成違約事件：",
        // "(a) 就任何合約而言，客戶違反或未能遵守或在其適當的時間和日期履行其任何規定（在不影響前" +
        //   "述規定的一般性原則下，包括本協議的任何規定），或客戶轉讓或聲稱轉讓任何合約的全部或部分利益；",
        // "(b) 客戶未能符合追收保證金通知（無論是初始、維持或附加）的要求,或未能或拒絕遵守公司根據" +
        //   "本協定提出的任何請求、通知或要求,或公司至少嘗試要求客戶進行追收保證金通知,且任何原" +
        //   "因無法直接與客戶溝通;",
        // "(c) 本公司以酌情權認定客戶存放作為保證金之任何款項或抵押品，就客戶所訂立或擬訂立之合約" +
        //   "價值而言並不足夠；或",
        // "(d) 客戶履行其在任何合約項下的任何義務屬於或成為不合法；及/或",
        // "(e) 在公司或任何高盈证券成員目前或將來承擔香港期貨交易所、外國期貨交易所、結算所或任何" +
        //   "適用法規規定的採取本附件第 11.2 條（補償）中提及的任何行動的任何義務的任何時間。",
        // "11.2 補償：在不影響本公司可能享有的任何其他權利或補償的前提下，若發生任何違約事件，則在不事" +
        //   "先向客戶發出要求的情況下：",
        // "(a) 本公司無義務（於採取補救方法之前）就任何合約向客戶支付作為擔保而持有的任何款項或交付任何資產；",
        // "(b) 本公司有權暫停履行其以任何方式產生的對客戶承擔的任何義務，無論是在任何合約項下還是" +
        //   "在其他項下，包括支付屆時到期或其後可能到期的任何一筆或多筆款項；",
        // "(c) 本公司有權認為就必需或適宜之方式結清所有或任何現有合約（儘管合約尚未到期結算），並" +
        //   "採取其認為必需之其他步驟以保障其利益，但在任何情況下，本公司均無責任行使任何該等權" +
        //   "利，或在對客戶有利之時間或以有利於客戶之方式行使該等權利；",
        // "(d) 本公司有權將帳戶內任何未平倉合約平倉，履行或維持有關未平倉合約；及就這目的交付或接" +
        //   "受交付合約之相關商品、沽出或平倉任何合約、訂立長倉或短倉之跨價期或馬鞍式組合，或作" +
        //   "出以上任何專案的組合",
        // "(e) 本公司可以行使因本公司代表客戶持有的任何現有合約而產生的任何選擇（即沽出或認購）；",
        // "(f) 本公司可採取該行為,並作出其唯一及絕對酌情權認為必要或可取的行為、事項或事項,以遵守" +
        //   "或履行、取消或履行本公司對客戶的任何義務,或客戶和/或本公司對香港期貨交易所、結算所" +
        //   "或任何外國期貨交易所的任何義務；",
        // "(g) 本公司可以將任何屬於客戶在本公司保管或控制下的資產（以直接或通過擔保或擔保方式）以" +
        //   "履行客戶對本公司承擔的任何義務；及/或",
        // "(h) 本公司可要求或強制執行可能為公司或任何高盈证券成員簽發、製造或創建的或有利於本公司的任何抵押品；",
        // "12 終止",
        // "12.1 終止：儘管有第 27.1（客戶提出的終止）條款的規定，客戶只能在期貨帳戶中沒有未完成的合約情況下終止本附件。",
        // "12.2 終止的後果：本附件的終止：",
        // "(a) 不得影響本公司於終止前依據本協議而訂立之任何交易；及",
        // "(b) 不得影響任何一方就未平倉合約或對本公司有尚未完成責任之合約之權利或責任，亦不得影響" +
        //   "本公司對其持有之一切存款、保證金及其他款項之權利，而本協議將繼續適用於以上各項。",
        // "13 轉讓",
        // "未經本公司事先書面同意，客戶不得轉讓、委託、分包、轉移或以其他方式處置本協議或任何合約" +
        //   "項下的任何權利。客戶在每一合約項下的權利應受限於因本協議適用於每一合約項下的每項交易以" +
        //   "及客戶與本公司簽訂的每一合約而產生的所有權利、責任和義務。",
        // "14 綜合帳戶",
        // "14.1 總帳戶：客戶是總合帳戶，且不是香港期貨交易所交易參與人的，對其在香港期貨交易所成交的合約，客戶應當：",
        // "(a) 於客戶與客戶就綜合戶口而接獲指示之一名人士（多名人士）進行買賣時，遵從及強制執行規" +
        //   "則及結算所規則訂明之保證金及變價調整規定及程式，猶如客戶乃香港期交所一名交易所參與" +
        //   "者，而為其戶口或利益而發出指示之該名（等）人士乃為客戶；",
        // "(b) 促使為履行有關指示而訂立交易所合約（定義見規則），從而在任何情況下，按指示進行的任" +
        //   "何買賣的形式，均不會構成香港或任何其他適用的司法管轄區的法例所指的非法買賣商品市場" +
        //   "的報價差額，或有關的買賣方式亦不會構成或涉及投注、打賭、博彩或就該等項目而進行的賭" +
        //   "博，從而違反香港法例或任何適用法律;及",
        // "(c) 確保客戶從其接獲指示之人士遵從規則訂明之保證金及變價調整規定，令致在香港期交所與本" +
        //   "公司之間，本公司應負責確保該等規定已獲綜合戶口中透過其傳達指示之所有人士遵從，猶如" +
        //   "各人均為該綜合戶口之客戶。",
        // "15 其他規定",
        // "15.1 不一致：倘若本協議內任何條款與香港期交所、結算所或對本協定目標事項具司法管轄權之任何當" +
        //   "局之任何現行或未來法例、規則或規例有抵觸，該項條文將視作已根據任何該等法例、規則或規例" +
        //   "而撤銷或修改。而本協議於所有其他方面將繼續維持十足效力及作用。",
        // "15.2 風險披露：客戶確認，（a）附件 X（風險披露聲明）中的風險披露聲明是以客戶選擇的語言（英文或" +
        //   "中文）提供的，（b）如客戶認為有必要，客戶可以閱讀風險披露，向專業顧問提出問題並接受獨立" +
        //   "諮詢意見，以及（c）客戶已經理解風險披露。客戶承認，這些風險披露聲明可能會不時發生變化。",

        // "附件 X：風險披露聲明",
        // "客戶務須細閱此等風險披露聲明。此等聲明為本協議及開戶表格的組成部份。客戶執行開戶表格，即表示確認" +
        //   "其已閱讀並細閱其選擇語言版本（英文或中文）的此等風險披露聲明，並獲邀閱讀該聲明、提出問題及在有此" +
        //   "意願的情況下徵求獨立的意見，以及確認其明白與帳戶有關的投資及交易可能產生的風險。",
        // "此等風險披露聲明沒有亦不旨在披露與帳戶有關的所有投資及交易的一切風險及相關考慮因素。客戶於全面" +
        //   "了解所涉及的風險，並從客戶本身的顧問取得客戶認為適當的獨立意見前，應避免作出任何投資或交易。本公" +
        //   "司並非客戶的財務顧問，亦不應被視作客戶的財務顧問。",
        // "1 證券交易的風險",
        // "投資附帶風險，過往業績並非未來表現的指標。證券價格有時可能會非常波動。證券價格可升可跌，甚至變成" +
        //   "毫無價值。買賣證券未必一定能夠賺取利潤，反而可能會招致損失。",
        // "2 期貨及期權交易的風險",
        // "2.1 買賣期貨合約或期權的虧蝕風險可以極大。在若干情況下，客戶所蒙受的虧蝕可能會超過最初存入的保證金數額。",
        // "2.2 即使客戶設定了備用指示，例如「止蝕」或「限價」等指示，亦未必能夠避免損失。市場情況可能使該等指示無法執行。",
        // "2.3 客戶可能會在短時間內被要求存入額外的保證金。假如未能在指定的時間內提供所需數額，客戶的" +
        //   "未平倉合約可能會被平倉。然而，客戶仍然要客戶的帳戶內任何因此而出現的短欠數額負責。",
        // "2.4 因此，客戶在買賣前應研究及理解期貨合約及期權，以及根據本身的財政狀況及投資目標，仔細考" +
        //   "慮這種買賣是否適合自己。",
        // "2.5 如果客戶買賣期權，便應熟悉行使期權及期權到期時的程序，以及客戶在行使期權及期權到期時的權利與責任。",
        // "2.6 期權涉及高風險，未必適合所有投資者。投資者應確保在參與期權市場之前了解這些風險。",
        // "2.7 有些期權在到期日方可行使（歐式期權的行使），其他期權可於到期前的任何時間行使（美式期權的" +
        //   "行使）。有些期權在行使時須以正股交收，而其他期權在行使時則須支付現金。",
        // "2.8 客户知悉期權乃損耗性資產，期權持有人可能會損失該期權的全部期權金。作為期權持有人，如欲" +
        //   "賺取利潤，必須行使期權或在市場將期權長倉平倉。在某些情況下，因市場流通量不足，買賣期權會出現困難。",
        // "2.9 作為期權沽出人，客户隨時可能要繳付額外的按金。期權沽出人與期權持有人不同，正股價的起跌" +
        //   "可令沽出人蒙受無限損失，而期權金乃沽出人的唯一回報。",
        // "2.10 此外，美式認購（認沽）期權的沽出人可能需要在到期前的任何時候交收正股或支付現金代價，該" +
        //   "價格為行使價乘以正股數目的積，上述責任可能與沽出期權所收到的期權金的價值完全不成比例，" +
        //   "而有關的通知期亦可能甚短。",
        // "3 買賣創業板股份的風險",
        // "3.1 創業板股份涉及很高的投資風險。尤其是該等公司可在無需具備盈利往績及無需預測未來盈利的情" +
        //   "況下在創業板上市。創業板股份可能非常波動及流通性很低。",
        // "3.2 客戶只應在審慎及仔細考慮後，才作出有關的投資決定。創業板市場的較高風險性質及其他特點，" +
        //   "意味著這個市場較適合專業及其他熟悉投資技巧的投資者。",

        // "3.3 現時有關創業板股份的資料只可以在香港聯合交易所有限公司所操作的互聯網網站上找到。創業板" +
        //   "上市公司一般毋須在憲報指定的報章刊登付費公告。",
        // "3.4 假如客戶對本風險披露聲明的內容或創業板市場的性質及在創業板買賣的股份所涉風險有不明白之" +
        //   "處，應尋求獨立的專業意見。",
        // "4 在香港以外地方收取或持有的客戶資產的風險",
        // "4.1 本公司在香港以外地方收取或持有的客戶資產，是受到有關海外司法管轄區的適用法律及規例所監" +
        //   "管的。這些法律及規例與《證券及期貨條例》（第 571 章）及根據該條例制訂的規則可能有所不同。",
        // "4.2 因此，有關客戶資產將可能不會享有賦予在香港收取或持有的客戶資產的相同保障。",
        // "5 在香港聯合交易所有限公司買賣納斯達克–美國證券交易所證券的風險",
        // "5.1 按照納斯達克–美國證券交易所試驗計劃（「試驗計劃」）掛牌買賣的證券是為熟悉投資技巧的投資者" +
        //   "而設的。客戶在買賣該項試驗計劃的證券之前，應先諮詢本公司的意見和熟悉該項試驗計劃。客戶" +
        //   "應知悉，按照該項試驗計劃掛牌買賣的證券並非以香港聯合交易所有限公司的主板或創業板作第一" +
        //   "或第二上市的證券類別加以監管。",
        // "6 使用網上交易協議下之電子服務的風險",
        // "6.1 如果客戶透過電子服務進行買賣，客戶便須承受該電子服務系統帶來的風險，包括有關系統硬體和" +
        //   "軟件可能會失靈的風險。系統失靈可能會導致客戶的買賣盤不能根據指示執行，甚或完全不獲執行。",
        // "6.2 由於未可預計的流量擠塞和其他原因，電子服務可能並不可靠的，及存在通過電子服務進行的交易" +
        //   "在傳輸和接收客戶的指示或其他資訊過程中可能會被耽誤、延遲執行客戶的指示或有關指示以有別" +
        //   "於客戶發出指示時的市價執行、指示在傳輸時被中斷或停頓等風險。",
        // "6.3 在通訊過程中也存在誤解或錯誤的風險，以及在發出了指示後，通常也不一定可以取消。由於此類" +
        //   "中斷、耽誤或被第三方入侵而使客戶遭受的任何損失，本公司概不承擔責任。如果客戶不準備接受" +
        //   "此類中斷或耽誤引致的風險，客戶不應透過電子服務來作出任何指示。",
        // "6.4 通過電子服務向客戶提供的市場數據和其他資訊可能是本公司從第三者獲得的。雖然本公司相信這" +
        //   "些數據和資訊是可靠的，但本公司或該等第三者都不會保證這些數據和資訊的準確性、完整性和即 時性。",
        // "7 保證金買賣的風險",
        // "7.1 藉存放抵押品而為交易取得融資的虧損風險可能極大。客戶所蒙受的虧蝕可能會超過客戶存放於本" +
        //   "公司作為抵押品的現金及任何其他資產。",
        // "7.2 市場情況可能使備用交易指示，例如「止蝕」或「限價」指示無法執行。",
        // "7.3 客戶可能會在短時間內被要求存入額外的保證金款額或繳付利息。假如客戶未能在指定的時間內支" +
        //   "付所需的保證金款額或利息，客戶的抵押品可能會在未經客戶的同意下被出售。",
        // "7.4 客戶應密切留意帳戶狀況，在市場波動下，本公司未必能聯絡客戶或提供足夠時間予客戶存錢，而" +
        //   "客戶的持倉將有可能被強制平倉。此外，客戶將要為客戶的帳戶內因此而出現的任何短欠數額及需繳付的利息負責。",
        // "7.5 因此，客戶應根據本身的財政狀況及投資目標，仔細考慮這種融資安排是否適合客戶。",
        // "8 提供將客戶的證券抵押品等再質押的授權書的風險",
        // "8.1 本公司提供授權書，容許其按照某份證券借貸協議書使用客戶的證券或證券抵押品、將客戶的證券" +
        //   "抵押品再質押以取得財務通融，或將客戶的證券抵押品存放為用以履行及清償其交收責任及債務的抵押品，存在一定風險。",

        // "8.2 假如客戶的證券或抵押品是由本公司收取或持有的，則上述安排僅限於客戶已就此給予書面同意的" +
        //   "情況下方行有效。此外，除非客戶是專業投資者，客戶的授權書必須指明有效期，該段有效期不得" +
        //   "超逾 12 個月。若客戶是專業投資者，則有關限制並不適用。",
        // "8.3 此外，假如本公司在有關授權的期限屆滿前最少 14 日向客戶發出有關授權將被視為已續期的提示，" +
        //   "而客戶對於在有關授權的期限屆滿前以此方式將該授權延續不表示反對，則客戶的授權將會在沒有"+
        // "客戶的書面同意下被視為已續期。",
        // "8.4 現時並無任何法例規定客戶必須簽署這些授權書。然而，本公司可能需要授權書，以便例如向客戶" +
        //   "提供保證金貸款或獲准將客戶的證券或證券抵押品借出予第三方或作為抵押品存放於第三方。本公" +
        //   "司應向客戶解釋將為何種目的而使用授權書。",
        // "8.5 倘若客戶簽署授權書，而客戶的證券或證券抵押品已借出予或存放予第三方，該等第三方將對客戶" +
        //   "的證券或證券抵押品具有留置權或作出押記。雖然本公司根據客戶的授權書而借出或存放屬於客戶" +
        //   "的證券或證券抵押品須對客戶負責，但若本公司的違責行為可能會導致客戶損失客戶的證券或證券抵押品。",
        // "8.6 本公司提供不涉及證券借貸的證券現金帳戶。假如客戶毋需使用保證金貸款，或不希望本身證券或" +
        //   "證券抵押品被借出或遭抵押，則切勿簽署上述的授權書，並應要求開立該等證券現金帳戶。",
        // "9 提供代存郵件或將郵件轉交第三方的授權書的風險",
        // "假如你向本公司提供授權書，允許本公司代存郵件或將郵件轉交予第三方，那麼你便須盡速親身收" +
        //   "取所有關於你帳戶的成交單據及結單，並加以詳細閱讀，以確保可及時偵察到任何差異或錯誤。",
        // "10 關於境外證券買賣，包括在中國内地上市股票的風險",
        // "10.1 客戶在進行任何境外證券交易前，應先了解將境外證券交易的性質和客戶就此須承擔的風險程度。",
        // "10.2 尤其是，儘管本公司是聯交所的交易所參與者，但境外證券買賣不受聯交所監管，也不受投資者賠償基金保護。",
        // "10.3 客戶應就本身的投資經驗、投資目標、財政資源及其他相關條件，小心衡量自己是否適合參與該等" +
        //   "買賣。假如客戶存有疑問，應尋求獨立的專業意見。",
        // "11 外幣交易的風險",
        // "11.1 以外幣計算產品的買賣所帶來的利潤或招致的虧損（不論交易是否在客戶本身所在的司法管轄區或" +
        //   "其他司法管轄區進行），均會在需要將產品的單位貨幣兌換成另一種貨幣時受到匯率波動的影響。",
        // "11.2 客戶明白若所買賣結構性產品的相關資產並非以港幣為單位，其尚要面對外匯風險。貨幣兌換率的" +
        //   "波動可對相關資產的價值造成負面影響，連帶影響結構性產品的價格。",
        // '12 交易所交易票據（"ETNs"）的風險',
        // "12.1 ETN 是一種由承銷銀行發行的無擔保、非次級債務證券，旨在為投資者提供各個市場基準的回報。" +
        //   "ETN 的回報通常與一個市場基準或策略的表現掛鈎，並扣除適用的費用。與其他債務證券類似，ETN" +
        //   "有到期日，且僅以發行人信用作為支持。",
        // "12.2 客戶可以透過交易所買賣 ETN 或於預定到期日收取現金付款，或視乎基準指數的表現有機會直接向" +
        //   "發行人提早贖回 ETN（須扣除適用的費用）。然而，客戶於贖回時可能受 ETN 的提早贖回條件限制，例如最少贖回數量。",

        // "12.3 本公司並不保證客戶於到期日或發行人提早回購時可收回投資本金或任何投資回報。對於 ETN，正" +
        //   "面表現的月份或無法抵銷其中某些極不利之月度表現。",
        // "12.4 ETN 發行人有權隨時按回購價值贖回 ETN。",
        // "12.5 若於任何時候 ETN 的回購價值為零，客戶的投資則變得毫無價值。ETN 可能流通性不足，不能保證" +
        //   "客戶可隨時按其意願，以目標價格買賣。",
        // "12.6 儘管 ETF 與 ETN 均有追蹤基準指數的特性，但 ETN 屬於債務證券，並不實際擁有其追蹤的任何資" +
        //   "產，擁有的僅是發行人向投資者分配理論上存在的基準指數所反映的回報之承諾。ETN 對投資組合" +
        //   "的多元化程度有限，投資者須受集中於特定指數及指數成份的集中性風險。鑒於 ETN 屬無抵押品的" +
        //   "債務工具，若 ETN 發行商發生違約或破產，最大潛在損失可能是投資額的百分之一百及無法獲得任何利潤。",
        // "12.7 即使受追蹤的相關指數沒有變化，發行人信用評級降级亦會導致 ETN 的價值下跌。因此，買賣 ETN" +
        //   "的客戶直接面臨發行人的信用風險，且在發行人宣佈破產的情況下僅擁有無擔保的破產索償權。",
        // "12.8 本金金額須扣除定期收納的投資者費用或任何適用的費用，該等費用會對回報產生不利影響。",
        // "12.9 個別 ETN 可能會採用槓桿，而 ETN 的價值會因應其對於相關資產的槓桿比率而迅速變化。客戶應" +
        //   "注意 ETN 的價值可能會跌至零，客戶可能損失所有的投資本金。",
        // "13 違約風險及交易對手風險",
        // "13.1 所有產品都具有違約風險及/或交易對手風險。違約風險是指發行商未能根據協定缴付。遇上經濟不" +
        //   "景，發行商未必能成功借貸繼續經營或償還舊債。信貸評级是評估结構性產品違約風險最常用的工" +
        //   "具。信貸評級代表信貸評級機構於某一持定時間内的意見，而信貸評級往往會因應發行商的財政狀" +
        //   "況或市場情況的改變而作出調整。",
        // "13.2 交易對手風險指交易方無力履行其財務合約責任，雖然信貸評級的評級有一定的可靠性，客戶除了" +
        //   "要參考發行商的信貸評級外，更要仔细留意產品的结構本身是否涉及衍生工具，以免招致損失。",
        // "14 集體投資計劃的風險",
        // "14.1 集體投資計劃可廣泛地（最多 100%）投資於金融衍生工具，定息證券及/或結構性產品（包括但不限" +
        //   "於信用違約掉期、次等投資級別債務、按揭抵押證券及其他資產抵押證券）、並涉及不同的風險（包" +
        //   "括但不限於交易對手風險、流通性風險、信用風險及市場風險）。",
        // "14.2 集體投資計劃可能使用衍生工具的交易策略可能招致損失的部份原因包括但不限於：市場狀況動盪、" +
        //   "衍生工具與取決其價格的證券走勢關連性不完美、市場缺乏流動性，以及交易對手方的違責風險。",
        // "15 衍生產品和結構性產品交易的一般風險",
        // "15.1 發行商失責風險：倘若結構性產品發行商破產而未能履行其對所發行證券的責任，客戶只被視為無" +
        //   "抵押債權人，對發行商任何資產均無優先索償權。因此，客戶須特別留意結構性產品發行商的財力及信用。",
        // "15.2 非抵押產品風險：非抵押結構性產品並沒有資產擔保。倘若發行商破產，客戶可以損失其全數投資。" +
        //   "客戶須細閱上市文件以確定產品是否屬非抵押性質，及該產品是否適合自己。",
        // "15.3 槓桿風險：衍生權證及牛熊證均是槓桿產品，其價值可按相對相關資產的槓桿比率而快速改變。客" +
        //   "戶須留意，衍生權證及牛熊證的價值可以跌至零，屆時當初投資的資金將會盡失。",
        // "15.4 有效期的考慮：結構性產品設有到期日，到期後的產品即一文不值。客戶須留意產品的到期時間，" +
        //   "確保所選產品尚餘的有效期能配合其交易策略。",

        // "15.5 特殊價格移動：結構性產品的價格或會因為外來因素（如市場供求）而有別於其理論價，因此實際" +
        //   "成交價可以高過亦可以低過理論價。",
        // "15.6 流通量風險：聯交所規定所有結構性產品發行商要為每一隻個別產品委任一名流通量提供者。流通" +
        //   "量提供者的職責在為產品提供兩邊開盤方便買賣。若有流通量提供者失責或停止履行職責，有關產" +
        //   "品的客戶或就不能進行買賣，直至有新的流通量提供者委任出來止。",
        // "16 買賣衍生權證的特定風險",
        // "16.1 時間損耗風險：假若其他情況不變，衍生權證愈接近到期日，價值會愈低，因此不能視為長線投資。",
        // "16.2 波幅風險：衍生權證的價格可隨相關資產價格的引申波幅而升跌，客戶須注意相關資產的波幅。",
        // "16.3 非長期有效：與股票不同，衍生權證有到期日，並非長期有效。衍生權證到期時如非價內權證，則不會有價值。",
        // "16.4 成交額：衍生權證成交額高不應被認作為其價值會上升。除了市場力量外，衍生權證的價值還受其" +
        //   "它因素影響，包括相關資產價格及波幅、剩餘到期時間、利率及預期股息。",
        // "17 買賣牛熊證的特定風險",
        // "17.1 強制收回風險：客戶買賣牛熊證，須留意牛熊證可以即日「取消」或強制收回的特色。若牛熊證的" +
        //   "相關資產值等同上市文件所述的強制收回價/水平，牛熊證即停止買賣。屆時，客戶只能收回已停止" +
        //   "買賣的牛熊證由產品發行商按上市文件所述計算出來的剩餘價值（注意：剩餘價值可以是零）。",
        // "17.2 融資成本：牛熊證的發行價已包括融資成本。融資成本會隨牛熊證接近到期日而逐漸減少。牛熊證" +
        //   "的年期愈長，總融資成本愈高。若一天牛熊證被收回，客戶即損失牛熊證整個有效期的融資成本。" +
        //   "融資成本的計算程式載於牛熊證的上市文件。",
        // "17.3 限定的有效期：牛熊證有一固定有效期，並於指定日期到期。有效期可以是 3 個月至 5 年不等。若" +
        //   "在到期前遭提早收回牛熊證的有效期將變得更短。期間牛熊證的價值會隨著相關資產價格的變動而" +
        //   "波動，於到期後或遭提早收回後更可能會變得沒有價值。",
        // "17.4 相關資產的走勢：牛熊證的價格變動雖然趨向緊貼相關資產的價格變動，但在某些情況下未必與相" +
        //   "關資產價格的變動同步（即對沖值不一定等於 1）。牛熊證的價格受多個因素所影響，包括其本身的" +
        //   "供求、財務費用及距離到期的時限。此外，個別牛熊證的對沖值亦不會經常接近 1，特別是當相關資" +
        //   "產的價格接近收回價時。",
        // "17.5 接近收回價時的交易：相關資產價格接近收回價時，牛熊證的價格可能會變得更加波動，買賣差價" +
        //   "可能會較闊，流通量亦可能較低。牛熊證隨時會被收回而交易終止。由於任何在強制收回事件後始" +
        //   "執行的交易將不被承認並會被取消，而強制收回事件發生的時間與牛熊證停止買賣之間可能有時差，" +
        //   "一些在強制收回事件發生後才達成的交易即使已被證券商確認最後亦會被取消，因此客戶買賣接近" +
        //   "收回價的牛熊證時需額外小心。",
        // "17.6 海外資產發行的牛熊證：若屬海外資產發行的牛熊證，強制收回事件可能會於香港交易所交易時段以外的時間發生。",
        // "18 交易所買賣基金的特定風險",
        // "18.1 市場風險：交易所買賣基金主要為追蹤某些指數、行業/領域又或資產組別（如股票、債券或商品）" +
        //   "的表現。交易所買賣基金經理可用不同策略達至目標，但通常也不能在跌市中酌情採取防守策略。" +
        //   "客戶必須要有因為相關指數/資產的波動而蒙受損失的準備。",
        // "18.2 追蹤誤差：這是指交易所買賣基金的表現與相關指數/資產的表現脫節，原因可以來自交易所買賣基" +
        //   "金的交易費及其他費用、相關指數/資產改變組合、交易所買賣基金經理的複製策略等等因素。（常見" +
        //   "的複製策略包括完全複製/選具代表性樣本以及綜合複製。）",

        // "18.3 以折讓或溢價交易：交易所買賣基金的價格可能會高於或低於其資產淨值，當中主要是供求因素的" +
        //   "問題，在市場大幅波動兼變化不定期間尤其多見，專門追蹤一些對直接投資設限的市場/行業的交易" +
        //   "所買賣基金亦可能會有此情況。",
        // "18.4 流通量風險：證券莊家是負責提供流通量、方便買賣交易所買賣基金的交易所參與者。儘管交易所" +
        //   "買賣基金多有一個或以上的證券莊家，但若有證券莊家失責或停止履行職責，客戶或就不能進行買賣。",
        // "18.5 由衍生工具構成的 ETF 風險：",
        // '(a) 交易所買賣基金（"ETF"）可投資於衍生工具。由衍生工具構成的 ETF 可投資於 CAAP、指數' +
        //   "期貨合約及其他金融衍生工具。",
        // "(b) 投資於金融衍生工具不等同直接投資於組成基礎指數之相關資產。",
        // "(c) 金融衍生工具乃一種合約。由衍生工具構成的 ETF 及其交易對手（即與由衍生工具構成的 ETF" +
        //   "達成協議之人士）根據衍生工具合約之條款同意在合約中列明之特定情況下或發生特定事件時" +
        //   "向對方支付若干款項。金融衍生工具之價值視乎或來自或參考相關資產之價值（例如證券或指數）而定。",
        // "(d) 若干金融衍生工具可能產生槓杆效應，令由衍生工具構成的 ETF 承受更大風險及增加其成本。" +
        //   "金融衍生工具或會較容易受到影響有關投資價值之因素所影響。因此，金融衍生工具價格變化" +
        //   "幅度甚大，並偶爾會出現急速之大幅價格變動。故此，金融衍生工具出現相對較為輕微之價格" +
        //   "變動，有可能即時導致由衍生工具構成的 ETF 蒙受重大損失（或收益）。與只投資傳統證券相" +
        //   "比，由衍生工具構成的 ETF 可能會因投資金融衍生工具而蒙受大於或可能相等於金融衍生工具全部價值的損失。",
        // "(e) 此外，不少金融衍生工具均不在證券交易所買賣，這意味著由衍生工具構成的 ETF 較難出售其" +
        //   "金融衍生工具投資以籌措現金及╱或已變現收益或損失或對該等金融衍生工具進行準確估值。" +
        //   "出售或購買不在證券交易所買賣之金融衍生工具均須私下協商，且一般並非由中央結算機構擔" +
        //   "保、每日盯市、結算及隔離帳戶審查機制、中介機構最低資本規定或政府機關監管，亦可能較" +
        //   "難找到自願之買方╱賣方，原因是並無監管規定要求市場作價者確保該等金融衍生工具有持續市場。",
        // "18.6 衍生工具之交易對手風險：如有關衍生工具風險一節所述，金融衍生工具乃一種合約。根據多份金" +
        //   "融衍生工具合約將予支付之款項並非通過中央結算機構支付，亦非獲中央結算機構作擔保。因此，" +
        //   "由衍生工具構成的 ETF 因投資金融衍生工具而須承受其交易對手不願或未能根據合約履行付款（及" +
        //   "其他）責任之風險。倘金融衍生工具之交易對手涉及任何無力償還債務事件，金融衍生工具之價值" +
        //   "或會大幅下跌，甚至不具任何價值，由衍生工具構成的 ETF 或遲遲無法收回款項，原因是投資於金" +
        //   "融衍生工具不等同直接投資於組成基礎指數之相關資產。",
        // "18.7 期貨買賣風險：期貨乃高度槓桿化，意指期貨合約價格的較小變動或會導致高於實繳保證金比例的" +
        //   "利潤或損失，及或會導致超過預繳任何保證金數額的不可估量的進一步損失。不少期貨合約買賣須" +
        //   "遵守每日價格波動限制，即禁止於特定日期按基於上一日收市價的規定價格範圍以外之價格進行期" +
        //   "貨交易。這或會產生流動性風險，原因是管理人於不斷變動的市場變現期貨持倉或會成本高昂或行不通。",
        // "18.8 「CAAP」指以美元為單位之中國 A 股連接產品，即為（a）基礎指數所掛鈎或不掛鈎之 A 股；或" +
        //   "（b）基礎指數，掛鈎之金融衍生工具（例如認股權證、票據或參與證明）。",
        // "19 槓桿及反向產品的主要風險",
        // "19.1 投資風險：買賣槓桿及反向產品涉及投資風險及並非為所有投資者而設。不保證可取回投資本金。",
        // "19.2 波動風險：槓桿及反向產品涉及使用槓桿和重新平衡活動，因而其價格可能會比傳統的交易所買賣基金（ETF）更波動。",

        // "19.3 不同於傳統的 ETF：槓桿及反向產品與傳統的 ETF 不同，具有不同的特性及風險。",
        // "19.4 長線持有的風險：槓桿及反向產品並非為持有超過重新平衡活動的間距，一般為一天而設。在每日" +
        //   "重新平衡及複合效應下，有關產品超過一天的表現會從幅度或方向上偏離相關指數同期的槓桿或相" +
        //   "反表現。在市況波動時有關偏離會更明顯。隨著一段時間受到每日重新平衡活動、相關指數波動，" +
        //   "以及複合效應對每日回報的影響，可能會出現相關指數上升或表現平穩，但槓桿產品卻錄得虧損。" +
        //   "同樣地亦有可能會出現相關指數下跌或表現平穩，但反向產品卻錄得虧損。",
        // "19.5 重新平衡活動的風險：槓桿及反向產品不保證每天都可以重新平衡其投資組合，以實現其投資目標。" +
        //   "市場中斷、規管限制或市場異常波動可能會對產品的重新平衡活動造成不利影響。",
        // "19.6 即日投資風險：槓桿及反向產品的槓桿倍數會隨交易日市場走勢而改變，但直至交易日完結都不會" +
        //   "重新平衡。因此槓桿及反向產品於交易日內的回報有可能會多於或少於相關指數的槓桿或相反回報。",
        // "19.7 重整組合的風險：相對傳統的 ETF，每日重新平衡活動會令槓桿及反向產品的投資交易次數較頻密，" +
        //   "因而增加經紀佣金和其他買賣開支。",
        // "19.8 關聯風險：費用、開支、交易成本及使用衍生工具的成本，可令有關產品的單日表現，與相關指數" +
        //   "的單日槓桿/反向表現的關聯度下降。",
        // "19.9 終止運作風險：如所有證券莊家均辭任，槓桿及反向產品必須終止運作。槓桿及反向產品必須在最" +
        //   "後一名證券莊家辭任生效時同時終止運作。",
        // "19.10 槓桿風險（僅適用於槓桿產品）：在槓桿效應下，當相關指數變動，或者當相關指數的計價貨幣不同" +
        //   "於有關槓桿產品的基準貨幣，而有關貨幣的匯價出現波動時，會令槓桿產品的盈利和虧損倍增。",
        // "19.11 有別於傳統的回報模式（僅適用於反向產品）：反向產品旨在提供與相關指數相反的單日回報。如果" +
        //   "有關指數長時間上升，或者當相關指數的計價貨幣不同於有關反向產品的基準貨幣，而該計價貨幣" +
        //   "的匯價長時間上升時，反向產品可能會損失大部分或所有價值。",
        // "19.12 反向產品與沽空（僅適用於反向產品）：投資反向產品並不等同於建立短倉。因為涉及重新平衡活動，" +
        //   "反向產品的表現可能會偏離短倉表現，特別是當市況波動和走勢經常搖擺不定的時候。",
        // "20 供股權證的風險",
        // "20.1 供股權證是公司向現有股東一次性發行股份，讓他們有機會通過在未來的某個日期以折扣價購買額" +
        //   "外的新股，來維持所有權的原有比例不被稀釋。",
        // "20.2 直至購買新股的日期為止，客戶可以按照與普通股交易的方式進行供股權證交易。如果客戶不打算" +
        //   "行使認購權，可以在公開市場上出售。",
        // "20.3 認購權一旦行使，便不能再次使用。如果客戶在這段時間內不行使認購權，認購權將會失效。",
        // "20.4 面對有折扣提供的股票很容易受到誘惑，但客戶不應假設這是買平貨，而是應先了解資金籌集的背" +
        //   "後原因，才作出明智的決定。",
        // "20.5 一家公司可能會使用供股來彌補債務，特別是當他們無法從其他來源借錢時。客戶應留意管理層有" +
        //   "否透露任何潛在的問題。",
        // "20.6 如果客戶決定不行使新股認購權，則由於所發行股份數量的增加，客戶所持有公司的總股權將被攤薄。",
        // "20.7 如果客戶在指定的時間範圍內不參與供股，客戶的未繳款供股權將會失效。公司將在扣除報價和費" +
        //   "用後，出售這些權利並分配任何淨收益。如果有的話，過期收益的金額將不會通知投資者，直到報" +
        //   "價關閉。因此不能保證客戶不會失去收益。",

        // "20.8 由供股權證所產生的投資和收益的價值可能會下降，客戶可能會收回比原本投資更少的資金。",
        // "21 買賣與股票掛釣的工具（「ELI」）的風險",
        // "21.1 如客戶指示本公司用該戶口買賣與股票掛釣的工具，客戶確認 ELI 並不保本，而如 ELI 的參考資產" +
        //   "的價格與客戶的看法不同，則客戶可蒙受損失。",
        // "21.2 在極端的情況下，客戶可損失全部投資。在若干情況下的損失風險甚大，除非客戶明白正在進行的" +
        //   "買賣的性質以及所須承擔的風險，否則不應買賣該等工具。客戶並須因應本身的環境及財政狀況，" +
        //   "審慎考慮究竟有關買賣是否適合。",
        // "21.3 客戶明白雖然大部分 ELI 一般較普通定期存款或債券的利息為高，但客戶的 ELI 的潛在收益可以發" +
        //   "行人指定的預先釐定的水平為上限。",
        // "21.4 在投資期間內，客戶於參考資產並無權利。該／該等參考資產的市價變動未必會導致 ELI 的市價及" +
        //   "／或潛在回報有相應的變動。",
        // "21.5 客戶完全明白投資 ELI 令客戶承受股權風險。客戶承受正股及股市價格波動，以及股息、企業行動" +
        //   "及對手方風險的影響。倘相關工具的價格跌至低於轉換價，客戶將接納法律責任，以預先議定的轉" +
        //   "換價購入相關工具，而非收取與 ELI 的本金。因此，倘 ELI 的價值低於客戶原本的投資，則客戶將" +
        //   "收到一項價值下跌的工具，而倘相關工具變得毫無價值，則更可能會失去全部本金或存款。ELI 並非" +
        //   "以任何資產或抵押品擔保。",
        // "21.6 客戶完全明白當購買 ELI 時，客戶倚賴發行商的信用可靠性。如發行商違約或資不抵債，則不論參" +
        //   "考資產的表現，客戶將須倚賴客戶的分銷商代表客戶採取行動，以發行商無抵押的債權人身份提出索償。",
        // "21.7 發行商可為其 ELI 提供有限度的莊家安排。但是，如客戶嘗試於發行商提供的莊家安排下在到期前" +
        //   "終止 ELI，則客戶可收取一筆大幅低於客戶原本的投資金額的款項。與股票掛釣的工具或會「不能轉" +
        //   "讓」，客戶或許無法將有關工具平倉或變現。ELI 的發行商亦可擔當不同角色，如 ELI 的安排行、市" +
        //   "場代理及計算代理。ELI 的發行商、其子公司及聯營公司擔當不同角色亦可引致利益衝突。",
        // "21.8 客戶應注意，正股的任何派息可影響其價格，而由於除息定價，可影響 ELI 到期時的回報。客戶亦" +
        //   "應注意，發行商可因正股的企業行動而對 ELI 作出調整。",
        // "21.9 潛在孳息率：客戶應就買賣 ELI 相關的費用及開支以及到期時的付款／交付諮詢客戶的經紀。港交" +
        //   "所發佈的潛在孳息率並無將費用及開支計算在內。",
        // "22 期貨 ETF 涉及的特定風險",
        // "22.1 期貨合約轉倉風險：期貨合約是透過期貨交易所訂立的具約束力協議，於未來的特定時間買賣相關" +
        //   "資產。「轉倉」是指，當現有期貨合約即將到期，以代表同一相關資產但到期日較後的期貨合約取代。" +
        //   "當期貨合約轉倉（即賣出近期的期貨合約，再買入較長期的期貨合約）時，如較長期的期貨合約的" +
        //   "價格高於即將到期的現有期貨合約價格，轉倉可能會導致虧損（即負轉倉收益「negativerollyield」）。" +
        //   "在此情況下，出售近期期貨合約所得的收益，並不足以購買相同數量而到期日較後的期貨合約，因" +
        //   "後者的價格較高，這會對期貨 ETF 的資產淨值有不利影響。",
        // "22.2 持有期貨合約數量的法定限制風險：在獲認可交易所上市的期貨合約受限於法定持倉限制，不能持" +
        //   "有多於某一特定數量之期貨合約。若期貨 ETF 的期貨合約持倉已增加至接近有關上限，則可能因無" +
        //   "法購買更多期貨合約而未能新增 ETF 單位，此情況可能令上市的 ETF 單位的交易價格偏離於其資產淨值。",
        // "23 人民幣計價證券之風險",

        // "23.1 人民幣不能自由兌換。人民幣與外幣（包括港元）之間的轉換，是受中國的監管限制，並會影響以" +
        //   "人民幣計價證券的流動性。",
        // "23.2 人民幣計價的證券可能沒有定期交易或活躍市場。因此，客戶或許不能及時出售，或大幅折讓其產" +
        //   "品的價值以作出售。",
        // "23.3 如人民幣貶值，以港元計價的投資亦會下降。",
        // "24 有關透過滬港通及/或深港通交易之特別風險",
        // "以下是一些通過本公司透過滬港通及/或深港通（下稱“中港通”）買賣上海證券交易所及/或深圳證券" +
        //   "交易所之風險。由於涉及風險，客戶只應在完全理解中港通之性質及客戶將承受之風險才進行有關" +
        //   "交易。客戶應按經驗、目的、財務資源及其他因素小心考慮（及在有需要時資詢客戶的顧問）該等" +
        //   "交易是否適合客戶。",
        // "24.1 中國相關風險：中國是一新興市場。投資於中國涉及特別的考慮和風險，包括但不只限於較大的價" +
        //   "格波動性、較不發達的監管及法律架構，以及經濟、社會及政治不穩定性等。",
        // "24.2 股票風險：投資中港通證券的回報率可能會高於短期和較長期債務證券。然而，投資中華通證券的" +
        //   "相關風險亦可能較高，原因在於投資中港通證券的表現取決於難以預測的因素，該等因素包括市場" +
        //   "突然或長期低迷的可能性以及與個別公司有關的風險。",
        // "24.3 流通量風險：無法保證可以就中港通建立或維持一個活躍的交易市場。如果中港通證券的價差很大，" +
        //   "客戶以期望的價格出售中港通證券的能力可能會受到重大影響。",
        // "25 深交所創業板市場風險",
        // "25.1 參與深交所創業板市場只限於機構專業投資者。",
        // "25.2 深交所創業板股票涉及高投資風險因為在深圳創業板上市的公司通常為初創公司，經營規模及股本" +
        //   "較小。由於市場上的股份流通量較小，其股票價格可能更容易受到操縱。因此，它們的股票價格和流動性波動較大。",
        // "25.3 深交所創業板的公司上市規則和法規，不如深交所主機板那麼嚴格。在深交所創業板除牌的情況可" +
        //   "能更加普遍和更快。如果客戶投資的公司被除牌，這可能對客戶產生不利影響。投資於深交所創業" +
        //   "板上市的股票可能導致客戶的重大損失。",
        // "26 上海交易所（上交所）科創板市場風險",
        // "26.1 規管差異風險：上交所科創板市場與上交所主板市場在上市、交易、信息披露以及其他事項的規則" +
        //   "和指引方面都存在較大差異。例如，就上市條件而言，尋求在科創板市場上市的公司將適用更短的" +
        //   "盈利歷史、更低的淨利潤和營業收入，以及更低的經營活動產生的現金流量要求。科創板上市公司" +
        //   "較之主板和中小板公司對於股本總額的要求也更低。科創板上市公司的交易安排亦與主板上市公司" +
        //   "不同，例如價格限制、最小買賣盤和最大買賣盤。關於上交所科創板與主板的上市條件詳情，請參閱上交所網站。",
        // "26.2 退市風險：科創板退市制度較主板不同，可能導致科創板市場上市公司退市的情形更多，退市速度更快。",
        // "26.3 公司經營風險：科創板市場上市公司一般處於發展初期，經營歷史較短，規模較小，經營穩定性較" +
        //   "低，抵抗市場風險和行業風險的能力較弱。儘管它們可能擁有更大的發展潛力並可更多地借助於科" +
        //   "技創新，其未來表現（尤其是那些尚未有良好盈利記錄的公司）存在很大的不確定性。",
        // "26.4 大幅股價波動：科創板市場上市公司股價可能隨市況變化、投資者投機行為或公司業績變動等情況" +
        //   "而頻繁發生大幅波動。流通股本較少的科創板市場上市公司可能較容易被主要股東操縱股價。不穩" +
        //   "定的公司業績亦令此類公司的估值較為困難。",

        // "26.5 技術風險：科創板市場上市公司的新技術能否轉化為現實中的產品或服務具有不確定性。當其所在" +
        //   "的行業正經歷快速的技術更新換代時，其產品可能面臨被淘汰的危險而令其公司難以為繼。",
        // "26.6 其他：投資者亦應參閱上海證券交易所科創板股票交易必備條款。每位內地投資者在交易上海科創" +
        //   "板股票之前都須認可該揭示書條款。",
        // "27 單位信託基金交易的特定風險",
        // "27.1 基金單位的價格會波動，甚至變成毫無價值。基金過往的表現並不代表將來表現。",
        // "27.2 不同類別基金所附帶的風險有所不同。客戶在決定是否投資該產品前，應審慎閱讀相關產品的銷售" +
        //   "文件（包括基金說明書、產品資料概覽及基金單張等）所披露的細節及風險。主要風險包括但不限於：",
        // "(a) 信貸風險：這風險通常適用於所有固定收入（即債券）以及貨幣市場工具的基金。債券附帶發" +
        //   "債機構違責的風險，即發行商有機會未能如期支付本金和利息。信貸評級機構給予的信貸評級" +
        //   "並非對發債機構信用可靠程度的保證。",
        // "(b) 流動性風險：此風險在基金內某些證券（包括債券等）可能在巿場上較難買入或沽售出現。未" +
        //   "上市或未被評級的證券可能需較長時間或無法於市場上沽出，因此具有較高的流通性風險。這" +
        //   "些風險有可能導致投資者招致嚴重虧損。",
        // "(c) 利率風險：如產品投資於債券，就較易受到利率波動的影響。一般來說，利率上升，債券價格" +
        //   "便會下跌。投資於債券的基金的價格便有可能下跌。",
        // "(d) 市場風險：投資價值可能會因政治、法律、經濟條件及利率變化而有波動。這些變化在全部市" +
        //   "場及資產類別上都很普遍，客戶取回的投資金額有可能少於初次投放的資金。",
        // "27.3 投資於高息債券的基金，除以上列舉的一般風險外，還須承受其他風險，例如：",
        // "(a) 較高的信貸風險：高息債券的評級通常低於投資級別，或不獲評級，因此涉及的發債機構違責風險往往較高；",
        // "(b) 受制於經濟周期的轉變：經濟下滑時，高息債券價值的跌幅往往會較投資級別債券為大，原因" +
        //   "是（i）投資者會較為審慎，不願承擔風險；（ii）違責風險加劇。",
        // "(c) 資本增長風險：派息基金，特別是某些高息債券基金可能會以資本來支付費用及／或股息。此" +
        //   "舉有可能令基金可供日後投資的資金減少，削弱資本增長。",
        // "(d) 股息分派風險：派息基金，特別是某些高息債券基金可能不會派息，取而代之的是將股息再投" +
        //   "資在基金上，又或投資經理可能有酌情權決定是否動用基金的收入及／或資本作分派之用。此" +
        //   "外，分派收益高並不意味投資者的總投資可取得正回報或高回報。",
        // "(e) 其他主要風險：投資於債券，特別是高息債券的基金，可能尚涉及其他主要風險，包括投資集" +
        //   "中於某特定種類的專門性債項或某特定地區市場或主權證券。",
        // "27.4 投資於「需具備衍生工具知識」基金的風險：",
        // "「需具備衍生工具知識」的基金可廣泛地使用金融衍生工具達致其投資目的，可能含有槓桿效應。" +
        //   "使用金融衍生工具可令基金承受額外風險，包括但不限於波動性風險及對手風險。基金經理可投資" +
        //   "於結構性產品、衍生工具及可投資於非投資級別的債務證券，最高達基金總資產淨值 100%。在惡劣" +
        //   "情況下，投資可能招致重大損失。",
        // "28 債券的特定風險",

        // "28.1 債券只在到期日提供 100%本金保證，但要視乎其發行人及/或擔保人（如適用）的信貸風險。",
        // "28.2 債券不應被視為一般或定期存款。",
        // "28.3 債券的價格會波動，甚至變成毫無價值。",
        // "28.4 產品主要風險：客戶在決定是否投資該產品前，應審慎閱讀相關產品認購書（如適用）所披露的細" +
        //   "節及風險。主要風險包括但不限於下頁所載：",
        // "(a) 信貸風險：客戶須承擔發行人及擔保人（如適用）的信貸風險，他們的信貸評級如有任何變動" +
        //   "將會影響本債券的價格及價值。債券附帶發債機構違責的風險，即發行人有機會未能如期支付" +
        //   "本金和利息。在最壞的情況下如發行人及擔保人（如適用）破產，客戶可能會損失全部投資。" +
        //   "信貸評級機構給予的信貸評級並非對發行人信用可靠程度的保證。",
        // "(b) 流動性風險：債券的流動性可能有限，及可能無活躍交易，及/或沒有經紀在市場提供報價，因此：",
        // "(i) 不可以在任何時間均能提供債券的市值及/或參考買入/賣出價，因其將取決於市場的流動性和情况；",
        // "(ii) 可能需要較長時間或無法於市場上出售債券；及",
        // "(iii) 所執行的賣出價可能與本行參考買入價有很大的差別，對客戶不利。",
        // "(c) 利率風險：債券較易受到利率波動的影響。一般來說，利率上升，債券價格便會下跌。",
        // "(d) 市場風險：投資價值可能會因政治、法律、經濟條件及利率變化而有波動。這些變化在全部市" +
        //   "場及資產類別上都很普遍，投資者取回的投資金額有可能少於初次投放的資金。",
        // "28.5 投資於高息債券，除以上列舉的一般風險外，還須承受其他風險，例如：",
        // "(a) 較高的信貸風險：高息債券的評級通常低於投資級別，或不獲評級，因此涉及的發債機構違責風險往往較高；",
        // "(b) 受制於經濟周期的轉變：經濟下滑時，高息債券價值的跌幅往往會較投資級別債券為大，原因" +
        //   "是（i）投資者會較為審慎，不願承擔風險；（ii）違責風險加劇。",
        // "28.6 某些債券可能別具特點及風險，投資時須格外注意。這些包括：",
        // "(a) 永續性債券的風險：永續性債券不設到期日，其利息派付取決於發行人在非常長遠的時間內的" +
        //   "存續能力，利息或會因根據其條款及細則而有所延遲或終止。一般而言，永續性債券一般為可" +
        //   "贖回及/或為後償債券，客戶須要承受再投資風險/或為後償債券風險，詳情如下。",
        // "(b) 可提早贖回債券的再投資風險：如果這是可提早贖回的債券，當發行人於債券到期前行使贖回" +
        //   "權，客戶便會面對再投資風險。客戶於再投資時可能會收到較小的孳息率。",
        // "(c) 後償債券的風險：後償債券於發行人遣債後的清盤過程中獲較低之索償權，因此後償債券之持" +
        //   "有人將承受比優先債券更高的風險。後償債券為無抵押，其信貸評級及債務的優先次序較優先" +
        //   "債券為低。客戶應特別注意產品之信貸資料，包括發行人，債券或擔保人的信貸評級（視情況而定）。",
        // "(d) 浮息及／或延遲派付利息的風險：如果債券具有浮息及／或延遲派付利息的條款，客戶便無法" +
        //   "確定將收取的利息金額及利息派付的時間。",
        // "(e) 可延遲到期日的風險：如果債券具有可延遲到期日的條款，客戶便沒有一個訂明償還本金的確實時間表。",
        // "(f) 可換股或可交換性質的債券的投資風險：屬可換股或可交換性質的債券，客戶須同時承受股票" +
        //   "及債券的投資風險；及／或具有或然撇減或彌補虧損特點的債券。當發生觸發事件時，這些債" +
        //   "券可能會作全數或部分撇賬，或轉換為普通股。"
      ]
    },

    knowledge_courses: {
      page_title: "衍生产品基本知识课程",
      h: "衍生产品基本知识课程",
      p2: [
        "1.   引言",
        "在日常生活中，不同的传媒都会经常提及期货、期权、及认股权证等金融产品，而这些金融产品均被称为「衍生产品」。以下的课程内容主要解释衍生产品的性质、常见 种类、用途以及相关之风险，以增加投资者对衍生产品的认识。由于衍生产品的种类众多，而且各有特性，建议投资者在投资衍生产品前，须先向有关专业投资顾问查询有关衍生产品的特性及相关之风险，清楚了解后才做出投资决定。",
        "2.  衍生品简介",
        "在金融市场中，衍生产品通常由现货市场产品（ 如外币、证券或黄金 ） 演变而成。相关的现货市场产品称为「相关资产」。衍生产品的价值会受相关资产的价值升跌而 有所波动，此外，衍生产品亦都会受到很多其他市场因素，如利率改变及经济环境等而影响其价格。",
        "以认股权证（俗称「窝轮」）为例，它便是一种衍生产品，与现货市场的相关股票价格之波幅有直接的关係。由于衍生产品和现货市场产品关係密切，而衍生产品是由现货市场的相关资产衍生出来，因此，这类金融产品会被统称为「衍生产品」。",
        "「现货市场」是指产品可以在短时间之内，让买家和卖家进行交易，买家付出金钱，而卖家就以现货做交收。于金融市场内，买卖外币或股票一般亦可在即日或短时间内交收，故这些产品被称为现货市场产品。",
        "一般而言，不同的交收时间亦是其中一样现货市场产品有别于衍生产品之特徵。若投资者已购买现货市场产品，即使其价格大幅下跌，只要不将持有之产品卖出，都不会有即时的损失。相反，若已购买衍生产品，由于须在指定日期交收（例如一个月后），当相关资产价格大幅下跌时，往往有机会承受损失。",
        "3.  衍生产品常见种类",
        "市面上的衍生产品种类繁多，一般投资者较常见的有两大类，分别是 (1)「期货类」及 (2)「期权类」。",
        "3.1 期货类",
        "「期货类」产品是要求买卖双方承诺在某个指定日期（例如一个月后），按一个指定价格，买卖双方买入或沽出相关资产（如证券、外币、黄金等）之一份合约。在双方指定交收的日期（即一般称的「到日」），双方必须履行合约所订之安排，按照合约上指定的价格及资产数量进行交收，即合约的买家要按指定的价格买入相关资产，而合约的卖家须按指定的价格将相关资产卖给买家。",
        "至于「期货类」产品大致可分为两种：一种是在「交易所买卖」的，而另一种是在「非交易所买卖」的。",
        "在交易所买卖的期货类产品一般称为「期货合约」，例如「恆生指数期货」就是在交易所买卖的期货合约之一。而在非交易所买卖的期货类产品，就称为「远期合约」。倘若由一对（即两张）远期合约组成，即同一时间买入及卖出不同的远期合约，便称为「掉期」，例如「外汇掉期」及「利率掉期」等。利用掉期产品可让投资者在指定的日期及价格进行两种不同货币或利率的交换。",
        "例如投资者希望于两日后将港币兑换成澳币，然后敍做定期外汇存款以赚取利息，并预期到期时，以一个预定的外汇价格将澳币转回港币。投资者便可以在今日同时买入及卖出两张澳币远期合约，锁定兑换价，避免外汇价格波动。",
        "在交易所买卖的期货合约都有一个相同的特徵，就是「标准化合约」。例如交易所已经订定恒生指数期货的每一点子价值为 50 元，即每一位参与买卖恒生指数期货的投资者，都是以指定的 50 元为一点子的价格计算，这就是标准化合约的特徵。",
        "至于非交易所买卖的远期合约则有别于交易所买卖的期货合约。非交易所买卖的远期合约之价格及交易金额都可以按买卖双方的需要而制订。如果某产品不是在交易所进行买卖，该产品会被称为「场外交易市场」产品。较为常见的例子为「外汇远期合约」，客户可以按自己的需求与金融机构制订一份外汇远期合约。",
        "3.2期权类",
        "「期权」是一种涉及买卖双方的合约，合约赋予买家权利而并非责任，从卖家买入或向卖家卖出相关资产。合约在订立时就已经釐订了相关资产的数量、价格及期权的有效期限。如买家行使期权，卖家就必须根据合约的细则进行交收。",
        "在期权类产品中，投资者必须要认识「认购期权」和「认沽期权」两者之间的分别（「认购」，就代表买入相关资产的意思；而「认沽」，就代表沽出或卖出相关资产的意思）。日常生活所看到的「认股权证」，均属认购期权产品。另外，在报章上报导一些企业的高级管理层会有可能得到一批由个别企业分发的股票认购权，这亦属于「认购期权」产品。",
        "在市场上，投资者可以选择做合约的买家或卖家。合约的买家有权买入或沽出相关资产，买家需要支付「期权金」（Option Premium）以换取权利；而合约的卖家就会收取「期权金」作为回报，但同时亦须承受市场价格波动而有机会亏损的风险。",
        "即使合约的卖家有亏损的风险，但他们仍愿意参与交易，原因包括：没有人能准确预测相关资产一个月后价格的上落；合约卖家会向买家收取一个金额作为买合约的价钱，就是上文所述的「期权金」，即买入权利之成本，亦都是最主要原因。期权合约的卖收到这些期权金，从而可以提高其潜在回报。",
        "由不同衍生产品组合而成的投资产品称为「结构性产品」。常见的结构性产品包括「股票挂鈎票据 / 股票连结票据」、「外汇挂鈎票据/ 外汇连结票据」或「信贷挂鈎票据 / 信用连结票据」。",
        "结构性产品大多数都包含了衍生产品在内，即由不同衍生产品结合而成，当中有些是「保本」，有些是「非保本」的，所以投资者购买这些包含了衍生产品的结构性产品时，必须清楚明白有关条款，理解其性质。当然，买卖结构性产品始终要承受市场价格波动而有机会亏损的风险。",
        "除此之外，市面上亦有许多衍生产品的例子，如交易所买卖的认股权证及牛熊证等，这些均属期权类产品。而较常见的非交易所买卖的产品，就如透过金融机构买到的股票挂鈎票据 / 股票连结票据及外汇挂鈎票据 / 外汇连结票据等。",
        "以股票挂鈎票据 / 股票连结票据为例，这种产品的结构包含一个期权产品在内；购买了股票挂鈎票据 / 股票连结票据的客户，等同于一个期权合约的卖家 （即卖方会收取期权金）。如果挂鈎的有关股票之价格未低过一个指定的价格，即「行使价」，投资者就可以赚取到这个期权金，从而增加投资者的回报，当然，投资者同时亦要承受市场价格波动而有机会亏损的风险。",
        "4.衍生产品的用途",
        "衍生产品用途广泛。主要用途有四种：",
        "a) 第一种：投机活动 - 提高收益；",
        "b) 第二种：可以参与不同类别的资产；",
        "c) 第三种：槓杆效应；and 及",
        "d) 第四种：可以看涨，亦可以看淡以作为风险对冲。",
        "4.1 投机活动 - 提高收益",
        "假设某投机者有一投资的看法，认为股市未来一个月不会大跌，即使跌低于某一个指定价格，该投资者都愿意用这个指定价格买入这批股票。 如果这样，该名投资者便可以利用股票挂鈎票据 / 股票连结票据成为一个认购期权的卖家。如果有关的股票价格没有跌低过指定价格，就可以在不需要买入股票的情况下收取期权金，提高其投资收益，但如果有关的股票价格跌低过指定价格就需要以高于市价买入股票，若股票大幅下跌，就会有大幅亏损的风险。",
        "4.2 可以参与不同类别的资产",
        "投资者可以透过衍生产品来参与或者买入或沽出各种不同类别的资产。举例来说，国外人士无法参与 A 股市场，但透过一些「合成交易所买卖基金」就可以间接参与 A 股市场。这些合成交易所买卖基金运用衍生产品跟踪或模拟某市场指数的表现为主要投资目标，透过这些合成交易所买卖基金，投资者虽然不能直接持有 A 股，但相关 A 股的表现却可以反映于投资者持有的合成交易所买卖基金内。",
        "4.3 槓杆效应",
        "由于投资者买入一手股份或需要数万元，故对现金流可能造成压力。但如果投资者选择购买认股权证，所需的成本只是数千元，便可以相对的买入一手股票，此做法就称为「槓杆效应」，即投资者在成本上不用提供十足金额以购买一手股票。然而，因为买卖的是衍生产品，并不是股票，投资者一定要注意因市场价格波动而带来的风险。",
        "4.4可以看涨，亦可以看淡以作为风险对冲",
        "投资者可以在市场买入一种看涨市场的认购权证，或可以买入一种看淡市场的认沽权证。认沽权证产品可以帮助投资者对冲一些市场下跌的风险。例如，若投资者拥有一些股票及看淡股市，可以买入一个认沽权证，如果市场价格真的下跌，其购入的认沽权证就可以带来额外的收益，以补偿其持有股票的部分损失。"
      ]
    },

    personal_data: {
      page_title: "个人资料(私隐)政策/私隐政策声明",
      company_info:[
        "香港尖沙咀港威大厦 6 座 31 樓 3102 室",
        "電話: (852) 2187 2100",
        "傳真: (852) 2187 2107",
        "網址: www.goingf.hk"
      ],
      h: "隱私政策",
      p2: [
        "1. 作為高盈证券有限公司之客戶（“客戶”），當申請開立或維持帳戶或建立、維持或提供投資、交易或相關服務時，需" +
          "不時向高盈证券或聯屬公司提供有關之個人資料（“個人資料”）。（《個人資料（私隱）條例》（香港法例第 486 章）（“私隱條" +
          "例”）所賦予之定義）。",
        "2. 若未能向高盈证券提供有關資料，將會導致高盈证券無法開立或維持戶口或建立、維持或提供投資、交易或相關服務。",
        "3. 個人資料將可能在與高盈证券及/或聯屬公司的正常業務往來過程中被收集。",
        "4. 根據私隠條例的條文，資料將可能用於下列用途：",
        "(a) 為提供服務給客戶之日常運作；",
        "(b) 作信貸或反洗錢檢查；",
        "(c) 確保客戶之信用持續良好及反洗錢風險監控；",
        "(d) 宣傳投資、交易或相關服務或產品(詳情請見如下第 8 段)；",
        "(e) 支援高盈证券在有關服務上作出之任何文件內之任何聲明；",
        "(f) 協助其他有關第三者、專業人員、機構及有關監管機構確認某些高盈证券在有關服務上之事實；",
        "(g) 根據高盈证券須遵守之有關法例及／或條例要求作出披露；",
        "(h) 組成接收資料者所經營業務的紀錄的一部份；",
        "(i) 與上述有關或隨附之其他用途。",
        "5. 高盈证券會把個人資料保密，但為達至上述第(4)段所述的用途，高盈证券可能會把個人資料提供給：",
        "(a) 任何中間人，或提供與高盈证券業務運作有關服務之第三者服務供應商；",
        "(b) 任何對高盈证券作出保密責任之適當人仕，包括對高盈证券作出保密資料承諾的任何聯屬公司；",
        "(c) 任何與閣下已有或建議有交易之人仕及機構；",
        "(d) 信貸諮詢機構及 (發生拖欠付款時) 收數公司；",
        "(e) 任何管治或與高盈证券及聯屬公司的業務有關的監管機構及交易所；",
        "(f) 任何承讓人、受讓人、代表、繼承人或獲轉讓有關帳戶之人士及授權人士；",
        "(g) 任何高盈证券之實際或建議受讓人或參與人或附屬參與人或受讓人。",
        "6. 客戶同意個人資料可轉到香港以外的任何地點 (不論是用作在香港以外處理、持有或使用該等資料)，並同意可轉發給向任何聯屬公司" +
          "就其業務經營而提供服務的服務提供者。",
        "7. 在法律許可的範圍內，客戶同意高盈证券不時收集的個人資料可按照私隱政策的規定使用及披露。",
        "8. 使用個人資料作直接促銷",
        "高盈证券擬使用閣下的該等資料作直接促銷，為此高盈证券在使用該等資料前須取得閣下的同意（包括表示不反對）。閣下同意與否" +
          "純屬個人意願。就此，務請閣下注意︰",
        "(a) 由高盈证券不時持有的閣下的姓名、聯絡詳情、產品及服務組合信息、交易模式及行為、財務背景及統計資料（「可作直銷用" +
          "途的個人資料」）可由高盈证券用作直接促銷；",
        "(b) 可促銷的各類服務、產品及主題如下︰",
        "i. 財務、保險、證券、商品、投資及相關服務、產品及設施；",
        "ii. 上文第(8)(b)(i)條所述各類促銷主題涉及的獎賞、忠誠獎勵或優惠計劃；",
        "iii. 由高盈证券的合作品牌夥伴因應上文第(8)(b)(i)條所述各類促銷主題而提供的服務和產品（合作品牌夥伴的名稱見相關服" +
          "務和產品（視屬何情況而定）申請書）；及",
        "iv. 為慈善及/或非牟利目的而作出的捐款及捐獻；",
        "(c) 上述服務、產品及主題可由高盈证券及/或以下各方提供或（如涉及捐款及捐獻）收集：",
        "i. 任何聯屬公司；",
        "ii. 第三方金融機構、承保人、證券、商品及投資服務提供者；",
        "iii. 第三方獎賞、忠誠獎勵、合作品牌或優惠計劃提供者；",
        "iv. 高盈证券的合作品牌夥伴（合作品牌夥伴的名稱見相關服務和產品（視屬何情況而定）申請書）；",
        "v. 慈善或非牟利組織；",
        "(d) 除了自行推廣上述服務、產品及主題外，高盈证券亦擬將上文第(8)(a)條所述資料提供予上文第(8)(c)條所述的全部或當中任何" +
          "人士（不論提供資料是為得益與否），以供該等人士在促銷上文第(8)(b)條所述的該等服務、產品及主題時使用（高盈证券可能" +
          "就此收取報酬），而高盈证券須為此用途取得閣下的書面同意（包括表示不反對）；",
        "在未經閣下同意之前高盈证券不會使用閣下可作直銷用途的個人資料進行直接促銷。當簽署相關客戶開戶文件時，請註明閣下" +
          "同意與否。如閣下在相關開戶文件中表明閣下同意後欲改變意願，希望高盈证券不再使用或向其他人士提供閣下可作直銷用途" +
          "的個人資料進行上述直接促銷，閣下可向高盈证券發出書面通知或致電高盈证券的客戶服務部（郵寄地址及電話號碼載於下文" +
          "第(11)條），以行使閣下拒絕參與直銷活動的權利。",
        "但請注意，如閣下是以公司或業務代表身份在相關客戶文件中表明同意參與直接促銷活動，而非以個人身份收取促銷資料，則上述權" +
          "利並不適用於閣下。",
        "9. 收集個人資料聲明-滬深港通北向交易",
        "閣下瞭解並同意高盈证券在為閣下提供滬深港通北向交易的過程中，高盈证券會被要求按有關規則處理客戶個人資料，包括以下各項：",
        "1. 在向中華證券通系統（“CSC”）遞交閣下每單北向交易指令時,附加閣下唯一的券商客戶編碼（Broker-to-Client Assigned " +
          "Number，“BCAN”）/為閣下聯名帳戶編派的券商客戶編碼；及",
        "2. 在交易所可能不時依據交易所規則向高盈证券提出要求時，高盈证券將向交易所提供閣下的券商客戶編碼和客戶識別資訊" +
          "（Client Identification Data，“CID”）" ,
          "在不局限於高盈证券就處理閣下個人資料曾發予閣下的通知或已從閣下獲得的同意/授權，閣下在此瞭解並同意高盈证券在提供滬深" +
          "港通北向交易服務過程中可根據需要收集、存儲、使用、披露和轉交與閣下有關的個人資料，包括如下：",
        "(a) 不時向交易所和相關的港交所附屬公司披露並轉交閣下的券商客戶編碼和客戶識別資訊，包括在向中華證券通輸入中華通交易" +
          "時註明閣下的券商客戶編碼，並即時轉送給相關的中華通市場營運者；",
        "(b) 允許各交易所及相關的港交所附屬公司：",
        "i. 為達至市場監督和監測及執行交易所規則之目的，收集、使用和存儲由中華通結算所提供的閣下券商客戶編碼，客戶識" +
          "別資訊以及任何經整合、驗證和配對的券商客戶編碼和客戶識別資訊（可由上述任何各方或通過香港交易所存儲）；",
        "ii. 為達至下文（c）和（d）之目的，不時將有關資料轉交有關中華通市場營運者（直接或經有關中華通結算所）;",
        "iii. 向香港監管機構和執法機關披露此類資訊以便其履行就香港金融市場的法定職能；",
        "(c) 允許相關中華通結算所：",
        "i. 收集、使用和存儲閣下的券商客戶編碼和客戶識別資訊，以便整合及驗證券商客戶編碼和客戶識別資訊，配對券商客戶" +
          "編碼和客戶識別資訊至投資者識別資料庫，並將經整合、驗證和配對的券商客戶編碼及客戶識別資訊提供給相關的中華" +
          "通市場營運者，各交易所及相關港交所附屬公司;",
        "ii. 使用閣下的券商客戶編碼和客戶識別資訊進行其證券帳戶管理的監管職能;",
        "iii. 將這些資訊披露給具有管轄權的中國內地監管機構和執法機關，以便其就中國內地金融市場履行監管，監督和執法職能；",
        "(d) 允許相關的中華通市場營運者：",
        "i. 收集、使用和存儲閣下的券商客戶編碼和客戶識別資訊，以便其監督和監測經中華通服務在相關中華通市場的證券交易" +
          "及執行相關中華通市場營運者的規則;",
        "ii. 將這些資訊披露給具有管轄權的中國內地監管機構和執法機關，以便其就中國內地金融市場履行監管，監督和執法職能；" ,
          "如果閣下就任何有關中華通證券的交易向高盈证券發出指示，即表示閣下確認並同意高盈证券為遵守交易所就滬深港通北向交易不時" +
          "制定的的要求及規則使用閣下的個人資料。閣下同時承認，儘管閣下後續可能表示撤回該同意，閣下的個人資料仍可能繼續被存儲，" +
          "使用，披露，轉移和及為達至上述目的其他方式處理，無論是在該等聲稱的撤回同意之前或之後。",
        "未能提供個人資料或同意的後果",
        "如閣下未能向高盈证券提供閣下的個人資料或上述同意/授權，這可能代表著高盈证券不會或不再能夠執行閣下的交易指令或向閣下" +
          "提供滬深港通北向交易服務。",
        "10. 根據私隱條例中之條文，任何人有權：",
        "(a) 審查高盈证券是否持有他／她的資料及查閱有關之資料；",
        "(b) 要求高盈证券改正有關他／她不準確之資料；",
        "(c) 查悉高盈证券對於資料之政策及實際運用及被通知高盈证券持有何種個人資料；",
        "(d) 就客戶信貸而要求獲通知哪項個人資料是例行披露予信貸諮詢機構或收數公司，以及獲提供進一步的資訊以便向有關的信貸諮" +
          "詢機構或收數公司作出查閱及改正要求。",
        "11. 根據私隱條例規定，高盈证券有權就處理任何查閱資料之要求收取合理費用。任何關於資料查閱或改正資料(當客戶認為由高盈证券" +
          "所提供有關他／她的資料不準確時)或關於資料政策及實際應用或資料種類之要求，應向下列人仕提出：私隱保護主任 " +
          "高盈证券有限公司，中國香港尖沙咀港威大厦 6 座 31 樓 3102 室。"
      ]
    },

    collection_statement: {
      page_title: "客户资料收集声明",
      h: "投资者识别及场外证券汇报制度之客户资料收集声明",
      p2: [
        "客户明白并同意，高盈证券有限公司（“高盈证券”）为了向阁下提供与在香港联合交易所（“联交所”）上市或买卖的证券相关的" +
          "服务，以及为了遵守不时生效的联交所与证券及期货事务监察委员会（“证监会”）的规则和规定，高盈证券可收集、储存、处理、使用、披" +
          "露及转移与阁下有关的个人资料（包括阁下的客户识别信息及券商客户编码）。在不限制以上的内容的前提下，当中包括：",
        "（a）根据不时生效的联交所及证监会规则和规定，向联交所及／或证监会披露及转移阁下的个人资料（包括客户识别信息及券商客户编码）；",
        "（b）允许联交所：",
        "（i）收集、储存、处理及使用阁下的个人资料（包括客户识别信息及券商客户编码），以便监察和监管市场及执行《联交所规则》；",
        "（ii）向香港相关监管机构和执法机构（包括但不限于证监会）披露及转移有关数据，以便他们就香港金融市场履行其法定职" +
          "能；及（iii）为监察市场目的而使用有关数据进行分析；及",
        "（c）允许证监会：",
        "（i）收集、储存、处理及使用阁下的个人资料（包括客户识别信息及券商客户编码），以便其履行法定职能，包括对香港" +
          "金融市场的监管、监察及执法职能；及",
          "（ii）根据适用法例或监管规定向香港相关监管机构和执法机构披露及转移有关数据。",
        "（d）向香港中央结算有限公司（香港结算）提供券商客户编码以允许香港结算：",
        "（i）从联交所取得、处理及储存允许披露及转移给香港结算属于阁下的客户识别信息，及向发行人的股分过户登记处转移阁下的客户识别信息，以便核实阁下未就相关股分认购进行重复申请，" +
          "以及便利首次公开招股抽签及首次公开招股结算程序；及",
        "（ii）处理及储存阁下的客户识别信息，及向发行人、发行人的股分过户登记处、证监会、联交所及其他公开招股的有关各方转移阁下的客户识别信息，以便处理阁下对有关股分认购的申请，或为载于公开招股发行人的招股章程的任何其他目的。" +
          "阁下亦同意，即使阁下其后宣称撤回同意，高盈证券在阁下宣称撤回同意后，仍可继续储存、处理、使用、披露或转移阁下的个人资料以作上述用途。如阁下未能向高盈证券提供个人资料或上述同意，可能意味着我们不会或不能够再（视情况而定）执行阁下的交易指示或向阁下提供证券相关服务，惟出售、转出或提取阁下现有的证券持仓（如有）除外。",
        "确认和同意",
        "本人确认已阅读并理解由高盈证券所发布的这份声明之内容。通过勾选下面的方框，本人表示同意高盈证券根据本声明中的条款和目的使用本人的个人资料。"
      ],
      checkText:"本人/本公司同意高盈证券将本人的个人资料用于本声明所述的目的。",
      endContent:"备注：本条文所述的“券商客户编码”及“客户识别信息”具有《证券及期货事务监察委员会持牌人或注册人操守准则》第5.6段所界定的含义。"
    },

    customer_agreement: {
      page_title: "证券及/或期货客户协议"
    },

    service_opening: {
      nav_title: "服务开通",
      page_title: "请选择要开通的服务",
      verify_fail_text: "请务必勾选香港期货交易服务"
    },

    trade_password_setting: {
      nav_title: "设置交易密码",
      page_title: "请设置交易密码",

      password_field: {
        label: "密码",
        placeholder: "至少6位数字和字母组合"
      },

      confirm_password_field: {
        label: " 确认密码",

        placeholder: "再次输入密码"
      }
    },

    electronic_sign: {
      nav_title: "电子签署",
      page_title: "客户确认及承诺",

      label: "倘签署本部份，客户即声明、同意及确认：",

      checkbox_label_1: " 本开户表格提供的资料，均为完整、真实及准确；",

      checkbox_label_2_prev:
        "我 / 我们确认高盈证券以客户选择的语言(英文或中文)提供",
      checkbox_label_2_middle: "证券及/或期货客户协议", //U
      checkbox_label_2_next:
        "包括风险披露声明及免责声明。我 / 我们进一步确认高盈证券已经邀请我 / 我们阅读风险披露声明，提出问题及征求独立的意见(如我/我们有此意愿)。我 / 我们应经常切留意市况，高盈证券可能在强制平仓前无法与我 / 我们联络或未能提供足够时间让客户进行额外的存款。", //U
      checkbox_label_3:
        "我 / 我们谨此确认已收到并细阅及明白以上之「风险披露声明书- 交易所买卖之衍生产品」。我 / 我们并且确认其财务状况确可承受买卖交易所买卖之衍生产品所引致之潜在损失。我 / 我们亦声明在其财务状况有所变更时，将尽速地通知高盈证券。",

      checkbox_label_4_prev: "我已参阅给予客户有关",

      checkbox_label_4_middle: "个人资料(私隐)政策/ 私隐政策声明",

      checkbox_label_4_middle_name: "和",

      checkbox_label_4_middle1: "客户常设授权",

      checkbox_label_4_next: "的通知，并明白且同意其条款。",

      checkbox_label_5_prev:
        "我/我们确认已阅读并理解由高盈证券所发布的关于实施",
      checkbox_label_5_middle: "投资者识别及场外证券汇报制度之客户资料收集声明",
      checkbox_label_5_next:
        "之内容。我/我们表示同意高盈证券根据本声明中的条款和目的使用我/我们的个人资料。",

      desc:
        "我 / 我们现获告知高盈证券拟使用及在高盈证券（如《交易账户条款及条件》中所定义）之间转移我 / 我们于高盈证券之个人资料以直接促销：(i) 金融服务和产品；(ii) 相关优惠计划；(iii) 金融与投资建议；或(iv) 高盈证券就前述产品及服务之业务推广和宣传活动。该等个人资料包括我 / 我们在本开户表格中向高盈证券提供的及高盈证券公司不时获得的姓名、联络详情、财务背景及统计资料等个人资料。我 / 我们明白可以随时通过高盈证券指定的渠道要求高盈证券停止在直接促销中使用我 / 我们的个人资料。 ",

      checkbox_label_5:
        "本人(等) (客户)不希望高盈证券使用本人(等)的个人资料作直接促销用途。",

      checkbox_label_6:
        "本人(等) (客户)不希望在高盈证券之间转移本人(等)的个人资料作直接促销用途。",

      checkbox_label_7:
        "我/我们同意高盈证券或联系人士各种方式提供投资或有关财务产品及服务的资料，其包括研究报告及特别优惠等。",

      checkbox_label_8:
        "我/我们同意签名同时用于开户申请表、衍生产品基本知识课程、风险承受能力问卷、W-8BEN表格、风险披露声明、客户常设授权、税务居民数据、FATCA、客户资料收集声明和其他适用文件。",

      checkbox_label_8_with_mainland:
        "我/我们同意签名同时用于开户申请表、衍生产品基本知识课程、风险承受能力问卷、W-8BEN表格、风险披露声明、客户常设授权、税务居民数据、FATCA、客户资料收集声明、内地投资者开户声明书和其他适用文件。",

	  checkbox_label_8_1:
	    "我/我们同意输入登录密码确认签名同时用于开户申请表、衍生产品基本知识课程、风险承受能力问卷、W-8BEN表格、风险披露声明、客户常设授权、税务居民数据、FATCA、客户资料收集声明和其他适用文件",

      sign_tip:
        "您的签名将同时作用于开户申请表、W-8BEN表格，风险承受能力问卷和其他适用文件 ",

      sign_title: "用户签名",

      sign_desc: "点击进入签名页"
    },

    sign_write: {
      reset_btn_text: "重置",
      confirm_btn_text: "确定",
      tip_dialog_title: "温馨提示",
      tip_dialog_message: "请将手机横屏操作",
      tip_dialog_btn_text: "知道了",
      empty_toast_text: "您还未签名"
    },

    result_page: {
      title: "提交成功", //U
      desc: "开户信息已提交，系统将尽快处理，请耐心等待", // U
      number_label: "业务受理编号" //U
    }
  },

  //人脸识别
  face_recognition: {
    nav_title: "人脸识别",
    pic_title: "正确示意流程",
    check_rule: "查看规范",
    tips_modal_title: "视频录制规范",
    tips_modal_close_btn_text: "我知道了",
    record_tip: ["请录制", "1~2秒多次眨眼", "视频"],
    record_btn_text: "开始录制",
    verify_success_msg: "人脸验证成功", //U1
    verify_success_btn_text: "完成验证", //U1
    verify_fail_msg: "无法确认为同一个人", //U1
    reVerify_btn_text: "重新验证", //U1
    common_btn_text: "常规开户", //U1
    dialog_content_msg: "常规开户将采用人工方式核验身份", //U1
    dialog_content_desc:
      "审核结果会以短信通知到您本人，\n 核审一般需要1-3个工作日" //U1
  },

  check_progress: {
    nav_title: "进度",
    status_text: "系统审核中",
    status_desc: "开户信息已提交，系统将尽快处理，请耐心等待",
    status_tip_prev: "审核时间平均1~3个工作日，如需加急，请",
    status_tip_next: "联系客服",
    acceptance_sn_label: "受理编号",
    created_time_label: "提交时间",
    progress_label: "处理进度",
    step_first_name: "资料审核中",
    step_second_name: "资料审核完成"
  }, // U

  //结算单

  statement: {
    list: {
      nav_title: "结算单",

      page_title: "结算单类型",

      standard_contract_statement_title: "标准合约结算单",

      standard_contract_statement_list: [
        {
          name: "日结算单",

          desc: ["香港期货", "环球期货"]
        },

        {
          name: "月结算单",

          desc: ["香港期货", "环球期货"]
        }
      ]
    },

    day_statement: "日结算单",
    month_statement: "月结算单",
    statement_type: ["标准合约", "连续合约"],

    detail: {
      no_result_text: "暂无结算单"
    }
  },

  //激活账户

  account_activation: {
    nav_title: "激活账户",
    desc:
      "系证监会新指引,允许客户通过同名香港银行账户转账方式完成身份核验,开通证券账户",
    desc1:
      "系证监会新指引,允许客户通过同名香港银行账户转账方式完成身份核验,开通期货账户",
    check_SFC_text: "查看证监会发文",

    steps_title: "您需要这样激活用户",

    step_first_name: "绑定客户同名香港银行账户",

    step_second_name: "转账至高盈证券银行户口",

    step_second_desc: "（不少于<strong style='color:#17161C;'>10,000港币</strong>或<strong style='color:#17161C;'>1,500美元</strong>）",

    activate_btn_text: "开始激活"
  },

  //安全中心

  security_center: {
    idcard_verify: {
      nav_title: "身份验证",
      page_title: "请验证您的身份信息",
      form_title: "请输入开户时使用的证件号码",
      idcard_field_placeholder: "证件号码"
    },

    trade_password_reset: {
      nav_title: "设置交易密码",
      page_title: "请设置交易密码",
      password_placeholder: "至少六位数字和字母组合",
      confirm_placeholder: "再次输入密码",
      trade_password_verify_fail_text: "密码应为数字和字母结合，长度不低于6位", //U
      trade_password_repeat_fail_text: "两次输入不一致", //U
      trade_password_reset_success_text: "交易密码设置成功" //U
    },

    login_password_modify: {
      nav_title: "登录密码",

      page_title: "修改密码",

      original_password_placeholder: "原密码",

      new_password_placeholder: "至少8位数字和字母的组合",

      confirm_new_password_placeholder: "重复新密码",

      new_password_verify_fail_text: "新密码应为数字和字母结合，长度不低于8位", //U
      new_password_repeat_fail_text: "新密码两次输入不一致" //U
    },

    trade_password_modify: {
      nav_title: "交易密码",

      page_title: "修改密码",

      original_password_placeholder: "原密码",

      new_password_placeholder: "至少6位数字和字母的组合",

      confirm_new_password_placeholder: "重复新密码",

      new_password_verify_fail_text: "新密码应为数字和字母结合，长度不低于6位", //U
      new_password_repeat_fail_text: "新密码两次输入不一致", //U

	  account_fail_text:"请选择一个账号"
    },

    login_device: {
      nav_title: "登录设备管理",
      tips:
        "已绑定的登录设备：你可以删除列表中的设备，删除后在该设备登录需要进行身份验证。",
      del_btn: "删除",
      del_text: "删除该登录设备",
      cancel_btn: "取消",
      ok_btn: "确定",
      operated: "操作成功"
    }
  },

  //帮助中心

  help_center: {
    nav_title: "帮助中心", //U
    list: [
      {
        text: "内地用户如何开户",
        path: "/help-center/mainland-account-open"
      },

      {
        text: "怎样激活邮箱",
        path: "/help-center/activation-email"
      }
    ]
  },

  //转出资金

  withdraw: {
    nav_title: "资金转出",

    a_account_name: "标准合约A账户",

    b_account_name: "连续合约B账户",

    transferred_text: "可转出",
    transferred_total_text: "可转出总计", //U
    usd: "美元",

    hkd: "港币",

    rmb: "人民币",

    currency_field: {
      label: "转出币种",
      placeholder: "请选择" //U
    },

    bankCard_field: {
      label: "转出银行卡",

      placeholder: "请选择",

      tip: "注意：银行卡必须能够接收上述币种"
    },

    amount_field: {
      label: "转出金额",

      placeholder: "请填写数字"
    },

    withdraw_explain_title: "资金转出说明",

    withdraw_explain_desc_1:
      "1.汇率会在一定期限内变动，实际到账资金可能与预计到账金额存在差别；",

    withdraw_explain_desc_2:
      "2.请确保您选择的银行卡能够接收您的转出币种，以免资金不能及时到账。",
    withdraw_success_title: "资金转出订单提交成功",
    withdraw_success_msg: "预计到账时间1~3个工作日",
    no_bankCard_dialog_msg: "您未绑定银行卡",
    no_bankCard_dialog_desc: "资金需要指定转出的银行卡",
    no_bankCard_dialog_cancel_btn_text: "暂不处理",
    no_bankCard_dialog_confirm_btn_text: "去绑定",
    all_amount: "全部余额"
  },

  //资金划转

  transfer: {
    nav_title: "资金划转",
	fade_out_name:'转出账户',
	fade_out_amout_name:'可转出金额',
	arreny_name:['美元','港币','人民币'],
	fade_in_name:'转入账户',
	fade_out_arreny:'转出币种',
	fade_out_amout:'转出金额',
	amout_placeolder:'请输入转出金额',
	btn:'确认提交',
	toast_amout:'划出金额不得超过可转出金额',
	toast_amout1:'最小转出金额不得小于0，请修改',
	confim:'知道了',
	confim_message:'资金划转订单提交成功预计1个工作日生效',
	forget_pwd:'忘记交易密码?',
	tr_pwd_title:'验证交易密码',
	confirm_btn:'确定',
	chanel_btn:'取消',
	rightBtn:'划转记录'
  },

  //失败原因
  fail_reason: {
    nav_title: "资料修改",
    page_title: "请按照提示修改资料并提交",
    reason_item_label: "可能是因为",
    processed_status: "已处理",
    untreated_status: "未处理",
    submit_btn_text1: "提交完成",
    submit_btn_text2: "提交修改",
    checkPassword: "验证登录密码",
    checkPasswordTips: "密码不能为空",
    confirm: "确认",
    cancel: "取消",
    reasonText:'可能不通过的原因',
    fail_reason_list: [
      {
        id: 1,
        title: "照片问题",
        reasons: ["身份信息与证件照不一致", "证件照片有部分缺失、不清晰"],
        status: 0,
        path: "/idcard-upload"
      },
      {
        id: 2,
        title: "视频问题",
        reasons: [
          "录制环境太暗，请在光线充足环境录制",
          "视频不清晰",
          "视频长度不够，请在录制时缓慢转头部或张口"
        ],
        status: 0,
        path: "/face-record"
      },
      {
        id: 3,
        title: "地址证明",
        reasons: [
          "地址证明与住址不一致",
          "地址证明不完整，缺少客户姓名",
          "请使用近3个月内的地址证明"
        ],
        status: 0,
        path: "/address-proof"
      },
      {
        id: 4,
        title: "税务资料有误",
        reasons: ["税务编号或其他信息不真实"],
        status: 0,
        path: "/tax-resident-info/page-one"
      },
      {
        id: 5,
        title: "W-8BEN资料有误",
        reasons: ["地址与居住地址不一致", "英文地址不符合规范"],
        status: 0,
        path: "/w8ben"
      },
      {
        id: 6,
        title: "上传凭证不合规范",
        reasons: ["上传凭证不合规范"],
        status: 0,
        path: "/cognition-of-derivatives"
      },
      {
        id: 7,
        title: "签名不正确或不符合规范",
        reasons: ["签名不正确或不符合规范"],
        status: 0,
        path: "/electronic-sign"
      },
      {
        id: 8,
        title: "本公司不接受此类型用户开户",
        reasons: ["签名不正确或不符合规范"],
        status: 0
      },
      {
        id: 9,
        title: "其他",
        reasons: ["签名不正确或不符合规范"],
        status: 0
      },
      {
        id: 10,
        title: "地址证明",
        reasons: ["地址输入不完整/和地址证明不符合"],
        status: 0
      },
      {
        id: 11,
        title: "风险承受能力问卷",
        reasons: ["风险承受能力问卷分数太低"],
        status: 0
      },
      {
        id: 12,
        title: "个人信息",
        reasons: ["公司名称不清晰"],
        status: 0
      },
      {
        id: 13,
        title: "个人信息",
        reasons: ["业务属性属于高风险"],
        status: 0
      },
      {
        id: 14,
        title: "个人信息",
        reasons: [" 身份证照片模糊"],
        status: 0
      },
      {
        id: 15,
        title: "个人信息",
        reasons: ["住址证明需在三个月内"],
        status: 0
      },
      {
        id: 16,
        title: "个人信息",
        reasons: ["住址证明需包含本人名字和住址信息"],
        status: 0
      },
      {
        id: 17,
        title: "个人信息",
        reasons: ["电子签名太小、不清晰"],
        status: 0
      },
      {
        id: 18,
        title: "适当性调查",
        reasons: ["财务状况与收入不符"],
        status: 0
      },
      {
        id: 19,
        title: "适当性调查",
        reasons: ["职业状态与资金来源不符"],
        status: 0
      },
      {
        id: 20,
        title: "个人信息",
        reasons: ["邮箱格式不正确"],
        status: 0
      },
      {
        id: 21,
        title: "客户声明",
        reasons: ["雇主书面同意书不清晰"],
        status: 0
      },
      {
        id: 22,
        title: "客户声明",
        reasons: ["持牌信息有误"],
        status: 0
      },
      {
        id: 24,
        title: "个人信息",
        reasons: ["身份信息有误"],
        status: 0
      },
      {
        id: 25,
        title: "税务资料有误",
        reasons: ["税务证明资料需包含本人名字和税务信息"],
        status: 0
      }
    ],

    mechanism: "开户信息审核失败，如需帮助，请联系客服"
  },

  //协议
  protocols: {
    customer_agreement_nav_title: "客户协议",
    license_agreement_nav_title: "产品使用许可协议",
    register_privacy_policy_nav_title: "隐私政策"
  },

  selectopening: {
    navtitle: "选择用户类型",
    openuser: "个人用户",
    openmu: "机构用户",
    openbtn: "立即开户",
    service: "本服务由",
    servicemiddle: "高盈证券有限公司",
    serviceend: "提供",
	market_hk:"港美股市场",
	compliant:"合规运营",
	company_commission:"我司接受香港证监会监管。",
	latency:"超低延时",
	transaction_latency:"与主流交易所搭建专属服务器，交易延时降到最低。",
	commission:"超低佣金",
	transaction_costs:"极具竞争力的佣金比例，最大程度节省您的交易成本。",
	activate:"去开通",
	market_glo:"期货市场",
	dialogMessage:"该用户是否持有香港银行账户?",
	yes:"是",
	no:"否",
	toastMessage:"暂时只接受持有香港银行账户的用户开户"
  },

  //验证交易密码弹框
  trade_password_verify: {
    header_title: "验证交易密码",
    reset_trade_password: "重置交易密码"
  },

  privacyProtocol: {
    title: "个人资料(私隐)政策/私隐政策声明",
    contents: [
      {
        content:
          "1.作为高盈证券有限公司（“高盈证券”）之客户（“客户”）,当申请开立或维持账户或建立、维持或提供投资、交易或相关服务时，需不时向高盈证券或联属公司提供有关之个人资料（“个人资料”）。（《个人资料（私隐）条例》（香港法例第486 章）（“私隐条例”）所赋予之定义）。"
      },
      {
        content:
          "2.若未能向高盈证券提供有关资料，将会导致高盈证券无法开立或维持户口或建立、维持或提供投资、交易或相关服务。"
      },
      {
        content:
          "3.个人资料将可能在与高盈证券及/或联属公司的正常业务往来过程中被收集。"
      },
      {
        content: "4.根据私隠条例的条文，资料将可能用于下列用途：",
        childContent: [
          "(a) 为提供服务给客户之日常运作；",
          "(b) 作信贷或反洗钱检查；",
          "(c) 确保客户之信用持续良好及反洗钱风险监控；",
          "(d) 宣传投资、交易或相关服务或产品(详情请见如下第8 段)；",
          "(e) 支持高盈证券在有关服务上作出之任何文件内之任何声明；",
          "(f) 协助其他有关第三者、专业人员、机构及有关监管机构确认某些高盈证券在有关服务上之事实；",
          "(g) 根据高盈证券须遵守之有关法例及／或条例要求作出披露；",
          "(h) 组成接收数据者所经营业务的纪录的一部份；",
          "(i) 与上述有关或随附之其他用途。"
        ]
      },
      {
        content:
          "5.高盈证券会把个人资料保密，但为达至上述第(4)段所述的用途，高盈证券可能会把个人资料提供给：",
        childContent: [
          "(a) 任何中间人，或提供与高盈证券业务运作有关服务之第三者服务供货商；",
          "(b) 任何对高盈证券作出保密责任之适当人士，包括对高盈证券作出保密资料承诺的任何联属公司；",
          "(c) 任何与客户已有或建议有交易之人士及机构；",
          "(d) 信贷咨询机构及(发生拖欠付款时) 收数公司；",
          "(e) 任何管治或与高盈证券及联属公司的业务有关的监管机构及交易所；",
          "(f) 任何承让人、受让人、代表、继承人或获转让有关账户之人士及授权人士；",
          "(g) 任何高盈证券之实际或建议受让人或参与人或附属参与人或受让人。"
        ]
      },
      {
        content:
          "6.客户同意个人资料可转到香港以外的任何地点(不论是用作在香港以外处理、持有或使用该等数据),并同意可转发给向任何联属公司就其业务经营而提供服务的服务提供商。"
      },
      {
        content:
          "7.在法律许可的范围内，客户同意高盈证券不时收集的个人资料可按照私隐政策的规定使用及披露。"
      },
      {
        content: "8.使用个人资料作直接促销",
        childContent: [
          "高盈证券拟使用客户的该等数据作直接促销，为此高盈证券在使用该等数据前须取得客户的同意（包括表示不反对）。客户同意与否纯属个人意愿。就此，务请客户注意",
          "(a) 由高盈证券不时持有的客户的姓名、联络详情、产品及服务组合信息、交易模式及行为、财务背景及统计资料（「可作直销用途的个人资料」）可由高盈证券用作直接促销；",
          "(b) 可促销的各类服务、产品及主题如下",
          "i. 财务、保险、证券、商品、投资及相关服务、产品及设施；",
          "ii. 上文第(8)(b)(i)条所述各类促销主题涉及的奖赏、忠诚奖励或优惠计划；",
          "iii. 由高盈证券的合作品牌伙伴因应上文第(8)(b)(i)条所述各类促销主题而提供的服务和产品（合作品牌伙伴的名称见相关服务和产品（视属何情况而定）申请书）；及",
          "iv. 为慈善及/或非牟利目的而作出的捐款及捐献；",
          "(c) 上述服务、产品及主题可由高盈证券及/或以下各方提供或（如涉及捐款及捐献）收集：",
          "i. 任何联属公司；",
          "ii. 第三方金融机构、承保人、证券、商品及投资服务提供商；",
          "iii. 第三方奖赏、忠诚奖励、合作品牌或优惠计划提供者；",
          "iv. 高盈证券的合作品牌伙伴（合作品牌伙伴的名称见相关服务和产品（视属何情况而定）申请书）；",
          "v. 慈善或非牟利组织；",
          "(d) 除了自行推广上述服务、产品及主题外，高盈证券亦拟将上文第(8)(a)条所述数据提供予上文第(8)(c),条所述的全部或当中任何人士（不论提供数据是为得益与否），以供该等人士在促销上文第(8)(b)条所述的该等服务、产品及主题时使用（高盈证券可能就此收取报酬），而高盈证券须为此用途取得客户的书面同意（包括表示不反对）；",
          "在未经客户同意之前高盈证券不会使用客户可作直销用途的个人资料进行直接促销。当签署相关客户开户文件时，请注明客户同意与否。如客户在相关开户文件中表明客户同意后欲改变意愿，希望高盈证券不再使用或向其他人士提供客户可作直销用途的个人资料进行上述直接促销，客户可向高盈证券发出书面通知或致电高盈证券的客户服务部（邮件地址及电话号码载于下文第(11)条），以行使客户拒绝参与直销活动的权利。",
          "但请注意，如客户是以公司或业务代表身份在相关客户文件中表明同意参与直接促销活动，而非以个人身份收取促销资料，则上述权利并不适用于客户。"
        ]
      },
      {
        content: "9.收集个人资料声明-沪深港通北向交易",
        childContent: [
          "阁下了解并同意高盈证券在为阁下提供沪深港通北向交易的过程中，高盈证券会被要求按有关规则处理客户个人资料，包括以下各项：",
          "1.在向中华证券通系统（“CSC”）递交阁下每单北向交易指令时，附加阁下唯一的券商客户编码（Broker-to-Client Assigned Number，“BCAN”）/为阁下联名账户编派的券商客户编码；及",
          "2. 在交易所可能不时依据交易所规则向高盈证券提出要求时，高盈证券将向交易所提供阁下的券商客户编码和客户识别信息（Client Identification Data，“CID”）",
          "在不局限于高盈证券就处理阁下个人资料曾发予阁下的通知或已从阁下获得的同意/授权，阁下在此了解并同意高盈证券在提供沪深"+
          "港通北向交易服务过程中可根据需要收集、存储、使用、披露和转交与阁下有关的个人资料，包括如下：",
          "(a) 不时向交易所和相关的港交所附属公司披露并转交阁下的券商客户编码和客户识别信息，包括在向中华证券通输入中华通交易"+
           "时注明阁下的券商客户编码，并即时转送给相关的中华通市场营运者；",
          "(b) 允许各交易所及相关的港交所附属公司：",
          "i. 为达至市场监督和监测及执行交易所规则之目的，收集、使用和存储由中华通结算所提供的阁下券商客户编码，客户识"+
          "别信息以及任何经整合、验证和配对的券商客户编码和客户识别信息（可由上述任何各方或通过香港交易所存储）；",
          "ii. 为达至下文（c）和（d）之目的，不时将有关数据转交有关中华通市场营运者（直接或经有关中华通结算所）;",
          "iii. 向香港监管机构和执法机关披露此类信息以便其履行就香港金融市场的法定职能；",
          "(c) 允许相关中华通结算所：",
          "i. 收集、使用和存储阁下的券商客户编码和客户识别信息，以便整合及验证券商客户编码和客户识别信息，配对券商客户"+
          "编码和客户识别信息至投资者识别数据库，并将经整合、验证和配对的券商客户编码及客户识别信息提供给相关的中华"+
            "通市场营运者，各交易所及相关港交所附属公司;",
          "ii. 使用阁下的券商客户编码和客户识别信息进行其证券账户管理的监管职能;",
          "iii. 将这些信息披露给具有管辖权的中国内地监管机构和执法机关，以便其就中国内地金融市场履行监管，监督和执法职能；",
          "(d) 允许相关的中华通市场营运者：",
          "i. 收集、使用和存储阁下的券商客户编码和客户识别信息，以便其监督和监测经中华通服务在相关中华通市场的证券交易"+
          "及执行相关中华通市场营运者的规则;",
          "ii. 将这些信息披露给具有管辖权的中国内地监管机构和执法机关，以便其就中国内地金融市场履行监管，监督和执法职能；",

          "如果阁下就任何有关中华通证券的交易向高盈证券发出指示，即表示阁下确认并同意高盈证券为遵守交易所就沪深港通北向交易不时"+
          "制定的的要求及规则使用阁下的个人资料。阁下同时承认，尽管阁下后续可能表示撤回该同意，阁下的个人资料仍可能继续被存储，"+
          "使用，披露，转移和及为达至上述目的其他方式处理，无论是在该等声称的撤回同意之前或之后。",
          "未能提供个人资料或同意的后果",
          "如阁下未能向高盈证券提供阁下的个人资料或上述同意/授权，这可能代表着高盈证券不会或不再能够执行阁下的交易指令或向阁下"+
          "提供沪深港通北向交易服务。",
        ]
      },
      {
        content: "10.根据私隐条例中之条文，任何人有权：",
        childContent: [
          "(a) 审查高盈证券是否持有他／她的数据及查阅有关之数据；",
          "(b) 要求高盈证券改正有关他／她不准确之资料；",
          "(c) 查悉高盈证券对于数据之政策及实际运用及被通知高盈证券持有何种个人资料；",
          "(d) 就客户信贷而要求获通知哪项个人资料是例行披露予信贷咨询机构或收数公司，以及获提供进一步的信息以便向有关的信贷咨询机构或收数公司作出查阅及改正要求。"
        ]
      },
      {
        content:
          "11.根据私隐条例规定，高盈证券有权就处理任何查阅数据之要求收取合理费用。任何关于数据查阅或改正数据(当客户认为由高盈证券所提供有关他／她的资料不准确时)或关于数据政策及实际应用或数据种类之要求，应向下列人士提出：私隐保护主任高盈证券有限公司，中国香港尖沙咀港威大厦 6 座 31 樓 3102 室。"
      }
    ]
  },
  newaccount: {
    title: "期货账户",
    new_title: "开户",
    startopen: "在线开户",
    speedaudit: "极速审核",
    capital: "资金进出",
    futurestrade: "交易",
    time: "10分钟",
    day: "1个工作日内",
    realtime: "实时T+0",
    world: "投资全球",
    compliance: "合规运营",
    low: "超低延时",
    commission: "超低佣金",
    worldcontent: "港美股、香港及环球期货",
    compliancecontent: "我司接受香港证监会监管。",
    lowcontent: "与主流交易所搭建专 属服务器，交易延时 降到最低。",
    commissioncontent: "机具竞争力的佣金比例，最大程度节省您的交易成本。",
    btnname: "马上开户",
    footertitle: "开户前请准备好",
    idcard: "身份证",
    wifi: "WiFi或4G"
  },
  passwordErrorPrompt: {
    tryAgain: "再试一次",
    set: "设置"
  },
  openReference: {
    nav_title: "推荐人信息",
    ipt_label: "推荐人信息",
    ipt_plh: "请输入",
    periodOfValidity: "证件有效期"
  },
  marketServices: {
    t00001: "行情服务",
    t00002: "我的行情",
    t00003: "<div>实时行情服务，<span style='color: #328CF4; text-decoration: underline;'>请联系客服</span></div>",
    t00004: "数据加载中...",
    t00005: "暂无实时行情服务"
  },
  mki18n:{
    t00001: "开始时间",
    t00002: "结束时间",
    t00003: '*请不要使用他人银行账户汇款，汇款人与账户持有人必须是同一人',
    t00004: '注册账号',
    t00005: '中国香港 +852',
    t00006: '中国大陆 +86',
    t00007: '持有人的英文名',
    t00008: '请输入',
    t00009: '银行名称',
    t00010: '银行代码/银行名称',
    t00011: '扣款银行',
    t00012: '收款银行',
    t00013: '方式一、从手机银行/网上银行转账',
    t00014: '方式二、从手机银行/网上银行发起FPS转账',
    t00015: '我已转账，通知高盈收款',
    t00016: '通知高盈收款',
    t00017: '预计到账时间',
    t00018: '1-3个工作日',
    t00019: '费用',
    t00020: '同行免费，跨行可能收费',
    t00021: '手机/网上银行转账',
    t00022: '入金审核中',
    t00023: '1. 系统正在处理，审核时间平均1~3个工作日，请耐心等待',
    t00024: '2. 如果需要修改或补充资料，您会收到邮件或短信通知，请留意',
    t00025: '3. 如需加急，请',
    t00026: '入金审核通过',
    t00027: '如需加急，请',
    t00028: '入金审核不通过',
    t00029: '如有疑问，请',
    t00030: '开通交易账户',
    t00031: '开通交易账户中',
    t00032: '重新入金激活',
    t00033: '开户进度',
    t00034: '保存',
    t00035: '终止开户',
    t00036: '系统提示您属于高风险人群，本公司不接收此类型用户开户',
    t00037: '我已知晓'
  },
  network_error_text: {
    t00001: '错误请求',
    t00002: '未授权，请重新登录',
    t00003: '拒绝访问',
    t00004: '请求错误,未找到该资源',
    t00005: '请求方法未允许',
    t00006: '请求超时',
    t00007: '服务器端出错',
    t00008: '网络未实现',
    t00009: '网络错误',
    t00010: '服务不可用',
    t00011: '网络超时',
    t00012: 'http版本不支持该请求',
    t00013: '连接错误',
  }
};

const languageFiles = require.context("./", false, /\.js$/);
languageFiles.keys().forEach(name => {
  moduleZh = { ...moduleZh, ...languageFiles(name).default };
});

export default moduleZh;
